webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConfigParameter = function () {

    /**
     *
     * @param paramKey
     * @param inputType
     * @param label
     * @param group
     * @param defaultValue
     * @param units
     * @param options
     * @param validator
     * @param placeholder
     * @param helper
     * @param aclDisable
     */
    function ConfigParameter(paramKey, inputType, label, group) {
        var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var units = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
        var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        var validator = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
        var placeholder = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
        var helper = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
        var aclDisable = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;

        _classCallCheck(this, ConfigParameter);

        this.paramKey = paramKey;
        this[paramKey] = {
            type: inputType,
            label: label,
            group: group,
            defaultValue: defaultValue,
            units: units,
            options: options,
            validator: validator,
            placeholder: placeholder,
            helper: helper,
            aclDisable: aclDisable
        };
        return this;
    }

    _createClass(ConfigParameter, [{
        key: "setInputType",
        value: function setInputType(inputType) {
            this[this.paramKey].type = inputType;
        }
    }, {
        key: "setLabel",
        value: function setLabel(label) {
            this[this.paramKey].label = label;
        }
    }, {
        key: "setGroup",
        value: function setGroup(group) {
            this[this.paramKey].group = group;
        }
    }, {
        key: "setDefaultValue",
        value: function setDefaultValue(defaultValue) {
            this[this.paramKey].defaultValue = defaultValue;
        }
    }, {
        key: "setUnits",
        value: function setUnits(units) {
            this[this.paramKey].units = units;
        }
    }, {
        key: "setOptions",
        value: function setOptions(options) {
            this[this.paramKey].options = options;
        }
    }, {
        key: "setValidator",
        value: function setValidator(validator) {
            this[this.paramKey].validator = validator;
        }
    }, {
        key: "setHelper",
        value: function setHelper(helper) {
            this[this.paramKey].helper = helper;
        }
    }, {
        key: "setAclDisable",
        value: function setAclDisable(aclDisable) {
            this[this.paramKey].aclDisable = aclDisable;
        }
    }]);

    return ConfigParameter;
}();

exports.default = ConfigParameter;

function gettext(text) {
    return text;
}

exports.gettext = gettext;

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONFIG = {"API_URL":"https://new-cms-contente-backend.dev.cdwv.pl/api","API_PUBLIC":"https://new-cms-contente-backend.dev.cdwv.pl","PUBLIC_SITE_URL":"http://__SITE_SLUG__.contente.net","DEV":false,"ROLES":["ROLE_USER","ROLE_ADMIN"],"UNSPLASH_ACCESS_KEY":"475919daaf6f38937bc3daf4c47a3d8fb0572e2ecc22b5097fb5745a39b4f882","UNSPLASH_SECRET_KEY":"cdd5aa0ce44dc3e0c6df71229df22c322dd959ffbcbcc1020b4e5b197a667e16","NOUN_PROJECT_KEY":"155322dd33d14129b816bd42d65f3512","NOUN_PROJECT_SECRET":"9d12fb2fc9164346bcb908702d8445ab"} || {};

/**
 * Config module for CMS. It will provide basic configuration for internal services (like API_URL constant).
 *
 * @namespace cms.config
 */
exports.default = angular.module('cms.config', []).constant('CONFIG', CONFIG).name;

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.config.sections', []).factory('SectionsLibraryService', function () {
  var _this = this;

  this.sections = {};

  /**
   * @param sectionDefinition {icon: '', label: '', type: ''}
   */
  var registerSection = function registerSection(sectionDefinition) {

    if (!('type' in sectionDefinition)) {
      console.error('Definition object should contain type');
    }

    if (!('icon' in sectionDefinition)) {
      console.error('Definition object should contain icon');
    }

    if (!('label' in sectionDefinition)) {
      console.error('Definition object should contain label');
    }

    if (_this.sections[sectionDefinition.type]) {
      console.error('Definition of object type ' + sectionDefinition.type + ' already exist (label: ' + sectionDefinition.label + ', group: ' + sectionDefinition.group + ')');
    }

    _this.sections[sectionDefinition.type] = sectionDefinition;
  };

  var getSections = function getSections(group, includeHidden) {
    var allSections = Object.values(_this.sections).filter(function (el) {
      return el.group === group;
    });
    return includeHidden ? allSections : allSections.filter(function (el) {
      return el.hidden !== true;
    });
  };

  var getSectionDefinition = function getSectionDefinition(type) {
    return _this.sections[type];
  };

  return {
    registerSection: registerSection,
    getSections: getSections,
    getSectionDefinition: getSectionDefinition
  };
}).name;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.toolbar.sections', []).factory('ToolbarService', function () {
  var _this = this;

  this.schemas = {};

  /**
   * @param {string} type
   * @param schema {{}, {}}
   */
  var registerSectionSchema = function registerSectionSchema(type, schema) {
    // Possible validation
    _this.schemas[type] = schema;
  };

  var getSectionSchema = function getSectionSchema(type) {

    if (!_this.schemas[type]) {
      console.error("Config for " + type + " not exists in schema. " + "Allowed options: " + Object.keys(_this.schemas).join(", "));
    }
    return _this.schemas[type];
  };

  var getSectionDefaultSchema = function getSectionDefaultSchema(type) {

    var schema = {};
    _angular2.default.forEach(_this.schemas[type], function (value, key) {
      if (_angular2.default.isFunction(value.defaultValue)) {
        schema[key] = value.defaultValue(type);
      } else {
        schema[key] = value.defaultValue;
      }
    });

    return schema;
  };

  return {
    registerSectionSchema: registerSectionSchema,
    getSectionSchema: getSectionSchema,
    getSectionDefaultSchema: getSectionDefaultSchema
  };
}).name;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomClassName = function (_ConfigParameter) {
    _inherits(CustomClassName, _ConfigParameter);

    function CustomClassName() {
        _classCallCheck(this, CustomClassName);

        return _possibleConstructorReturn(this, (CustomClassName.__proto__ || Object.getPrototypeOf(CustomClassName)).call(this, 'customClassName', 'text', (0, _ConfigParameter2.gettext)('Custom class name'), 'advanced', ''));
    }

    return CustomClassName;
}(_ConfigParameter3.default);

exports.default = CustomClassName;

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _PaddingTop = __webpack_require__(1116);

var _PaddingTop2 = _interopRequireDefault(_PaddingTop);

var _PaddingBottom = __webpack_require__(1117);

var _PaddingBottom2 = _interopRequireDefault(_PaddingBottom);

var _PaddingLeft = __webpack_require__(1118);

var _PaddingLeft2 = _interopRequireDefault(_PaddingLeft);

var _PaddingRight = __webpack_require__(1119);

var _PaddingRight2 = _interopRequireDefault(_PaddingRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Paddings = function Paddings() {
    var paddingTopBottom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { value: 15, unit: 'px' };
    var paddingLeftRight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { value: 15, unit: 'px' };
    var defaultUnits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['px', '%'];

    _classCallCheck(this, Paddings);

    var paddingTop = new _PaddingTop2.default();
    paddingTop.setDefaultValue(_extends({}, paddingTopBottom));
    paddingTop.setUnits(defaultUnits);
    var paddingBottom = new _PaddingBottom2.default();
    paddingBottom.setDefaultValue(_extends({}, paddingTopBottom));
    paddingBottom.setUnits(defaultUnits);

    var paddingLeft = new _PaddingLeft2.default();
    paddingLeft.setDefaultValue(_extends({}, paddingLeftRight));
    paddingLeft.setUnits(defaultUnits);
    var paddingRight = new _PaddingRight2.default();
    paddingRight.setDefaultValue(_extends({}, paddingLeftRight));
    paddingRight.setUnits(defaultUnits);

    return _extends({}, paddingTop, paddingBottom, paddingLeft, paddingRight);
};

exports.default = Paddings;

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextColor = function (_ConfigParameter) {
    _inherits(TextColor, _ConfigParameter);

    function TextColor() {
        _classCallCheck(this, TextColor);

        return _possibleConstructorReturn(this, (TextColor.__proto__ || Object.getPrototypeOf(TextColor)).call(this, 'color', 'color', (0, _ConfigParameter2.gettext)('Text color'), 'mainConfig', '#000000'));
    }

    return TextColor;
}(_ConfigParameter3.default);

exports.default = TextColor;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Module for auth actions.
 * @namespace cms.auth
 */
exports.default = _angular2.default.module('cms.auth', [_ConfigModule2.default]).factory('CMSAuthService', ['CONFIG', '$http', 'localStorageService', '$timeout', function (CONFIG, $http, localStorageService, $timeout) {
    /** @ngInclude */

    var service = {};

    /**
     * Login action.
     * Get auth token from backend.
     * @param string username
     * @param string password
     */
    service.login = function (username, password) {

        return $http.post(CONFIG.API_URL + "/login_check", {
            _username: username,
            _password: password
        }, { ignoreAuthModule: true, timeout: 20000 }).then(function onSuccess(response) {

            localStorageService.set('user', response.data);
            localStorageService.set('invalidate-login', { invalidate: false });
            service.setHttpAuth();
            return {
                success: true,
                response: response
            };
        }, function onError(response) {
            return {
                success: false,
                response: response
            };
        });
    };

    /**
     * Login using only password.
     * User fetched from storage
     * @param string password
     */
    service.reLogin = function (password) {
        return service.login(service.getUser().username, password);
    };

    /**
     * Logout - remove user from storage and http headers
     * @param function callback
     */
    service.logout = function (callback) {
        localStorageService.remove('user');
        $http.defaults.headers.common.Authorization = '';
        if (callback) {
            callback();
        }
    };

    service.resetPasswordRequest = function (email) {
        return $http.post(CONFIG.API_URL + "/resetPasswordRequest", {
            email: email
        });
    };

    service.resetPassword = function (token, password, passwordRepeat) {
        return $http.post(CONFIG.API_URL + "/resetPassword", {
            token: token,
            plainPassword: password,
            plainPasswordRepeat: passwordRepeat
        });
    };

    /**
     * Add auth token to http requests
     */
    service.setHttpAuth = function () {
        if (service.getToken()) {
            $http.defaults.headers.common.Authorization = "JWT " + service.getToken();
        }
    };

    /**
     * Get user data from localstorage
     */
    service.getUser = function () {
        if (localStorageService.get('user')) {
            return localStorageService.get('user').data;
        }
    };

    /**
     * Save user data to localstorage
     * @param userData
     */
    service.setUser = function (userData) {
        var storedUser = localStorageService.get('user');
        storedUser.data = userData;
        localStorageService.set('user', storedUser);
    };

    /**
     * Get token from localstorage
     */
    service.getToken = function () {
        if (localStorageService.get('user')) {
            return localStorageService.get('user').token;
        }
    };

    /**
     * Get invalidateLogin from localstorage
     */
    service.getInvalidateLogin = function () {
        if (localStorageService.get('invalidate-login')) {
            return localStorageService.get('invalidate-login').invalidate;
        }
    };

    return service;
}]).name;

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FontSize = function (_ConfigParameter) {
    _inherits(FontSize, _ConfigParameter);

    function FontSize() {
        _classCallCheck(this, FontSize);

        return _possibleConstructorReturn(this, (FontSize.__proto__ || Object.getPrototypeOf(FontSize)).call(this, 'fontSize', 'number', (0, _ConfigParameter2.gettext)('Font size'), 'mainConfig', { value: 14, unit: 'px' }, ['px']));
    }

    return FontSize;
}(_ConfigParameter3.default);

exports.default = FontSize;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FontWeight = function (_ConfigParameter) {
    _inherits(FontWeight, _ConfigParameter);

    function FontWeight() {
        _classCallCheck(this, FontWeight);

        return _possibleConstructorReturn(this, (FontWeight.__proto__ || Object.getPrototypeOf(FontWeight)).call(this, 'fontWeight', 'object-select', (0, _ConfigParameter2.gettext)('Font weight'), 'mainConfig', 'bold', null, [{ value: 'normal', label: (0, _ConfigParameter2.gettext)('Normal') }, { value: 'bold', label: (0, _ConfigParameter2.gettext)('Bold') }]));
    }

    return FontWeight;
}(_ConfigParameter3.default);

exports.default = FontWeight;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Width = function (_ConfigParameter) {
    _inherits(Width, _ConfigParameter);

    function Width() {
        _classCallCheck(this, Width);

        return _possibleConstructorReturn(this, (Width.__proto__ || Object.getPrototypeOf(Width)).call(this, 'width', 'select', (0, _ConfigParameter2.gettext)('Width'), 'mainConfig', 12, null, [12, 11, 10, 9, 8, 7, 6, 5, 4, 3]));
    }

    return Width;
}(_ConfigParameter3.default);

exports.default = Width;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Placeholder = function (_ConfigParameter) {
    _inherits(Placeholder, _ConfigParameter);

    function Placeholder() {
        _classCallCheck(this, Placeholder);

        return _possibleConstructorReturn(this, (Placeholder.__proto__ || Object.getPrototypeOf(Placeholder)).call(this, 'placeholder', 'text', (0, _ConfigParameter2.gettext)('Placeholder'), 'mainConfig', ''));
    }

    return Placeholder;
}(_ConfigParameter3.default);

exports.default = Placeholder;

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_ConfigParameter) {
    _inherits(Label, _ConfigParameter);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).call(this, 'label', 'text', (0, _ConfigParameter2.gettext)('Label'), 'mainConfig', ''));
    }

    return Label;
}(_ConfigParameter3.default);

exports.default = Label;

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundColor = function (_ConfigParameter) {
    _inherits(BackgroundColor, _ConfigParameter);

    function BackgroundColor() {
        _classCallCheck(this, BackgroundColor);

        return _possibleConstructorReturn(this, (BackgroundColor.__proto__ || Object.getPrototypeOf(BackgroundColor)).call(this, 'backgroundColor', 'color', (0, _ConfigParameter2.gettext)('Background color'), 'mainConfig', 'transparent'));
    }

    return BackgroundColor;
}(_ConfigParameter3.default);

exports.default = BackgroundColor;

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.delete.element.dialog.service', []).factory('deleteElementDialog', ['$uibModal', function ($uibModal) {

    var service = {};

    service.open = function (_content) {
        var modalInstance = $uibModal.open({
            animation: true,
            template: __webpack_require__(937),
            size: 'md',
            resolve: { content: function content() {
                    return _content;
                } },
            controller: ['$scope', 'content', function controller($scope, content) {
                $scope.content = content;
            }]
        });

        return modalInstance.result;
    };

    return service;
}]).name;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Align = function (_ConfigParameter) {
    _inherits(Align, _ConfigParameter);

    function Align() {
        _classCallCheck(this, Align);

        return _possibleConstructorReturn(this, (Align.__proto__ || Object.getPrototypeOf(Align)).call(this, 'align', 'align', (0, _ConfigParameter2.gettext)('Align'), 'position', 'center'));
    }

    return Align;
}(_ConfigParameter3.default);

exports.default = Align;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HelperText = function (_ConfigParameter) {
    _inherits(HelperText, _ConfigParameter);

    function HelperText() {
        _classCallCheck(this, HelperText);

        return _possibleConstructorReturn(this, (HelperText.__proto__ || Object.getPrototypeOf(HelperText)).call(this, 'helperText', 'text', (0, _ConfigParameter2.gettext)('Helper text'), 'mainConfig', ''));
    }

    return HelperText;
}(_ConfigParameter3.default);

exports.default = HelperText;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HelperImage = function (_ConfigParameter) {
    _inherits(HelperImage, _ConfigParameter);

    function HelperImage() {
        _classCallCheck(this, HelperImage);

        return _possibleConstructorReturn(this, (HelperImage.__proto__ || Object.getPrototypeOf(HelperImage)).call(this, 'helperImage', 'media', (0, _ConfigParameter2.gettext)('Helper image'), 'mainConfig', []));
    }

    return HelperImage;
}(_ConfigParameter3.default);

exports.default = HelperImage;

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Required = function (_ConfigParameter) {
    _inherits(Required, _ConfigParameter);

    function Required() {
        _classCallCheck(this, Required);

        return _possibleConstructorReturn(this, (Required.__proto__ || Object.getPrototypeOf(Required)).call(this, 'required', 'checkbox', (0, _ConfigParameter2.gettext)('Required'), 'mainConfig', false));
    }

    return Required;
}(_ConfigParameter3.default);

exports.default = Required;

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.service', [_angularResource2.default, _ConfigModule2.default]).factory('MediaResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInject */

    return $resource(CONFIG.API_URL + '/media/:id', { id: '@id' }, {
        'get': { cancellable: true, method: 'GET' },
        'save': { method: 'POST' },
        'remove': { method: 'DELETE', url: CONFIG.API_URL + '/media/:id' },
        'delete': { method: 'DELETE', url: CONFIG.API_URL + '/media/:id' } }, {
        stripTrailingSlashes: true
    });
}]).name;

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userResource = _angular2.default.module('cms.user.resource', [_angularResource2.default, _ConfigModule2.default]).factory('UserResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInclude */

    return $resource(CONFIG.API_URL + '/users/:id', { id: '@id' }, {
        'findAll': { method: 'GET' },
        'find': { method: 'GET' },
        'save': { method: 'POST' },
        'update': { method: 'PUT', params: { id: '@id' } },
        'delete': { method: 'DELETE', params: { id: '@id' } }
    }, {
        stripTrailingSlashes: true
    });
}]);

exports.default = userResource.name;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _uiSelect = __webpack_require__(202);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _angularLocalStorage = __webpack_require__(94);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _main = __webpack_require__(899);

var agGrid = _interopRequireWildcard(_main);

var _PaginationControlsModule = __webpack_require__(229);

var _PaginationControlsModule2 = _interopRequireDefault(_PaginationControlsModule);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

agGrid.initialiseAgGridWithAngular1(_angular2.default);

exports.default = _angular2.default.module('cms.grid.directive', ['agGrid', _uiSelect2.default, _PaginationControlsModule2.default, _angularLocalStorage2.default, _angularGettext2.default]).component('cmsGrid', {
    template: __webpack_require__(924),
    bindings: {
        gridOptions: '=',
        datasource: '=',
        initialSortModel: '=?',
        initialFilterModel: '=?',
        initialPage: '=?',
        onPageChange: '&?'
    },
    controller: ['$scope', 'localStorageService', 'gettextCatalog', function controller($scope, localStorageService, gettextCatalog) {
        var _this = this;

        this.itemsPerPage = 20;
        this.itemsPerPageSelect = [20, 50, 100];

        var getConstrainsLocaleTexts = function getConstrainsLocaleTexts() {
            return {
                contains: gettextCatalog.getString('Contains'),
                equals: gettextCatalog.getString('Equals'),
                notEqual: gettextCatalog.getString('Not equal'),
                startsWith: gettextCatalog.getString('Starts with'),
                endsWith: gettextCatalog.getString('Ends with'),
                notContains: gettextCatalog.getString('Not contains'),
                inRange: gettextCatalog.getString('In range')
            };
        };

        this.$onInit = function () {

            if (typeof _this.gridOptions._columnDefsCallback === 'function') {
                _this.gridOptions.columnDefs = _this.gridOptions._columnDefsCallback();
            }

            // Add Rows spinner
            if (_this.gridOptions.columnDefs[0]) {
                _this.gridOptions.columnDefs[0].cellRenderer = function (params) {
                    if (params.value !== undefined) {
                        return params.value;
                    } else {
                        return '<i class="fa fa-spin fa-circle-o-notch"></i>';
                    }
                };
            }

            /**
             * @see https://www.ag-grid.com/javascript-grid-infinite-scrolling/#gsc.tab=0
             */
            _this.gridOptions = _angular2.default.merge({

                rowModelType: 'infinite',

                pagination: true,
                suppressPaginationPanel: true,
                paginationPageSize: _this.itemsPerPage,

                enableServerSideSorting: true,
                enableServerSideFilter: true,
                enableColResize: true,
                floatingFilter: true,
                autoHeight: true,
                _gridStateId: undefined,
                headerHeight: 36,
                rowHeight: 36,
                floatingFiltersHeight: 38,
                localeText: getConstrainsLocaleTexts(),

                onPaginationChanged: function onPaginationChanged() {
                    $scope.$apply();
                    var currentPage = _this.gridOptions.api.paginationGetCurrentPage() + 1;
                    if (_this.onPageChange) {
                        _this.onPageChange({ $page: currentPage });
                    }
                },

                onGridReady: function onGridReady() {
                    if (_this.initialSortModel) {
                        _this.gridOptions.api.setSortModel(_this.initialSortModel);
                    }
                    if (_this.initialFilterModel) {
                        _this.gridOptions.api.setFilterModel(_this.initialFilterModel);
                    }
                    _this.gridOptions.api.setDatasource(_this.datasource);
                    _this.gridOptions.api.sizeColumnsToFit();

                    if (_this.gridOptions._gridStateId) {
                        var gridState = localStorageService.get(_this.gridOptions._gridStateId);

                        if (gridState) {
                            _this.gridOptions.columnApi.setColumnState(gridState);
                        }
                    }
                },
                onColumnResized: function onColumnResized(params) {
                    var columnState = params.columnApi.getColumnState();
                    if (_this.gridOptions._gridStateId) {
                        localStorageService.set(_this.gridOptions._gridStateId, columnState);
                    }
                },
                onColumnMoved: function onColumnMoved(params) {
                    var columnState = params.columnApi.getColumnState();
                    if (_this.gridOptions._gridStateId) {
                        localStorageService.set(_this.gridOptions._gridStateId, columnState);
                    }
                }

            }, _this.gridOptions);

            _this.updatePageSize = function (value) {
                _this.gridOptions.api.cacheBlockSize = value;
                _this.gridOptions.api.paginationSetPageSize(value);
            };

            _this.refreshGrid = function () {
                _this.gridOptions.api.paginationGoToFirstPage();
                _this.gridOptions.api.setFilterModel(null);
                _this.gridOptions.api.setSortModel(null);

                localStorageService.remove(_this.gridOptions._gridStateId);

                _this.gridOptions.columnApi.resetColumnState();

                _this.gridOptions.columnApi.getAllColumns().forEach(function (a) {
                    this.gridOptions.columnApi.autoSizeColumn(a);
                }, _this);

                _this.gridOptions.api.sizeColumnsToFit();
            };

            $scope.$on('language-changed', function () {

                _this.gridOptions.api.setColumnDefs(_this.gridOptions._columnDefsCallback());
                _this.gridOptions.localeText = getConstrainsLocaleTexts();

                var gridState = localStorageService.get(_this.gridOptions._gridStateId);

                if (gridState) {
                    _this.gridOptions.columnApi.setColumnState(gridState);
                }
            });
        };
    }]
}).name;

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.grid.param-converter', []).factory('GridParamsConverter', function () {

    return {

        /**
         *
         * @param {Object} params Ag-Grid get parameters
         * @param {number} params.startRow
         * @param {number} params.endRow
         * @param {*} params.sortModel
         * @param {*} params.filterModel
         * @param {string} params.context
         * @param {function} params.successCallback successCallback(rowsThisBlock, lastRow)
         * @param {function} params.failCallback failCallback(reason)
         * @returns {*} cmsApiParams Cms api parameters model
         */
        getCmsApiParams: function getCmsApiParams(params) {
            var limit = params.endRow - params.startRow;
            var page = Math.floor(params.startRow / limit) + 1;
            var queryParams = { limit: limit, page: page };
            Object.keys(params.filterModel).forEach(function (paramName) {
                var filterModel = params.filterModel[paramName];
                if (filterModel.filterType === "date" && filterModel.type === "inRange") {
                    queryParams[paramName + 'After'] = filterModel.dateFrom;
                    queryParams[paramName + 'Before'] = filterModel.dateTo;
                } else queryParams[paramName] = filterModel.filter;
            });

            if (params.sortModel.length) {
                var order = params.sortModel[0];
                queryParams.order_by = order.colId;
                queryParams.order_direction = order.sort;
            }

            return queryParams;
        }
    };
}).name;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param CMSAuthService
 * @returns {aclService}
 */
var aclService = function aclService(CMSAuthService) {

    /**
     * Allow (true) when:
     * - empty roles param
     * - user has at least one role matching roles param
     *
     * Disallow (false) when:
     * - user not logged (!user)
     * - user roles empty
     * - user has none of requested roles param
     *
     * @param roles
     * @returns boolean
     */
    this.matchRoles = function (roles) {

        if (!roles) {
            return true;
        }

        var user = CMSAuthService.getUser();
        if (!user || !user.roles) {
            return false;
        }

        var allowed = user.roles.some(function (el) {
            return roles.indexOf(el) !== -1;
        });

        return allowed;
    };
    return this;
};

aclService.$inject = ['CMSAuthService'];
/**
 * @namespace cms.acl
 */
exports.default = _angular2.default.module('cms.acl.service', [_CMSAuthService2.default]).factory('ACLService', aclService).name;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
      value: true
});

exports.default = function (fullHtml) {
      var html = fullHtml.replace(/<body(.*)>/, '<body>');
      var start = html.indexOf('<body>') + 6;
      var end = html.indexOf('</body>');
      html = html.substring(start, end).trim();
      return html;
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _BackgroundImage = __webpack_require__(1120);

var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Backgrounds = function Backgrounds() {
    _classCallCheck(this, Backgrounds);

    return _extends({}, new _BackgroundColor2.default(), new _BackgroundImage2.default());
};

exports.default = Backgrounds;

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/contente.svg";

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageResource = _angular2.default.module('cms.page.resource', [_angularResource2.default, _ConfigModule2.default]).factory('PageResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInclude */

    return $resource(CONFIG.API_URL + '/pages/:id', { id: '@id' }, {
        'findAll': { method: 'GET' },
        'find': { method: 'GET' },
        'save': { method: 'POST' },
        'update': { method: 'PUT', params: { id: '@id' } },
        'delete': { method: 'DELETE', params: { id: '@id' } },
        'findFormData': { method: 'GET', url: CONFIG.API_URL + '/pages/form/:pageId', params: { pageId: '@pageId' } },
        'findFormDataDetails': { method: 'GET', url: CONFIG.API_URL + '/pages/form/data/:id', params: { id: '@id' } },
        'deleteFormData': { method: 'DELETE', url: CONFIG.API_URL + '/pages/form/:id', params: { id: '@id' } }
    }, {
        stripTrailingSlashes: true
    });
}]);

exports.default = pageResource.name;

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularLocalStorage = __webpack_require__(94);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _UserResource = __webpack_require__(106);

var _UserResource2 = _interopRequireDefault(_UserResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.language.manager', [_angularGettext2.default, _angularLocalStorage2.default, _UserResource2.default]).factory('languageManager', ['gettextCatalog', 'UserResource', 'CMSAuthService', function (gettextCatalog, UserResource, CMSAuthService) {

    var service = {};

    /**
     * Set current app language
     * @param language
     */
    service.setLanguage = function (language) {
        gettextCatalog.setCurrentLanguage(language);
        var currentUser = CMSAuthService.getUser();

        UserResource.update({
            id: currentUser.id,
            language: language
        });

        currentUser.language = language;
        CMSAuthService.setUser(currentUser);
    };

    /**
     * Get current user language
     * @returns {string}
     */
    service.getLanguage = function () {
        return CMSAuthService.getUser() ? CMSAuthService.getUser().language : 'pl';
    };

    return service;
}]).name;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _modal = __webpack_require__(125);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = _angular2.default.module('media.picker.modal', [_modal2.default]).service('MediaPickerModal', ['$uibModal', function ($uibModal) {

    this.open = function () {
        var _multiple = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        return $uibModal.open({
            animation: true,
            template: __webpack_require__(887),
            size: 'lg',
            windowClass: 'media-picker-modal',
            resolve: {
                multiple: function multiple() {
                    return _multiple;
                }
            },
            controllerAs: '$ctrl',
            controller: ['$scope', 'CONFIG', 'MediaResource', 'UnsplashResource', 'multiple', 'gettextCatalog', function controller($scope, CONFIG, MediaResource, UnsplashResource, multiple, gettextCatalog) {
                var _this = this;

                /** @ngInject */

                this.multiple = multiple;
                this.selectedMedia = [];
                this.showSpinner = false;

                this.activeTab = 1;

                this.setActiveTab = function (number) {
                    _this.activeTab = number;
                };

                this.onMediaSelected = function (media, selected) {
                    if (_this.multiple) {
                        if (selected) {
                            _this.selectedMedia.push(media);
                        } else {
                            _this.selectedMedia = _this.selectedMedia.filter(function (selectedElement) {
                                return selectedElement.id !== media.id;
                            });
                        }
                    } else {
                        _this.selectedMedia = selected ? [media] : [];
                    }
                };

                this.selectedMediaString = function () {
                    return _this.selectedMedia.map(function (el) {
                        if (_this.isUnsplashElement(el)) {
                            return gettextCatalog.getString("Photo by {{user}} from {{source}}", {
                                user: el.user.name,
                                source: 'Unsplash'
                            });
                        } else {
                            return el.clientOriginalName;
                        }
                    }).join(", ");
                };

                this.isUnsplashElement = function (el) {
                    return !el.key && el.id && el.links && el.urls;
                };

                this.close = function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(selectedMedia) {
                        var i;
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _this.pending = true;
                                        i = 0;

                                    case 2:
                                        if (!(i < selectedMedia.length)) {
                                            _context.next = 11;
                                            break;
                                        }

                                        if (!_this.isUnsplashElement(selectedMedia[i])) {
                                            _context.next = 7;
                                            break;
                                        }

                                        _context.next = 6;
                                        return UnsplashResource.get({ id: selectedMedia[i].id }).$promise;

                                    case 6:
                                        selectedMedia[i] = _context.sent;

                                    case 7:
                                        _this.removeUnnecessaryKeysFromSelectedMedia(selectedMedia[i]);

                                    case 8:
                                        i++;
                                        _context.next = 2;
                                        break;

                                    case 11:
                                        _this.pending = false;
                                        $scope.$close(selectedMedia);

                                    case 13:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, _this);
                    }));

                    return function (_x2) {
                        return _ref.apply(this, arguments);
                    };
                }();

                this.removeUnnecessaryKeysFromSelectedMedia = function (selectedMedia) {
                    Object.keys(selectedMedia).forEach(function (key) {
                        if (['key', 'id', 'type', 'size', 'clientOriginalName'].indexOf(key) === -1) {
                            delete selectedMedia[key];
                        }
                    });
                };
            }]
        });
    };
}]).name;

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiBootstrap = __webpack_require__(233);

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.page.content.guard', [_angularUiBootstrap2.default]).factory('ContentGuardService', ['$uibModal', function ($uibModal) {
    var _this = this;

    this.lockedElements = {};

    var registerLocked = function registerLocked(elementType) {
        _this.lockedElements[elementType] ? _this.lockedElements[elementType]++ : _this.lockedElements[elementType] = 1;
    };

    var checkIsLocked = function checkIsLocked(elementType, showInfo) {
        var locked = _this.lockedElements[elementType];
        if (locked && showInfo) {
            openDuplicatesModal();
        }
        return locked;
    };

    var deregisterLocked = function deregisterLocked(elementType) {
        _this.lockedElements[elementType]--;
    };

    var openDuplicatesModal = function openDuplicatesModal() {
        return $uibModal.open({
            animation: true,
            template: __webpack_require__(1111)
        }).result.then(function () {}, function () {});
    };

    return {
        registerLocked: registerLocked,
        deregisterLocked: deregisterLocked,
        checkIsLocked: checkIsLocked
    };
}]).name;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Color = function (_ConfigParameter) {
    _inherits(Color, _ConfigParameter);

    function Color() {
        _classCallCheck(this, Color);

        return _possibleConstructorReturn(this, (Color.__proto__ || Object.getPrototypeOf(Color)).call(this, 'color', 'color', (0, _ConfigParameter2.gettext)('Color'), 'mainConfig', '#ffffff'));
    }

    return Color;
}(_ConfigParameter3.default);

exports.default = Color;

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XdebugInterceptor = function XdebugInterceptor(CONFIG) {
    /** @ngInclude */

    return {
        'request': function request(config) {

            if (CONFIG.DEV && window.XDEBUG_SESSION_ID) {
                config.params = config.params || {};
                if (!/.*\.html/.test(config.url)) {
                    config.params.XDEBUG_SESSION_START = window.XDEBUG_SESSION_ID;
                }
            }

            return config;
        }
    };
};

XdebugInterceptor.$inject = ['CONFIG'];
/**
 * Http interceptor for xdebug.
 * Detects xDebug config in app configuration (config.js) and session_id in js window property
 * to enable xDebug session. See README.md
 * @namespace cms.interceptor.xdebug
 */
exports.default = _angular2.default.module('cms.interceptor.xdebug', [_ConfigModule2.default]).factory('XdebugInterceptor', XdebugInterceptor).name;

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__(886);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class to represent specific media usage. It'll grow as we allow user to select the crop area.
 *
 * @class MediaUsage
 * @property media {object} Media object
 * @property width {integer} Requested media width
 * @property height {integer} Requested media height
 */
var MediaUsage = function () {
    function MediaUsage(media, width, height) {
        _classCallCheck(this, MediaUsage);

        this.media = media;
        this.width = width;
        this.height = height;
    }

    _createClass(MediaUsage, [{
        key: 'getImgUrl',
        value: function getImgUrl() {
            return _config2.default.API_PUBLIC.replace(/\/+$/, '') + '/image/' + this.width + 'x' + this.height + '/' + this.media.key;
        }
    }]);

    return MediaUsage;
}();

exports.default = MediaUsage;

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.pagination-controls', []).component('paginationControls', {
    template: __webpack_require__(923),
    bindings: {
        pages: '<',
        currentPage: '<',
        onPageChange: '&'
    },
    controller: function controller() {
        var _this = this;

        this.aroundEdges = 2;
        this.aroundCurrent = 1;
        this.pageControls = [];

        this.generatePages = function () {
            _this.pageControls.length = 0;
            var pageControls = _this.pageControls;

            if (_this.currentPage > _this.aroundEdges + _this.aroundCurrent) {
                for (var i = 1; i <= _this.aroundEdges; i++) {
                    pageControls.push({
                        label: i,
                        page: i
                    });
                }

                pageControls.push({
                    label: '...',
                    disabled: true,
                    page: '-1'
                });

                for (var _i = _this.currentPage - _this.aroundCurrent; _i < _this.currentPage; _i++) {
                    pageControls.push({
                        label: _i,
                        page: _i
                    });
                }
            } else {
                for (var _i2 = 1; _i2 < _this.currentPage; _i2++) {
                    pageControls.push({
                        label: _i2,
                        page: _i2
                    });
                }
            }

            pageControls.push({
                label: _this.currentPage || '...',
                page: _this.currentPage
            });

            if (_this.currentPage < _this.pages - _this.aroundEdges - _this.aroundCurrent) {
                for (var _i3 = _this.currentPage + 1; _i3 <= _this.currentPage + _this.aroundCurrent; _i3++) {
                    pageControls.push({
                        label: _i3,
                        page: _i3
                    });
                }
                pageControls.push({
                    label: '...',
                    disabled: true,
                    page: '-2'
                });

                for (var _i4 = _this.pages - _this.aroundEdges + 1; _i4 <= _this.pages; _i4++) {
                    pageControls.push({
                        label: _i4,
                        page: _i4
                    });
                }
            } else {
                for (var _i5 = _this.currentPage + 1; _i5 <= _this.pages; _i5++) {
                    pageControls.push({
                        label: _i5,
                        page: _i5
                    });
                }
            }
        };

        this.$onInit = function () {
            _this.generatePages();
        };

        this.$onChanges = function (_ref) {
            var pagesChange = _ref.pages,
                currentPageChange = _ref.currentPage;


            if (currentPageChange) _this.currentPage = currentPageChange.currentValue;

            if (pagesChange) _this.pages = pagesChange.currentValue;

            if (currentPageChange || pagesChange) {
                _this.generatePages();
            }
        };

        this.goToPage = function (page) {
            if (page > _this.pages) return;

            if (page < 1) return;

            _this.currentPage = page;

            if (_this.onPageChange) {
                _this.onPageChange({ page: page });
            }
        };
    }
}).name;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mailsResource = _angular2.default.module('cms.mails.resource', [_angularResource2.default, _ConfigModule2.default]).factory('MailsResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInclude */

    return $resource(CONFIG.API_URL + '/mails/:id', { id: '@id' }, {
        'findAll': { method: 'GET' },
        'find': { method: 'GET' },
        'save': { method: 'POST' },
        'update': { method: 'PUT', params: { id: '@id' } },
        'delete': { method: 'DELETE', params: { id: '@id' } }
    }, {
        stripTrailingSlashes: true
    });
}]);

exports.default = mailsResource.name;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Context class for creator-elements communication
 */
var Context = function () {
  function Context() {
    _classCallCheck(this, Context);

    this.currentElement = {};
    this.dragularScope = {};
    this.clickOutsideEnabled = true;
  }

  _createClass(Context, [{
    key: 'setDragularScope',
    value: function setDragularScope(scope) {
      var _this = this;

      this.dragularScope = scope;
      scope.$on('$destroy', function () {
        _this.clearCurrentElement();
      });
    }
  }, {
    key: 'getDragularScope',
    value: function getDragularScope() {
      return this.dragularScope;
    }
  }, {
    key: 'clearCurrentElement',
    value: function clearCurrentElement() {
      this.currentElement = {};
    }
  }, {
    key: 'hasCurrentElement',
    value: function hasCurrentElement() {
      return this.currentElement ? Object.keys(this.currentElement).length !== 0 : false;
    }
  }, {
    key: 'setCurrentElement',
    value: function setCurrentElement(element) {
      this.currentElement = element;
    }
  }, {
    key: 'getCurrentElement',
    value: function getCurrentElement() {
      return this.currentElement;
    }
  }, {
    key: 'setClickOutsideEnabled',
    value: function setClickOutsideEnabled(status) {
      this.clickOutsideEnabled = typeof status === 'undefined' ? true : status;
    }
  }, {
    key: 'isClickOutsideEnabled',
    value: function isClickOutsideEnabled() {
      return this.clickOutsideEnabled;
    }
  }]);

  return Context;
}();

exports.default = Context;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service to handle "locked" state of something.
 * If locked, promise is created;
 * If unlicked, promise is resolved;
 * Usage: SaveGuard.check().then(()=> // do code if state unlocked );
 */
exports.default = _angular2.default.module('cms.save.guard', []).factory('SaveGuard', function () {

    var promise = new Promise(function (resolve) {
        return resolve();
    });
    var _resolveFn = null;

    return {
        check: function check() {
            return promise;
        },
        lock: function lock() {
            return promise = new Promise(function (resolve) {
                return _resolveFn = resolve;
            });
        },
        unlock: function unlock() {
            return _resolveFn();
        }
    };
}).name;

/***/ }),
/* 233 */,
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.password
 * @property {object}   bindings.errors         Form errors object
 * @property {string}   bindings.title          Input title and/or placeholder
 * @property {string}   bindings.model          Input value reference
 */
var cmsInputPassword = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        disabled: '=',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: __webpack_require__(235)
};

/**
 * Password control
 * @namespace cms.input.password
 */
exports.default = _angular2.default.module('cms.input.password', []).component('cmsInputPassword', cmsInputPassword).name;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\" \n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }}\">\n        <input type=\"password\" \n               class=\"form-control\"\n               placeholder=\"{{ $ctrl.title }}\"\n               ng-disabled=\"$ctrl.aclDisable || $ctrl.disabled\"\n               autocomplete=\"off\"\n               ng-model=\"$ctrl.model\">\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n    </div>\n</div>";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.email
 * @property {object}   bindings.errors   Form errors object
 * @property {array}    bindings.model    Text model reference
 * @property {string}   bindings.title    Input label and/or placeholder
 */
var cmsInputEmail = {
    bindings: {
        errors: '=',
        model: '=',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: __webpack_require__(237)
};

/**
 * Email editor control.
 * @namespace cms.input.email
 */
exports.default = _angular2.default.module('cms.input.email', []).component('cmsInputEmail', cmsInputEmail).name;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }}\">\n        <input type=\"text\"\n               class=\"form-control\"\n               placeholder=\"Email\"\n               ng-disabled=\"$ctrl.aclDisable\"\n               ng-model=\"$ctrl.model\">\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n    </div>\n</div>";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _AnchorModal = __webpack_require__(1103);

var _AnchorModal2 = _interopRequireDefault(_AnchorModal);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var workspaceElement = {
    bindings: {
        section: '<',
        sections: '<',
        context: '<',
        workspaceType: '<',
        sectionsNested: '<',
        content: '=',
        options: '<'
    },
    template: __webpack_require__(1105),
    controller: ['dragulaService', 'SectionsLibraryService', 'ToolbarService', '$scope', 'deleteElementDialog', 'gettextCatalog', 'ClickOutside', '$uibModal', 'UniqueIdGenerator', 'AnchorModal', '$rootScope', '$timeout', function controller(dragulaService, SectionsLibraryService, ToolbarService, $scope, deleteElementDialog, gettextCatalog, ClickOutside, $uibModal, UniqueIdGenerator, AnchorModal, $rootScope, $timeout) {
        var _this = this;

        /** @ngInject() */

        var dragularListener = void 0;

        this.$onInit = function () {

            if (!_this.section.config) {
                _this.onFocus(_this.section);
            }

            clearSectionKeys(_this.section);

            _this.dragularScope = _this.context.getDragularScope();

            if (_this.section.type !== 'pageSection' && _this.workspaceType === 'workspace' && _this.sectionsNested) {
                wrapElementInSection(_this.section);
            }

            _this.sectionDefinition = SectionsLibraryService.getSectionDefinition(_this.section.type);
        };

        /**
         * Check if section has "disableRemove" flag
         * @returns {boolean}
         */
        this.isRemoveDisabled = function () {
            return _this.sectionDefinition && _this.sectionDefinition.options ? _this.sectionDefinition.options.disableRemove : false;
        };

        /**
         * Check if section has "disableCopy" flag
         * If not, check if child sections have this option
         * @returns {boolean}
         */
        this.isCopyDisabled = function () {
            var selfDisabled = _this.sectionDefinition && _this.sectionDefinition.options ? _this.sectionDefinition.options.disableCopy : false;
            var childrenDisabled = false;

            if (!selfDisabled && _this.section && _this.section.config && _this.section.config.children) {
                _this.section.config.children.forEach(function (column) {
                    column.forEach(function (subSection) {
                        if (subSection) {
                            var childConfig = SectionsLibraryService.getSectionDefinition(subSection.type);
                            if (childConfig && childConfig.options && childConfig.options.disableCopy) {
                                childrenDisabled = true;
                            }
                        }
                    });
                });
            }

            return selfDisabled || childrenDisabled;
        };

        this.onFocus = function (section, $event) {

            if ($event) {
                $event.stopPropagation();
            }

            _this.context.setCurrentElement(section);

            $timeout(function () {
                $rootScope.$broadcast('creator-workspace-selection-changed');
            });

            if (_this.context.isClickOutsideEnabled()) {
                $scope.$broadcast('creator-workspace-focus', { section: section });
                ClickOutside.setCurrent('section-element', function () {
                    _this.context.clearCurrentElement();
                    $scope.$apply();
                    $scope.$broadcast('creator-workspace-blur');
                }, 'disable-click-outside');
            }
        };

        this.isSelected = function (section) {
            return _this.context.getCurrentElement() === section;
        };

        this.removeSection = function (section, $event) {
            $event.stopPropagation();
            var position = _this.findPosition(section);
            _this.sections.splice(position, 1);
            _this.context.clearCurrentElement();

            $scope.$emit('content-changed');
        };

        this.copySection = function (event, section) {
            event.stopPropagation();
            var copiedSection = _angular2.default.copy(section);
            var position = _this.findPosition(section) + 1;
            if (copiedSection.config && copiedSection.config.key) {
                copiedSection.config.key = copiedSection.type + Math.floor(Math.random() * (Math.pow(2, 30) - 1) + 1);
            }

            _this.regenerateUid(copiedSection);

            if (copiedSection.config && copiedSection.config.sectionId) {
                copiedSection.config.sectionId = UniqueIdGenerator.generate(copiedSection.type);
            }
            if (copiedSection.config && copiedSection.config.children) {
                copiedSection.config.children.forEach(function (column) {
                    column.forEach(function (element) {
                        if (element.config && element.config.sectionId) {
                            element.config.sectionId = UniqueIdGenerator.generate(element.type);
                        }
                    });
                });
            }
            _this.sections.splice(position, 0, copiedSection);
            _this.onFocus(_this.sections[position]);

            $scope.$emit('content-changed');
        };

        this.regenerateUid = function (section) {
            if (section.config && section.config.uid) {
                section.config.uid = UniqueIdGenerator.generate('element-uid');
            }
            if (section.config && section.config.children) {
                section.config.children.forEach(function (column) {
                    column.forEach(function (subSection) {
                        if (subSection.config && subSection.config.uid) {
                            subSection.config.uid = UniqueIdGenerator.generate('element-uid');
                        }
                    });
                });
            }
        };

        this.findPosition = function (section) {
            var position = -1;

            _this.sections.forEach(function (el, key) {

                if (el.$$hashKey === section.$$hashKey) {
                    position = key;
                }
            });
            return position;
        };

        /**
         * Wrap child section in section container
         * @param elementToWrap
         */
        var wrapElementInSection = function wrapElementInSection(elementToWrap) {

            var copy = _angular2.default.copy(elementToWrap);

            var wrapped = {
                type: 'pageSection',
                group: 'page',
                config: ToolbarService.getSectionDefaultSchema('pageSection')
            };

            clearSectionKeys(elementToWrap);
            wrapped.config.children = [[copy]];
            wrapped.config.columnsWidth = [12];
            _angular2.default.merge(elementToWrap, wrapped);
        };

        var clearSectionKeys = function clearSectionKeys(element) {
            Object.keys(element).forEach(function (key) {
                if (['type', 'group', 'config', '$$hashKey'].indexOf(key) === -1) {
                    delete element[key];
                }
            });
        };

        this.showAnchorModal = function (section) {
            AnchorModal.open(section);
        };

        this.moveUp = function (section) {
            var position = _this.findPosition(section);
            if (position > 0) {
                var movedSection = _this.sections[position - 1];
                _this.sections[position - 1] = section;
                _this.sections[position] = movedSection;
                $scope.$emit('content-changed');
            }
        };

        this.moveDown = function (section) {
            var position = _this.findPosition(section);
            if (position < _this.sections.length) {
                var movedSection = _this.sections[position + 1];
                _this.sections[position + 1] = section;
                _this.sections[position] = movedSection;
                $scope.$emit('content-changed');
            }
        };

        $scope.$on('$destroy', function () {
            if (dragularListener) {
                dragularListener();
            }
        });
    }]
};

exports.default = _angular2.default.module('cms.creator.workspace-element', [_deleteElement2.default, _SectionsLibraryService2.default, _ToolbarService2.default, _angularGettext2.default, _AnchorModal2.default]).component('workspaceElement', workspaceElement).name;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextContent = function (_ConfigParameter) {
    _inherits(TextContent, _ConfigParameter);

    function TextContent() {
        _classCallCheck(this, TextContent);

        return _possibleConstructorReturn(this, (TextContent.__proto__ || Object.getPrototypeOf(TextContent)).call(this, 'text', 'hidden', null, 'mainConfig'));
    }

    return TextContent;
}(_ConfigParameter3.default);

exports.default = TextContent;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_ConfigParameter) {
    _inherits(Image, _ConfigParameter);

    function Image() {
        _classCallCheck(this, Image);

        return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, 'image', 'media', (0, _ConfigParameter2.gettext)('Image'), 'mainConfig', []));
    }

    return Image;
}(_ConfigParameter3.default);

exports.default = Image;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_ConfigParameter) {
    _inherits(Link, _ConfigParameter);

    function Link() {
        _classCallCheck(this, Link);

        return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, 'href', 'text', (0, _ConfigParameter2.gettext)('Link'), 'mainConfig', "", null, null, null, (0, _ConfigParameter2.gettext)('Insert URL here...')));
    }

    return Link;
}(_ConfigParameter3.default);

exports.default = Link;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(1149);

var _MediaPickerModalService = __webpack_require__(1150);

var _MediaPickerModalService2 = _interopRequireDefault(_MediaPickerModalService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.placeholder', [_MediaPickerModalService2.default]).component('mediaPlaceholder', {
    bindings: {
        model: '='
    },
    template: __webpack_require__(1151),
    controller: ['$scope', 'MediaPickerModalService', function controller($scope, MediaPickerModalService) {
        var _this = this;

        this.openMediaPicker = function () {
            MediaPickerModalService.open(_this.model).then(function (model) {
                _this.model = model;
                $scope.$emit('content-changed');
            });
        };
    }]
}).name;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BorderColor = __webpack_require__(1161);

var _BorderColor2 = _interopRequireDefault(_BorderColor);

var _BorderWidth = __webpack_require__(1162);

var _BorderWidth2 = _interopRequireDefault(_BorderWidth);

var _BorderRadius = __webpack_require__(449);

var _BorderRadius2 = _interopRequireDefault(_BorderRadius);

var _BorderStyle = __webpack_require__(1163);

var _BorderStyle2 = _interopRequireDefault(_BorderStyle);

var _ConfigParameter = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Borders = function Borders() {
    var defaultBorderColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#cbcbcb';

    _classCallCheck(this, Borders);

    var borderRadius = new _BorderRadius2.default();
    borderRadius.setLabel((0, _ConfigParameter.gettext)('Border radius'));
    borderRadius.setGroup('borders');

    var borderColor = new _BorderColor2.default();
    borderColor.setDefaultValue(defaultBorderColor);

    return _extends({}, borderColor, new _BorderWidth2.default(), new _BorderRadius2.default(), new _BorderStyle2.default());
};

exports.default = Borders;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Height = function (_ConfigParameter) {
    _inherits(Height, _ConfigParameter);

    function Height() {
        _classCallCheck(this, Height);

        return _possibleConstructorReturn(this, (Height.__proto__ || Object.getPrototypeOf(Height)).call(this, 'height', 'number', (0, _ConfigParameter2.gettext)('Height'), 'mainConfig', { value: 300, unit: 'px' }, ['px']));
    }

    return Height;
}(_ConfigParameter3.default);

exports.default = Height;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Options = function (_ConfigParameter) {
    _inherits(Options, _ConfigParameter);

    function Options() {
        _classCallCheck(this, Options);

        return _possibleConstructorReturn(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, 'options', 'options', (0, _ConfigParameter2.gettext)('Options'), 'mainConfig', function () {
            return [(0, _ConfigParameter2.gettext)("Option 1"), (0, _ConfigParameter2.gettext)("Option 2")];
        }));
    }

    return Options;
}(_ConfigParameter3.default);

exports.default = Options;

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.loader.manager', []).factory('LoaderManager', function () {

    var loaders = {};

    this.getActive = function (key) {
        return loaders[key];
    };

    this.setActive = function (key, active) {
        loaders[key] = typeof active === 'undefined' ? true : active;
    };

    return this;
}).name;

/***/ }),
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _LanguageManager = __webpack_require__(146);

var _LanguageManager2 = _interopRequireDefault(_LanguageManager);

__webpack_require__(890);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.mails.subscribeStatsChart', [_LanguageManager2.default]).component('mailSubscribeStatsChart', {
  template: __webpack_require__(891),
  controller: ['baConfig', 'layoutPaths', 'baUtil', '$http', '$scope', 'languageManager', 'CONFIG', function controller(baConfig, layoutPaths, baUtil, $http, $scope, languageManager, CONFIG) {

    var layoutColors = baConfig.colors;
    var chart = void 0;

    var printChart = function printChart(chartData) {

      chart = AmCharts.makeChart('subscribeStatsChart', {
        type: 'serial',
        theme: 'light',
        language: languageManager.getLanguage(),
        dataDateFormat: "DD/MM/YYYY",
        marginTop: 15,
        marginRight: 15,
        dataProvider: chartData,
        categoryField: 'date',
        categoryAxis: {
          gridAlpha: 0,
          parseDates: true,
          minPeriod: 'DD',
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        },
        valueAxes: [{
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }],
        graphs: [{
          id: 'g0',
          bullet: 'none',
          lineColor: layoutColors.success,
          lineThickness: 1,
          type: 'smoothedLine',
          valueField: 'new',
          fillAlphas: .1,
          fillColorsField: 'lineColor'
        }, {
          id: 'g1',
          bullet: 'none',
          lineColor: layoutColors.danger,
          lineThickness: 1,
          type: 'smoothedLine',
          valueField: 'deleted',
          fillAlphas: .1,
          fillColorsField: 'lineColor'
        }],
        chartCursor: {
          categoryBalloonDateFormat: 'DD/MM/YYYY',
          categoryBalloonColor: '#4285F4',
          categoryBalloonAlpha: 0.7,
          cursorAlpha: .5,
          valueLineEnabled: true,
          valueLineBalloonEnabled: true,
          valueLineAlpha: 0.5,
          selectWithoutZooming: true
        },
        creditsPosition: 'bottom-right',
        zoomControl: {
          zoomControlEnabled: false

        }
      });
    };

    $http.get(CONFIG.API_URL + '/mailsStats/subscriptions/30').then(function (response) {
      printChart(response.data);
    });

    $scope.$on('language-changed', function (event, data) {
      if (chart && data.newLanguage) {
        chart.language = data.newLanguage;
        chart.validateData();
      }
    });
  }]
}).name;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angular3 = __webpack_require__(892);

var _angular4 = _interopRequireDefault(_angular3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.panels.pie-chart', ['easypiechart']).component('cmsPieChart', {
    bindings: {
        title: '@',
        icon: '@',
        percent: '@',
        description: '@'
    },
    template: __webpack_require__(893),
    controller: function controller() {
        this.options = {
            easing: 'easeOutBounce',
            barColor: '#2C3E50',
            trackColor: 'rgba(0,0,0,0)',
            size: 84,
            scaleLength: 0,
            animation: 2000,
            lineWidth: 9,
            lineCap: 'round'
        };
    }
}).name;

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productResource = _angular2.default.module('cms.product.resource', [_angularResource2.default, _ConfigModule2.default]).factory('ProductResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInclude */

    return $resource(CONFIG.API_URL + '/products/:id', { id: '@id' }, {
        'findAll': { method: 'GET' },
        'find': { method: 'GET' },
        'save': { method: 'POST' },
        'update': { method: 'PUT', params: { id: '@id' } },
        'delete': { method: 'DELETE', params: { id: '@id' } },
        'export': { method: 'GET', params: { id: 'export' } }
    }, {
        stripTrailingSlashes: true
    });
}]);

exports.default = productResource.name;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.unsplash.service', [_angularResource2.default, _ConfigModule2.default]).factory('UnsplashResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInject */

    return $resource(CONFIG.API_URL + '/unsplash/:id', { id: '@id' }, {
        'save': { cancellable: true, method: 'POST' },
        'find': { cancellable: true, method: 'GET' },
        'findAll': { cancellable: true, method: 'GET' }

    }, {
        stripTrailingSlashes: true
    });
}]).name;

/***/ }),
/* 434 */,
/* 435 */,
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.historyStorage', []).factory('historyStorage', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
    var _this = this;

    this.stack = [];
    this.counter = 0;

    var MAX_STACK_COUNT = 50;

    var next = function next() {
        if (_this.stack.length > 1) {
            if (_this.counter < -1 || _this.counter > _this.stack.length) {
                _this.counter = 0;
            }
            var snapshot = _this.stack[++_this.counter];

            if (snapshot) {
                $rootScope.$broadcast('history-storage-change', { snapshot: _angular2.default.copy(snapshot) });
            }
        }
    };

    var back = function back() {
        if (_this.counter > 0) {
            _this.counter--;

            var snapshot = _this.stack[_this.counter];
            if (snapshot) {
                $rootScope.$broadcast('history-storage-change', { snapshot: _angular2.default.copy(snapshot) });
            }
        }
    };

    var add = function add(item) {
        var lastElement = _this.stack[_this.counter];

        if (!lastElement) {
            lastElement = { content: {} };
        }

        var copy = _angular2.default.copy(item);

        if (!_angular2.default.equals(lastElement, copy)) {
            _this.stack[++_this.counter] = copy;

            _this.stack.splice(_this.counter + 1);

            if (_this.counter > MAX_STACK_COUNT) {
                _this.stack.shift();
                _this.counter--;
            }
        }
    };

    var register = function register(element, page, contentScope) {
        _this.stack = [];
        _this.counter = -1;

        element.on('mousedown', function (el) {
            if ($(el.target).hasClass('undo-redo')) {
                return;
            }

            add(page());
        });

        contentScope.$on('sections-library.drop-model', function (el, target, source) {
            $timeout(function () {
                add(page());
            });
        });

        contentScope.$on('content-changed', function (event, value) {
            $timeout(function () {
                add(page());
            });
        });
    };

    var clear = function clear() {
        _this.stack = [];
        _this.counter = -1;
    };

    var getStackLength = function getStackLength() {
        return _this.stack.length;
    };

    var getCounter = function getCounter() {
        return _this.counter;
    };

    return {
        next: next,
        back: back,
        add: add,
        register: register,
        getStackLength: getStackLength,
        getCounter: getCounter,
        clear: clear
    };
}]).name;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.page.find.form', []).factory('FindFormService', function () {

    this.findForm = function (content) {
        var returnModule = {};
        content.forEach(function (section) {
            section.config.children.forEach(function (column) {
                column.forEach(function (module) {
                    if (module.type === 'pageForm') {
                        returnModule = module;
                    }
                });
            });
        });
        return returnModule;
    };

    return this;
}).name;

/***/ }),
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _CKEditorTextarea = __webpack_require__(1068);

var _CKEditorTextarea2 = _interopRequireDefault(_CKEditorTextarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Inline editor component
 */
var editorTextarea = {
    bindings: {
        contentLoaded: '<',
        disabled: '<',
        model: '='
    },
    template: __webpack_require__(1069)
};

exports.default = _angular2.default.module('cms.editor.textarea', [_CKEditorTextarea2.default]).component('editorTextarea', editorTextarea).name;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.ckeditor.config', [_CMSAuthService2.default]).factory('CKEditorConfig', ["CMSAuthService", function (CMSAuthService) {
    var _this = this;

    this.options = {
        toolbar: [{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] }, { name: 'insert', items: ['HorizontalRule'] }, { name: 'links', items: ['Link', 'Unlink'] }, '/', { name: 'styles', items: ['Font', 'FontSize'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }],
        skin: 'moono-lisa',
        language: CMSAuthService.getUser().language || 'pl',
        extraPlugins: 'link,justify,font,colorbutton,divarea,sharedspace,cmsplaceholder',
        removePlugins: 'sourcearea,save,elementspath,placeholder',
        removeButtons: '',
        entities: false,
        title: false,
        basicEntities: true,
        entities_additional: '',
        resize_enabled: false,
        pasteFromWordRemoveStyles: true,
        pasteFromWordRemoveFontStyles: true,
        enterMode: CKEDITOR.ENTER_P,
        fillEmptyBlocks: true,
        format_tags: 'p;h1;h2;h3',
        fontSize_defaultLabel: 'Auto'
    };

    return {
        getOptions: function getOptions() {
            return _angular2.default.copy(_this.options);
        }
    };
}]).name;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LineStyle = function (_ConfigParameter) {
    _inherits(LineStyle, _ConfigParameter);

    function LineStyle() {
        _classCallCheck(this, LineStyle);

        return _possibleConstructorReturn(this, (LineStyle.__proto__ || Object.getPrototypeOf(LineStyle)).call(this, 'style', 'selectionButtons', (0, _ConfigParameter2.gettext)('Style'), 'mainConfig', 'dotted', null, [{ value: 'solid', template: '<hr style="border-top: 2px solid; margin-top: 15px; width: 16px">' }, { value: 'dashed', template: '<hr style="border-top: 2px dashed; margin-top: 15px; width: 16px">' }, { value: 'dotted', template: '<hr style="border-top: 2px dotted; margin-top: 15px; width: 16px">' }]));
    }

    return LineStyle;
}(_ConfigParameter3.default);

exports.default = LineStyle;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LineSize = function (_ConfigParameter) {
    _inherits(LineSize, _ConfigParameter);

    function LineSize() {
        _classCallCheck(this, LineSize);

        return _possibleConstructorReturn(this, (LineSize.__proto__ || Object.getPrototypeOf(LineSize)).call(this, 'size', 'number', (0, _ConfigParameter2.gettext)('Line size'), 'mainConfig', { value: 2, unit: 'px' }, ['px']));
    }

    return LineSize;
}(_ConfigParameter3.default);

exports.default = LineSize;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacebookUrl = function (_ConfigParameter) {
    _inherits(FacebookUrl, _ConfigParameter);

    function FacebookUrl() {
        _classCallCheck(this, FacebookUrl);

        return _possibleConstructorReturn(this, (FacebookUrl.__proto__ || Object.getPrototypeOf(FacebookUrl)).call(this, 'facebookUrl', 'text', (0, _ConfigParameter2.gettext)('Facebook'), 'mainConfig', 'https://facebook.com/_profile_'));
    }

    return FacebookUrl;
}(_ConfigParameter3.default);

exports.default = FacebookUrl;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GooglePlusUrl = function (_ConfigParameter) {
    _inherits(GooglePlusUrl, _ConfigParameter);

    function GooglePlusUrl() {
        _classCallCheck(this, GooglePlusUrl);

        return _possibleConstructorReturn(this, (GooglePlusUrl.__proto__ || Object.getPrototypeOf(GooglePlusUrl)).call(this, 'googlePlusUrl', 'text', (0, _ConfigParameter2.gettext)('Google+'), 'mainConfig', 'https://plus.google.com/_profile_'));
    }

    return GooglePlusUrl;
}(_ConfigParameter3.default);

exports.default = GooglePlusUrl;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkedInUrl = function (_ConfigParameter) {
    _inherits(LinkedInUrl, _ConfigParameter);

    function LinkedInUrl() {
        _classCallCheck(this, LinkedInUrl);

        return _possibleConstructorReturn(this, (LinkedInUrl.__proto__ || Object.getPrototypeOf(LinkedInUrl)).call(this, 'linkedInUrl', 'text', (0, _ConfigParameter2.gettext)('LinkedIn'), 'mainConfig', 'https://linkedin.com/in/_profile_'));
    }

    return LinkedInUrl;
}(_ConfigParameter3.default);

exports.default = LinkedInUrl;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstagramUrl = function (_ConfigParameter) {
    _inherits(InstagramUrl, _ConfigParameter);

    function InstagramUrl() {
        _classCallCheck(this, InstagramUrl);

        return _possibleConstructorReturn(this, (InstagramUrl.__proto__ || Object.getPrototypeOf(InstagramUrl)).call(this, 'instagramUrl', 'text', (0, _ConfigParameter2.gettext)('Instagram'), 'mainConfig', 'https://instagram.com/_profile_'));
    }

    return InstagramUrl;
}(_ConfigParameter3.default);

exports.default = InstagramUrl;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwitterUrl = function (_ConfigParameter) {
    _inherits(TwitterUrl, _ConfigParameter);

    function TwitterUrl() {
        _classCallCheck(this, TwitterUrl);

        return _possibleConstructorReturn(this, (TwitterUrl.__proto__ || Object.getPrototypeOf(TwitterUrl)).call(this, 'twitterUrl', 'text', (0, _ConfigParameter2.gettext)('Twitter'), 'mainConfig', 'https://twitter.com/@_profile_'));
    }

    return TwitterUrl;
}(_ConfigParameter3.default);

exports.default = TwitterUrl;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PinterestUrl = function (_ConfigParameter) {
    _inherits(PinterestUrl, _ConfigParameter);

    function PinterestUrl() {
        _classCallCheck(this, PinterestUrl);

        return _possibleConstructorReturn(this, (PinterestUrl.__proto__ || Object.getPrototypeOf(PinterestUrl)).call(this, 'pinterestUrl', 'text', (0, _ConfigParameter2.gettext)('Pinterest'), 'mainConfig', 'https://www.pinterest.com/_profile_'));
    }

    return PinterestUrl;
}(_ConfigParameter3.default);

exports.default = PinterestUrl;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BorderRadius = function (_ConfigParameter) {
    _inherits(BorderRadius, _ConfigParameter);

    function BorderRadius() {
        _classCallCheck(this, BorderRadius);

        return _possibleConstructorReturn(this, (BorderRadius.__proto__ || Object.getPrototypeOf(BorderRadius)).call(this, 'borderRadius', 'number', (0, _ConfigParameter2.gettext)('Border radius'), 'borders', { value: 5, unit: 'px' }, ['px']));
    }

    return BorderRadius;
}(_ConfigParameter3.default);

exports.default = BorderRadius;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundButtonColor = function (_ConfigParameter) {
    _inherits(BackgroundButtonColor, _ConfigParameter);

    function BackgroundButtonColor() {
        _classCallCheck(this, BackgroundButtonColor);

        return _possibleConstructorReturn(this, (BackgroundButtonColor.__proto__ || Object.getPrototypeOf(BackgroundButtonColor)).call(this, 'backgroundButtonColor', 'color', (0, _ConfigParameter2.gettext)('Button color'), 'mainConfig', '#039be5'));
    }

    return BackgroundButtonColor;
}(_ConfigParameter3.default);

exports.default = BackgroundButtonColor;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonText = function (_ConfigParameter) {
    _inherits(ButtonText, _ConfigParameter);

    function ButtonText() {
        _classCallCheck(this, ButtonText);

        return _possibleConstructorReturn(this, (ButtonText.__proto__ || Object.getPrototypeOf(ButtonText)).call(this, 'text', 'text', (0, _ConfigParameter2.gettext)('Button text'), 'mainConfig', (0, _ConfigParameter2.gettext)('Button text')));
    }

    return ButtonText;
}(_ConfigParameter3.default);

exports.default = ButtonText;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SizeWidth = function (_ConfigParameter) {
    _inherits(SizeWidth, _ConfigParameter);

    function SizeWidth() {
        _classCallCheck(this, SizeWidth);

        return _possibleConstructorReturn(this, (SizeWidth.__proto__ || Object.getPrototypeOf(SizeWidth)).call(this, 'width', 'number', (0, _ConfigParameter2.gettext)('Width'), 'mainConfig', { value: 50, unit: '%' }, ['%', 'px']));
    }

    return SizeWidth;
}(_ConfigParameter3.default);

exports.default = SizeWidth;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MarginTop = __webpack_require__(1157);

var _MarginTop2 = _interopRequireDefault(_MarginTop);

var _MarginBottom = __webpack_require__(1158);

var _MarginBottom2 = _interopRequireDefault(_MarginBottom);

var _MarginLeft = __webpack_require__(1159);

var _MarginLeft2 = _interopRequireDefault(_MarginLeft);

var _MarginRight = __webpack_require__(1160);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Margins = function Margins() {
    var marginTopBottom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { value: 15, unit: 'px' };
    var marginLeftRight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { value: 30, unit: 'px' };

    _classCallCheck(this, Margins);

    var marginTop = new _MarginTop2.default();
    marginTop.setDefaultValue(_extends({}, marginTopBottom));
    var marginBottom = new _MarginBottom2.default();
    marginBottom.setDefaultValue(_extends({}, marginTopBottom));

    var marginLeft = new _MarginLeft2.default();
    marginLeft.setDefaultValue(_extends({}, marginLeftRight));
    var marginRight = new _MarginRight2.default();
    marginRight.setDefaultValue(_extends({}, marginLeftRight));

    return _extends({}, marginTop, marginBottom, marginLeft, marginRight);
};

exports.default = Margins;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UrlPart = function (_ConfigParameter) {
    _inherits(UrlPart, _ConfigParameter);

    function UrlPart() {
        _classCallCheck(this, UrlPart);

        return _possibleConstructorReturn(this, (UrlPart.__proto__ || Object.getPrototypeOf(UrlPart)).call(this, 'urlPart', 'text', (0, _ConfigParameter2.gettext)('Name of the page from facebook url'), 'mainConfig', 'ContenteApp'));
    }

    return UrlPart;
}(_ConfigParameter3.default);

exports.default = UrlPart;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Language = function (_ConfigParameter) {
    _inherits(Language, _ConfigParameter);

    function Language() {
        _classCallCheck(this, Language);

        return _possibleConstructorReturn(this, (Language.__proto__ || Object.getPrototypeOf(Language)).call(this, 'language', 'object-select', (0, _ConfigParameter2.gettext)('Language'), 'mainConfig', 'en_GB', null, [{ value: 'en_GB', label: 'English' }, { value: 'pl_PL', label: 'Polski' }], null, null, (0, _ConfigParameter2.gettext)('Language change will be visible only on generated page.')));
    }

    return Language;
}(_ConfigParameter3.default);

exports.default = Language;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwitterWidth = function (_ConfigParameter) {
    _inherits(TwitterWidth, _ConfigParameter);

    function TwitterWidth() {
        _classCallCheck(this, TwitterWidth);

        return _possibleConstructorReturn(this, (TwitterWidth.__proto__ || Object.getPrototypeOf(TwitterWidth)).call(this, 'width', 'number', (0, _ConfigParameter2.gettext)('Width'), 'mainConfig', { value: 300, unit: 'px' }, ['px']));
    }

    return TwitterWidth;
}(_ConfigParameter3.default);

exports.default = TwitterWidth;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineInputs = function (_ConfigParameter) {
    _inherits(InlineInputs, _ConfigParameter);

    function InlineInputs() {
        _classCallCheck(this, InlineInputs);

        return _possibleConstructorReturn(this, (InlineInputs.__proto__ || Object.getPrototypeOf(InlineInputs)).call(this, 'inlineInputs', 'checkbox', (0, _ConfigParameter2.gettext)('Show input inline'), 'mainConfig', false));
    }

    return InlineInputs;
}(_ConfigParameter3.default);

exports.default = InlineInputs;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(459);
module.exports = __webpack_require__(661);


/***/ }),
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(662);

var _ravenJs = __webpack_require__(663);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _angular = __webpack_require__(669);

var _angular2 = _interopRequireDefault(_angular);

var _angular3 = __webpack_require__(0);

var _angular4 = _interopRequireDefault(_angular3);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularAnimate = __webpack_require__(672);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularLocalStorage = __webpack_require__(94);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _angularHttpAuth = __webpack_require__(281);

var _angularHttpAuth2 = _interopRequireDefault(_angularHttpAuth);

var _xdebugInterceptor = __webpack_require__(198);

var _xdebugInterceptor2 = _interopRequireDefault(_xdebugInterceptor);

var _LoaderInterceptor = __webpack_require__(675);

var _LoaderInterceptor2 = _interopRequireDefault(_LoaderInterceptor);

var _ResponseInterceptor = __webpack_require__(676);

var _ResponseInterceptor2 = _interopRequireDefault(_ResponseInterceptor);

__webpack_require__(678);

__webpack_require__(685);

__webpack_require__(731);

var _blurAdminTheme = __webpack_require__(782);

var _blurAdminTheme2 = _interopRequireDefault(_blurAdminTheme);

var _cmsConfig = __webpack_require__(859);

var _cmsConfig2 = _interopRequireDefault(_cmsConfig);

var _cmsRun = __webpack_require__(860);

var _cmsRun2 = _interopRequireDefault(_cmsRun);

var _msgCenter = __webpack_require__(862);

var _msgCenter2 = _interopRequireDefault(_msgCenter);

var _Dashboard = __webpack_require__(870);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Logs = __webpack_require__(895);

var _Logs2 = _interopRequireDefault(_Logs);

var _Users = __webpack_require__(928);

var _Users2 = _interopRequireDefault(_Users);

var _ProductsPageModule = __webpack_require__(939);

var _ProductsPageModule2 = _interopRequireDefault(_ProductsPageModule);

var _MediaPageModule = __webpack_require__(947);

var _MediaPageModule2 = _interopRequireDefault(_MediaPageModule);

var _MailsPageModule = __webpack_require__(963);

var _MailsPageModule2 = _interopRequireDefault(_MailsPageModule);

var _PagesPageModule = __webpack_require__(994);

var _PagesPageModule2 = _interopRequireDefault(_PagesPageModule);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

var _AuthDialogService = __webpack_require__(1020);

var _AuthDialogService2 = _interopRequireDefault(_AuthDialogService);

var _LanguageManager = __webpack_require__(146);

var _LanguageManager2 = _interopRequireDefault(_LanguageManager);

var _LoaderDirective = __webpack_require__(1023);

var _LoaderDirective2 = _interopRequireDefault(_LoaderDirective);

var _TitlePageDirective = __webpack_require__(1025);

var _TitlePageDirective2 = _interopRequireDefault(_TitlePageDirective);

var _PageClassDirective = __webpack_require__(1026);

var _PageClassDirective2 = _interopRequireDefault(_PageClassDirective);

var _OnLoadDirective = __webpack_require__(1027);

var _OnLoadDirective2 = _interopRequireDefault(_OnLoadDirective);

var _ACLService = __webpack_require__(117);

var _ACLService2 = _interopRequireDefault(_ACLService);

var _ExportService = __webpack_require__(1028);

var _ExportService2 = _interopRequireDefault(_ExportService);

var _ExportMailTemplateService = __webpack_require__(1029);

var _ExportMailTemplateService2 = _interopRequireDefault(_ExportMailTemplateService);

var _ExportPageTemplateService = __webpack_require__(1030);

var _ExportPageTemplateService2 = _interopRequireDefault(_ExportPageTemplateService);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _CmsInputText = __webpack_require__(1031);

var _CmsInputText2 = _interopRequireDefault(_CmsInputText);

var _CmsInputVideo = __webpack_require__(1033);

var _CmsInputVideo2 = _interopRequireDefault(_CmsInputVideo);

var _CmsFontSelect = __webpack_require__(1035);

var _CmsFontSelect2 = _interopRequireDefault(_CmsFontSelect);

var _CmsInputTextarea = __webpack_require__(1037);

var _CmsInputTextarea2 = _interopRequireDefault(_CmsInputTextarea);

var _CmsInputSlug = __webpack_require__(1039);

var _CmsInputSlug2 = _interopRequireDefault(_CmsInputSlug);

var _CmsInputMoney = __webpack_require__(1041);

var _CmsInputMoney2 = _interopRequireDefault(_CmsInputMoney);

var _CmsInputNumber = __webpack_require__(1043);

var _CmsInputNumber2 = _interopRequireDefault(_CmsInputNumber);

var _CmsInputPassword = __webpack_require__(234);

var _CmsInputPassword2 = _interopRequireDefault(_CmsInputPassword);

var _CmsInputEmail = __webpack_require__(236);

var _CmsInputEmail2 = _interopRequireDefault(_CmsInputEmail);

var _CmsInputCheckbox = __webpack_require__(1046);

var _CmsInputCheckbox2 = _interopRequireDefault(_CmsInputCheckbox);

var _CmsInputSelect = __webpack_require__(1048);

var _CmsInputSelect2 = _interopRequireDefault(_CmsInputSelect);

var _CmsInputObjectSelect = __webpack_require__(1050);

var _CmsInputObjectSelect2 = _interopRequireDefault(_CmsInputObjectSelect);

var _CmsInputAlign = __webpack_require__(1052);

var _CmsInputAlign2 = _interopRequireDefault(_CmsInputAlign);

var _CmsInputSelectionButtons = __webpack_require__(1054);

var _CmsInputSelectionButtons2 = _interopRequireDefault(_CmsInputSelectionButtons);

var _CmsInputDate = __webpack_require__(1056);

var _CmsInputDate2 = _interopRequireDefault(_CmsInputDate);

var _CmsInputMedia = __webpack_require__(1063);

var _CmsInputMedia2 = _interopRequireDefault(_CmsInputMedia);

var _CmsInputColor = __webpack_require__(1065);

var _CmsInputColor2 = _interopRequireDefault(_CmsInputColor);

var _CmsInputHtmlEditor = __webpack_require__(1067);

var _CmsInputHtmlEditor2 = _interopRequireDefault(_CmsInputHtmlEditor);

var _CmsInputOptions = __webpack_require__(1071);

var _CmsInputOptions2 = _interopRequireDefault(_CmsInputOptions);

var _CmsEditForm = __webpack_require__(1073);

var _CmsEditForm2 = _interopRequireDefault(_CmsEditForm);

var _CmsInputColumns = __webpack_require__(1076);

var _CmsInputColumns2 = _interopRequireDefault(_CmsInputColumns);

var _CmsInputMenu = __webpack_require__(1078);

var _CmsInputMenu2 = _interopRequireDefault(_CmsInputMenu);

var _CmsButtonLink = __webpack_require__(1081);

var _CmsButtonLink2 = _interopRequireDefault(_CmsButtonLink);

var _CmsInputMapAddress = __webpack_require__(1083);

var _CmsInputMapAddress2 = _interopRequireDefault(_CmsInputMapAddress);

var _HasMediaTile = __webpack_require__(1085);

var _HasMediaTile2 = _interopRequireDefault(_HasMediaTile);

var _SelectMedia = __webpack_require__(1087);

var _SelectMedia2 = _interopRequireDefault(_SelectMedia);

var _changePassword = __webpack_require__(1089);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

var _UniqueIdGenerator = __webpack_require__(1091);

var _UniqueIdGenerator2 = _interopRequireDefault(_UniqueIdGenerator);

var _saveWarningDialog = __webpack_require__(1092);

var _saveWarningDialog2 = _interopRequireDefault(_saveWarningDialog);

var _saveWarningIntervalDialog = __webpack_require__(1094);

var _saveWarningIntervalDialog2 = _interopRequireDefault(_saveWarningIntervalDialog);

var _AddPageDialog = __webpack_require__(1096);

var _AddPageDialog2 = _interopRequireDefault(_AddPageDialog);

var _ExportAsTemplateDialog = __webpack_require__(1098);

var _ExportAsTemplateDialog2 = _interopRequireDefault(_ExportAsTemplateDialog);

var _Workspace = __webpack_require__(1101);

var _Workspace2 = _interopRequireDefault(_Workspace);

var _Toolbar = __webpack_require__(1107);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _SectionsLibrary = __webpack_require__(1109);

var _SectionsLibrary2 = _interopRequireDefault(_SectionsLibrary);

var _Text = __webpack_require__(1113);

var _Text2 = _interopRequireDefault(_Text);

var _Divider = __webpack_require__(1121);

var _Divider2 = _interopRequireDefault(_Divider);

var _Image = __webpack_require__(1124);

var _Image2 = _interopRequireDefault(_Image);

var _Social = __webpack_require__(1126);

var _Social2 = _interopRequireDefault(_Social);

var _Button = __webpack_require__(1129);

var _Button2 = _interopRequireDefault(_Button);

var _ImageText = __webpack_require__(1131);

var _ImageText2 = _interopRequireDefault(_ImageText);

var _EditorTextarea = __webpack_require__(439);

var _EditorTextarea2 = _interopRequireDefault(_EditorTextarea);

var _EditorInline = __webpack_require__(1134);

var _EditorInline2 = _interopRequireDefault(_EditorInline);

var _Text3 = __webpack_require__(1138);

var _Text4 = _interopRequireDefault(_Text3);

var _Html = __webpack_require__(1141);

var _Html2 = _interopRequireDefault(_Html);

var _Divider3 = __webpack_require__(1145);

var _Divider4 = _interopRequireDefault(_Divider3);

var _Image3 = __webpack_require__(1148);

var _Image4 = _interopRequireDefault(_Image3);

var _Social3 = __webpack_require__(1153);

var _Social4 = _interopRequireDefault(_Social3);

var _Button3 = __webpack_require__(1156);

var _Button4 = _interopRequireDefault(_Button3);

var _Form = __webpack_require__(1166);

var _Form2 = _interopRequireDefault(_Form);

var _Section = __webpack_require__(1180);

var _Section2 = _interopRequireDefault(_Section);

var _Menu = __webpack_require__(1194);

var _Menu2 = _interopRequireDefault(_Menu);

var _Map = __webpack_require__(1206);

var _Map2 = _interopRequireDefault(_Map);

var _Video = __webpack_require__(1210);

var _Video2 = _interopRequireDefault(_Video);

var _FacebookFeed = __webpack_require__(1214);

var _FacebookFeed2 = _interopRequireDefault(_FacebookFeed);

var _TwitterFeed = __webpack_require__(1221);

var _TwitterFeed2 = _interopRequireDefault(_TwitterFeed);

var _FormEditor = __webpack_require__(1224);

var _FormEditor2 = _interopRequireDefault(_FormEditor);

var _LogFeed = __webpack_require__(1252);

var _LogFeed2 = _interopRequireDefault(_LogFeed);

var _SaveWarning = __webpack_require__(1254);

var _SaveWarning2 = _interopRequireDefault(_SaveWarning);

var _ImageUrlFilter = __webpack_require__(1255);

var _ImageUrlFilter2 = _interopRequireDefault(_ImageUrlFilter);

var _MediaPlaceholder = __webpack_require__(242);

var _MediaPlaceholder2 = _interopRequireDefault(_MediaPlaceholder);

var _HtmlTrustedFilter = __webpack_require__(1256);

var _HtmlTrustedFilter2 = _interopRequireDefault(_HtmlTrustedFilter);

var _NumberWithUnitFilter = __webpack_require__(1257);

var _NumberWithUnitFilter2 = _interopRequireDefault(_NumberWithUnitFilter);

var _ScrollLockDirective = __webpack_require__(1258);

var _ScrollLockDirective2 = _interopRequireDefault(_ScrollLockDirective);

var _pieChart = __webpack_require__(405);

var _pieChart2 = _interopRequireDefault(_pieChart);

var _linearChart = __webpack_require__(1259);

var _linearChart2 = _interopRequireDefault(_linearChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// charts
/**
 * Root namespace for cms modules
 * @namespace cms
 */
_ravenJs2.default.config('https://af42a9f9864b42f7902469e8388b8ac8@sentry.cdwv.pl/77', {
    shouldSendCallback: function shouldSendCallback() {
        return !{"API_URL":"https://new-cms-contente-backend.dev.cdwv.pl/api","API_PUBLIC":"https://new-cms-contente-backend.dev.cdwv.pl","PUBLIC_SITE_URL":"http://__SITE_SLUG__.contente.net","DEV":false,"ROLES":["ROLE_USER","ROLE_ADMIN"],"UNSPLASH_ACCESS_KEY":"475919daaf6f38937bc3daf4c47a3d8fb0572e2ecc22b5097fb5745a39b4f882","UNSPLASH_SECRET_KEY":"cdd5aa0ce44dc3e0c6df71229df22c322dd959ffbcbcc1020b4e5b197a667e16","NOUN_PROJECT_KEY":"155322dd33d14129b816bd42d65f3512","NOUN_PROJECT_SECRET":"9d12fb2fc9164346bcb908702d8445ab"}.DEV;
    } }).addPlugin(_angular2.default, _angular4.default).install();

/**
 * Main module for our cms. Most of the time this will be entry point for the angular application.
 * Currently Main module is responsible for "global" configuration and for loading main pages and dependencies.
 *
 * @namespace cms.MainModule
 */
var MainModule = _angular4.default.module('cms', [_Dashboard2.default, _SaveWarning2.default, _Logs2.default, _MediaPageModule2.default, _Users2.default, _MailsPageModule2.default, _ProductsPageModule2.default, _PagesPageModule2.default, _angularAnimate2.default, _angularLocalStorage2.default, _ConfigModule2.default, _CMSAuthService2.default, _LanguageManager2.default, _AuthDialogService2.default, _LoaderDirective2.default, _ExportService2.default, _ExportMailTemplateService2.default, _ExportPageTemplateService2.default, _angularHttpAuth2.default, _xdebugInterceptor2.default, _LoaderInterceptor2.default, _ResponseInterceptor2.default, _blurAdminTheme2.default, _msgCenter2.default, _angularGettext2.default, _EditorTextarea2.default, _EditorInline2.default, _CmsFontSelect2.default, _CmsInputText2.default, _CmsInputTextarea2.default, _CmsInputSlug2.default, _CmsInputMoney2.default, _CmsInputNumber2.default, _CmsInputPassword2.default, _CmsInputEmail2.default, _CmsInputCheckbox2.default, _CmsInputSelect2.default, _CmsInputObjectSelect2.default, _CmsInputSelectionButtons2.default, _CmsInputVideo2.default, _CmsInputAlign2.default, _CmsInputDate2.default, _CmsInputMedia2.default, _CmsInputHtmlEditor2.default, _CmsInputColor2.default, _CmsInputOptions2.default, _CmsEditForm2.default, _CmsInputColumns2.default, _CmsInputMenu2.default, _CmsButtonLink2.default, _CmsInputMapAddress2.default, _changePassword2.default, _HasMediaTile2.default, _deleteElement2.default, _UniqueIdGenerator2.default, _saveWarningDialog2.default, _saveWarningIntervalDialog2.default, _AddPageDialog2.default, _ExportAsTemplateDialog2.default, _SelectMedia2.default, _TitlePageDirective2.default, _PageClassDirective2.default, _ACLService2.default, _Workspace2.default, _Toolbar2.default, _SectionsLibrary2.default, _Text2.default, _Divider2.default, _Image2.default, _Social2.default, _Button2.default, _ImageText2.default, _Text4.default, _Divider4.default, _Image4.default, _Social4.default, _Button4.default, _Form2.default, _Section2.default, _Menu2.default, _Html2.default, _Map2.default, _Video2.default, _FacebookFeed2.default, _TwitterFeed2.default, _FormEditor2.default, _OnLoadDirective2.default, _ImageUrlFilter2.default, _MediaPlaceholder2.default, _HtmlTrustedFilter2.default, _NumberWithUnitFilter2.default, _LogFeed2.default, _ScrollLockDirective2.default, _pieChart2.default, _linearChart2.default, _angular2.default.moduleName]).config(_cmsConfig2.default).run(_cmsRun2.default);

exports.default = MainModule.name;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(280);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.jQuery = _jquery2.default; /**
                                   * globalize jquery for legacy modules and angular
                                   */

window.$ = _jquery2.default;

/***/ }),
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _LoaderManager = __webpack_require__(282);

var _LoaderManager2 = _interopRequireDefault(_LoaderManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoaderInterceptor = function LoaderInterceptor(CONFIG, LoaderManager, $q) {
    /** @ngInclude */

    var pendingRequests = 0;

    var addPending = function addPending() {
        pendingRequests++;
        LoaderManager.setActive('global');
    };

    var removePending = function removePending() {
        pendingRequests -= 1;
        if (pendingRequests === 0) {
            LoaderManager.setActive('global', false);
        }
    };

    return {
        request: function request(config) {
            addPending();
            return config;
        },
        response: function response(_response) {
            removePending();
            return _response;
        },
        responseError: function responseError(rejection) {
            removePending();
            return $q.reject(rejection);
        }

    };
};

LoaderInterceptor.$inject = ['CONFIG', 'LoaderManager', '$q'];
exports.default = _angular2.default.module('cms.loader.interceptor', [_ConfigModule2.default, _LoaderManager2.default]).factory('LoaderInterceptor', LoaderInterceptor).name;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponseInterceptor = function ResponseInterceptor($q, $injector) {
    /** @ngInclude */

    return {
        responseError: function responseError(response) {
            var toastr = $injector.get('toastr');
            var gettextCatalog = $injector.get('gettextCatalog');
            switch (response.status) {
                case 401:
                    toastr.error(gettextCatalog.getString('You are not logged in!'), gettextCatalog.getString('Authentication Error'));
                    break;
                case 403:
                    toastr.error(gettextCatalog.getString('You are not permitted to view this page.'), gettextCatalog.getString('Permission Error'));
                    break;
                case 406:
                    toastr.error(gettextCatalog.getString('Unsplash Rate Limit Exceeded. Try again later.'), gettextCatalog.getString('Unsplash error'));
                    break;
                case 500:
                    toastr.error(gettextCatalog.getString('There was a problem processing your request. Try again later.'), gettextCatalog.getString('System error'));
                    break;
            }

            return $q.reject(response);
        }
    };
};

ResponseInterceptor.$inject = ['$q', '$injector'];
exports.default = _angular2.default.module('cms.response.interceptor', [_angularToastr2.default, _angularGettext2.default]).factory('ResponseInterceptor', ResponseInterceptor).name;

/***/ }),
/* 677 */,
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(686);

__webpack_require__(35);

__webpack_require__(687);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(732);

__webpack_require__(733);

__webpack_require__(734);

__webpack_require__(735);

__webpack_require__(736);

__webpack_require__(737);

__webpack_require__(738);

__webpack_require__(781);

/***/ }),
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(783);

__webpack_require__(784);

__webpack_require__(785);

__webpack_require__(786);

__webpack_require__(787);

__webpack_require__(788);

__webpack_require__(789);

__webpack_require__(790);

__webpack_require__(791);

__webpack_require__(792);

__webpack_require__(794);

__webpack_require__(795);

__webpack_require__(796);

__webpack_require__(797);

__webpack_require__(798);

__webpack_require__(799);

__webpack_require__(801);

__webpack_require__(802);

__webpack_require__(803);

__webpack_require__(804);

__webpack_require__(806);

__webpack_require__(807);

__webpack_require__(809);

__webpack_require__(811);

__webpack_require__(813);

__webpack_require__(815);

__webpack_require__(817);

__webpack_require__(818);

__webpack_require__(819);

__webpack_require__(820);

__webpack_require__(821);

__webpack_require__(822);

__webpack_require__(823);

__webpack_require__(824);

__webpack_require__(825);

__webpack_require__(826);

__webpack_require__(827);

__webpack_require__(828);

__webpack_require__(829);

__webpack_require__(831);

__webpack_require__(833);

__webpack_require__(834);

__webpack_require__(835);

__webpack_require__(836);

var _backTop = __webpack_require__(837);

var _backTop2 = _interopRequireDefault(_backTop);

var _blurAdminLoaderDecorator = __webpack_require__(838);

var _blurAdminLoaderDecorator2 = _interopRequireDefault(_blurAdminLoaderDecorator);

var _baSidebarDecorator = __webpack_require__(840);

var _baSidebarDecorator2 = _interopRequireDefault(_baSidebarDecorator);

var _pageTopDirectiveDecorator = __webpack_require__(843);

var _pageTopDirectiveDecorator2 = _interopRequireDefault(_pageTopDirectiveDecorator);

var _contentTopDecorator = __webpack_require__(857);

var _contentTopDecorator2 = _interopRequireDefault(_contentTopDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Since we don't want to use all external libraries included in BlurAdmin, we need to strip its dependency
 * injection list. `stripDependency` Does exaclty that. Given name of angular module it will try to remove it
 * from "BlurAdmin.theme" moudule dependency list.
 *
 * @function
 * @memberOf cms.BlurAdmin
 * @param name
 */


//import 'blur_admin/src/app/theme/directives/animatedChange';
function stripDependency(name) {
  var requires = angular.module("BlurAdmin.theme").requires;
  var index = requires.indexOf(name);

  if (index !== -1) {
    requires.splice(index, 1);
  }
}

//import 'blur_admin/src/app/theme/components/msgCenter/msgCenter.directive';
//import 'blur_admin/src/app/theme/components/msgCenter/MsgCenterCtrl';

stripDependency('angular-chartist');
stripDependency('textAngular');

/**
 * Now our decorators and overrides, with proper importsw
 */

/**
 * Main module for BlurAdmin related modules. Most of the time this will contain decorators for BlurAdmin
 * providers.
 *
 * @namespace cms.BlurAdmin
 */

exports.default = angular.module('cms.blur-admin', [angular.module('BlurAdmin.theme').name, _backTop2.default, _baSidebarDecorator2.default, _pageTopDirectiveDecorator2.default, _contentTopDecorator2.default, _blurAdminLoaderDecorator2.default]).name;

/***/ }),
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(280);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * backTopDecorator decorates back to top directive from BlurAdmin.
 * It serves more educational purpose than practical (yes, it would be easier to create new directive instad).
 * Note that when decorating directive you are provided with an array of directive definitions, because there may
 * be more than one directive with the same name.
 *
 * @memberof BlurAdmin
 * @param {Array} $delegate all definitions matching "backTopDirective"
 * @param {Window} $window
 * @returns {*} Overrided directive definitions
 */
/** @ngInject */
var backTopDecorator = function backTopDecorator($delegate, $window) {
    $delegate.forEach(function (directiveDeffinition) {
        directiveDeffinition.controller = function () {
            var $backTop = (0, _jquery2.default)('#backTop');
            $backTop.click(function () {
                (0, _jquery2.default)("html, body").stop().animate({ scrollTop: 0 }, 500);
            }).css('position', 'fixed').addClass('animated').css('animation-duration', '0.25s');
            _angular2.default.element($window).on('scroll', function (e) {
                if (_angular2.default.element($window).scrollTop() > $window.innerHeight / 2) {
                    $backTop.removeClass('fadeOutRight').addClass('fadeInRight').css('display', 'block');
                } else {
                    $backTop.removeClass('fadeInRight').addClass('fadeOutRight');
                }
            });
        };
    });
    return $delegate;
};

backTopDecorator.$inject = ['$delegate', '$window'];
backTopDecorator.$inject = ['$delegate', '$window'];
var backTopDecoratorConfig = function backTopDecoratorConfig($provide) {
    /** @ngInject */

    $provide.decorator('backTopDirective', backTopDecorator);
};

backTopDecoratorConfig.$inject = ['$provide'];
exports.default = _angular2.default.module('cms.blur-admin.backTopDecorator', ['BlurAdmin.theme.components']).config(backTopDecoratorConfig).name;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var interceptedImages = {
    '/images/blur_admin/blur-bg.jpg': __webpack_require__(683),
    '/images/blur_admin/blur-bg-blurred.jpg': __webpack_require__(684),
    '/images/blur_admin/blur-bg-mobile.jpg': __webpack_require__(839)
};

var preloaderDecorator = function preloaderDecorator($delegate) {
    /** @ngInject */

    var coreLoadImg = $delegate.loadImg;
    $delegate.loadImg = function (path) {
        if (interceptedImages[path]) coreLoadImg(interceptedImages[path]);else coreLoadImg(path);
    };
    return $delegate;
};

preloaderDecorator.$inject = ['$delegate'];
var preloaderConfig = function preloaderConfig($provide) {
    /** @ngInject */

    $provide.decorator('preloader', preloaderDecorator);
};

preloaderConfig.$inject = ['$provide'];
exports.default = _angular2.default.module('cms.blur-admin.preloaderDecorator', [_angular2.default.module('BlurAdmin.theme').name]).config(preloaderConfig).name;

/***/ }),
/* 839 */,
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _baSidebarServiceDecorator = __webpack_require__(841);

var _baSidebarServiceDecorator2 = _interopRequireDefault(_baSidebarServiceDecorator);

var _baSidebarDirectiveDecorator = __webpack_require__(842);

var _baSidebarDirectiveDecorator2 = _interopRequireDefault(_baSidebarDirectiveDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baSidebarServiceConfig = function baSidebarServiceConfig($provide) {
    /** @ngInject */

    $provide.decorator('baSidebarService', _baSidebarServiceDecorator2.default);
    $provide.decorator('baSidebarDirective', _baSidebarDirectiveDecorator2.default);
};

baSidebarServiceConfig.$inject = ['$provide'];
exports.default = _angular2.default.module('cms.blur-admin.baSidebarDecorator', [_angular2.default.module('BlurAdmin.theme').name, _angularGettext2.default]).config(baSidebarServiceConfig).name;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
baSidebarServiceDecorator.$inject = ["$delegate", "gettextCatalog", "$state", "CMSAuthService"];
/** @ngInject */
function baSidebarServiceDecorator($delegate, gettextCatalog, $state, CMSAuthService) {
    var oldGedMenu = $delegate.getMenuItems;
    var oldShouldMenuBeCollapsed = $delegate.shouldMenuBeCollapsed;
    var lockAutoCollapse = false;

    function translateTitles(menuItems) {
        menuItems.forEach(function (item) {

            if (item.title) {
                item.title = gettextCatalog.getString(item.title);
            }

            if (item.subMenu) {
                translateTitles(item.subMenu);
            }
        });
    }

    function isAllowed(userRoles, stateRoles) {
        if (!stateRoles) {
            return true;
        }

        var isAllowed = false;
        userRoles.forEach(function (userRole) {
            if (stateRoles.indexOf(userRole) !== -1) {
                isAllowed = true;
            }
        });
        return isAllowed;
    }

    $delegate.getMenuItems = function () {
        var menuItems = oldGedMenu.apply($delegate, arguments);
        var filteredMenuItems = [];
        var user = CMSAuthService.getUser();

        menuItems.forEach(function (item) {
            var state = $state.get(item.name);

            if (!state) {
                /* Menu items like developer zone, manually added (static states) */
                filteredMenuItems.push(item);
            }

            if (state && isAllowed(user.roles, state.sidebarMeta.allow)) {
                filteredMenuItems.push(item);
            }
        });

        translateTitles(filteredMenuItems);

        return filteredMenuItems;
    };

    $delegate.lockAutoCollapse = function (lock) {
        lockAutoCollapse = lock;
    };

    $delegate.shouldMenuBeCollapsed = function () {
        if (lockAutoCollapse) {
            return true;
        }
        return oldShouldMenuBeCollapsed();
    };

    return $delegate;
}

exports.default = baSidebarServiceDecorator;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
baSidebarDirectiveDecorator.$inject = ['$delegate', 'baSidebarService'];
/**
 * This method will override ba-sidebar directive to reload menu items each time language changes.
 * @param $delegate
 * @param baSidebarService
 * @returns {*}
 */
/** @ngInject */
function baSidebarDirectiveDecorator($delegate, baSidebarService) {

    $delegate.forEach(function (sidebarDirectiveDelegate) {
        if (sidebarDirectiveDelegate.link) {
            var oldLink = sidebarDirectiveDelegate.link;
            sidebarDirectiveDelegate.link = function (scope, el) {
                oldLink.apply(this, arguments);

                scope.$on('gettextLanguageChanged', function () {
                    scope.menuItems = baSidebarService.getMenuItems();
                });
            };

            sidebarDirectiveDelegate.compile = function () {
                return sidebarDirectiveDelegate.link;
            };

            sidebarDirectiveDelegate.template = sidebarDirectiveDelegate.template.replace('ng-repeat="item in ::menuItems"', 'ng-repeat="item in menuItems"');
        }
    });

    return $delegate;
}

exports.default = baSidebarDirectiveDecorator;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _LanguageChanger = __webpack_require__(844);

var _LanguageChanger2 = _interopRequireDefault(_LanguageChanger);

var _AvatarFilter = __webpack_require__(849);

var _AvatarFilter2 = _interopRequireDefault(_AvatarFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @ngInject */
var baPageTopDirectiveDecorator = function baPageTopDirectiveDecorator($delegate, CMSAuthService, CONFIG, $window, ACLService) {

    $delegate.forEach(function (directiveDefinition) {
        directiveDefinition.template = __webpack_require__(856);
        directiveDefinition.controllerAs = 'vm';
        directiveDefinition.controller = function () {

            var vm = {};
            vm.logout = function () {
                CMSAuthService.logout(function () {
                    window.location.href = "/login.html";
                });
            };
            vm.user = CMSAuthService.getUser();

            vm.matchRoles = ACLService.matchRoles('ROLE_USER');

            vm.reloadRoute = function () {
                $window.location.reload();
            };

            return vm;
        };
    });

    return $delegate;
};

baPageTopDirectiveDecorator.$inject = ['$delegate', 'CMSAuthService', 'CONFIG', '$window', 'ACLService'];
baPageTopDirectiveDecorator.$inject = ['$delegate', 'CMSAuthService', 'CONFIG', '$window', 'ACLService'];
var baPageTopDirectiveConfig = function baPageTopDirectiveConfig($provide) {
    /** @ngInject */
    $provide.decorator('pageTopDirective', baPageTopDirectiveDecorator);
};

baPageTopDirectiveConfig.$inject = ['$provide'];
/**
 * PageTop module based on pageTop from blur admin
 *
 * @namespace cms.blur-admin.pageTopDecorator
 *
 * @see {@link /node_modules/blur_admin/src/app/theme/components/pageTop}
 */
exports.default = _angular2.default.module('cms.blur-admin.baPageTopDirectiveDecorator', [_angular2.default.module('BlurAdmin.theme').name, _CMSAuthService2.default, _ConfigModule2.default, _LanguageChanger2.default, _AvatarFilter2.default]).config(baPageTopDirectiveConfig).name;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _LanguageManager = __webpack_require__(146);

var _LanguageManager2 = _interopRequireDefault(_LanguageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.language.changer', [_LanguageManager2.default]).component('cmsLanguageChanger', {
    template: __webpack_require__(846),
    controller: ['languageManager', '$rootScope', function controller(languageManager, $rootScope) {

        this.setLanguage = function (language) {
            languageManager.setLanguage(language);
            $rootScope.$broadcast('language-changed', { newLanguage: language });
        };

        this.getCurrentLanguage = function () {
            return languageManager.getLanguage();
        };
    }]
}).name;

/***/ }),
/* 845 */,
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"language-changer\">\n    <a href ng-click=\"$ctrl.setLanguage('pl')\">\n        <img class=\"language-changer__icon\"\n             ng-class=\"{'language-changer__icon--selected': $ctrl.getCurrentLanguage() === 'pl'}\"\n             src=\"" + __webpack_require__(847) + "\" alt=\"pl\">\n    </a>\n    <a href ng-click=\"$ctrl.setLanguage('en')\">\n        <img ng-class=\"{'language-changer__icon--selected': $ctrl.getCurrentLanguage() === 'en'}\"\n             class=\"language-changer__icon\"\n             src=\"" + __webpack_require__(848) + "\" alt=\"en\">\n    </a>\n</div>";

/***/ }),
/* 847 */,
/* 848 */,
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _gravatar = __webpack_require__(850);

var _gravatar2 = _interopRequireDefault(_gravatar);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

GetAvatar.$inject = ['CONFIG'];
exports.default = _angular2.default.module('cms.filter.avatar', [_ConfigModule2.default]).filter('avatar', GetAvatar).name;


function GetAvatar(CONFIG) {
    if (CONFIG.API_PUBLIC.indexOf('localhost') > -1) {
        return function (user) {
            var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;

            return CONFIG.API_PUBLIC + '/avatar/' + user.id + '.png';
        };
    }
    return function (user) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;

        return _gravatar2.default.url(user.email, {
            s: size,
            r: 'pg',
            d: CONFIG.API_PUBLIC + '/avatar/' + user.id + '.png'
        });
    };
}

/***/ }),
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{'scrolled': scrolled}\">\n\n    <a href class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu></a>\n\n    <a ui-sref=\"dashboard\" class=\"al-logo clearfix\">\n        <img class=\"al-logo-title\" src=\"" + __webpack_require__(124) + "\" alt=\"logo\">\n    </a>\n\n    <div class=\"user-profile clearfix\">\n\n        <cms-language-changer class=\"pull-right element-hidden\"></cms-language-changer>\n\n        <div class=\"al-user-profile\" uib-dropdown>\n            <a uib-dropdown-toggle class=\"profile-toggle-link\">\n                <img ng-src=\"{{vm.user | avatar}}\" alt=\"logo\">\n            </a>\n            <ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu>\n                <li><em class=\"dropdown-arr\"></em></li>\n                <li>\n                    <a href=\"#\" ng-click=\"vm.logout()\">\n                        <em class=\"fa fa-power-off\"></em> {{'Sign out'|translate}}\n                    </a>\n                    <a href=\"/login.html#!/changePasswordRequest\" ng-click=\"vm.reloadRoute()\" ng-show=\"vm.matchRoles\">\n                        <em class=\"fa fa-key\"></em> {{'Change password'|translate}}\n                    </a>\n                </li>\n            </ul>\n\n        </div>\n    </div>\n\n</div>";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * contentTopDecorator decorates content-top directive from BlurAdmin.
 * The reason behind the change is to provide template with translations to the state titles.
 *
 * @memberof BlurAdmin
 * @param {Array} $delegate all definitions matching "contentTopDirective"
 * @returns {*} Overrided directive definitions
 */
/** @ngInject */
var contentTopDecorator = function backTopDecorator($delegate) {
    $delegate.forEach(function (directiveDeffinition) {
        directiveDeffinition.template = __webpack_require__(858);

        /** @ngInject */
        directiveDeffinition.controller = function ($scope, $state, $stateParams) {

            $scope.pageTitle = function () {
                return $stateParams.pageTitle;
            };

            $scope.showTopBar = function () {
                var current = $state.current;
                if (current.breadcrumbsMeta && typeof current.breadcrumbsMeta.topBar !== 'undefined') {
                    return current.breadcrumbsMeta.topBar;
                }
                return true;
            };

            /**
             * Go to state - use returnState $stateParams to include eg. grid sorting
             * @param stateName
             */
            $scope.goToState = function (stateName) {

                if ($stateParams.returnState) {
                    $state.go($stateParams.returnState.name, $stateParams.returnState.params);
                } else {
                    $state.go(stateName, {});
                }
            };

            $scope.$watch(function () {
                var current = $state.current;
                if (current.breadcrumbsMeta && current.breadcrumbsMeta.parentState) {
                    $scope.parentState = $state.get(current.breadcrumbsMeta.parentState);
                } else {
                    $scope.parentState = null;
                }
            });
        };
        directiveDeffinition.controller.$inject = ['$scope', '$state', '$stateParams'];
    });
    return $delegate;
};

contentTopDecorator.$inject = ['$delegate'];
contentTopDecorator.$inject = ['$delegate'];
var contentTopDecoratorConfig = function contentTopDecoratorConfig($provide) {
    /** @ngInject */

    $provide.decorator('contentTopDirective', contentTopDecorator);
};

contentTopDecoratorConfig.$inject = ['$provide'];
exports.default = _angular2.default.module('cms.blur-admin.content-top', ['BlurAdmin.theme.components', _angularGettext2.default]).config(contentTopDecoratorConfig).name;

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "<div class=\"content-top clearfix\" ng-show=\"showTopBar()\">\n    <h1 class=\"al-title\">{{ activePageTitle | translate }} {{ pageTitle() }}</h1>\n\n    <ul class=\"breadcrumb al-breadcrumb\">\n        <li>\n            <a href=\"#\" ng-click=\"goToState('dashboard')\">{{'Home' | translate:'Homepage/Dashboard'}}</a>\n        </li>\n\n        <li ng-show=\"parentState\">\n            <a href=\"#\" ng-click=\"goToState(parentState.name)\">{{ parentState.title | translate }}</a>\n        </li>\n\n        <li>\n            {{ activePageTitle | translate }}\n        </li>\n    </ul>\n</div>";

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = appConfig;
appConfig.$inject = ['baSidebarServiceProvider', 'baConfigProvider', 'layoutPaths', 'gettext', '$locationProvider', 'localStorageServiceProvider', '$animateProvider', '$httpProvider'];
/**
 * Config method for main CMS module. We'll start configuration using providers.
 *
 * @function appConfig
 * @memberOf cms.MainModule
 */
/** @ngInject */
function appConfig(baSidebarServiceProvider, baConfigProvider, layoutPaths, gettext, $locationProvider, localStorageServiceProvider, $animateProvider, $httpProvider) {

    $locationProvider.html5Mode(true);

    $httpProvider.interceptors.push('XdebugInterceptor');
    $httpProvider.interceptors.push('LoaderInterceptor');
    $httpProvider.interceptors.push('ResponseInterceptor');

    localStorageServiceProvider.setStorageType('localStorage');
    localStorageServiceProvider.setPrefix('cms');
    $animateProvider.customFilter(function (node, event, options) {
        if (!!node.attributes.toast) return true;

        return (/\banimated\b|ui-select-/.test(node.className)
        );
    });

    var IMAGES_ROOT = '/images/blur_admin/';
    layoutPaths.images.root = IMAGES_ROOT;
    layoutPaths.images.profile = IMAGES_ROOT + 'app/profile/';
    //baConfigProvider.changeTheme({blur: true});
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cmsRun;

var _pl_PL = __webpack_require__(861);

var _pl_PL2 = _interopRequireDefault(_pl_PL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cmsRun.$inject = ['gettextCatalog', 'CMSAuthService', 'ACLService', '$http', '$rootScope', 'AuthDialogService', 'languageManager', 'PasswordChangeService', 'toastrConfig', '$transitions', 'SaveWarning', 'toastr'];

/**
 * Run method for main CMS module. Here we'll continue configuration using services.
 *
 * @function cmsRun
 * @memberOf cms.MainModule
 */
/** @ngInject */
function cmsRun(gettextCatalog, CMSAuthService, ACLService, $http, $rootScope, AuthDialogService, languageManager, PasswordChangeService, toastrConfig, $transitions, SaveWarning, toastr) {

    gettextCatalog.setStrings("pl", _pl_PL2.default.pl_PL);
    gettextCatalog.setCurrentLanguage(languageManager.getLanguage());

    angular.extend(toastrConfig, {
        preventOpenDuplicates: true,
        timeOut: 3000
    });
    // Check auth token on app load
    if (CMSAuthService.getToken() && typeof CMSAuthService.getInvalidateLogin() !== 'undefined') {
        CMSAuthService.setHttpAuth();
    } else {
        window.location.href = "/login.html";
    }

    // Check auth token on location change
    $rootScope.$on('$locationChangeStart', function () {
        if (!CMSAuthService.getToken()) {
            window.location.href = "/login.html";
        }
    });

    // Check if first login
    $rootScope.$on('$locationChangeStart', function () {
        if (CMSAuthService.getUser() && !CMSAuthService.getUser().resetPasswordAt) {
            PasswordChangeService.open();
        }
    });

    // Event from angular-http-auth
    $rootScope.$on('event:auth-loginRequired', function () {
        AuthDialogService.open();
    });

    var criteriaAuthorizationState = {
        entering: function entering(state) {
            return state.data && state.data.requiresAuth;
        }
    };

    $transitions.onStart(criteriaAuthorizationState, function (transition) {
        var requiredRoles = transition.to().data.requiresAuth;
        var allow = ACLService.matchRoles(requiredRoles);
        if (!allow) {
            toastr.error(gettextCatalog.getString('This action is locked for your account type'), gettextCatalog.getString('Contente free account'));
            return transition.router.stateService.target(transition.from().name);
        }
    });

    var criteriaObjEdit = {
        from: function from(state) {
            return state.name.includes('Edit');
        }
    };

    $transitions.onExit(criteriaObjEdit, function () {
        return SaveWarning.isEdited();
    });

    var criteriaObjAdd = {
        from: function from(state) {
            return state.name.includes('Add');
        }
    };

    $transitions.onExit(criteriaObjAdd, function () {
        return SaveWarning.isEdited();
    });
}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = {"pl_PL":{"A password reset link has been sent to your email address.":"Na podany przez Ciebie adres został wysłany link do resetowania hasła.","Account active":"Konto aktywne","Actions":"Akcje","Add":"Dodaj","Add Page":"Dodaj stronę","Add Product":"Dodaj produkt","Add User":"Dodaj użytkownika","Add mail":"Dodaj maila","Add new page":"Utwórz nową stronę","Add user":"Dodaj użytkownika","Adding menu":"Dodawane menu","Adding menu item":"Dodawanie elementu menu","Address":"Adres","Advanced":"Zaawansowane","Align":"Wyrównanie","An image URL which should represent your object within the graph.":"Adres URL grafiki, która będzie reprezentowała obiekt w grafie, np: http://moja-nazwa.pl/img/obrazek.jpg.","Analytics":"Analityka","Anchor":"Kotwica","Animation":"Animacja","Animation disabled":"Animacja wyłączona","Are you sure that you want to delete the \"{{name}}\" product?":"Czy na pewno chcesz usunąć produkt \"{{name}}\"?","Are you sure that you want to delete this form data?":"Czy na pewno chcesz usunąć te dane formularza?","Are you sure that you want to delete this page?":"Czy na pewno chcesz usunąć tę stronę?","Are you sure you want to cancel this upload?":{"Dropzone.js option":"Na pewno chcesz anulować wysyłanie tego pliku?"},"Attached file":"Dołączony plik","Authentication Error":"Błąd autoryzacji","Back":"Wróć","Background color":"Kolor tła","Background image":"Obrazek tła","Before removing, check if this image is not used somewhere":"Przed usunięciem, upewnij się, że ten obrazek nie jest nigdzie używany","Bold":"Pogrubiona","Border color":"Kolor obramowania","Border radius":"Zaokrąglenie","Border style":"Styl obramowania","Border width":"Szerokość obramowania","Bottom":"Do dołu","Button":"Przycisk","Button borders":"Obramowanie przycisku","Button color":"Kolor przycisku","Button text":"Tekst przycisku","Cancel":"Anuluj","Cancel upload":{"Dropzone.js option":"Anuluj wysyłanie"},"Cannot remove file.":"Nie można usunąć pliku.","Captcha":"Pokaż captchę","Categories":"Kategorie","Change":"Zmień","Change password":"Zmień hasło użytkownika","Changed password":"Zmień hasło","Check it if you want your form secured by Google reCaptcha":"Zaznacz to pole jeżeli chcesz by Twój formularz był zabezpieczony przez Goggle reCaptcha","Checkbox":"Pole wyboru","Checkboxes":"Pola wyboru","Choose message template":"Wybierz szablon odpowiedzi","Choose...":"Wybierz...","Clear old logs":"Wyczyść stare logi","Clear selection":{"Media picker clearing selection":"Wyczyść zaznaczenie"},"Click Through Rate":"Wps. klikalności","Click on the selected module with the left mouse button and drag and drop elements to the place where you want them in the workspace. Gray lines suggest where the item will be added.<img src=\"/images/drag_and_drop.gif\" alt=\"drag and drop showcase\" class=\"img-responsive\"/>":"Aby dodać nowy element do swojej strony, kliknij wybrany moduł lewym przyciskiem myszy, przeciągnij i upuść w wybrane przez Ciebie miejsce w obszarze roboczym. \nSzare linie podpowiadają, gdzie pojawi się dodawany element.<img src=\"/images/drag_and_drop.gif\" alt=\"drag and drop showcase\" class=\"img-responsive\"/>","Click to set module options":{"Creator section module placeholder":"Kliknij, aby zmienić ustawienia modułu"},"Close":"Zamknij","Color":"Kolor","Columns background color":"Kolor tła kolumn","Columns count":"Liczba kolumn","Columns width":"Szerokość kolumn","Contains":"Zawiera","Contente free account":"Darmowe konto Contente","Context":"Kontekst","Create":"Utwórz","Create new page":"Utwórz nową stronę","Created":"Utworzył(a)","Created at:":"Utworzono:","Creator settings":"Ustawienia Kreatora","Currency":"Waluta","Custom class name":"Niestandardowa nazwa klasy","Custom styles":"Własne style","Dashboard":"Kokpit","Date":"Data","Date and time":"Data i czas","Delete":"Usuń","Delete user":"Usuń użytkownika","Deleted":"Usunął/Usunęła","Deleted Users":"Usunięci użytkownicy","Description":"Opis","Division":"Podział","Do not forget about me":"Nie zapomnij o mnie","Do you really want to change number of columns? Content of last columns will be removed. (This action is irreversible!)":"Czy na pewno chcesz zmieić liczbę kolumn? Zawartość ostatnich kolumn zostanie utracone. (Ta akcja jest nieowracalna!)","Do you really want to delete this account? (This action is irreversible!)":"Czy na pewno chcesz usunąć konto? (Ta akcja jest nieodwracalna!)","Do you really want to delete this mail? (This action is irreversible!)":"Czy na pewno chcesz usunąć tego maila? (Ta akcja jest nieodwracalna!)","Don't pin":"Nie przypinaj","Download to your files":"Pobierz do biblioteki","Downloaded from Unsplash":"Pobrane z Unsplash","Draft":"Szkic","Drag (left or right) column divider to change columns size.<img src=\"/images/columns-resize.gif\" alt=\"columns resize\" class=\"img-responsive\"/>":"Złap i prczeciągnij (w lewo lub w prawo) podziałkę kolumn by zmienić ich rozmiar.<img src=\"/images/columns-resize.gif\" alt=\"columns resize\" class=\"img-responsive\"/>","Drag and drop this component if you want to add the menu to your page.":"Kliknij i przeciągnij ten komponent jeżeli chcesz dodać menu do swojej strony.","Drop elements here":"Przeciągnij moduły tutaj","Drop files here or click to upload":{"Dropzone.js option":"Przeciągnij tutaj pliki lub kliknij aby wybrać z dysku"},"E-mail":"E-mail","Edit":"Edycja","Edit Mail":"Edycja emaila","Edit Page":"Edycja strony","Edit Product":"Edytuj produkt","Edit form":"Edytuj formularz","Edit form inputs":"Edytuj pola formularza","Edit user":"Edycja danych użytkownika","Editing page settings":"Edycja ustawień strony","Email":"E-mail","Enable event tracking":"Włącz śledzenie zdarzeń","Enable parallax effect":"Włącz efekt parallax","Ends with":"Kończy się na","Equals":"Równa się","Error":"Błąd","Event":"Zdarzenie","Event tracking uses Google Analytics. Check global page settings to enable your GA key.":"Śledzenie zdarzeń wykorzystuje Google Analytics. Sprawdź globalne ustawienia strony i wprowadź klucz GA.","Exit":"Wyjdź","Export":"Eksportuj","Export as a template":"Eksportuj jako szablon","Export template":"Eksportuj szablon","Export to CSV":"Zapisz jako CSV","Facebook":"Facebook","Facebook Feed":"Tablica Facebooka","Fade in":"Rozjaśnianie","Fade left":"Wlot w lewo","Fade right":"Wlot w prawo","File is too big":"Plik jest za duży","File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.":{"Dropzone.js option":"Plik jest za duży ({{filesize}}MiB). Maksymalny rozmiar to: {{maxFilesize}}MiB."},"Files":"Pliki","First name":"Imię","Font":"Czcionka","Font size":"Rozmiar czcionki","Font weight":"Styl czcionki","Forgot your password?":"Zapomniałeś hasła?","Form":"Formularz","Form Data List Page":"Lista danych z formularza","Form Data Page":"Dane z formularza","Form data deleted!":"Dane z formularza usunięte!","Form data for":"Dane formularza dla","Global settings:":"Ustawienia globalne:","Go to Demo >":"Idź do Demo >","Go to user logs":"Przejdź do listy logów","Google Analytics token":"Token Google Analytics","Google Tag Manager key":"Klucz Google Tag Manager","Google Tag Manager key for AMP":"Klucz Google Tag Manager dla AMP","Google+":"Google+","Heading 1":"Nagłówek 1","Heading 2":"Nagłówek 2","Heading 3":"Nagłówek 3","Height":"Wysokość","Help":"Pomoc","Helper image":"Obrazek pomocy","Helper text":"Tekst pomocy","Home":{"Homepage/Dashboard":"CMS"},"Hover effect":"Efekt po najechaniu","Html":"Html","Html code":"Kod Html","Ignored if section is pinned.":"Ignorowana jeżeli sekcja jest przypięta.","Image":"Obrazek","Image added!":"Dodano obraz!","Image error, try again!":"Błąd obrazka, spróbuj ponownie!","Image position":"Położenie obrazka","In range":"W zakresie","Incorrect url address youtube/vimeo!":"Niepoprawny adres  url youtube/vimeo!","Input borders":"Obramowania","Insert URL here...":"Wprowadź adres URL...","Insert URL or pick the file.":"Wprowadź URL lub wybierz plik.","Insert text here...":"Wpisz tutaj tekst...","Insert title of your page":"Wprowadź tytuł swojej strony","Insert title of your template":"Dodaj tytuł swojego szablonu","Instagram":"Instagram","Invalid login or password":"Błędny login lub hasło","Invalid password":"Błędne hasło","It seems that your session has been expired. To continue, please log in using your password.":"Wygląda na to, że Twoja sesja wygasła. Aby kontynuować pracę, wpisz swoje hasło.","Item background color":"Kolor tła elementu","Item border radius":"Zaokrąglenie elementu","Item position":"Położenie elementu","Keywords":"Słowa kluczowe","Label":"Opis pola","Labels align":"Wyrównanie opisów pola","Labels position":"Pozycja opisu pola","Labels width":"Szerokość opisów pól","Landing pages":"Strony","Language":"Język","Language change will be visible only on generated page.":"Język zmieni się dopiero na wygenerowanej stronie.","Last name":"Nazwisko","Leave the page":"Opuść stronę","Leave the page?":"Opuścić stronę?","Line height":"Wysokość linii","Line size":"Wysokość linii","Link":"Link","Link color":"Kolor odnośników","Link or attached file":"Link lub dołączony plik","LinkedIn":"LinkedIn","Logged in":"Zalogował(a) się","Logs":"Logi","Logs cleared in database!":"Logi w bazie wyczyszczone!","Logs feed":"Lista logów","Mail open rate map":"Mapa liczby przeczytanych maili","Mail {{name}} added!":"Mail {{name}} został utworzony!","Mail {{name}} deleted!":"Usunięto maila {{name}}!","Mail {{name}} saved!":"Mail {{name}} został zapisany!","Mails templates":"Szablony maili","Main":"Ogólne","Main config":"Główna konfiguracja","Main info":"Podstawowe informacje","Map":"Mapa","Map API key":"Klucz API mapy ","Margin bottom":"Margines dolny","Margin left":"Margines lewy","Margin right":"Margines prawy","Margin top":"Margines górny","Mark All as Read":"Oznacz wszystkie jako przeczytane","Media":"Media","Media alt":{"Media tile input":"Tekst alternatywny"},"Media library":"Biblioteka mediów","Menu":"Menu","Messages":"Wiadomości","Middle":"Do środka","Mobile background image":"Obrazek rozdzielczości telefonu","Module editions":"Edycja modułu","Module settings":"Ustawienia modułu","Most popular hosts":"Popularni dostawcy","Name":"Nazwa","Name of the page from facebook url":"Nazwa strony używana w linku facebooka","New Users":"Nowi użytkownicy","New page":"Nowa strona","New password":"Nowe hasło","Next":"Dalej","Normal":"Normalna","Normally section is split into 12 columns. Adjust their widths according to your personal preferences. Remember that sum of widths bigger than max(12) will cause collumns to collapse.":"Sekcja jest podzielona na 12 równych kolumn. Dostosuj ich szerokości wg. własnych potrzeb. Pamiętaj, że jeżeli suma szerokości przekroczy max(12), kolumny będą spadać pod siebie.","Not contains":"Nie zawiera","Not equal":"Nie równe","Notes":"Notatki","Number":"Liczba","Number of inputs":"Liczba wpisów","Number of rows":"Liczba wierszy","OK":"OK","Only videos from Youtube and Vimeo are supported.":"Tylko filmy z Youtube i Vimeo są wspierane.","Open Rate":"Wsp. otwarcia","Open page":"Otwórz stronę","Option 1":"Wybór 1","Option 2":"Wybór 2","Option is available only in full version of the product.":"Opcja jest dostępna tylko w pełnej wersji produktu.","Options":"Opcje","Other action":"Niezidentyfikowana akcja!","Padding (image)":"Odstęp (obrazek)","Padding (text)":"Odstęp (tekst)","Padding bottom":"Odstęp dolny","Padding left":"Odstęp lewy","Padding right":"Odstęp prawy","Padding top":"Odstęp górny","Page info":"Informacje o stronie","Page {{$ctrl.gridOptions.api.paginationGetCurrentPage()+1}} of {{$ctrl.gridOptions.api.paginationGetTotalPages()}}":"Strona  {{$ctrl.gridOptions.api.paginationGetCurrentPage()+1}} z {{$ctrl.gridOptions.api.paginationGetTotalPages()}}","Page {{title}} added!":"Strona {{title}} została utworzona!","Page {{title}} deleted!":"Usunięto stronę {{title}}!","Page {{title}} saved!":"Strona {{title}} została zapisana!","Password":"Hasło","Password has been changed":"Hasło zostało zmienione","Permission Error":"Brak uprawnień","Photo by {{user}} from {{source}}":"Zdjęcie {{user}} z {{source}}","Photos":"Zdjęcia","Pick some file:":"Wybierz plik:","Pick the file":"Wybierz plik","Pick the media":{"Media picker CTA":"Wybierz plik"},"Pin Section":"Przypnij sekcję","Pinterest":"Pinterest","Placeholder":"Tekst zastępczy","Plain text":"Zwykły tekst","Please correct form errors and try again.":"Popraw błędy w formularzu i spróbuj ponownie.","Please use the fallback form below to upload your files like in the olden days.":{"Dropzone.js option":"Użyj formularza poniżej, żeby wysłać pliki jak za starych dobrych czasów."},"Position":"Pozycja","Preview (all links, buttons and forms are disabled in preview mode, if you wan't to test them open page in new window)":"Podgląd (wszystkie linki, przyciski oraz formularze są wyłączone w trybie podglądu, jeżeli chcesz przetestować te funkcjonalności otwórz stronę w nowej karcie)","Price":"Cena","Product {{name}} added!":"Produkt {{name}} został utworzony!","Product {{name}} deleted!":"Usunięto produkt {{name}}!","Product {{name}} saved!":"Produkt {{name}} został zapisany!","Products":"Produkty","Promotion end":"Koniec promocji","Promotion start":"Początek promocji","Public":"Publiczna","ROLE_ADMIN":"Administrator","ROLE_USER":"Użytkownik","Radio":"Przycisk radio","Radio buttons":"Przyciski radio","Rebuild and validate slug":"Wygeneruj link ponownie","Receive an e-mail with submitted form":"Chcę otrzymać e-mail z wysłanym formularzem","Redo":"Ponów","Release date":"Data wydania","Remove file":{"Dropzone.js option":"Usuń plik"},"Repeat password":"Powtórz hasło","Request timed out":"Przekroczono czas żądania","Required":"Wymagane","Reset password":"Zresetuj hasło","Resizing of columns":"Zmiana szerokości kolumn","Roles":"Role","SECTION":"SEKCJA","SEO":"SEO","Save":"Zapisz","Save and Preview":"Zapisz i podejrzyj","Save and leave":"Zapisz i wyjdź","Save changes":"Zapisz zmiany","Save product":"Zapisz produkt","Search by name...":"Szukaj po nazwie...","Search by tag...":"Szukaj po tagu...","Search by type":"Szukaj po typie","Search by type...":"Szukaj po typie...","Section":"Sekcja","Section Id":"Id sekcji","Section config":"Sekcja konfiguracji","Section title":"Tytuł sekcji","Section {{index}} title":"Tytuł sekcji {{index}}","See all messages":"Zobacz wszystkie wiadomości","Select":"Lista rozwijalna","Select a module to see it's options":"Zaznacz element by wyświetlić jego opcje","Select an item on the workspace to display its settings.":"Wybierz element w obszarze roboczym, aby wyświetlić jego ustawienia.","Select items":"Wybór elementów","Selected media:":"Zaznaczony plik:","Send Email":"Wyślij e-mail","Send e-mail confirmation to submitter":"Wyślij potwierdzenie e-mail do wysyłającego formularz","Server responded with {{statusCode}} code.":{"Dropzone.js option":"Serwer odpowiedział kodem błędu {{statusCode}}."},"Session expired":"Sesja wygasła","Settings":"Ustawienia","Show captcha":"Pokaż captche","Show details":"Pokaż szczegóły","Show events":"Pokazuj wydarzenia","Show form data":"Pokaż dane z formularza","Show input inline":"Pokaż w tej samej linii","Show messages":"Pokazuj wiadomości","Show timeline":"Pokazuj tablicę","Show users avatars in header":"Pokaż avatary użytkowników w nagłówku","Sign in":"Zaloguj się","Sign out":"Wyloguj się","Site address":"Adres strony","Size":{"File size label":"Rozmiar"},"Slug":"Link","Slug:":"Link:","Social":"Społeczny","Sort by":"Sortuj po","Space between items":"Przerwa między elementami","Starts with":"Zaczyna się","Statistics":"Statystyki","Status":"Status","Stay on the site":"Zostań na tej stronie","Stock photos":"Darmowe zdjęcia","Stretch section to full width":"Sekcja na całą szerokość strony","Style":"Styl","Submit":"Zapisz","Submitted data:":"Wysłane dane:","Subscriptions":"Subskrypcje","Success":"Sukces","Summary {{1}}":"Podsumowanie {{1}}","System error":"Błąd systemowy","Tablet background image":"Obrazek rozdzielczości tabletu","Template":"Szablon","Template preview":"Podgląd templatki","Template {{title}} added!":"Szablon {{title}} dodany!","Text":"Tekst","Text color":"Kolor tekstu","Text with image":"Tekst z obrazkiem","Textarea":"Duże pole tekstowe","Thank you custom URL":"Adres URL po sukcesie","Thank you text":"Tekst podziękowania","The canonical URL of your object that will be used as its permanent ID in the graph, e.g., `http://www.imdb.com/title/tt0117500/`.":"URL do obiektu czyli adres strony, np. http://moja-nazwa.pl/artykul/tytul-mojego-artykulu.","The passwords are not identical.":"Hasła nie są identyczne.","The title of your object as it should appear within the graph, e.g., `The Rock`.":"Tytuł strony. Pod tym tytułem pojawi się w grafie społecznościowym, np. „Tytuł mojego artykułu”","The type of your object, e.g., `video.movie`. Depending on the type you specify, other properties may also be required.":"Typ obiektu, np. \"article\"","There was a problem processing your request. Try again later.":"Problem z procesowaniem twojego zapytania. Proszę spróbować później.","This action is locked for your account type":"Ta akcja jest zablokowana dla Twojego typu konta","This field cannot be empty.":"Pole nie może być puste.","This mail is used as a e-mail template!":"Ten szablon jest używany jako odpowiedź na przesłane formularze!","This template can be accessible by everyone":"Ten szablon będzie dostępny dla wszystkich","This value is already used":"Ta wartość jest już wykorzystywana","Thumbnail":"Thumbnail","Timezone:":"Strefa czasowa:","Title":"Tytuł","Toggle Dropdown":"Rozwiń","Toolbox modules":" Przybornik modułów","Top":"Do góry","Twitter":"Twitter","Twitter Feed":"Tablica Twittera","Twitter login":"Login Twittera","Type":"Typ","Undo":"Cofnij","Unsplash Rate Limit Exceeded. Try again later.":"Dopuszczalna liczba żądań przekroczona. Spróbuj ponownie później.","Unsplash error":"Błąd  Unsplash","Untitled":"Brak tytułu","Update roles":"Aktualizuj role","Updated":"Zaktualizował(a)","Updated at:":"Zaktualizowano:","Upload error":"Błąd  przesyłania","Upload timeout":"Przekroczony czas żądania","Uploaded files":"Przesłane pliki","Use media button to add beautiful images directly to your page. Choose from thousand Unsplash library photos or upload one of your own.<img src=\"/images/media-library.jpg\" alt=\"stock photos\" class=\"img-responsive\"/>":"Użyj przycisku biblioteki mediów by dodać piękne zdjęcia prosto do swojej strony. Wybieraj spośród tysięcy zdjęć z biblioteki Unsplash lub dodaj własne.<img src=\"/images/media-library.jpg\" alt=\"stock photos\" class=\"img-responsive\"/>","Use this button to add a new element to your menu. Don't forget to add a section title.<img src=\"/images/section-title.jpg\" alt=\"section title\" class=\"img-responsive\"/>":"Uzyj tego przycisku aby dodać nowy element do Twojego menu. Nie zapomnij nadać sekcji nazwę.<img src=\"/images/section-title.jpg\" alt=\"section title\" class=\"img-responsive\"/>","User":"Użytkownik","User Name":"Login","User logs":"Logi użytkownika","User {{username}} created!":"Utworzono użytkownika {{username}}!","User {{username}} deleted!":"Usunięto użytkownika {{username}}!","User {{username}} updated!":"Zapisano użytkownika {{username}}!","Users":"Użytkownicy","Validation Errors":"Błędy walidacji","Video":"Wideo","Video URL":"Wideo URL","Video player":"Odtwarzacz wideo","View":"Wygląd","Warning":"Uwaga","Webhook Url":"Webhook Url","Welcome":"Witamy","Welcome to the <img style=\"max-width: 75px; display: inline-block;\" src=\"/fonts/contente.svg\" alt=\"logo\"> trial. You can explore all builder functionalities without any limits. Just pick the first element and drag and drop it on the page to see how easy it is! Don't forget about registration to share your page with the wider audience.":"Witaj w demo <img style=\"max-width: 75px; display: inline-block;\" src=\"/fonts/contente.svg\" alt=\"logo\">. MOżesz sprawdzić wszystkie funkcjonalności kreatora stron bez jakichkolwiek limitów. Po prostu wybierz element i upuść go na stronę by zobaczyć jakie to proste. Nie zapomnij o rejestracji abu podzielić się swoją pracą z szerszą widownią.","Width":"Szerokość","You are not logged in!":"Nie jesteś zalogowany!","You are not permitted to view this page.":"Nie masz uprawnień do przeglądania tej strony.","You can check out templates":"Możesz sprawdzić szablony","You can edit and customize each element of the page here.":"Tutaj możesz edytować i dostosować do swoich wymagań każdy element strony. ","You can manage information about your website here.":"Miejsce, w którym zarządzasz informacjami o swojej stronie.","You can not upload any more files.":{"Dropzone.js option":"Nie możesz wysłać więcej plików."},"You can return to this tutorial anytime by clicking on the help icon in the upper right corner.":"Do samouczka możesz wrócić w każdej chwili, wystarczy kliknąć ikonę pomocy dostępną w prawym górnym rogu ekranu.","You can't add more than one section of this type.":"Nie możesz dodać więcej niż jednej sekcji tego typu.","You can't upload files of this type.":{"Dropzone.js option":"Nie możesz wysłać tego typu plików."},"You have not finished entering data into the form. Do you want to leave anyway?":"Nie skończyłeś wprowadzać danych do formularza. Czy mimo to chcesz wyjść?","You have to choose e-mail template":"Musisz wybrać szablon e-mail","You haven't saved your progress in 5 minutes!":"Strona nie była zapisana przez ostatnie 5 minut!","You may lose your work if you are not saving it regularly.":"Możesz stracić swoje zmiany jeżeli nie zapisujesz ich regularnie.","Your browser does not support drag'n'drop file uploads.":{"Dropzone.js option":"Twoja przeglądarka nie wspiera wysyłania plików metodą przeciągnij i upuść."},"Your entry has been saved":"Twój wpis został zapisany","Your form must have 1 required e-mail field!":"Twój formularz musi zawierać jedno wymagane pole typu e-mail","Your free domain name will be:":"Nazwa Twojej darmowej domeny to:","Zoom":"Powiększenie","[[title]]: [[customData]] mails opened":"[[title]]: [[customData]] przeczytanych maili","element:":"element:","file extension":{"As in \"Sort by media file extension\"":"rozszerzeniu"},"here":"tutaj","name":{"As in \"Sort by media name\"":"nazwie"},"og:image":"og:image","og:title":"og:title","og:type":"og:type","og:url":"og:url","or":"albo","size":{"As in \"Sort by media file size\"":"rozmiarze"},"type":{"As in \"Sort by media type\"":"typie"},"upload date":{"As in \"Sort by media upload date\"":"dacie przesłania"}}}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MsgCenterCtrl = __webpack_require__(863);

var _MsgCenterCtrl2 = _interopRequireDefault(_MsgCenterCtrl);

var _index = __webpack_require__(864);

var _index2 = _interopRequireDefault(_index);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * MessageCenter module based on msgCenter from blur admin
 *
 * @namespace cms.MessageCenter
 *
 * @see {@link ./node_modules/blur_admin/src/app/theme/components/msgCenter}
 */
exports.default = _angular2.default.module('cms.MessageCenter', [_index2.default, _angularToastr2.default, _angularGettext2.default]).component('msgCenter', {
    restrict: 'E',
    template: __webpack_require__(869),
    controller: _MsgCenterCtrl2.default
}).name;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MsgCenterCtrl;
MsgCenterCtrl.$inject = ['$scope', '$sce', 'toastr', 'gettextCatalog'];
/**
 * @class MsgCenterCtrl
 * @memberOf cms.MessageCenter
 *
 * Skeleton of message center
 */
/** @ngInject */
function MsgCenterCtrl($scope, $sce, toastr, gettextCatalog) {

    $scope.users = {
        0: {
            name: 'User1'
        },
        1: {
            name: 'User2'
        },
        2: {
            name: 'User3'
        },
        3: {
            name: 'User4'
        }
    };

    $scope.messages = [{
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
    }, {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
    }, {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
    }, {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
    }, {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
    }, {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
    }, {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
    }];

    $scope.getMessage = function (msg) {
        var text = msg.template;
        if (msg.userId || msg.userId === 0) {
            text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
        }
        return $sce.trustAsHtml(text);
    };
}

/***/ }),
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"al-msg-center clearfix\">\n    <li uib-dropdown>\n        <a href class=\"msg\" uib-dropdown-toggle>\n            <em class=\"fa fa-envelope-o\"></em><span ng-if=\"messages.length\">{{messages.length}}</span>\n            <div class=\"notification-ring\" ng-if=\"messages.length\"></div>\n        </a>\n        <div uib-dropdown-menu class=\"top-dropdown-menu\">\n            <em class=\"dropdown-arr\"></em>\n            <div class=\"header clearfix\">\n                <strong translate>Messages</strong>\n                <a href ng-click=\"messages.length = 0\" translate>Mark All as Read</a>\n                <a href translate>Settings</a>\n            </div>\n            <div class=\"msg-list\">\n                <a href class=\"clearfix\" ng-repeat=\"msg in messages\">\n                    <div class=\"img-area\">\n                        <img class=\"photo-msg-item\"\n                                               ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\" alt=\"message\">\n                    </div>\n                    <div class=\"msg-area\">\n                        <div>{{ msg.text }}</div>\n                        <span>{{ msg.time }}</span>\n                    </div>\n                </a>\n            </div>\n            <a href translate>See all messages</a>\n        </div>\n    </li>\n</ul>";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DashboardPageDirective = __webpack_require__(871);

var _DashboardPageDirective2 = _interopRequireDefault(_DashboardPageDirective);

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _buttonsDemo = __webpack_require__(874);

var _buttonsDemo2 = _interopRequireDefault(_buttonsDemo);

var _summaryDemo = __webpack_require__(877);

var _summaryDemo2 = _interopRequireDefault(_summaryDemo);

var _mediaPickerDemoPanel = __webpack_require__(879);

var _mediaPickerDemoPanel2 = _interopRequireDefault(_mediaPickerDemoPanel);

var _SubscribeStatsChart = __webpack_require__(404);

var _SubscribeStatsChart2 = _interopRequireDefault(_SubscribeStatsChart);

var _pieChart = __webpack_require__(405);

var _pieChart2 = _interopRequireDefault(_pieChart);

__webpack_require__(894);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

routeConfig.$inject = ['$stateProvider', 'gettext'];


var dashboardModule = _angular2.default.module('cms.pages.dashboard', [_angularjs2.default, _DashboardPageDirective2.default, _buttonsDemo2.default, _summaryDemo2.default, _angularGettext2.default, _mediaPickerDemoPanel2.default, _SubscribeStatsChart2.default, _pieChart2.default]).config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */

    $stateProvider.state('dashboard', {
        url: '/',
        component: 'appDashboard',
        title: gettext('Dashboard'),
        data: {
            requiresAuth: ['ROLE_ADMIN', 'ROLE_USER']
        },
        sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
            allow: ['ROLE_ADMIN', 'ROLE_USER']
        },
        breadcrumbsMeta: {
            topBar: false
        }
    });
}

exports.default = dashboardModule.name;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dashboardPageModule = _angular2.default.module('cms.dashboard.page', []).component('appDashboard', {
    template: __webpack_require__(872),
    controller: ['$http', 'CONFIG', 'ACLService', 'PageResource', '$state', 'addPageDialog', function controller($http, CONFIG, ACLService, PageResource, $state, addPageDialog) {
        var _this = this;

        var limitUserPages = 1;
        this.pieChartNewUsers = {};
        this.pieChartDeletedUsers = {};
        this.pieChartOpenRate = {};
        this.pieChartClickThroughRate = {};

        this.isAdmin = ACLService.matchRoles(['ROLE_ADMIN']);

        $http.get(CONFIG.API_URL + '/dashboard/new-users-statistics').then(function (response) {
            _this.pieChartNewUsers = response.data;
        });

        $http.get(CONFIG.API_URL + '/dashboard/deleted-users-statistics').then(function (response) {
            _this.pieChartDeletedUsers = response.data;
        });

        $http.get(CONFIG.API_URL + '/dashboard/open-rate-statistics').then(function (response) {
            _this.pieChartOpenRate = response.data;
        });

        $http.get(CONFIG.API_URL + '/dashboard/click-through-rate-statistics').then(function (response) {
            _this.pieChartClickThroughRate = response.data;
        });

        // User

        this.userPages = [];
        this.pendingPageLoad = true;

        PageResource.findAll({}, function (response) {
            _this.userPages = response;
            _this.pendingPageLoad = false;
        }, function (err) {
            _this.pendingPageLoad = false;
        });

        this.goToPage = function (page) {
            return $state.go('pagesEdit', { id: page.id });
        };

        this.addPage = function () {

            if (!_this.canCreatePage()) {
                return;
            }

            addPageDialog.open().then(function (response) {
                $state.go('pagesEdit', {
                    id: response.id,
                    title: response.title,
                    returnState: {
                        name: 'pages',
                        params: _angular2.default.copy($state.params)
                    }

                });
            }).catch(function () {});
        };

        this.canCreatePage = function () {
            return _this.userPages.total_count < limitUserPages || _this.isAdmin;
        };
    }]
});
exports.default = dashboardPageModule.name;

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dashboard-page\">\n    <div ng-if=\"!$ctrl.isAdmin\">\n        <div ng-if=\"$ctrl.pendingPageLoad\" class=\"spinner-loading animated\">\n            <span class=\"fa fa-circle-o-notch fa-spin loading-spinner\"></span>\n        </div>\n        <div ng-if=\"!$ctrl.pendingPageLoad\">\n            <div class=\"row\">\n                <div class=\"col-md-2\">\n                    <div class=\"page-tile\" ng-click=\"$ctrl.addPage()\" ng-class=\"{'disabled-tile': !$ctrl.canCreatePage()}\"\n                         uib-tooltip=\"{{!$ctrl.canCreatePage() ? 'The page limit has been reached' : '' | translate }}\">\n                        <div class=\"page-tile-wrapper\">\n                            <div class=\"page-tile-content\">\n                                <h3><i class=\"fa fa-plus-circle fa-2x\"></i></h3>\n                                <h4 translate>Add new page</h4>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-md-2\" ng-repeat=\"page in $ctrl.userPages.data\">\n                    <div class=\"page-tile\" ng-click=\"$ctrl.goToPage(page)\">\n                        <div class=\"page-tile-wrapper\">\n                            <div class=\"page-tile-content\">\n                                <h3>{{page.title}}</h3>\n                                <h4>{{page.updatedAt || page.createdAt |date:'yyyy/MM/dd'}}</h4>\n                            </div>\n                            <div class=\"page-tile-actions\">\n                                <a class=\"page-tile-action\" ng-click=\"$ctrl.goToPage(page)\">\n                                    <i class=\"fa fa-pencil\"></i>\n                                </a>\n                                <a class=\"page-tile-action\" ng-click=\"$ctrl.openPage()\">\n                                    <i class=\"fa fa-external-link\"></i>\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n    <div ng-if=\"$ctrl.isAdmin\">\n        <div class=\"row pie-charts\">\n            <cms-pie-chart\n                    title=\"{{ 'New Users' | translate }}\"\n                    percent=\"{{ $ctrl.pieChartNewUsers.percent }}\"\n                    description=\"{{ $ctrl.pieChartNewUsers.data }}\"\n                    icon=\"i-person\">\n            </cms-pie-chart>\n            <cms-pie-chart\n                    title=\"{{ 'Deleted Users' | translate }}\"\n                    percent=\"{{ $ctrl.pieChartDeletedUsers.percent }}\"\n                    description=\"{{ $ctrl.pieChartDeletedUsers.data }}\"\n                    icon=\"i-person\">\n            </cms-pie-chart>\n            <cms-pie-chart\n                    title=\"{{ 'Open Rate' | translate }}\"\n                    percent=\"{{ $ctrl.pieChartOpenRate.percent }}\"\n                    description=\"{{ $ctrl.pieChartOpenRate.data }}\"\n                    icon=\"i-refresh\">\n            </cms-pie-chart>\n            <cms-pie-chart\n                    title=\"{{ 'Click Through Rate' | translate }}\"\n                    percent=\"{{ $ctrl.pieChartClickThroughRate.percent }}\"\n                    description=\"{{ $ctrl.pieChartClickThroughRate.data }}\"\n                    icon=\"i-face\">\n            </cms-pie-chart>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-lg-6 col-md-12 col-sm-12\"\n                 ba-panel\n                 ba-panel-title=\"{{ 'Most popular hosts' | translate }}\"\n                 ba-panel-class=\"medium-panel traffic-panel\">\n                <mail-host-stats-chart></mail-host-stats-chart>\n            </div>\n            <div class=\"col-lg-6 col-md-12 col-sm-12\"\n                 ba-panel\n                 ba-panel-title=\"{{'Mail open rate map'|translate}}\"\n                 ba-panel-class=\"medium-panel\">\n                <mail-open-rate-map></mail-open-rate-map>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <div class=\"row\">\n                    <div class=\"col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12\"\n                         ba-panel\n                         ba-panel-title=\"{{'Subscriptions'|translate}}\"\n                         ba-panel-class=\"medium-panel\">\n                        <mail-subscribe-stats-chart></mail-subscribe-stats-chart>\n                    </div>\n                    <div class=\"col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12\"\n                         ba-panel\n                         ba-panel-class=\"popular-app medium-panel\">\n                        <!-- Todo: Podgląd maila refs #16725 -->\n                        <popular-app></popular-app>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12\"\n                 ba-panel\n                 ba-panel-title=\"{{'Logs feed'|translate}}\"\n                 ba-panel-class=\"medium-panel with-scroll feed-panel\">\n                <logs-feed></logs-feed>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 873 */,
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(875);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.panels.buttons-demo', ['angular-progress-button-styles']).component('buttonsDemo', {
    template: __webpack_require__(876),
    controller: ['$scope', '$timeout', function ButtonDemoCtrl($scope, $timeout) {
        /** @ngInject */

        $scope.progressFunction = function () {
            return $timeout(function () {}, 3000);
        };
    }]
}).name;

/***/ }),
/* 875 */,
/* 876 */
/***/ (function(module, exports) {

module.exports = "<div ba-panel ba-panel-title=\"Bajer buttons\" ba-panel-class=\"with-scroll\">\n    <div class=\"progress-buttons-container text-center default-text\">\n        <div class=\"row\">\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">fill horizontal</span>\n                <button progress-button=\"progressFunction()\" class=\"btn btn-success\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">fill vertical</span>\n                <button progress-button=\"progressFunction()\" pb-direction=\"vertical\" class=\"btn btn-danger\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">shrink horizontal</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"shrink\" class=\"btn btn-warning\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">shrink vertical</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"shrink\" pb-direction=\"vertical\" class=\"btn btn-info\">Submit</button>\n            </section>\n        </div>\n        <div class=\"row\">\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-angle-bottom <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-bottom\" class=\"btn btn-success\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-angle-top <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-top\" class=\"btn btn-danger\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-angle-left <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-left\" class=\"btn btn-warning\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-angle-right <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-right\" class=\"btn btn-info\">Submit</button>\n            </section>\n        </div>\n        <div class=\"row\">\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-side-down <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-down\" class=\"btn btn-success\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-side-up <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-up\" class=\"btn btn-danger\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-side-left <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-left\" class=\"btn btn-warning\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-side-right <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-right\" class=\"btn btn-info\">Submit</button>\n            </section>\n        </div>\n        <div class=\"row\">\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">rotate-back <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"rotate-back\" class=\"btn btn-success\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">flip-open <br/>perspective</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"flip-open\" class=\"btn btn-danger\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">slide-down <br/>horizontal</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"slide-down\" class=\"btn btn-warning\">Submit</button>\n            </section>\n            <section class=\"col-md-6 col-lg-3\">\n                <span class=\"button-title\">move-up <br/>horizontal</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"move-up\" class=\"btn btn-info\">Submit</button>\n            </section>\n        </div>\n        <div class=\"row\">\n            <section class=\"col-md-6\">\n                <span class=\"button-title\">top-line <br/>horizontal</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"top-line\" class=\"btn btn-success\">Submit</button>\n            </section>\n            <section class=\"col-md-6\">\n                <span class=\"button-title\">lateral-lines <br/>vertical</span>\n                <button progress-button=\"progressFunction()\" pb-style=\"lateral-lines\" class=\"btn btn-info\">Submit</button>\n            </section>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.panels.summary', []).component('summaryDemo', {
    template: __webpack_require__(878)
}).name;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-md-6\">\n        <div ba-panel ba-panel-title=\"Data 1\" ba-panel-class=\"with-scroll tree-panel\">\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <h1 translate>\n                        Summary {{1}}\n                    </h1>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"col-md-6\">\n        <div ba-panel ba-panel-title=\"Data 2\" ba-panel-class=\"with-scroll tree-panel\">\n            <p>\n                Summary asd\n            </p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MediaPicker = __webpack_require__(880);

var _MediaPicker2 = _interopRequireDefault(_MediaPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.panels.media-picker-demo', [_MediaPicker2.default]).component('mediaPickerDemoPanel', {
    template: __webpack_require__(889)
}).name;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _MediaResource = __webpack_require__(95);

var _MediaResource2 = _interopRequireDefault(_MediaResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _modal = __webpack_require__(125);

var _modal2 = _interopRequireDefault(_modal);

var _MediaUsage = __webpack_require__(201);

var _MediaUsage2 = _interopRequireDefault(_MediaUsage);

var _MediaPickerModal = __webpack_require__(147);

var _MediaPickerModal2 = _interopRequireDefault(_MediaPickerModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.picker', [_ConfigModule2.default, _MediaResource2.default, _modal2.default, _MediaPickerModal2.default, _angularGettext2.default]).component('mediaPicker', {
    template: __webpack_require__(888),
    require: {
        ngModel: '^'
    },
    bindings: {
        media: '<',
        onRemoved: '&',
        width: '<',
        height: '<'
    },
    controller: ['$scope', '$uibModal', 'MediaPickerModal', 'gettextCatalog', function controller($scope, $uibModal, MediaPickerModal, gettextCatalog) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {

            if (_this.ngModel.$modelValue) {
                _this.selectedMedia = _this.ngModel.$modelValue;
                _this.resultPreview = new _MediaUsage2.default(media, _this.width, _this.height);
            }
        };

        /**
         * Used from in the modal to remember current selection
         *
         * @private
         * @param {MediaResource} media
         */
        this.onMediaSelected = function (media) {
            _this.selectedMedia = media;
        };

        /**
         * Clear the model, media and preview
         *
         * @private
         */
        this.clearSelection = function () {
            _this.selectedMedia = null;
            _this.ngModel.$setViewValue(null);
            _this.resultPreview = null;
        };

        /**
         * Open the modal
         *
         * @private
         */
        this.openMediaPickerModal = function () {
            MediaPickerModal.open().result.then(function (media) {
                _this.resultPreview = new _MediaUsage2.default(media, _this.width, _this.height);
                _this.ngModel.$setViewValue(new _MediaUsage2.default(media, _this.width, _this.height));
            });
        };
    }]
}).name;

/***/ }),
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Simple config 
 * For local config create config.js
 */

module.exports = {
    "API_URL": "https://new-cms-contente-backend.dev.cdwv.pl/api",
    "API_PUBLIC": "https://new-cms-contente-backend.dev.cdwv.pl",
    "PUBLIC_SITE_URL": "http://__SITE_SLUG__.contente.net",
    "DEV": false,
    "ROLES": ['ROLE_USER', 'ROLE_ADMIN'],
    "UNSPLASH_ACCESS_KEY": "475919daaf6f38937bc3daf4c47a3d8fb0572e2ecc22b5097fb5745a39b4f882",
    "UNSPLASH_SECRET_KEY": "cdd5aa0ce44dc3e0c6df71229df22c322dd959ffbcbcc1020b4e5b197a667e16",
    "NOUN_PROJECT_KEY": "155322dd33d14129b816bd42d65f3512",
    "NOUN_PROJECT_SECRET": "9d12fb2fc9164346bcb908702d8445ab"
};

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = "\n\n<div class=\"modal-header\">\n    <h4 class=\"modal-title\">\n        {{ 'Media library' | translate }}\n    </h4>\n</div>\n\n<ul class=\"media-browser-tabs\">\n    <li ng-class=\"{'active': $ctrl.activeTab == 1}\">\n        <a href=\"\" ng-click=\"$ctrl.setActiveTab(1)\">{{ 'Uploaded files' | translate }}</a>\n    </li>\n    <li ng-class=\"{'active': $ctrl.activeTab == 2}\">\n        <a href=\"\" ng-click=\"$ctrl.setActiveTab(2)\">\n            {{ 'Stock photos' | translate }}\n        </a>\n    </li>\n</ul>\n\n<div class=\"modal-body\">\n    <cms-media-listing\n            multiple=\"$ctrl.multiple\"\n            ng-if=\"$ctrl.activeTab == 1\"\n            selectable=\"true\" display-limit=\"12\"\n            on-select=\"$ctrl.onMediaSelected(media, selected)\"\n            should-auto-select=\"true\">\n    </cms-media-listing>\n    <cms-unsplash-listing\n            multiple=\"$ctrl.multiple\"\n            ng-if=\"$ctrl.activeTab == 2\"\n            selectable=\"true\" display-limit=\"12\"\n            on-select=\"$ctrl.onMediaSelected(media, selected)\">\n    </cms-unsplash-listing>\n</div>\n\n<div class=\"modal-footer\">\n\n    <div class=\"footer-elements\">\n        <div class=\"selected-files-list\">\n            <span ng-show=\"$ctrl.selectedMedia.length\">\n                Selected: {{$ctrl.selectedMediaString()}}\n            </span>\n        </div>\n\n        <div style=\"flex-grow:2\"></div>\n\n        <button type=\"button\"\n                class=\"btn btn-default\"\n                ng-click=\"$dismiss()\">\n            {{'Cancel' | translate}}\n        </button>\n        <button type=\"button\"\n                class=\"btn btn-primary\"\n                ng-disabled=\"!$ctrl.selectedMedia || $ctrl.pending\"\n                ng-click=\"$ctrl.close($ctrl.selectedMedia)\">\n\n            <span ng-show=\"!$ctrl.pending\">{{'Save changes' | translate}}</span>\n            <em ng-show=\"$ctrl.pending\" class=\"fa fa-circle-o-notch fa-spin\"></em>\n\n        </button>\n    </div>\n</div>\n";

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "<div class=\"media-picker\" ng-style=\"{\n                width: $ctrl.width + 'px',\n                height: $ctrl.height + 'px'\n             }\">\n    <img ng-if=\"$ctrl.resultPreview.getImgUrl()\" ng-src=\"{{$ctrl.resultPreview.getImgUrl()}}\" alt=\"\" />\n    <svg ng-if=\"!$ctrl.resultPreview.getImgUrl()\"\n         ng-attr-viewBox=\"0 0 {{$ctrl.width}} {{$ctrl.height}}\"\n         class=\"media-picker__image-placeholder\"\n         ng-style=\"{\n                width: $ctrl.width + 'px',\n                height: $ctrl.height + 'px'\n             }\">\n        <text x=\"50%\" y=\"50%\" fill=\"currentColor\" alignment-baseline=\"middle\" text-anchor=\"middle\">\n            {{$ctrl.width}} x {{$ctrl.height}}\n        </text>\n    </svg>\n    <div class=\"media-picker__button-overlay\">\n        <button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"$ctrl.openMediaPickerModal()\">\n            {{ 'Pick the media' | translate:'Media picker CTA' }}\n        </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.clearSelection()\">\n            {{ 'Clear selection' | translate:'Media picker clearing selection' }}\n        </button>\n    </div>\n</div>";

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div ba-panel ba-panel-title=\"Media picker demo\">\n            <div class=\"row col-xs-6\">\n                <h3 translate>Pick some file:</h3>\n                <media-picker ng-model=\"$ctrl.selectedMedia\" width=\"300\" height=\"150\"></media-picker>\n            </div>\n            <div class=\"row col-xs-6\">\n                <h3 translate>Selected media:</h3>\n                <media-tile ng-if=\"!!$ctrl.selectedMedia\" media=\"$ctrl.selectedMedia.media\"></media-tile>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "<div id=\"subscribeStatsChart\"></div>";

/***/ }),
/* 892 */,
/* 893 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pie-chart-item-container\">\n    <div ba-panel>\n        <div class=\"pie-chart-item\">\n            <div easypiechart class=\"chart\" options=\"$ctrl.options\" percent=\"$ctrl.percent\">\n                <span class=\"percent\">{{ $ctrl.percent }}</span>\n            </div>\n            <div class=\"description\">\n                <div>{{ $ctrl.title}}</div>\n                <div class=\"description-stats\">{{ $ctrl.description }}</div>\n            </div>\n            <em class=\"chart-icon {{ $ctrl.icon }}\"></em>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LogsPageDirective = __webpack_require__(896);

var _LogsPageDirective2 = _interopRequireDefault(_LogsPageDirective);

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

routeConfig.$inject = ['$stateProvider', 'gettext'];


var logsModule = _angular2.default.module('cms.pages.logs', [_angularjs2.default, _LogsPageDirective2.default, _angularGettext2.default]).config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */

    $stateProvider.state('logs', {
        url: '/logs?ownerName&page&order_by&order_direction&ip&context&event&createdAtAfter&createdAtBefore',
        reloadOnSearch: false,
        component: 'appLogs',
        title: gettext('Logs'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        sidebarMeta: {
            icon: 'ion-clock',
            order: 1,
            allow: ['ROLE_ADMIN']
        }
    });
}

exports.default = logsModule.name;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _LogsGrid = __webpack_require__(897);

var _LogsGrid2 = _interopRequireDefault(_LogsGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logsPageDirective = _angular2.default.module('cms.pages.logs.directive', [_LogsGrid2.default, _angularToastr2.default]).component('appLogs', {
    template: __webpack_require__(927),
    bindings: {
        $transition$: '<'
    },
    controller: ['$http', 'LogResource', 'GridParamsConverter', '$state', 'toastr', 'gettextCatalog', function controller($http, LogResource, GridParamsConverter, $state, toastr, gettextCatalog) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.initialParams = _this.$transition$.params();
        };

        this.clearLogs = function () {
            LogResource.deleteOld('', function (response) {
                toastr.success(gettextCatalog.getString('Logs cleared in database!'), gettextCatalog.getString('Success'));
            });
        };

        this.onParamsChange = function (params) {
            delete params.page;
            $state.go('.', params, {
                location: 'replace'
            });
        };

        this.onPageChange = function (page) {
            if (page === 0) {
                return;
            }
            $state.go('.', { page: page !== 1 ? page : undefined }, {
                location: 'replace'
            });
        };
    }]
});

exports.default = logsPageDirective.name;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _GridDirective = __webpack_require__(107);

var _GridDirective2 = _interopRequireDefault(_GridDirective);

var _LogResource = __webpack_require__(925);

var _LogResource2 = _interopRequireDefault(_LogResource);

var _GridParamsConverter = __webpack_require__(116);

var _GridParamsConverter2 = _interopRequireDefault(_GridParamsConverter);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logsPageDirective = _angular2.default.module('cms.logs.grid', [_GridDirective2.default, _LogResource2.default, _GridParamsConverter2.default, _angularGettext2.default]).component('logsGrid', {
    template: __webpack_require__(926),
    bindings: {
        initialParams: '<?',
        onParamsChange: '&?',
        onPageChange: '&?',
        gridOptions: '<?'
    },
    controller: ['LogResource', 'GridParamsConverter', 'gettextCatalog', function controller(LogResource, GridParamsConverter, gettextCatalog) {
        var _this = this;

        /** @ngInject */

        var getColumnDefs = function getColumnDefs() {
            return [{ headerName: gettextCatalog.getString('User'), field: "ownerName", _translateKey: 'User' }, { headerName: "IP", field: "ip" }, { headerName: gettextCatalog.getString('Context'), field: "context" }, { headerName: gettextCatalog.getString('Event'), field: "event" }, {
                headerName: gettextCatalog.getString('Date'),
                field: "createdAt",
                filter: 'date',
                filterParams: { filterOptions: ['inRange'] },
                valueFormatter: function valueFormatter(data) {
                    if (data && data.value) return new Date(data.value).toLocaleString();

                    return data;
                }
            }];
        };

        var dataInitialized = false;

        var defaultParams = {
            page: undefined,
            order_by: undefined,
            order_direction: undefined,
            ownerName: undefined,
            ip: undefined,
            context: undefined,
            event: undefined,
            createdAtAfter: undefined,
            createdAtBefore: undefined
        };

        this.$onInit = function () {
            if (!_this.initialParams) _this.initialParams = _angular2.default.copy(defaultParams);

            if (_this.initialParams.order_by) {
                _this.initialSortModel = [{ colId: _this.initialParams.order_by, sort: _this.initialParams.order_direction || 'asc' }];
            }

            if (_this.initialParams.page) {
                _this.initialPage = _this.initialParams.page;
            }

            _this.initialFilterModel = {};

            ['ownerName', 'ip', 'context', 'event', 'ownerId'].forEach(function (field) {
                if (_this.initialParams[field]) _this.initialFilterModel[field] = { type: 'contains', filter: _this.initialParams[field] };
            });

            ['createdAt'].forEach(function (field) {
                if (_this.initialParams[field + 'After'] && _this.initialParams[field + 'Before']) _this.initialFilterModel[field] = {
                    type: 'inRange',
                    filterType: "date",
                    dateFrom: _this.initialParams[field + 'After'],
                    dateTo: _this.initialParams[field + 'Before']
                };
            });
            _this.datasource = {

                /**
                 * Load next rows function
                 * @param {Object} params Params container
                 * @param {number} params.startRow
                 * @param {number} params.endRow
                 * @param {string} params.sortModel
                 * @param {string} params.filterModel
                 * @param {string} params.context
                 * @param {function} params.successCallback successCallback(rowsThisBlock, lastRow)
                 * @param {function} params.failCallback failCallback(reason)
                 */
                getRows: function getRows(params) {
                    var queryParams = GridParamsConverter.getCmsApiParams(params);
                    var stateParams = Object.assign({}, defaultParams, queryParams);
                    if (_this.onParamsChange) {
                        _this.onParamsChange({ $params: _angular2.default.copy(stateParams) });
                    }

                    var logs = LogResource.get(queryParams, function (response) {
                        var data = logs.data;
                        var lastRow = logs.total_count;
                        params.successCallback(data, lastRow);

                        if (!dataInitialized && _this.initialPage && _this.initialPage !== _this.griOptions.api.paginationGetCurrentPage() + 1) {
                            dataInitialized = true;
                            _this.gridOptions.api.paginationGoToPage(parseInt(_this.initialPage) - 1);
                        }

                        if (!_this.resizeOnFirstLoad) {
                            _this.gridOptions.api.sizeColumnsToFit();
                            _this.resizeOnFirstLoad = true;
                        }
                    });
                }
            };
        };
        this._onPageChange = function (page) {
            if (!dataInitialized) return;
            if (_this.onPageChange) {
                _this.onPageChange({ $page: page });
            }
        };

        this.gridOptions = {
            _columnDefsCallback: getColumnDefs,
            _gridStateId: 'log-grid-state'
        };

        // Access to grid via this.options.api obj.
        // API object is accessible after grid initialization
    }]
});

exports.default = logsPageDirective.name;

/***/ }),
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"pagination disable-click-outside\">\n    <li>\n        <a href\n           ng-click=\"$ctrl.goToPage($ctrl.currentPage - 1)\"\n           ng-disabled=\"$ctrl.currentPage <= 1\">\n            <em class=\"ion ion-arrow-left-a\"></em>\n        </a>\n    </li>\n    <li ng-repeat=\"pageControl in $ctrl.pageControls track by pageControl.page\"\n        ng-class=\"{active: pageControl.page === $ctrl.currentPage}\">\n        <a href ng-click=\"$ctrl.goToPage(pageControl.page)\">\n            {{pageControl.label}}\n        </a>\n    </li>\n\n    <li>\n        <a href\n           ng-disabled=\"$ctrl.currentPage >= $ctrl.pages\"\n           ng-click=\"$ctrl.goToPage($ctrl.currentPage + 1)\">\n            <em class=\"ion ion-arrow-right-a\"></em>\n        </a>\n    </li>\n</ul>";

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "<div ag-grid=\"$ctrl.gridOptions\"\n     class=\"grid-theme-cms\"\n     style=\"{{$ctrl.gridOptions.height ? ('height: ' + $ctrl.gridOptions.height + 'px') : ''}}\"\n     ng-class=\"($ctrl.gridOptions.autoHeight) ? 'grid-auto-height':''\"></div>\n\n<div class=\"grid-footer\" ng-hide=\"$ctrl.gridOptions.hideItemsPageSelect\">\n\n    <div ng-show=\"$ctrl.gridOptions.api.paginationGetTotalPages()>1\" translate>\n        Page {{$ctrl.gridOptions.api.paginationGetCurrentPage()+1}} of {{$ctrl.gridOptions.api.paginationGetTotalPages()}}\n    </div>\n\n    <div style=\"flex-grow: 2\"></div>\n\n    <pagination-controls pages=\"$ctrl.gridOptions.api.paginationGetTotalPages()\"\n                         current-page=\"$ctrl.gridOptions.api.paginationGetCurrentPage() + 1\"\n                         ng-show=\"$ctrl.gridOptions.api.paginationGetTotalPages()>1\"\n                         on-page-change=\"$ctrl.gridOptions.api.paginationGoToPage(page - 1)\">\n    </pagination-controls>\n\n    <div style=\"flex-grow: 2\"></div>\n\n    <div>\n        <a class=\"btn btn-default\" ng-click=\"$ctrl.refreshGrid()\">\n            Reset <em class=\"fa fa-refresh\"></em>\n        </a>\n    </div>\n\n    <div>\n        <ui-select\n           style=\"width: 100px\"\n           ng-model=\"$ctrl.itemsPerPage\"\n           ng-change=\"$ctrl.updatePageSize($ctrl.itemsPerPage)\"\n           class=\"btn-group bootstrap-select\"\n           search-enabled=\"false\">\n            <ui-select-match placeholder=\"Liczba wierszy\">\n                <span>{{$select.selected}}</span>\n            </ui-select-match>\n            <ui-select-choices repeat=\"page in $ctrl.itemsPerPageSelect\">\n                <span>{{page}}</span>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n\n</div>\n\n\n\n";

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.log.resource', [_angularResource2.default, _ConfigModule2.default]).factory('LogResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInject */

    return $resource(CONFIG.API_URL + '/logs', {}, {
        'get': { cancellable: true, method: 'GET' },
        'save': { method: 'POST' },
        'remove': { method: 'DELETE', url: CONFIG.API_URL + '/logs/:id' },
        'delete': { method: 'DELETE', url: CONFIG.API_URL + '/logs/:id' },
        'deleteOld': { method: 'DELETE', url: CONFIG.API_URL + '/logs' }
    }, {
        stripTrailingSlashes: true
    });
}]).name;

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "<cms-grid grid-options=\"$ctrl.gridOptions\"\n          datasource=\"$ctrl.datasource\"\n          on-page-change=\"$ctrl._onPageChange($page)\"\n          initial-sort-model=\"$ctrl.initialSortModel\"\n          initial-filter-model=\"$ctrl.initialFilterModel\"\n></cms-grid>\n";

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports = "<div ba-panel ba-panel-title=\"{{ 'Logs'  | translate }}\" ba-panel-class=\"\">\n    <div class=\"text-right\">\n        <a class=\"btn btn-md btn-danger\" ng-click=\"$ctrl.clearLogs()\" translate>Clear old logs</a>\n    </div>\n    <br>\n    <logs-grid on-page-change=\"$ctrl.onPageChange($page)\"\n               initial-params=\"$ctrl.initialParams\"\n               on-params-change=\"$ctrl.onParamsChange($params)\"></logs-grid>\n\n</div>";

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _UsersListPageDirective = __webpack_require__(929);

var _UsersListPageDirective2 = _interopRequireDefault(_UsersListPageDirective);

var _UsersAddPageDirective = __webpack_require__(933);

var _UsersAddPageDirective2 = _interopRequireDefault(_UsersAddPageDirective);

var _UsersEditPageDirective = __webpack_require__(935);

var _UsersEditPageDirective2 = _interopRequireDefault(_UsersEditPageDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

routeConfig.$inject = ['$stateProvider', 'gettext'];


var usersModule = _angular2.default.module('cms.pages.users', [_angularjs2.default, _angularGettext2.default, _UsersListPageDirective2.default, _UsersAddPageDirective2.default, _UsersEditPageDirective2.default]).config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */

    $stateProvider.state('users', {
        url: '/users?firstName&lastName&email&order_by&order_direction&page',
        component: 'appUsersList',
        title: gettext('Users'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        reloadOnSearch: false,
        sidebarMeta: {
            icon: 'ion-person',
            order: 0,
            allow: ['ROLE_ADMIN']
        }
    }).state('usersAdd', {
        url: '/users/add',
        component: 'appUsersAdd',
        title: gettext('Add User'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        params: {
            returnState: null
        },
        breadcrumbsMeta: {
            parentState: 'users'
        }
    }).state('usersEdit', {
        url: '/users/edit/:id',
        component: 'appUsersEdit',
        params: {
            returnState: null
        },
        title: gettext('Edit user'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        breadcrumbsMeta: {
            parentState: 'users'
        }
    });
}

exports.default = usersModule.name;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _UsersGrid = __webpack_require__(930);

var _UsersGrid2 = _interopRequireDefault(_UsersGrid);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersPageModule = _angular2.default.module('cms.users.list', [_UsersGrid2.default, _angularGettext2.default, _ConfigModule2.default]).component('appUsersList', {
    template: __webpack_require__(932),
    bindings: {
        $transition$: '<'
    },
    controller: ['gettextCatalog', 'toastr', 'CONFIG', '$state', 'ExportService', function controller(gettextCatalog, toastr, CONFIG, $state, ExportService) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.initialParams = _this.$transition$.params();
        };

        this.onParamsChange = function (params) {
            delete params.page;
            $state.go('.', params, {
                location: 'replace'
            });
        };

        this.onPageChange = function (page) {
            if (page === 0) {
                return;
            }
            $state.go('.', { page: page !== 1 ? page : undefined }, {
                location: 'replace'
            });
        };

        this.addUser = function () {
            $state.go('usersAdd', {
                returnState: {
                    name: 'users',
                    params: _angular2.default.copy($state.params)
                }
            });
        };

        this.exportUrl = function () {
            return ExportService.getUrl('users');
        };
    }]
});

exports.default = usersPageModule.name;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _GridDirective = __webpack_require__(107);

var _GridDirective2 = _interopRequireDefault(_GridDirective);

var _GridParamsConverter = __webpack_require__(116);

var _GridParamsConverter2 = _interopRequireDefault(_GridParamsConverter);

var _UserResource = __webpack_require__(106);

var _UserResource2 = _interopRequireDefault(_UserResource);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularLocalStorage = __webpack_require__(94);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersGridModule = _angular2.default.module('cms.users.grid', [_GridDirective2.default, _UserResource2.default, _angularGettext2.default, _angularLocalStorage2.default, _ConfigModule2.default, _GridParamsConverter2.default]).component('usersGrid', {
    template: __webpack_require__(931),
    bindings: {
        initialParams: '<?',
        onParamsChange: '&?',
        onPageChange: '&?'
    },
    controller: ['UserResource', 'gettextCatalog', 'toastr', 'localStorageService', 'CONFIG', 'GridParamsConverter', '$state', function controller(UserResource, gettextCatalog, toastr, localStorageService, CONFIG, GridParamsConverter, $state) {
        var _this = this;

        /** @ngInject */

        var getColumnDefs = function getColumnDefs() {
            return [{
                headerName: gettextCatalog.getString("Email"),
                field: "email",
                filter: "text",
                filterParams: { filterOptions: ['contains'] }
            }, {
                headerName: gettextCatalog.getString("First name"),
                field: "firstName",
                filterParams: { filterOptions: ['contains'] }
            }, {
                headerName: gettextCatalog.getString("Last name"),
                field: "lastName",
                filterParams: { filterOptions: ['contains'] }
            }, {
                headerName: gettextCatalog.getString("Actions"),
                suppressFilter: true,
                cellRenderer: function cellRenderer(params) {
                    var button = _angular2.default.element('<button class="btn btn-xs btn-primary">\n                                    <i class="ion-edit"></i> \n                                    ' + gettextCatalog.getString('Edit') + '\n                                </button>');

                    button.on('click', function () {
                        $state.go('usersEdit', {
                            id: params.data.id,
                            returnState: {
                                name: 'users',
                                params: _angular2.default.copy($state.params)
                            }
                        });
                    });

                    return button[0];
                }
            }];
        };

        this.options = {
            _gridStateId: 'user-grid-state',
            _columnDefsCallback: getColumnDefs
        };

        this.initialFilterModel = {};
        var dataInitialized = false;

        var defaultParams = {
            fistName: undefined,
            lastName: undefined,
            email: undefined,
            order_by: undefined,
            order_direction: undefined
        };

        this.$onInit = function () {
            if (!_this.initialParams) {
                _this.initialParams = _angular2.default.copy(defaultParams);
            }

            if (_this.initialParams.order_by) {
                _this.initialSortModel = [{ colId: _this.initialParams.order_by, sort: _this.initialParams.order_direction || 'asc' }];
            }

            if (_this.initialParams.page) {
                _this.initialPage = _this.initialParams.page;
            }

            ['firstName', 'lastName', 'email'].forEach(function (field) {
                if (_this.initialParams[field]) _this.initialFilterModel[field] = { type: 'contains', filter: _this.initialParams[field] };
            });

            ['date'].forEach(function (field) {
                if (_this.initialParams[field + 'After'] && _this.initialParams[field + 'Before']) _this.initialFilterModel[field] = {
                    type: 'inRange',
                    filterType: "date",
                    dateFrom: _this.initialParams[field + 'After'],
                    dateTo: _this.initialParams[field + 'Before']
                };
            });

            _this.datasource = {
                getRows: function getRows(params) {
                    var queryParams = GridParamsConverter.getCmsApiParams(params);
                    var stateParams = Object.assign({}, defaultParams, queryParams);

                    if (_this.onParamsChange) _this.onParamsChange({ params: _angular2.default.copy(stateParams) });

                    delete stateParams.page;
                    $state.go('.', stateParams, {
                        location: 'replace'
                    });

                    var responseData = [];
                    UserResource.findAll(queryParams, function (response) {
                        responseData = response.data;
                        var lastRow = response.total_count;
                        params.successCallback(responseData, lastRow);

                        if (!dataInitialized && _this.initialPage && _this.initialPage !== _this.options.api.paginationGetCurrentPage() + 1) {
                            dataInitialized = true;
                            _this.options.api.paginationGoToPage(parseInt(_this.initialPage) - 1);
                        }
                    });
                }
            };
        };

        this._onPageChange = function (page) {
            if (!dataInitialized) return;
            if (_this.onPageChange) _this.onPageChange({ $page: page });
        };
    }]
});

exports.default = usersGridModule.name;

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <cms-grid grid-options=\"$ctrl.options\"\n              datasource=\"$ctrl.datasource\"\n              initial-sort-model=\"$ctrl.initialSortModel\"\n              initial-filter-model=\"$ctrl.initialFilterModel\"\n              on-page-change=\"$ctrl._onPageChange($page)\"></cms-grid>\n</div>";

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "<div ba-panel ba-panel-title=\"{{'Users' | translate}}\" ba-panel-class=\"\">\n    <div class=\"text-right\">\n        <a class=\"btn btn-md btn-primary\" href=\"{{ $ctrl.exportUrl() }}\" translate target=\"_blank\">Export to CSV</a>\n        <a class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.addUser()\" translate >Add User</a>\n    </div>\n    <br>\n    <users-grid initial-params=\"$ctrl.initialParams\" on-params-change=\"$ctrl.onParamsChange(params)\" on-page-change=\"$ctrl.onPageChange($page)\"></users-grid>\n</div>";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _UserResource = __webpack_require__(106);

var _UserResource2 = _interopRequireDefault(_UserResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersPageAddModule = _angular2.default.module('cms.users.add', [_UserResource2.default, _angularGettext2.default, _angularToastr2.default]).component('appUsersAdd', {
    template: __webpack_require__(934),
    controller: ['UserResource', '$state', 'toastr', 'gettextCatalog', '$stateParams', 'SaveWarning', function controller(UserResource, $state, toastr, gettextCatalog, $stateParams, SaveWarning) {
        var _this = this;

        /** @ngInject */

        this.user = {
            language: 'en'
        };
        this.errors = {};
        this.successAdd = false;

        SaveWarning.watch({}, this.user);

        function goToReturnState() {
            SaveWarning.stopWatch();
            if ($stateParams.returnState) {
                $state.go($stateParams.returnState.name, $stateParams.returnState.params);
            } else {
                $state.go('users', {});
            }
        }

        this.add = function () {
            UserResource.save(_this.user, function (response) {
                _this.user = {};
                _this.errors = {};
                _this.successAdd = true;
                toastr.success(gettextCatalog.getString('User {{username}} created!', { username: _this.user.username }), gettextCatalog.getString('Success'));

                goToReturnState();
            }, function (response) {
                _this.errors = response.data;
                _this.successAdd = false;
            });
        };

        this.onCancel = function () {
            goToReturnState();
        };
    }]
});

exports.default = usersPageAddModule.name;

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widgets narrow-container\">\n    <div class=\"row\">\n        <div class=\"col-lg-8\">\n            <div ba-panel ba-panel-title=\"{{'Add user' | translate}}\" ba-panel-class=\"with-scroll\">\n                <form class=\"form-horizontal\" ng-submit=\"$ctrl.add()\" autocomplete=\"off\" novalidate>\n\n                    <cms-input-text model=\"$ctrl.user.username\" errors=\"$ctrl.errors.username\" label=\"{{ 'User Name' | translate }}\"></cms-input-text>\n                    <cms-input-email model=\"$ctrl.user.email\" errors=\"$ctrl.errors.email\" label=\"{{ 'Email' | translate }}\"></cms-input-email>\n                    <cms-input-password model=\"$ctrl.user.plainPassword\" errors=\"$ctrl.errors.plainPassword\" label=\"{{ 'Password' | translate }}\"></cms-input-password>\n                    <cms-input-text model=\"$ctrl.user.firstName\" errors=\"$ctrl.errors.firstName\" label=\"{{ 'First name' | translate }}\"></cms-input-text>\n                    <cms-input-text model=\"$ctrl.user.lastName\" errors=\"$ctrl.errors.lastName\" label=\"{{ 'Last name' | translate }}\"></cms-input-text>\n                    <cms-input-select model=\"$ctrl.user.language\"\n                                      errors=\"$ctrl.errors.language\"\n                                      label=\"{{ 'Language' | translate }}\"\n                                      options=\"['en', 'pl']\">\n\n                    </cms-input-select>\n                    <div class=\"col-sm-10 col-sm-offset-2\">\n                        <cms-input-checkbox model=\"$ctrl.user.sendMail\" label=\"{{ 'Send Email' | translate }}\"></cms-input-checkbox>\n                    </div>\n                    <div class=\"form-group\">\n                        <div class=\"col-sm-offset-2 col-sm-10\">\n                            <button type=\"submit\" class=\"btn btn-warning\" translate>Add</button>\n                            <button type=\"button\" ng-click=\"$ctrl.onCancel()\" class=\"btn btn-default\" translate>Cancel</button>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _UserResource = __webpack_require__(106);

var _UserResource2 = _interopRequireDefault(_UserResource);

var _LastLogOptions = __webpack_require__(936);

var _LastLogOptions2 = _interopRequireDefault(_LastLogOptions);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersPageEditModule = _angular2.default.module('cms.users.edit', [_UserResource2.default, _angularGettext2.default, _angularToastr2.default, _CMSAuthService2.default, _LastLogOptions2.default, _ConfigModule2.default, _deleteElement2.default]).component('appUsersEdit', {
    template: __webpack_require__(938),
    controller: ['UserResource', '$stateParams', '$state', 'toastr', 'gettextCatalog', 'CMSAuthService', 'LastLogOptions', 'CONFIG', 'deleteElementDialog', 'SaveWarning', function controller(UserResource, $stateParams, $state, toastr, gettextCatalog, CMSAuthService, LastLogOptions, CONFIG, deleteElementDialog, SaveWarning) {
        var _this = this;

        /** @ngInject */

        this.user = {};
        this.user.roles = [];
        this.errors = {};

        this.roles = CONFIG.ROLES.map(function (roleName) {
            return { name: roleName, selected: false };
        });

        this.isMe = false;
        this.showSettingsSection = false;

        /* Grid */
        this.gridOptions = LastLogOptions;
        this.initialParams = {
            ownerId: $stateParams.id
        };

        function goToReturnState() {
            SaveWarning.stopWatch();
            if ($stateParams.returnState) {
                $state.go($stateParams.returnState.name, $stateParams.returnState.params);
            } else {
                $state.go('users', {});
            }
        }

        this.isChecked = function (role) {
            return _this.user.roles.indexOf(role) > -1;
        };

        this.user.id = $stateParams.id;

        UserResource.find(this.user, function (response) {
            _this.user = response;
            SaveWarning.watch(response, _this.user);

            _this.isMe = CMSAuthService.getUser().id === response.id;

            if (!_this.user.isLdapUser && !_this.isMe) {
                _this.showSettingsSection = true;
            }

            if (response.roles) {
                _this.roles.forEach(function (role) {
                    _this.user.roles.forEach(function (userRole) {
                        if (userRole === role.name) {
                            role.selected = true;
                        }
                    });
                });
            } else {
                _this.roles = null;
            }
        }, function (errResponse) {});

        this.saveChanges = function () {
            UserResource.update(_this.user, function (response) {
                _this.errors = {};

                toastr.success(gettextCatalog.getString('User {{username}} updated!', { username: _this.user.username }), gettextCatalog.getString('Success'));
                goToReturnState();
            }, function (errResponse) {
                _this.errors = errResponse.data;
            });
        };

        this.delete = function () {
            UserResource.delete({ id: _this.user.id }, function (response) {
                toastr.success(gettextCatalog.getString('User {{username}} deleted!', { username: _this.user.username }), gettextCatalog.getString('Success'));
                $state.go('users');
            });
        };

        this.enabled = function () {
            var request = { id: _this.user.id, enabled: _this.user.enabled };
            UserResource.update(request, function (response) {});
        };

        this.confirmDelete = function () {
            var deleteMessage = gettextCatalog.getString("Do you really want to delete this account? (This action is irreversible!)");
            deleteElementDialog.open(deleteMessage).then(function () {
                _this.delete();
            }).catch(function () {});
        };

        this.submitRoles = function () {
            var newRoles = [];
            _this.roles.forEach(function (role) {
                if (role.selected) {
                    newRoles.push(role.name);
                }
            });

            var request = { roles: newRoles, id: _this.user.id };

            UserResource.update(request, function (response) {
                _this.user.roles = response.roles;
                toastr.success(gettextCatalog.getString('User {{username}} updated!', { username: _this.user.username }), gettextCatalog.getString('Success'));
            }, function (errResponse) {
                toastr.error(gettextCatalog.getString('There was a problem processing your request. Try again later.'), gettextCatalog.getString('System error'));
            });
        };

        this.onCancel = function () {
            goToReturnState();
        };
    }]
});

exports.default = usersPageEditModule.name;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LastLogOptions = function LastLogOptions(gettextCatalog) {
    var getColumnDefs = function getColumnDefs() {
        return [{ headerName: 'User', field: 'ownerId', hide: true }, { headerName: gettextCatalog.getString('Event'), field: 'event', suppressFilter: true, width: 110 }, {
            headerName: gettextCatalog.getString('Context'),
            field: "context",
            suppressFilter: true,
            valueFormatter: function valueFormatter(data) {
                if (data && data.value) return data.value.split('\\').pop();
                return data;
            },
            width: 110
        }, {
            headerName: gettextCatalog.getString('Date'),
            field: "createdAt",
            suppressFilter: true,
            valueFormatter: function valueFormatter(data) {
                if (data && data.value) return new Date(data.value).toLocaleString();

                return data;
            }
        }];
    };
    return {
        _columnDefsCallback: getColumnDefs,
        enableFilter: false,
        floatingFilter: false,
        hideItemsPageSelect: true,
        paginationPageSize: 10,
        autoHeight: true,
        height: 300
    };
};

LastLogOptions.$inject = ['gettextCatalog'];
exports.default = _angular2.default.module('cms.user.last_log', []).factory('LastLogOptions', LastLogOptions).name;

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-danger\">\n        <em class=\"fa fa-warning\"></em><span style=\"margin-left: 10px;\" translate>Warning</span>\n    </div>\n    <div class=\"modal-body text-center\">{{ content }}</div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" translate>Cancel</button>\n        <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$close()\" translate>Delete</button>\n    </div>\n</div>";

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widgets user-edit-form narrow-container\">\n    <div class=\"row\">\n        <div class=\"col-lg-8\">\n            <div ba-panel ba-panel-title=\"{{ 'Edit user' | translate }}\" ba-panel-class=\"with-scroll\">\n                <form class=\"form-horizontal\" ng-submit=\"$ctrl.saveChanges()\" autocomplete=\"off\" novalidate>\n\n                    <cms-input-text model=\"$ctrl.user.username\" errors=\"$ctrl.errors.username\"\n                                    label=\"{{ 'User Name' | translate }}\"></cms-input-text>\n                    <cms-input-email model=\"$ctrl.user.email\" errors=\"$ctrl.errors.email\"\n                                     label=\"{{ 'Email' | translate }}\"></cms-input-email>\n\n                    <cms-input-password model=\"$ctrl.user.plainPassword\"\n                                        errors=\"$ctrl.errors.plainPassword\"\n                                        label=\"{{ 'Password' | translate }}\"\n                                        disabled=\"$ctrl.user.isLdapUser\">\n                    </cms-input-password>\n\n                    <cms-input-text model=\"$ctrl.user.firstName\" errors=\"$ctrl.errors.firstName\"\n                                    label=\"{{ 'First name' | translate }}\"></cms-input-text>\n                    <cms-input-text model=\"$ctrl.user.lastName\" errors=\"$ctrl.errors.lastName\"\n                                    label=\"{{ 'Last name' | translate }}\"></cms-input-text>\n\n                    <cms-input-select model=\"$ctrl.user.language\"\n                                      errors=\"$ctrl.errors.language\"\n                                      label=\"{{ 'Language' | translate }}\"\n                                      options=\"['en', 'pl']\">\n                    </cms-input-select>\n\n                    <div class=\"form-group\">\n                        <div class=\"col-sm-offset-2 col-sm-10\">\n                            <button type=\"submit\" class=\"btn btn-success\" translate>Save changes</button>\n                            <button type=\"button\" ng-click=\"$ctrl.onCancel()\" class=\"btn btn-default\" translate>Cancel\n                            </button>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class=\"col-lg-4\">\n            <div ba-panel ba-panel-title=\"{{ 'Settings'| translate }}\" ba-panel-class=\"with-scroll\">\n\n                <cms-input-checkbox model=\"$ctrl.user.enabled\"\n                                    errors=\"$ctrl.errors.enabled\"\n                                    disabled=\"!$ctrl.showSettingsSection\"\n                                    label=\"{{ 'Account active' | translate }}\"\n                                    changed=\"$ctrl.enabled()\"\n                                    position=\"left\"\n                                    label-size=\"4\"\n                                    input-size=\"1\"\n                >\n                </cms-input-checkbox>\n\n                    <button class=\"btn btn-danger\" translate data-toggle=\"modal\" ng-click=\"$ctrl.confirmDelete()\"\n                            ng-disabled=\"!$ctrl.showSettingsSection\">\n                        Delete user\n                    </button>\n            </div>\n\n            <div ba-panel ba-panel-title=\"{{ 'Roles' | translate }}\" ba-panel-class=\"with-scroll\">\n\n                <div class=\"checkbox\" ng-repeat=\"role in $ctrl.roles\">\n\n                    <label for=\"{{ role.name }}\">\n                        <input type=\"checkbox\" ng-model=\"role.selected\" ng-checked='role.selected'\n                               value=\"{{ role.name }}\" id=\"{{ role.name }}\">\n                        {{ role.name | translate }}\n                    </label>\n\n                </div>\n                <button class=\"btn btn-primary\" ng-click=\"$ctrl.submitRoles()\" ng-disabled=\"!$ctrl.user.roles\" translate>Update roles</button>\n            </div>\n\n            <div ba-panel ba-panel-title=\"{{ 'User logs' | translate }}\" ba-panel-class=\"with-scroll\">\n\n                <logs-grid grid-options=\"$ctrl.gridOptions\" initial-params=\"$ctrl.initialParams\"></logs-grid>\n\n                <button class=\"btn btn-default\" translate ui-sref=\"logs({ownerName:$ctrl.user.username})\">\n                    Go to user logs\n                </button>\n\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _ProductsListPage = __webpack_require__(940);

var _ProductsListPage2 = _interopRequireDefault(_ProductsListPage);

var _ProductsFormPage = __webpack_require__(944);

var _ProductsFormPage2 = _interopRequireDefault(_ProductsFormPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

routeConfig.$inject = ['$stateProvider', 'gettext'];


var productsPageModule = _angular2.default.module('cms.pages.products', [_angularjs2.default, _angularGettext2.default, _ProductsListPage2.default, _ProductsFormPage2.default]).config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */
    $stateProvider.state('products', {
        url: '/products?name&slug&price&status&order_by&order_direction&page',
        component: 'productsListPage',
        title: gettext('Products'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        reloadOnSearch: false,
        sidebarMeta: {
            icon: 'ion-android-cart',
            order: 0,
            allow: ['ROLE_ADMIN']
        }
    }).state('productsAdd', {
        url: '/products/add',
        component: 'productsFormPage',
        title: gettext('Add Product'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        params: {
            returnState: null
        },
        breadcrumbsMeta: {
            parentState: 'products'
        }
    }).state('productsEdit', {
        url: '/products/edit/:id',
        component: 'productsFormPage',
        params: {
            returnState: null
        },
        title: gettext('Edit Product'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        breadcrumbsMeta: {
            parentState: 'products'
        }
    });
}

exports.default = productsPageModule.name;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ProductsGrid = __webpack_require__(941);

var _ProductsGrid2 = _interopRequireDefault(_ProductsGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.products.list', [_ProductsGrid2.default]).component('productsListPage', {
    template: __webpack_require__(943),
    bindings: {
        $transition$: '<'
    },
    controller: ['gettextCatalog', 'toastr', 'CONFIG', '$state', 'ExportService', function controller(gettextCatalog, toastr, CONFIG, $state, ExportService) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.initialParams = _this.$transition$.params();
        };

        this.onParamsChange = function (params) {
            delete params.page;
            $state.go('.', params, {
                location: 'replace'
            });
        };

        this.addProduct = function () {
            $state.go('productsAdd', {
                returnState: {
                    name: 'products',
                    params: _angular2.default.copy($state.params)
                }
            });
        };

        this.onPageChange = function (page) {
            if (page === 0) {
                return;
            }
            $state.go('.', { page: page !== 1 ? page : undefined }, {
                location: 'replace'
            });
        };

        this.exportUrl = function () {
            return ExportService.getUrl('products');
        };
    }]
}).name;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _GridDirective = __webpack_require__(107);

var _GridDirective2 = _interopRequireDefault(_GridDirective);

var _GridParamsConverter = __webpack_require__(116);

var _GridParamsConverter2 = _interopRequireDefault(_GridParamsConverter);

var _ProductResource = __webpack_require__(432);

var _ProductResource2 = _interopRequireDefault(_ProductResource);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productsGridModule = _angular2.default.module('cms.products.grid', [_GridDirective2.default, _ProductResource2.default, _angularGettext2.default, _ConfigModule2.default, _GridParamsConverter2.default]).component('productsGrid', {
    template: __webpack_require__(942),
    bindings: {
        initialParams: '<?',
        onParamsChange: '&?',
        onPageChange: '&?'
    },
    controller: ['ProductResource', 'gettextCatalog', 'toastr', 'CONFIG', 'GridParamsConverter', '$state', function controller(ProductResource, gettextCatalog, toastr, CONFIG, GridParamsConverter, $state) {
        var _this = this;

        /** @ngInject */

        var getColumnDefs = function getColumnDefs() {
            return [{
                headerName: gettextCatalog.getString("Name"),
                field: "name",
                filter: "text",
                filterParams: { filterOptions: ['contains'] }
            }, {
                headerName: gettextCatalog.getString("Slug"),
                field: "slug",
                filter: "text",
                filterParams: { filterOptions: ['contains'] }
            }, {
                headerName: gettextCatalog.getString("Price"),
                field: "price",
                filter: "number",
                filterParams: { filterOptions: ['startsWith'] }
            }, {
                headerName: gettextCatalog.getString("Status"),
                field: "status",
                filter: "text",
                filterParams: { filterOptions: ['startsWith'] },
                cellRenderer: function cellRenderer(params) {
                    var cls = params.value === 'aktywny' ? 'success' : 'danger';
                    var label = _angular2.default.element('<span class="text-' + cls + '"><i class="fa fa-circle"></i>&nbsp; ' + params.value + '</span>');
                    return label[0];
                }

            }, {
                headerName: gettextCatalog.getString("Actions"),
                suppressFilter: true,
                cellRenderer: function cellRenderer(params) {
                    var button = _angular2.default.element('<button class="btn btn-xs btn-primary">\n                                    <i class="ion-edit"></i>\n                                    ' + gettextCatalog.getString('Edit') + '\n                                </button>');

                    button.on('click', function () {
                        $state.go('productsEdit', {
                            id: params.data.id,
                            returnState: {
                                name: 'products',
                                params: _angular2.default.copy($state.params)
                            }
                        });
                    });

                    return button[0];
                }
            }];
        };

        this.options = {
            _columnDefsCallback: getColumnDefs,
            _gridStateId: 'product-grid-state'
        };

        this.initialFilterModel = {};
        var dataInitialized = false;

        var defaultParams = {
            name: undefined,
            slug: undefined,
            price: undefined,
            status: undefined,
            order_by: undefined,
            order_direction: undefined
        };

        this.$onInit = function () {
            if (!_this.initialParams) {
                _this.initialParams = _angular2.default.copy(defaultParams);
            }

            if (_this.initialParams.order_by) {
                _this.initialSortModel = [{ colId: _this.initialParams.order_by, sort: _this.initialParams.order_direction || 'asc' }];
            }

            if (_this.initialParams.page) {
                _this.initialPage = _this.initialParams.page;
            }

            ['name', 'slug', 'price', 'status'].forEach(function (field) {
                if (_this.initialParams[field]) _this.initialFilterModel[field] = { type: 'contains', filter: _this.initialParams[field] };
            });

            _this.datasource = {
                getRows: function getRows(params) {
                    var queryParams = GridParamsConverter.getCmsApiParams(params);
                    var stateParams = Object.assign({}, defaultParams, queryParams);

                    if (_this.onParamsChange) _this.onParamsChange({ params: _angular2.default.copy(stateParams) });

                    delete stateParams.page;
                    $state.go('.', stateParams, {
                        location: 'replace'
                    });

                    var responseData = [];
                    ProductResource.findAll(queryParams, function (response) {
                        responseData = response.data;
                        var lastRow = response.total_count;
                        params.successCallback(responseData, lastRow);

                        if (!dataInitialized && _this.initialPage && _this.initialPage !== _this.options.api.paginationGetCurrentPage() + 1) {
                            dataInitialized = true;
                            _this.options.api.paginationGoToPage(parseInt(_this.initialPage) - 1);
                        }
                    }, function (errResponse) {});
                }
            };
        };

        this._onPageChange = function (page) {
            if (!dataInitialized) return;
            if (_this.onPageChange) _this.onPageChange({ $page: page });
        };
    }]
});

exports.default = productsGridModule.name;

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <cms-grid grid-options=\"$ctrl.options\"\n              datasource=\"$ctrl.datasource\"\n              initial-sort-model=\"$ctrl.initialSortModel\"\n              initial-filter-model=\"$ctrl.initialFilterModel\"\n              on-page-change=\"$ctrl._onPageChange($page)\"></cms-grid>\n</div>";

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "<div ba-panel ba-panel-title=\"{{'Products' | translate }}\" ba-panel-class=\"\">\n    <div class=\"text-right\">\n        <a class=\"btn btn-md btn-primary\" href=\"{{ $ctrl.exportUrl() }}\" translate target=\"_blank\">Export to CSV</a>\n        <a class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.addProduct()\" translate >Add Product</a>\n    </div>\n    <br>\n    <products-grid initial-params=\"$ctrl.initialParams\" on-params-change=\"$ctrl.onParamsChange(params)\" on-page-change=\"$ctrl.onPageChange($page)\"></products-grid>\n</div>";

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _ProductResource = __webpack_require__(432);

var _ProductResource2 = _interopRequireDefault(_ProductResource);

var _ProductCategoryResource = __webpack_require__(945);

var _ProductCategoryResource2 = _interopRequireDefault(_ProductCategoryResource);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productsFormPage = _angular2.default.module('cms.products.add', [_ProductResource2.default, _ProductCategoryResource2.default, _angularGettext2.default, _angularToastr2.default, _deleteElement2.default]).component('productsFormPage', {
    template: __webpack_require__(946),
    controller: ['$scope', 'ProductResource', 'ProductCategoryResource', '$state', '$stateParams', '$http', '$q', 'toastr', 'gettextCatalog', 'ACLService', 'deleteElementDialog', 'CONFIG', 'SaveWarning', '$element', function controller($scope, ProductResource, ProductCategoryResource, $state, $stateParams, $http, $q, toastr, gettextCatalog, ACLService, deleteElementDialog, CONFIG, SaveWarning, $element) {
        var _this = this;

        /** @ngInject */

        if ($stateParams.id) {
            ProductResource.find({ id: $stateParams.id }, function (response) {
                _this.product = response;
                SaveWarning.watch(response, _this.product, $scope, $element);
            });
        } else {
            this.product = {
                attachments: [],
                photos: []
            };
            SaveWarning.watch(this.product, this.product, $scope, $element);
        }

        this.matchRoles = ACLService.matchRoles;

        this.errors = {};
        this.pending = false;

        /**
         * Broadcast slug recalculation request
         */
        this.updateSlug = function () {
            if (!this.product.id || !this.product.slug) {
                $scope.$broadcast('slug.recalc');
            }
        };

        /**
         * Actions to validate slug
         * Returns promise;
         * @param data
         */
        this.validateSlug = function (data) {
            var _this2 = this;

            this.errors.slug = [];
            if (!data) {
                return $q.when([]);
            }

            var productResourcePromise = ProductResource.findAll({ slug_strict: data }).$promise;

            productResourcePromise.then(function (response) {

                _angular2.default.forEach(response.data, function (value) {
                    if (value.id !== this.product.id) {
                        this.errors.slug = [gettextCatalog.getString('This value is already used')];
                    }
                }, _this2);
            });

            return productResourcePromise;
        };

        ProductCategoryResource.findAll({}, function (data) {
            _this.productCategories = data.data;
        });

        this.onErrorMessage = function () {
            return toastr.error(gettextCatalog.getString('Please correct form errors and try again.', { name: this.product.name }), gettextCatalog.getString('Validation Errors'));
        };

        /**
         * Submit products
         */
        this.create = function () {
            _this.pending = true;
            ProductResource.save(_this.product, function (response) {
                _this.product = {};
                _this.errors = {};
                SaveWarning.watch(response, _this.product, $scope, $element);
                toastr.success(gettextCatalog.getString('Product {{name}} added!', { name: _this.product.name }), gettextCatalog.getString('Success'));
                goToReturnState();
                _this.pending = false;
            }, function (response) {
                if (response.status === 400) {
                    _this.errors = response.data;
                    _this.onErrorMessage();
                }
                _this.pending = false;
            });
        };

        /**
         * Submit products
         */
        this.update = function () {
            _this.pending = true;
            ProductResource.update(_this.product, function (response) {
                _this.product = {};
                _this.errors = {};
                SaveWarning.watch(response, _this.product, $scope, $element);
                toastr.success(gettextCatalog.getString('Product {{name}} saved!', { name: _this.product.name }), gettextCatalog.getString('Success'));
                goToReturnState();
                _this.pending = false;
            }, function (response) {
                if (response.status === 400) {
                    _this.errors = response.data;
                    _this.onErrorMessage();
                }
                _this.pending = false;
            });
        };

        this.updateOrCreate = function () {
            if (_this.product.id) {
                return _this.update(false);
            } else {
                return _this.create(false);
            }
        };

        this.delete = function () {
            _this.pending = true;
            ProductResource.delete({ id: _this.product.id }, function (response) {
                toastr.success(gettextCatalog.getString('Product {{name}} deleted!', { name: _this.product.name }), gettextCatalog.getString('Success'));
                goToReturnState();
                _this.pending = false;
            });
        };

        this.confirmDelete = function () {
            var removeMessage = gettextCatalog.getString("Are you sure that you want to delete the \"{{name}}\" product?", { name: _this.product.name });
            deleteElementDialog.open(removeMessage).then(function () {
                _this.delete();
            }).catch(function () {});
        };

        // @tip wyrzucając tą funkcję do innego pliku pozbędziemy się 2 zależności - $http i CONFIG
        this.orderStatistics = function () {
            if ($stateParams.id) {
                return $http.get(CONFIG.API_URL + '/product-stats/order/' + $stateParams.id + '/30');
            }
        };

        this.cancel = function () {
            return goToReturnState();
        };

        function goToReturnState() {
            SaveWarning.stopWatch();
            if ($stateParams.returnState) {
                $state.go($stateParams.returnState.name, $stateParams.returnState.params);
            } else {
                $state.go('products', {});
            }
        }

        $scope.$on('save.object', function () {
            _this.updateOrCreate();
        });
    }]
});

exports.default = productsFormPage.name;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productCategoryResource = _angular2.default.module('cms.productCategory.resource', [_angularResource2.default, _ConfigModule2.default]).factory('ProductCategoryResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInclude */

    return $resource(CONFIG.API_URL + '/productCategories', {}, {
        'findAll': { method: 'GET' }
    });
}]);

exports.default = productCategoryResource.name;

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widgets narrow-container\">\n    <div class=\"row\">\n        <div class=\"col-lg-8\">\n            <div ba-panel ba-panel-title=\"{{'Main info' | translate}}\" ba-panel-class=\"with-scroll\">\n                <form class=\"form-horizontal\" autocomplete=\"off\" novalidate>\n\n\n                    <cms-input-text model=\"$ctrl.product.name\"\n                                    label=\"{{ 'Name' | translate }}\"\n                                    errors=\"$ctrl.errors.name\"\n                                    on-blur=\"$ctrl.updateSlug(data)\"></cms-input-text>\n\n                    <cms-input-slug model=\"$ctrl.product.slug\"\n                                    label=\"{{'Slug' | translate }}\"\n                                    errors=\"$ctrl.errors.slug\"\n                                    slug-validation=\"$ctrl.validateSlug(data)\"\n                                    slug-source=\"$ctrl.product.name\"></cms-input-slug>\n\n                    <cms-input-select model=\"$ctrl.product.status\" errors=\"$ctrl.errors.status\" label=\"{{ 'Status' | translate }}\"\n                                      options=\"['aktywny', 'nieaktywny']\"></cms-input-select>\n\n                    <cms-input-money model=\"$ctrl.product.price\" errors=\"$ctrl.errors.price\" label=\"{{ 'Price' | translate }}\"\n                                     currency=\"\"></cms-input-money>\n\n                    <cms-input-select model=\"$ctrl.product.currency\" errors=\"$ctrl.errors.currency\" label=\"{{ 'Currency' | translate }}\"\n                                      options=\"['EUR', 'USD', 'GBP', 'PLN']\"></cms-input-select>\n\n\n                    <cms-input-html-editor model=\"$ctrl.product.description\"\n                                           errors=\"$ctrl.errors.description\"\n                                           label=\"{{ 'Description' | translate }}\"></cms-input-html-editor>\n\n                    <cms-input-select model=\"$ctrl.product.categories\" errors=\"$ctrl.errors.categories\" label=\"{{ 'Categories' | translate }}\"\n                                      options=\"$ctrl.productCategories\" multiple=\"true\"></cms-input-select>\n\n                    <cms-input-date model=\"$ctrl.product.releaseDate\"\n                                    errors=\"$ctrl.errors.releaseDate\"\n                                    time-picker-enabled=\"false\"\n                                    label=\"{{ 'Release date' | translate }}\">\n                    </cms-input-date>\n\n                    <cms-input-date model=\"$ctrl.product.promotionStartDate\"\n                                    errors=\"$ctrl.errors.promotionStartDate\"\n                                    time-picker-enabled=\"true\"\n                                    label=\"{{ 'Promotion start' | translate }}\">\n                    </cms-input-date>\n\n                    <cms-input-date model=\"$ctrl.product.promotionEndDate\"\n                                    errors=\"$ctrl.errors.promotionEndDate\"\n                                    time-picker-enabled=\"true\"\n                                    label=\"{{ 'Promotion end' | translate }}\">\n                    </cms-input-date>\n\n\n                </form>\n            </div>\n\n            <div ba-panel ba-panel-title=\"{{'Media' | translate}}\" ba-panel-class=\"with-scroll\">\n                <div class=\"form-horizontal\" autocomplete=\"off\" novalidate>\n                    <cms-input-media multiple=\"true\" label=\"{{ 'Photos' | translate }}\" extra-fields=\"{alt:true}\" model=\"$ctrl.product.photos\"></cms-input-media>\n                    <cms-input-media multiple=\"true\" label=\"{{ 'Files' | translate }}\" model=\"$ctrl.product.attachments\"></cms-input-media>\n                </div>\n            </div>\n\n            <div ba-panel ba-panel-title=\"{{'SEO' | translate}}\" ba-panel-class=\"with-scroll\">\n                <form class=\"form-horizontal\" autocomplete=\"off\" novalidate>\n                    <cms-input-text model=\"$ctrl.product.seoKeywords\" errors=\"$ctrl.errors.seoKeywords\" label=\"{{ 'Keywords' | translate }}\"></cms-input-text>\n                    <cms-input-text model=\"$ctrl.product.seoDescription\" errors=\"$ctrl.errors.seoDescription\" label=\"{{ 'Description' | translate }}\"></cms-input-text>\n                    <cms-input-text model=\"$ctrl.product.seoOgTitle\" errors=\"$ctrl.errors.seoOgTitle\" label=\"{{ 'og:title' | translate }}\"></cms-input-text>\n                    <cms-input-text model=\"$ctrl.product.seoOgType\" errors=\"$ctrl.errors.seoOgType\" label=\"{{ 'og:type' | translate }}\"></cms-input-text>\n                    <cms-input-text model=\"$ctrl.product.seoOgImage\" errors=\"$ctrl.errors.seoOgImage\" label=\"{{ 'og:image' | translate }}\"></cms-input-text>\n                    <cms-input-text model=\"$ctrl.product.seoOgUrl\" errors=\"$ctrl.errors.seoOgUrl\" label=\"{{ 'og:url' | translate }}\"></cms-input-text>\n                </form>\n            </div>\n\n            <div ba-panel ba-panel-title=\"{{'Notes' | translate}}\" ba-panel-class=\"with-scroll\">\n                <form class=\"form-horizontal\" autocomplete=\"off\" novalidate>\n                    <cms-input-textarea\n                            model=\"$ctrl.product.notes\"\n                            errors=\"$ctrl.errors.notes\"\n                            label=\"{{ 'Notes' | translate }}\"\n                            acl-show=\"$ctrl.matchRoles(['ROLE_USER', 'ROLE_ADMIN'])\"\n                            acl-disable=\"$ctrl.matchRoles(['ROLE_USER'])\"\n                    ></cms-input-textarea>\n                </form>\n            </div>\n\n            <div ba-panel class=\"text-right\">\n                <button ng-click=\"$ctrl.cancel()\" ng-disabled=\"$ctrl.pending\" class=\"btn btn-default pull-left\" translate>Cancel</button>\n                <button ng-click=\"$ctrl.create()\" ng-disabled=\"$ctrl.pending\" ng-if=\"!$ctrl.product.id\" class=\"btn btn-success\" translate>Save product</button>\n                <button ng-click=\"$ctrl.update()\" ng-disabled=\"$ctrl.pending\" ng-if=\"$ctrl.product.id\" class=\"btn btn-success\" translate>Save product</button>\n            </div>\n\n        </div>\n\n        <div class=\"col-lg-4\">\n            <div ba-panel ba-panel-title=\"{{'Settings' | translate}}\" class=\"side-form\" ba-panel-class=\"with-scroll\">\n\n                <p class=\"text-ellipsis\">{{$ctrl.product.name || ' '}}</p>\n\n                <ul class=\"side-form__details\">\n                    <li><strong translate>Slug:</strong> {{$ctrl.product.slug || '-'}}</li>\n                    <li><strong translate>Created at:</strong> {{ ($ctrl.product.createdAt | date: \"d.MM.yyyy H:mm:ss\") || '-'}}</li>\n                    <li><strong translate>Updated at:</strong> {{ ($ctrl.product.updatedAt | date: \"d.MM.yyyy H:mm:ss\") || '-'}}</li>\n                </ul>\n\n                <div class=\"side-form__buttons\">\n\n                    <button ng-click=\"$ctrl.create()\" ng-disabled=\"$ctrl.pending\" ng-if=\"!$ctrl.product.id\" class=\"btn btn-success\" translate>Save product</button>\n                    <button ng-click=\"$ctrl.update()\" ng-disabled=\"$ctrl.pending\" ng-if=\"$ctrl.product.id\" class=\"btn btn-success\" translate>Save product</button>\n                    <button ng-click=\"$ctrl.confirmDelete()\" ng-disabled=\"!$ctrl.product.id || $ctrl.pending\" class=\"btn btn-danger\" translate>Delete</button>\n                </div>\n            </div>\n\n            <div ba-panel ba-panel-title=\"{{'Statistics' | translate}}\" class=\"side-form\" ba-panel-class=\"with-scroll\" ng-if=\"$ctrl.product.id\">\n                <cms-linear-chart chart-id=\"orderProductsStatistics\" callback-promise=\"$ctrl.orderStatistics\"></cms-linear-chart>\n            </div>\n\n        </div>\n\n    </div>\n</div>\n";

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _MediaPageDirective = __webpack_require__(948);

var _MediaPageDirective2 = _interopRequireDefault(_MediaPageDirective);

__webpack_require__(962);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

routeConfig.$inject = ['$stateProvider', 'gettext'];


var dashboardModule = _angular2.default.module('cms.pages.media', [_angularjs2.default, _angularGettext2.default, _MediaPageDirective2.default]).config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */
    $stateProvider.state('media', {
        url: '/media',
        component: 'mediaPageView',
        title: gettext('Media library'),
        data: {
            requiresAuth: ['ROLE_ADMIN', 'ROLE_USER']
        },
        sidebarMeta: {
            icon: 'ion-image',
            order: 0,
            allow: ['ROLE_ADMIN', 'ROLE_USER']
        }
    });
}

exports.default = dashboardModule.name;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MediaListing = __webpack_require__(949);

var _MediaListing2 = _interopRequireDefault(_MediaListing);

var _UnsplashListing = __webpack_require__(957);

var _UnsplashListing2 = _interopRequireDefault(_UnsplashListing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediaPageModule = _angular2.default.module('cms.media.page', [_MediaListing2.default, _UnsplashListing2.default]).component('mediaPageView', {
    template: __webpack_require__(961),
    controller: function controller() {
        var _this = this;

        this.activeTab = 1;

        this.setActiveTab = function (number) {
            _this.activeTab = number;
        };
    }
});
exports.default = mediaPageModule.name;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MediaResource = __webpack_require__(95);

var _MediaResource2 = _interopRequireDefault(_MediaResource);

var _MediaTile = __webpack_require__(950);

var _MediaTile2 = _interopRequireDefault(_MediaTile);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _MediaDropzoneModule = __webpack_require__(953);

var _MediaDropzoneModule2 = _interopRequireDefault(_MediaDropzoneModule);

var _PaginationControlsModule = __webpack_require__(229);

var _PaginationControlsModule2 = _interopRequireDefault(_PaginationControlsModule);

var _uiSelect = __webpack_require__(202);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.listing', [_MediaResource2.default, _ConfigModule2.default, _MediaTile2.default, _MediaDropzoneModule2.default, _PaginationControlsModule2.default, _uiSelect2.default, _angularGettext2.default]).component('cmsMediaListing', {
    template: __webpack_require__(956),
    bindings: {
        displayLimit: '<',
        selectable: '<',
        onSelect: '&',
        tileClass: '@',
        multiple: '<',
        shouldAutoSelect: '='
    },
    controller: ['MediaResource', '$scope', 'gettextCatalog', function controller(MediaResource, $scope, gettextCatalog) {
        var _this = this;

        /** @ngInject */

        this.defaultDisplayLimit = 10;

        this.selectionData = {};

        this.availableOrders = [];

        this.$onInit = function () {
            _this.selectedOrder = _this.availableOrders[7];
            _this.currentPage = MediaResource.get({
                page: 1,
                order_by: _this.selectedOrder.property,
                order_direction: _this.selectedOrder.direction,
                limit: _this.displayLimit || _this.defaultDisplayLimit
            });
        };

        var getAvailableFilters = function getAvailableFilters() {
            return {
                type: {
                    values: ['image', 'file'].map(function (type) {
                        return {
                            label: gettextCatalog.getString(type),
                            property: 'type',
                            value: type
                        };
                    }),
                    title: gettextCatalog.getString('Search by type'),
                    selectedPrefix: gettextCatalog.getString('Type')
                }
            };
        };
        this.availableFilters = getAvailableFilters();

        this.selectedFilters = {
            clientOriginalName: {
                value: ''
            }
        };

        var getFilterLabels = function getFilterLabels() {
            return [{
                label: gettextCatalog.getString('name', null, 'As in "Sort by media name"'),
                property: 'clientOriginalName'
            }, {
                label: gettextCatalog.getString('file extension', null, 'As in "Sort by media file extension"'),
                property: 'extension'
            }, {
                label: gettextCatalog.getString('size', null, 'As in "Sort by media file size"'),
                property: 'size',
                sortType: 'numeric'
            }, {
                label: gettextCatalog.getString('upload date', null, 'As in "Sort by media upload date"'),
                property: 'createdAt',
                sortType: 'numeric'
            }, {
                label: gettextCatalog.getString('type', null, 'As in "Sort by media type"'),
                property: 'type'
            }].forEach(function (filterGroup) {
                _this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'asc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });
                _this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'desc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });
            });
        };

        var filterLabels = getFilterLabels();

        $scope.$on('language-changed', function () {
            _this.availableOrders = [];
            filterLabels = getFilterLabels();
            _this.availableFilters = getAvailableFilters();

            _this.availableOrders.forEach(function (element) {
                if (element.property === this.selectedOrder.property && element.direction === this.selectedOrder.direction) {
                    this.selectedOrder = element;
                }
            }, _this);
        });

        this.onTileSelectionChange = function (selected, media) {
            Object.keys(_this.selectionData).forEach(function (key) {
                if (!_this.multiple && key !== media.id) {
                    delete _this.selectionData[key];
                }
                if (_this.multiple && key === media.id) {
                    delete _this.selectionData[key];
                }
            });

            _this.onSelect({ media: media, selected: selected });
        };

        this.onRemoved = function (media) {
            var index = _this.currentPage.data.indexOf(media);
            if (index > -1) {
                _this.currentPage.data.splice(index, 1);
            }
        };

        this.onUploadAdded = function (file) {
            var uploadTile = {
                _uploadId: file.upload.uuid,
                type: file.type.indexOf("image") === -1 ? 'file' : 'image',
                clientOriginalName: file.name,
                size: file.size,
                status: file.status
            };
            $scope.$apply(function () {
                _this.currentPage.data.unshift(uploadTile);
            });
        };

        this.onUploadUpdated = function (uploadId, file) {
            _this.currentPage.data.forEach(function (element, index, uploads) {
                if (element._uploadId === uploadId) {
                    $scope.$apply(function () {
                        uploads[index].status = file.status;
                        uploads[index].dataURL = file.dataURL;
                    });
                }
            });
        };

        this.onUploadSuccess = function (uploadId, media) {
            _this.currentPage.data.forEach(function (element, index, uploads) {
                if (element._uploadId === uploadId) {
                    $scope.$apply(function () {
                        delete uploads[index].status;
                        delete uploads[index]._uploadId;
                        uploads[index].key = media.key;
                        uploads[index].id = media.id;
                        if (_this.shouldAutoSelect) {
                            _this.selectionData[media.id] = media;
                            _this.onTileSelectionChange(true, media);
                        }
                    });
                }
            });
        };

        this.onUploadError = function (uploadId, file, message) {
            _this.currentPage.data.forEach(function (element, index, uploads) {
                if (element._uploadId === uploadId) {
                    $scope.$apply(function () {
                        uploads[index].status = file.status;
                        uploads[index].errorMessage = message;
                    });
                }
            });
        };

        this.loadPage = function (page) {
            var filterValues = {};

            Object.keys(_this.selectedFilters).forEach(function (filterProperty) {
                if (_this.selectedFilters[filterProperty]) filterValues[filterProperty] = _this.selectedFilters[filterProperty].value;
            });

            _this.currentPage.$cancelRequest();

            var criteria = {
                page: page,
                order_by: _this.selectedOrder.property,
                order_direction: _this.selectedOrder.direction,
                limit: _this.displayLimit || _this.defaultDisplayLimit
            };

            _this.currentPage = MediaResource.get(Object.assign(criteria, filterValues));
        };

        this.applyFilters = function () {
            _this.currentPage.current_page = 1;
            _this.loadPage(_this.currentPage.current_page);
        };
    }]
}).name;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _MediaResource = __webpack_require__(95);

var _MediaResource2 = _interopRequireDefault(_MediaResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _FileSizeFilter = __webpack_require__(951);

var _FileSizeFilter2 = _interopRequireDefault(_FileSizeFilter);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.browser.tile', [_ConfigModule2.default, _MediaResource2.default, _FileSizeFilter2.default, _angularGettext2.default, _angularToastr2.default]).component('mediaTile', {
    template: __webpack_require__(952),
    bindings: {
        media: '<',
        softDelete: '<',
        onRemoved: '&',
        selectable: '<',
        onSelectionChange: '&',
        isSelected: '=',
        tileClass: '@',
        disabled: '<'
    },
    transclude: true,
    controller: ['CONFIG', 'MediaResource', '$scope', 'toastr', 'gettextCatalog', function controller(CONFIG, MediaResource, $scope, toastr, gettextCatalog) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.previewImage = _this.media.key ? CONFIG.API_PUBLIC + '/image/250x180/' + _this.media.key : null;
        };

        this.$onChanges = function () {
            _this.previewImage = _this.media.key ? CONFIG.API_PUBLIC + '/image/250x180/' + _this.media.key : null;
        };

        this.toggleSelected = function () {
            if (!_this.selectable) return;

            _this.isSelected = !_this.isSelected;

            _this.onSelectionChange({ selected: _this.isSelected });
        };

        this.onRemoveMedia = function () {

            if (_this.softDelete) {
                _this.onRemoved(_this.media);

                $scope.$emit('content-changed');
                return;
            }

            _this.isRemoving = true;
            MediaResource.delete({ id: _this.media.id }, function () {
                if (_this.onRemoved) {
                    _this.onRemoved(_this.media);
                }

                $scope.$emit('content-changed');
            }, function (error) {
                var errorMessage = error.data.id[0];
                toastr.error(gettextCatalog.getString(errorMessage), gettextCatalog.getString("Cannot remove file."));
                _this.isRemoving = false;
            });
        };
    }]
}).name;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.filter.file-size', []).filter('fileSize', function () {
    return function (bytes, precision) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
        if (typeof precision === 'undefined') precision = 1;
        var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'],
            number = Math.floor(Math.log(bytes) / Math.log(1000));
        return (bytes / Math.pow(1000, number)).toFixed(precision) + ' ' + units[number];
    };
}).name;

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = "<div class=\"media-tile\"\n     ng-class=\"[\n            $ctrl.tileClass || 'panel',\n            'media-tile--' + $ctrl.media.type,\n             {\n                'media-tile--removing':$ctrl.isRemoving,\n                'media-tile--selected':$ctrl.isSelected,\n                'media-tile--selectable':$ctrl.selectable,\n                'media-tile--error':$ctrl.media.status === 'error'\n             }]\">\n    <div ng-click=\"$ctrl.toggleSelected()\">\n        <div class=\"media-tile__selected-marker\"></div>\n        <div class=\"media-tile__miniature-wrapper\"\n             style=\"background-image: url('{{ $ctrl.previewImage || $ctrl.media.dataURL }}')\">\n\n            <em ng-if=\"$ctrl.media.type !== 'image'\" class=\"tile-icon-element ion-document-text\" ></em>\n\n            <div class=\"tile-actions-element\">\n                <a href=\"\" class=\"tile-action-element btn-remove\" type=\"button\"\n                    ng-click=\"$event.stopPropagation(); $ctrl.isDeleteConfirmationVisible = true\">\n                    <em class=\"ion-trash-a\"></em>\n                </a>\n            </div>\n\n        </div>\n        <div class=\"media-tile__name\" title=\"{{$ctrl.media.clientOriginalName}}\">\n            {{$ctrl.media.clientOriginalName}}\n        </div>\n\n        <ng-transclude></ng-transclude>\n\n        <ul class=\"media-tile__details\">\n            <li>{{'Size' | translate:'File size label'}}: {{$ctrl.media.size | fileSize}}</li>\n            <li ng-click=\"$event.stopPropagation()\" class=\"pull-right text-light\">\n                <em ng-show=\"$ctrl.media.source === 'unsplash'\"\n                    class=\"fa fa-camera fa-1x\"\n                    uib-tooltip=\"{{ 'Downloaded from Unsplash' | translate }}\"\n                    tooltip-placement=\"left\">\n                </em>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"tile-overlay tile-overlay-pending animated\"\n         ng-if=\"$ctrl.media.status === 'added' || $ctrl.media.status === 'uploading'\">\n        <em class=\"fa fa-3x fa-circle-o-notch fa-spin\" ></em>\n    </div>\n\n    <div class=\"tile-overlay tile-overlay-error animated disable-click-outside\"\n         ng-if=\"$ctrl.media.status === 'error'\"\n         ng-click=\"$ctrl.onRemoved($ctrl.media)\">\n        <p>{{$ctrl.media.errorMessage}}</p>\n    </div>\n\n    <div ng-if=\"$ctrl.isDeleteConfirmationVisible\" class=\"tile-overlay tile-overlay-actions animated\">\n        <div>\n            <p>{{ 'Before removing, check if this image is not used somewhere' | translate }}</p>\n            <button type=\"button\" class=\"btn btn-default btn-sm\"\n                    ng-click=\"$ctrl.isDeleteConfirmationVisible = false\">{{'Cancel' | translate}}</button>\n            <button type=\"button\" class=\"btn btn-danger btn-sm disable-click-outside\"\n                    ng-click=\"$ctrl.onRemoveMedia()\">{{'Delete' | translate}}</button>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _dropzone = __webpack_require__(954);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

var _MediaResource = __webpack_require__(95);

var _MediaResource2 = _interopRequireDefault(_MediaResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.dropzone', [_ConfigModule2.default, _CMSAuthService2.default, _MediaResource2.default, _angularGettext2.default]).component('mediaDropzone', {
    template: __webpack_require__(955),
    bindings: {
        onUploadAdded: '&',
        onUploadUpdated: '&',
        onUploadSuccess: '&',
        onUploadError: '&'
    },
    controller: ['$scope', '$element', 'CONFIG', 'CMSAuthService', 'MediaResource', 'gettextCatalog', '$rootScope', function controller($scope, $element, CONFIG, CMSAuthService, MediaResource, gettextCatalog, $rootScope) {
        var _this = this;

        /** @ngInject */
        var globalDropzone = null;
        this.$onInit = function () {
            globalDropzone = new _dropzone2.default($element.find('.media-dropzone')[0], {
                url: function url() {
                    return CONFIG.API_URL + "/media?Authorization=" + CMSAuthService.getToken();
                },
                headers: {
                    'Cache-Control': null,
                    'X-Requested-With': null
                },
                previewTemplate: '<div></div>',
                dictDefaultMessage: gettextCatalog.getString("Drop files here or click to upload", null, "Dropzone.js option"),
                dictFallbackMessage: gettextCatalog.getString("Your browser does not support drag'n'drop file uploads.", null, "Dropzone.js option"),
                dictFallbackText: gettextCatalog.getString("Please use the fallback form below to upload your files like in the olden days.", null, "Dropzone.js option"),
                dictFileTooBig: gettextCatalog.getString("File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.", null, "Dropzone.js option"),
                dictInvalidFileType: gettextCatalog.getString("You can't upload files of this type.", null, "Dropzone.js option"),
                dictResponseError: gettextCatalog.getString("Server responded with {{statusCode}} code.", null, "Dropzone.js option"),
                dictCancelUpload: gettextCatalog.getString("Cancel upload", null, "Dropzone.js option"),
                dictCancelUploadConfirmation: gettextCatalog.getString("Are you sure you want to cancel this upload?", null, "Dropzone.js option"),
                dictRemoveFile: gettextCatalog.getString("Remove file", null, "Dropzone.js option"),
                dictMaxFilesExceeded: gettextCatalog.getString("You can not upload any more files.", null, "Dropzone.js option")
            });

            /**
             * Fired when file added to queue
             */
            globalDropzone.on("addedfile", function (file) {
                _this.onUploadAdded({ file: file });
            });

            /**
             * Fired when file is sending to backend
             * Set type of file for backend
             * Set xhr callback to handle timeout exception (not handled by Dropzone.js)
             */
            globalDropzone.on("sending", function (file, xhr, formData) {
                if (file.type.indexOf("image") === -1) {
                    formData.append("type", "file");
                }

                xhr.ontimeout = function () {
                    file.status = "error";
                    _this.onUploadError({
                        uploadId: file.upload.uuid,
                        file: file,
                        message: gettextCatalog.getString('Upload timeout')
                    });
                };
            });

            /**
             * Fired when thumbnail is ready
             */
            globalDropzone.on("thumbnail", function (file) {
                _this.onUploadUpdated({
                    uploadId: file.upload.uuid,
                    file: file
                });
            });

            globalDropzone.on("success", function (file, response) {
                _this.onUploadSuccess({ uploadId: file.upload.uuid, media: new MediaResource(response) });
            });

            globalDropzone.on("error", function (file, responseData, response) {

                var message = gettextCatalog.getString('Upload error');

                // Backend Validation Error
                if (response && response.status === 400) {
                    message = Object.values(responseData).join(", ");
                }

                if (response && response.status === 401) {
                    $rootScope.$emit('event:auth-loginRequired');
                }

                // Other validation error
                if (!response) {
                    message = gettextCatalog.getString('File is too big');
                }

                if (_this.onUploadError) {
                    _this.onUploadError({
                        uploadId: file.upload.uuid,
                        file: file,
                        message: message
                    });
                }
            });
        };

        $scope.$on('gettextLanguageChanged', function () {
            globalDropzone.destroy();
            $element.find('.media-dropzone')[0].innerHTML = "";
            _this.$onInit();
        });
    }]
}).name;

/***/ }),
/* 954 */,
/* 955 */
/***/ (function(module, exports) {

module.exports = "<div class=\"media-dropzone dropzone\"></div>";

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "<media-dropzone\n        on-upload-added=\"$ctrl.onUploadAdded(file)\"\n        on-upload-updated=\"$ctrl.onUploadUpdated(uploadId, file)\"\n        on-upload-success=\"$ctrl.onUploadSuccess(uploadId, media)\"\n        on-upload-error=\"$ctrl.onUploadError(uploadId, file, message)\"\n></media-dropzone>\n\n<!--// filtr-->\n<div class=\"media-browser__sort-controls\">\n    <div class=\"form-inline row\">\n        <div class=\"form-group col-xs-4\">\n            <input type=\"text\"\n                   placeholder=\"{{ 'Search by name...' | translate }}\"\n                   ng-model=\"$ctrl.selectedFilters.clientOriginalName.value\"\n                   ng-change=\"$ctrl.applyFilters()\"\n                   ng-model-options=\"{debounce: 500}\"\n                   class=\"form-control\"/>\n        </div>\n        <div class=\"form-group col-xs-4\">\n            <ui-select ng-model=\"$ctrl.selectedOrder\"\n                       class=\"btn-group bootstrap-select\"\n                       on-select=\"$ctrl.applyFilters()\"\n                       title=\"{{'Sort by' | translate}}...\">\n                <ui-select-match placeholder=\"{{'Sort by' | translate}}...\">\n                    {{'Sort by' | translate}}: {{$select.selected.label}}\n                    <em class=\"fa fa-sort-{{$select.selected.sortType}}-{{$select.selected.direction}}\"></em>\n                </ui-select-match>\n                <ui-select-choices repeat=\"filter in $ctrl.availableOrders | filter: ($select.search || '')\">\n                    <span>{{filter.label}}\n                        <em class=\"fa fa-pull-right fa-sort-{{filter.sortType}}-{{filter.direction}}\"></em>\n                    </span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n        <div class=\"form-group col-xs-4\">\n            <ui-select ng-repeat=\"(property, propertyFilter) in $ctrl.availableFilters\"\n                       ng-model=\"$ctrl.selectedFilters[property]\"\n                       class=\"btn-group bootstrap-select\"\n                       on-select=\"$ctrl.applyFilters()\"\n                       title=\"{{propertyFilter.title}}\">\n                <ui-select-match allow-clear=\"true\" placeholder=\"{{ 'Search by type...' | translate }}\">\n                    {{propertyFilter.selectedPrefix}}: {{$select.selected.label}}\n                    <em class=\"fa fa-sort-{{$select.selected.sortType}}-{{$select.selected.direction}}\"></em>\n                </ui-select-match>\n                <ui-select-choices\n                        repeat=\"filter in propertyFilter.values | filter: ($select.search || '')\">\n                    <span>{{filter.label}}</span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n</div>\n\n<!--// paginacja-->\n<div class=\"media-browser__pagination\">\n    <pagination-controls ng-if=\"$ctrl.currentPage.total_pages > 1\"\n                         pages=\"$ctrl.currentPage.total_pages\"\n                         current-page=\"$ctrl.currentPage.current_page\"\n                         on-page-change=\"$ctrl.loadPage(page)\">\n    </pagination-controls>\n</div>\n\n<!--// lista-->\n<div class=\"media-browser__items\">\n    <div ng-if=\"!$ctrl.currentPage.data\" class=\"media-browser__spinner\">\n        <em class=\"fa fa-5x fa-circle-o-notch fa-spin\"></em>\n    </div>\n    <div class=\"media-browser__item\" ng-repeat=\"item in $ctrl.currentPage.data\">\n        <media-tile selectable=\"$ctrl.selectable\"\n                    media=\"item\"\n                    tile-class=\"{{$ctrl.tileClass}}\"\n                    is-selected=\"$ctrl.selectionData[item.id]\"\n                    on-selection-change=\"$ctrl.onTileSelectionChange(selected, item)\"\n                    on-removed=\"$ctrl.onRemoved(item)\">\n        </media-tile>\n    </div>\n</div>\n\n<!--//paginacja 2-->\n<div class=\"media-browser__pagination\">\n    <pagination-controls ng-if=\"$ctrl.currentPage.total_pages > 1\"\n                         pages=\"$ctrl.currentPage.total_pages\"\n                         current-page=\"$ctrl.currentPage.current_page\"\n                         on-page-change=\"$ctrl.loadPage(page)\">\n    </pagination-controls>\n</div>\n";

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _UnsplashTile = __webpack_require__(958);

var _UnsplashTile2 = _interopRequireDefault(_UnsplashTile);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _UnsplashResource = __webpack_require__(433);

var _UnsplashResource2 = _interopRequireDefault(_UnsplashResource);

var _PaginationControlsModule = __webpack_require__(229);

var _PaginationControlsModule2 = _interopRequireDefault(_PaginationControlsModule);

var _uiSelect = __webpack_require__(202);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.unsplash.listing', [_UnsplashResource2.default, _ConfigModule2.default, _UnsplashTile2.default, _PaginationControlsModule2.default, _uiSelect2.default, _angularGettext2.default]).component('cmsUnsplashListing', {
    template: __webpack_require__(960),
    bindings: {
        displayLimit: '<',
        selectable: '<',
        onSelect: '&',
        tileClass: '@',
        multiple: '<'
    },
    controller: ['UnsplashResource', '$scope', 'gettextCatalog', function controller(UnsplashResource, $scope, gettextCatalog) {
        var _this = this;

        /** @ngInject */

        this.defaultDisplayLimit = 10;

        this.selectionData = {};

        this.availableOrders = [];

        this.selectedFilters = {
            clientOriginalName: {
                value: ''
            }
        };

        this.$onInit = function () {
            _this.selectedOrder = _this.availableOrders[0];
            _this.currentPage = UnsplashResource.findAll({
                page: 1,
                order_by: _this.selectedOrder.property,
                order_direction: _this.selectedOrder.direction,
                limit: _this.displayLimit || _this.defaultDisplayLimit
            });
        };

        var getFilterLabels = function getFilterLabels() {
            return [{
                label: gettextCatalog.getString('upload date', null, 'As in "Sort by media upload date"'),
                property: 'createdAt',
                sortType: 'numeric'
            }].forEach(function (filterGroup) {
                _this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'asc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });
                _this.availableOrders.push({
                    group: filterGroup.label,
                    label: filterGroup.label,
                    direction: 'desc',
                    property: filterGroup.property,
                    sortType: filterGroup.sortType || 'alpha'
                });
            });
        };
        var filterLabels = getFilterLabels();
        $scope.$on('language-changed', function () {
            _this.availableOrders = [];
            filterLabels = getFilterLabels();

            _this.availableOrders.forEach(function (element) {
                if (element.property === this.selectedOrder.property && element.direction === this.selectedOrder.direction) {
                    this.selectedOrder = element;
                }
            }, _this);
        });

        this.onTileSelectionChange = function (selected, media) {
            Object.keys(_this.selectionData).forEach(function (key) {
                if (!_this.multiple && key !== media.id) {
                    delete _this.selectionData[key];
                }
                if (_this.multiple && key === media.id) {
                    delete _this.selectionData[key];
                }
            });

            _this.onSelect({ media: media, selected: selected });
        };

        this.onRemoved = function (media) {
            var index = _this.currentPage.data.indexOf(media);
            if (index > -1) {
                _this.currentPage.data.splice(index, 1);
            }
        };

        this.onMediaAdded = function (media) {
            $scope.$apply(function () {
                _this.currentPage.data.unshift(media);
            });
        };

        this.loadPage = function (page) {
            var filterValues = {};

            Object.keys(_this.selectedFilters).forEach(function (filterProperty) {
                if (_this.selectedFilters[filterProperty]) filterValues[filterProperty] = _this.selectedFilters[filterProperty].value;
            });

            _this.currentPage.$cancelRequest();

            var criteria = {
                page: page,
                order_by: _this.selectedOrder.property,
                order_direction: _this.selectedOrder.direction,
                limit: _this.displayLimit || _this.defaultDisplayLimit
            };

            _this.currentPage = UnsplashResource.find(Object.assign(criteria, filterValues));
        };

        this.applyFilters = function () {
            _this.currentPage.current_page = 1;
            _this.loadPage(_this.currentPage.current_page);
        };
    }]
}).name;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _UnsplashResource = __webpack_require__(433);

var _UnsplashResource2 = _interopRequireDefault(_UnsplashResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.browser.unsplash.tile', [_UnsplashResource2.default, _angularGettext2.default, _angularToastr2.default]).component('mediaUnsplashTile', {
    template: __webpack_require__(959),
    bindings: {
        media: '<',
        softDelete: '<',
        selectable: '<',
        onSelectionChange: '&',
        isSelected: '=',
        tileClass: '@',
        disabled: '<'
    },
    transclude: true,
    controller: ['$sce', 'UnsplashResource', 'gettextCatalog', 'toastr', function controller($sce, UnsplashResource, gettextCatalog, toastr) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.status = 'downloadable';
            _this.tileTitle = gettextCatalog.getString("Photo by {{user}} from {{source}}", {
                user: _this.media.user.name,
                source: 'Unsplash'
            });
            _this.tileTitleLink = $sce.trustAsHtml(gettextCatalog.getString("Photo by {{user}} from {{source}}", {
                user: '<a href="' + _this.media.user.links.html + '" target="_blank">' + _this.media.user.name + '</a>',
                source: '<a href="https://unsplash.com" target="_blank">Unsplash</a>'
            }));
        };

        this.toggleSelected = function () {
            if (!_this.selectable) return;

            _this.isSelected = !_this.isSelected;
            _this.onSelectionChange({ selected: _this.isSelected });
        };

        this.downloadImage = function ($event) {

            $event.stopPropagation();

            if (_this.status === 'downloaded') {
                return;
            }

            _this.status = 'download';
            return UnsplashResource.get({ id: _this.media.id }, function (response) {
                _this.errors = {};
                toastr.success(gettextCatalog.getString('Image added!'), gettextCatalog.getString('Success'));
                _this.status = 'downloaded';
                return response;
            }, function (response) {
                if (response.status === 400) {
                    _this.status = 'error';
                    toastr.error(gettextCatalog.getString('Image error, try again!'), gettextCatalog.getString('Error'));
                }
            }).$promise;
        };
    }]
}).name;

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "<div class=\"media-tile media-unsplash-tile\"\n     ng-class=\"[\n            $ctrl.tileClass || 'panel',\n            'media-tile--image',\n             {\n                'media-tile--selected':$ctrl.isSelected,\n                'media-tile--selectable':$ctrl.selectable\n             }]\">\n    <div class=\"media-tile__preview\"\n         ng-click=\"$ctrl.toggleSelected()\">\n        <div class=\"media-tile__selected-marker\"></div>\n        <div class=\"media-tile__miniature-wrapper\"\n             style=\"background-image: url('{{ $ctrl.media.urls.thumb }}'); background-size: contain\">\n\n            <div class=\"tile-actions-element overlay-visible\">\n\n                <div type=\"button\"\n                     uib-tooltip=\"{{'Download to your files' | translate}}\"\n                     tooltip-placement=\"left\"\n                     class=\"tile-action-element\"\n                        ng-class=\"{\n                                'btn-info': $ctrl.status == 'downloadable',\n                                'btn-default': $ctrl.status == 'download',\n                                'btn-success': $ctrl.status == 'downloaded',\n                                'btn-danger': $ctrl.status == 'error'}\"\n                        ng-click=\"$ctrl.downloadImage($event)\"\n                        ng-disabled=\"$ctrl.status == 'downloaded'\">\n                    <em class=\"ion-android-download\" ng-if=\"$ctrl.status == 'downloadable'\"></em>\n                    <em class=\"fa fa-circle-o-notch fa-spin\" ng-if=\"$ctrl.status == 'download'\"></em>\n                    <em class=\"ion-checkmark\" ng-if=\"$ctrl.status == 'downloaded'\"></em>\n                    <em class=\"ion-close\" ng-if=\"$ctrl.status == 'error'\"></em>\n                </div>\n            </div>\n        </div>\n        <div class=\"media-tile__name\" title=\"{{$ctrl.tileTitle}}\" ng-bind-html=\"$ctrl.tileTitleLink\"></div>\n\n        <ng-transclude></ng-transclude>\n\n    </div>\n</div>\n";

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "<div class=\"media-browser__sort-controls\">\n    <div class=\"form-inline row\">\n        <div class=\"form-group col-xs-4\">\n            <input type=\"text\"\n                   placeholder=\"{{'Search by tag...' | translate  }}\"\n                   ng-model=\"$ctrl.selectedFilters.clientOriginalName.value\"\n                   ng-change=\"$ctrl.applyFilters()\"\n                   ng-model-options=\"{debounce: 500}\"\n                   class=\"form-control\"/>\n        </div>\n    </div>\n</div>\n\n<!--// paginacja-->\n<div class=\"media-browser__pagination\">\n    <pagination-controls ng-if=\"$ctrl.currentPage.total_pages > 1\"\n                         pages=\"$ctrl.currentPage.total_pages\"\n                         current-page=\"$ctrl.currentPage.current_page\"\n                         on-page-change=\"$ctrl.loadPage(page)\">\n    </pagination-controls>\n</div>\n\n<!--// lista-->\n<div class=\"media-browser__items\">\n    <div ng-if=\"!$ctrl.currentPage.data\" class=\"media-browser__spinner\">\n        <em class=\"fa fa-5x fa-circle-o-notch fa-spin\"></em>\n    </div>\n    <div class=\"media-browser__item\" ng-repeat=\"item in $ctrl.currentPage.data\">\n        <media-unsplash-tile selectable=\"$ctrl.selectable\"\n                             media=\"item\"\n                             tile-class=\"{{$ctrl.tileClass}}\"\n                             is-selected=\"$ctrl.selectionData[item.id]\"\n                             on-selection-change=\"$ctrl.onTileSelectionChange(selected, item)\">\n        </media-unsplash-tile>\n    </div>\n</div>\n\n<!--//paginacja 2-->\n<div class=\"media-browser__pagination\">\n    <pagination-controls ng-if=\"$ctrl.currentPage.total_pages > 1\"\n                         pages=\"$ctrl.currentPage.total_pages\"\n                         current-page=\"$ctrl.currentPage.current_page\"\n                         on-page-change=\"$ctrl.loadPage(page)\">\n    </pagination-controls>\n</div>\n";

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "<div class=\"media-browser media-browser-page\">\n\n    <uib-tabset active=\"$tabSetStatus.activeTab\">\n        <uib-tab heading=\"{{ 'Uploaded files' | translate }}\" ng-click=\"$ctrl.setActiveTab(1)\">\n            <cms-media-listing ng-if=\"$ctrl.activeTab == 1\"></cms-media-listing>\n        </uib-tab>\n        <uib-tab heading=\"{{ 'Stock photos' | translate }}\" ng-click=\"$ctrl.setActiveTab(2)\">\n            <cms-unsplash-listing ng-if=\"$ctrl.activeTab == 2\"></cms-unsplash-listing>\n        </uib-tab>\n    </uib-tabset>\n</div>\n\n";

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _MailsListPageDirective = __webpack_require__(964);

var _MailsListPageDirective2 = _interopRequireDefault(_MailsListPageDirective);

var _MailsFormPageDirective = __webpack_require__(968);

var _MailsFormPageDirective2 = _interopRequireDefault(_MailsFormPageDirective);

var _SubscribeStatsChart = __webpack_require__(404);

var _SubscribeStatsChart2 = _interopRequireDefault(_SubscribeStatsChart);

var _OpenRateMap = __webpack_require__(989);

var _OpenRateMap2 = _interopRequireDefault(_OpenRateMap);

var _HostsStatsChart = __webpack_require__(992);

var _HostsStatsChart2 = _interopRequireDefault(_HostsStatsChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

routeConfig.$inject = ['$stateProvider', 'gettext'];


var mailsModule = _angular2.default.module('cms.pages.mails', [_angularjs2.default, _MailsListPageDirective2.default, _MailsFormPageDirective2.default, _SubscribeStatsChart2.default, _OpenRateMap2.default, _HostsStatsChart2.default]).config(routeConfig);

function routeConfig($stateProvider, gettext) {
  /** @ngInject */

  $stateProvider.state('mails', {
    url: '/mails?',
    component: 'appMailsList',
    title: gettext('Mails templates'),
    data: {
      requiresAuth: ['ROLE_ADMIN']
    },
    reloadOnSearch: false,
    sidebarMeta: {
      icon: 'ion-email',
      order: 0,
      allow: ['ROLE_ADMIN']
    }
  }).state('mailsAdd', {
    url: '/mails/add',
    component: 'appMailsForm',
    title: gettext('Add mail'),
    data: {
      requiresAuth: ['ROLE_ADMIN']
    },
    params: {
      returnState: null
    },
    breadcrumbsMeta: {
      parentState: 'mails'
    }
  }).state('mailsEdit', {
    url: '/mails/edit/:id',
    component: 'appMailsForm',
    params: {
      returnState: null
    },
    title: gettext('Edit Mail'),
    data: {
      requiresAuth: ['ROLE_ADMIN']
    },
    breadcrumbsMeta: {
      parentState: 'mails'
    }
  });
}

exports.default = mailsModule.name;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MailsGrid = __webpack_require__(965);

var _MailsGrid2 = _interopRequireDefault(_MailsGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mailsPageModule = _angular2.default.module('cms.mails.list', [_MailsGrid2.default]).component('appMailsList', {
  template: __webpack_require__(967),
  bindings: {
    $transition$: '<'
  },
  controller: ['$state', function controller($state) {
    var _this = this;

    /** @ngInject */
    this.$onInit = function () {
      _this.initialParams = _this.$transition$.params();
    };

    this.addMail = function () {
      $state.go('mailsAdd', {
        returnState: {
          name: 'mails',
          params: _angular2.default.copy($state.params)
        }
      });
    };

    this.onParamsChange = function (params) {
      delete params.page;
      $state.go('.', params, {
        location: 'replace'
      });
    };

    this.onPageChange = function (page) {
      if (page === 0) {
        return;
      }
      $state.go('.', { page: page !== 1 ? page : undefined }, {
        location: 'replace'
      });
    };
  }]
});

exports.default = mailsPageModule.name;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _GridDirective = __webpack_require__(107);

var _GridDirective2 = _interopRequireDefault(_GridDirective);

var _GridParamsConverter = __webpack_require__(116);

var _GridParamsConverter2 = _interopRequireDefault(_GridParamsConverter);

var _MailsResource = __webpack_require__(230);

var _MailsResource2 = _interopRequireDefault(_MailsResource);

var _angularLocalStorage = __webpack_require__(94);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mailsGridModule = _angular2.default.module('cms.mails.grid', [_GridDirective2.default, _MailsResource2.default, _angularLocalStorage2.default, _ConfigModule2.default, _GridParamsConverter2.default]).component('mailsGrid', {
  template: __webpack_require__(966),
  bindings: {
    initialParams: '<?',
    onParamsChange: '&?',
    onPageChange: '&?'
  },
  controller: ['MailsResource', 'gettextCatalog', 'toastr', 'localStorageService', 'CONFIG', 'GridParamsConverter', '$state', function controller(MailsResource, gettextCatalog, toastr, localStorageService, CONFIG, GridParamsConverter, $state) {
    var _this = this;

    /** @ngInject */

    var getColumnDefs = function getColumnDefs() {
      return [{
        headerName: gettextCatalog.getString("Title"),
        field: "title",
        filter: "text",
        filterParams: { filterOptions: ['contains'] }
      }, {
        headerName: gettextCatalog.getString("Description"),
        field: "description",
        filter: "text",
        filterParams: { filterOptions: ['contains'] }
      }, {
        headerName: gettextCatalog.getString("Actions"),
        suppressFilter: true,
        cellRenderer: function cellRenderer(params) {
          var button = _angular2.default.element('<button class="btn btn-xs btn-primary">\n                                    <i class="ion-edit"></i> \n                                    ' + gettextCatalog.getString('Edit') + '\n                                </button>');

          button.on('click', function () {
            $state.go('mailsEdit', {
              id: params.data.id,
              returnState: {
                name: 'mails',
                params: _angular2.default.copy($state.params)
              }
            });
          });

          return button[0];
        }
      }];
    };

    this.options = {
      _gridStateId: 'mails-grid-state',
      _columnDefsCallback: getColumnDefs
    };

    this.initialFilterModel = {};
    var dataInitialized = false;

    var defaultParams = {
      fistName: undefined,
      lastName: undefined,
      email: undefined,
      order_by: undefined,
      order_direction: undefined
    };

    this.$onInit = function () {
      if (!_this.initialParams) {
        _this.initialParams = _angular2.default.copy(defaultParams);
      }

      if (_this.initialParams.order_by) {
        _this.initialSortModel = [{ colId: _this.initialParams.order_by, sort: _this.initialParams.order_direction || 'asc' }];
      }

      if (_this.initialParams.page) {
        _this.initialPage = _this.initialParams.page;
      }

      _this.datasource = {
        getRows: function getRows(params) {
          var queryParams = GridParamsConverter.getCmsApiParams(params);
          var stateParams = Object.assign({}, defaultParams, queryParams);

          if (_this.onParamsChange) _this.onParamsChange({ params: _angular2.default.copy(stateParams) });

          delete stateParams.page;
          $state.go('.', stateParams, {
            location: 'replace'
          });

          var responseData = [];
          MailsResource.findAll(queryParams, function (response) {
            responseData = response.data;
            var lastRow = response.total_count;
            params.successCallback(responseData, lastRow);

            if (!dataInitialized && _this.initialPage && _this.initialPage !== _this.options.api.paginationGetCurrentPage() + 1) {
              dataInitialized = true;
              _this.options.api.paginationGoToPage(parseInt(_this.initialPage) - 1);
            }
          });
        }
      };
    };

    this._onPageChange = function (page) {
      if (!dataInitialized) return;
      if (_this.onPageChange) _this.onPageChange({ $page: page });
    };
  }]
});

exports.default = mailsGridModule.name;

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <cms-grid grid-options=\"$ctrl.options\"\n              datasource=\"$ctrl.datasource\"\n              initial-sort-model=\"$ctrl.initialSortModel\"\n              initial-filter-model=\"$ctrl.initialFilterModel\"\n              on-page-change=\"$ctrl._onPageChange($page)\">\n    </cms-grid>\n</div>";

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = "<div ba-panel ba-panel-title=\"{{'Mails templates' | translate}}\" ba-panel-class=\"\">\n    <div class=\"text-right\">\n        <a class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.addMail()\" translate >Add mail</a>\n    </div>\n    <br>\n    <br>\n    <mails-grid initial-params=\"$ctrl.initialParams\" on-params-change=\"$ctrl.onParamsChange(params)\" on-page-change=\"$ctrl.onPageChange($page)\">\n\n    </mails-grid>\n</div>";

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _MailsResource = __webpack_require__(230);

var _MailsResource2 = _interopRequireDefault(_MailsResource);

var _angularjsDragula = __webpack_require__(969);

var _angularjsDragula2 = _interopRequireDefault(_angularjsDragula);

var _Context = __webpack_require__(231);

var _Context2 = _interopRequireDefault(_Context);

var _SaveGuard = __webpack_require__(232);

var _SaveGuard2 = _interopRequireDefault(_SaveGuard);

var _Preview = __webpack_require__(983);

var _Preview2 = _interopRequireDefault(_Preview);

var _angularStickyPlugin = __webpack_require__(987);

var _angularStickyPlugin2 = _interopRequireDefault(_angularStickyPlugin);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var mailsFormPage = _angular2.default.module('cms.mails.add', [_MailsResource2.default, _angularToastr2.default, (0, _angularjsDragula2.default)(_angular2.default), _Preview2.default, _SaveGuard2.default, 'hl.sticky', _deleteElement2.default]).component('appMailsForm', {
    template: __webpack_require__(988),
    controller: ['$scope', '$rootScope', 'MailsResource', '$stateParams', '$state', 'toastr', 'gettextCatalog', 'dragulaService', 'deleteElementDialog', 'SaveWarning', 'SaveGuard', '$element', function controller($scope, $rootScope, MailsResource, $stateParams, $state, toastr, gettextCatalog, dragulaService, deleteElementDialog, SaveWarning, SaveGuard, $element) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.context = new _Context2.default();
            _this.context.setDragularScope($scope);
        };

        this.mail = { content: [], globalBackgroundColor: '#e0e0e0', globalHrefColor: "#2196f3" };
        if ($stateParams.id) {
            MailsResource.find({ id: $stateParams.id }, function (response) {
                _this.mail = response;
                _this.blocked = response.form.length;
                SaveWarning.watch(response, _this.mail, $scope, $element);
            });
        } else {
            SaveWarning.watch(this.mail, this.mail, $scope, $element);
        }

        this.errors = {};
        this.pending = false;

        this.create = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _this.pending = true;
                            _context.next = 3;
                            return SaveGuard.check();

                        case 3:
                            return _context.abrupt('return', MailsResource.save(_this.mail, function (response) {
                                _this.errors = {};
                                SaveWarning.watch(response, _this.mail, $scope, $element);
                                toastr.success(gettextCatalog.getString('Mail {{name}} added!', { name: _this.mail.title }), gettextCatalog.getString('Success'));
                                if (redirect) {
                                    goToReturnState();
                                }
                                _this.pending = false;
                            }, function (response) {
                                _this.errors = response.data;
                                _this.pending = false;
                                _this.onErrorMessage();
                            }).$promise);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        this.update = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            _this.pending = true;
                            _context2.next = 3;
                            return SaveGuard.check();

                        case 3:
                            return _context2.abrupt('return', MailsResource.update(_this.mail, function (response) {
                                _this.errors = {};
                                SaveWarning.watch(response, _this.mail, $scope, $element);
                                toastr.success(gettextCatalog.getString('Mail {{name}} saved!', { name: _this.mail.title }), gettextCatalog.getString('Success'));
                                if (redirect) {
                                    goToReturnState();
                                }
                                _this.pending = false;
                            }, function (response) {
                                _this.errors = response.data;
                                _this.pending = false;
                                _this.onErrorMessage();
                            }).$promise);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        this.updateOrCreate = function () {
            if (_this.mail.id) {
                return _this.update(false);
            } else {
                return _this.create(false);
            }
        };

        this.confirmDelete = function () {
            var deleteMessage = gettextCatalog.getString("Do you really want to delete this mail? (This action is irreversible!)");
            deleteElementDialog.open(deleteMessage).then(function () {
                _this.delete();
            }).catch(function () {});
        };

        this.delete = function () {
            _this.pending = true;
            MailsResource.delete({ id: _this.mail.id }, function (response) {
                toastr.success(gettextCatalog.getString('Mail {{name}} deleted!', { name: _this.mail.title }), gettextCatalog.getString('Success'));
                goToReturnState();
                _this.pending = false;
            });
        };

        this.onErrorMessage = function () {
            return toastr.error(gettextCatalog.getString('Please correct form errors and try again.', { name: this.mail.title }), gettextCatalog.getString('Validation Errors'));
        };

        function goToReturnState() {
            SaveWarning.stopWatch();
            if ($stateParams.returnState) {
                $state.go($stateParams.returnState.name, $stateParams.returnState.params);
            } else {
                $state.go('mails', {});
            }
        }

        $scope.$on('save.object', function () {
            _this.updateOrCreate();
        });
    }]
});

exports.default = mailsFormPage.name;

/***/ }),
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(984);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CmsMailsPreview = _angular2.default.module('cms.mails.preview', []).component('cmsMailsPreview', {
  bindings: {
    mail: '=',
    prePreview: '<',
    pending: '<'
  },
  template: __webpack_require__(985),
  controller: ['$uibModal', 'ExportMailTemplateService', function controller($uibModal, ExportMailTemplateService) {
    var _this = this;

    this.preview = function () {

      _this.prePreview().then(function (response) {

        _this.mail = response;

        $uibModal.open({
          template: __webpack_require__(986),
          size: 'lg',
          controllerAs: '$ctrl',
          controller: ['url', '$sce', function controller(url, $sce) {
            var _this2 = this;

            this.url = $sce.trustAsResourceUrl(url);
            this.loading = true;
            this.mobile = false;

            this.onLoaded = function (event) {
              _this2.loading = false;
            };

            this.setMobile = function () {
              _this2.mobile = true;
            };

            this.setDesktop = function () {
              _this2.mobile = false;
            };
          }],
          resolve: {
            url: function url() {
              return _this.getTemplateUrl(response.id);
            }
          }
        }).result.then(function () {}, function (res) {});
      }).catch(function (e) {
        return console.log(e);
      });
    };

    this.getTemplateUrl = function (id) {
      return ExportMailTemplateService.getUrl(id);
    };
  }]
});

exports.default = CmsMailsPreview.name;

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "<button ng-click=\"$ctrl.preview()\" ng-disabled=\"$ctrl.pending\"\n        class=\"btn btn-default\"\n        uib-tooltip=\"{{'Save and Preview' | translate}}\"\n        tooltip-placement=\"bottom\"\n>\n    <em class=\"fa fa-eye\"></em>\n</button>";

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-default\">\n        <span translate>Template preview</span>\n    </div>\n    <div class=\"modal-body text-center\">\n        <div class=\"row\">\n            <button class=\"btn btn-{{$ctrl.mobile ? 'default ' : 'success'}} btn-with-icon\" ng-click=\"$ctrl.setDesktop()\">\n                <em class=\"ion-monitor\"></em>Desktop\n            </button>\n            <button class=\"btn btn-{{!$ctrl.mobile ? 'default ' : 'success'}} btn-with-icon\" ng-click=\"$ctrl.setMobile()\">\n                <em class=\"ion-iphone\" ></em>Mobile\n            </button>\n        </div>\n        <br>\n        <div class=\"cms-spinner sample-show-hide animated\" ng-show=\"$ctrl.loading\"\n             style=\"position: absolute; top: 10% ;left: 50%;\">\n            <em class=\"fa fa-circle-o-notch fa-spin\"></em>\n        </div>\n\n        <iframe class=\"iframe-preview\" ng-class=\"{'iframe-loaded': !$ctrl.loading, 'iframe-mobile': $ctrl.mobile}\" ng-src=\"{{ $ctrl.url }}\"\n                cms-on-load=\"$ctrl.onLoaded(event)\" title=\"preview\">\n        </iframe>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\" translate>Close</button>\n    </div>\n</div>";

/***/ }),
/* 987 */,
/* 988 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .editor-inline__container a {\n        color: {{ $ctrl.mail.globalHrefColor }};\n    }\n</style>\n\n<div class=\"narrow-container mails-edit-form\">\n    <div class=\"row\">\n        <div class=\"col-lg-8\">\n            <div ba-panel ba-panel-title=\"{{'Add mail' | translate}}\">\n\n                <form class=\"form-horizontal\" autocomplete=\"off\" novalidate>\n                    <cms-input-text\n                            model=\"$ctrl.mail.title\"\n                            errors=\"$ctrl.errors.title\"\n                            label=\"{{ 'Title' | translate }}\">\n                    </cms-input-text>\n                    <cms-input-text model=\"$ctrl.mail.description\"\n                                    errors=\"$ctrl.errors.description\"\n                                    label=\"{{ 'Description' | translate }}\">\n                    </cms-input-text>\n\n\t\t            <div hl-sticky=\"\" offset-top=\"66\" collection=\"sections\">\n\t\t                <creator-sections-library\n                                context=\"$ctrl.context\"\n                                group=\"mail\"></creator-sections-library>\n\t\t            </div>\n                    <creator-workspace\n                        context=\"$ctrl.context\"\n                        sections=\"$ctrl.mail.content\"\n                        style=\"background-color: {{$ctrl.mail.globalBackgroundColor}};\">\n                    </creator-workspace>\n                </form>\n            </div>\n        </div>\n        <div class=\"col-lg-4\">\n            <div hl-sticky=\"\" offset-top=\"90\" collection=\"settings\">\n                <div ba-panel ba-panel-title=\"{{'Creator settings' | translate}}\" class=\"side-form\"\n                    ba-panel-class=\"with-scroll\">\n\n                    <p class=\"text-ellipsis\">{{$ctrl.mail.title || ' '}}</p>\n\n                    <div class=\"side-form__buttons\">\n\n                        <cms-mails-preview pending=\"$ctrl.pending\" mail=\"$ctrl.mail\"\n                                           pre-preview=\"$ctrl.updateOrCreate\"></cms-mails-preview>\n\n                        <button ng-click=\"$ctrl.create()\" ng-disabled=\"$ctrl.pending\" ng-if=\"!$ctrl.mail.id\"\n                                uib-tooltip=\"{{ 'Save' | translate }}\" tooltip-placement=\"bottom\"\n                                class=\"btn btn-success\">\n                            <em class=\"fa fa-save\"></em>\n                        </button>\n                        <button ng-click=\"$ctrl.update()\" ng-disabled=\"$ctrl.pending\" ng-if=\"$ctrl.mail.id\"\n                                uib-tooltip=\"{{ 'Save' | translate }}\" tooltip-placement=\"bottom\"\n                                class=\"btn btn-success\">\n                            <em class=\"fa fa-save\"></em>\n                        </button>\n                        <button ng-click=\"$ctrl.confirmDelete()\" ng-disabled=\"!$ctrl.mail.id || $ctrl.pending || $ctrl.blocked\"\n                                uib-tooltip=\"{{ 'Delete' | translate }}\" tooltip-placement=\"bottom\"\n                                class=\"btn btn-danger\">\n                            <em class=\"ion-trash-a\"></em>\n                        </button>\n                        <br><br>\n                    </div>\n\n                    <p class=\"alert alert-warning\" style=\"color: black;\" ng-if=\"$ctrl.blocked\">{{ 'This mail is used as a e-mail template!' | translate }}</p>\n\n                </div>\n\n                <div ba-panel ba-panel-title=\"{{'Section config' | translate}}\" class=\"side-form disable-click-outside\"\n                     ba-panel-class=\"with-scroll\">\n                    <creator-toolbar\n                            context=\"$ctrl.context\"\n                            model=\"$ctrl.mail\">\n\n                        <h5 translate>Select an item on the workspace to display its settings.</h5>\n\n                        <hr>\n\n                        <h4 translate>Global settings:</h4>\n\n                        <form class=\"form-horizontal\">\n\n                            <cms-input-color\n                                    label=\"{{ 'Background color' | translate }}\"\n                                    model=\"$ctrl.mail.globalBackgroundColor\"\n                                    label-size=\"4\"\n                                    input-size=\"8\">\n                            </cms-input-color>\n\n                            <cms-input-color\n                                    label=\"{{ 'Link color' | translate }}\"\n                                    model=\"$ctrl.mail.globalHrefColor\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                            >\n                            </cms-input-color>\n\n                        </form>\n\n                    </creator-toolbar>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(990);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.mails.openRateMap', []).component('mailOpenRateMap', {
    template: __webpack_require__(991),
    controller: ['baConfig', 'layoutPaths', 'baUtil', '$http', '$scope', 'languageManager', 'CONFIG', 'gettextCatalog', function controller(baConfig, layoutPaths, baUtil, $http, $scope, languageManager, CONFIG, gettextCatalog) {

        var layoutColors = baConfig.colors;
        var map = void 0;

        var createMap = function createMap(areas) {
            map = AmCharts.makeChart('openRateMap', {
                type: "map",
                theme: "light",
                zoomControl: {
                    zoomControlEnabled: false,
                    panControlEnabled: false
                },
                dataProvider: {
                    map: 'worldLow',
                    zoomLevel: 3.5,
                    zoomLongitude: 10,
                    zoomLatitude: 52,
                    areas: areas
                },
                areasSettings: {
                    rollOverOutlineColor: layoutColors.border,
                    rollOverColor: layoutColors.dashboard.blueStone,
                    alpha: 0.8,
                    unlistedAreasAlpha: 0.2,
                    unlistedAreasColor: layoutColors.defaultText,
                    balloonText: gettextCatalog.getString('[[title]]: [[customData]] mails opened')
                }
            });
        };

        $http.get(CONFIG.API_URL + '/mailsStats/openRate').then(function (response) {
            var areas = response.data;

            _angular2.default.forEach(areas, function (area) {
                area.groupId = area.customData < 250 ? 4 : area.customData < 500 ? 3 : area.customData < 750 ? 2 : 1;
                area.color = area.groupId === 1 ? layoutColors.primary : area.groupId === 2 ? layoutColors.success : area.groupId === 3 ? layoutColors.warning : layoutColors.danger;
            });

            createMap(areas);
        });
    }]
}).name;

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = "<div id=\"openRateMap\"></div>";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.dashboard.hostsStatsChart', []).component('mailHostStatsChart', {
  template: __webpack_require__(993),
  controller: ['baConfig', 'layoutPaths', 'baUtil', '$http', 'colorHelper', 'CONFIG', function controller(baConfig, layoutPaths, baUtil, $http, colorHelper, CONFIG) {
    var _this = this;

    this.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors;

    var printChart = function printChart(data) {

      _this.allCount = data.all;

      _this.doughnutData = {
        labels: data.labels,
        datasets: [{
          data: data.data,
          backgroundColor: [colorHelper.tint(dashboardColors.danger, 15), colorHelper.tint(dashboardColors.info, 15), colorHelper.tint(dashboardColors.success, 15), colorHelper.tint(dashboardColors.warning, 15), colorHelper.tint(dashboardColors.primaryLight, 15)],
          hoverBackgroundColor: [colorHelper.shade(dashboardColors.danger, 15), colorHelper.shade(dashboardColors.info, 15), colorHelper.shade(dashboardColors.success, 15), colorHelper.shade(dashboardColors.warning, 15), colorHelper.shade(dashboardColors.primaryLight, 15)],
          percentage: data.percentage
        }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      var hostsChart = new Chart(ctx, {
        type: 'doughnut',
        data: _this.doughnutData,
        options: {
          cutoutPercentage: 64,
          responsive: true,
          legend: {
            display: false
          },
          elements: {
            arc: {
              borderWidth: 0
            }
          }
        }
      });
    };

    $http.get(CONFIG.API_URL + '/mailsStats/hosts').then(function (response) {
      printChart(response.data);
    });
  }]
}).name;

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "<div class=\"channels-block\" ng-class=\"{'transparent': transparent}\">\n    <div class=\"chart-bg\"></div>\n    <div class=\"traffic-chart\" id=\"trafficChart\">\n        <div class=\"canvas-holder\">\n            <canvas id=\"chart-area\" width=\"280\" height=\"280\"></canvas>\n            <div class=\"traffic-text\">\n                {{$ctrl.allCount}}\n                <span translate>Subscriptions</span>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"channels-info\">\n        <div>\n            <div class=\"channels-info-item\" ng-repeat=\"label in $ctrl.doughnutData.labels\"\n                 ng-init=\"i = $index; data = $ctrl.doughnutData.datasets[0]\">\n                <div class=\"legend-color\" style=\"background-color: {{::data.backgroundColor[i]}}\"></div>\n                <p>{{::label}}<span class=\"channel-number\">+{{data.percentage[i]}}%</span></p>\n                <div class=\"progress progress-sm channel-progress\">\n                    <div class=\"progress-bar \" role=\"progressbar\"\n                         aria-valuenow=\"{{$ctrl.data.percentage[i]}}\" aria-valuemin=\"0\" aria-valuemax=\"100\"\n                         style=\"width: {{item.percentage}}%\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _PagesListPage = __webpack_require__(995);

var _PagesListPage2 = _interopRequireDefault(_PagesListPage);

var _PagesFormPage = __webpack_require__(999);

var _PagesFormPage2 = _interopRequireDefault(_PagesFormPage);

var _PageFormDataListPage = __webpack_require__(1014);

var _PageFormDataListPage2 = _interopRequireDefault(_PageFormDataListPage);

var _PageFormDataPage = __webpack_require__(1018);

var _PageFormDataPage2 = _interopRequireDefault(_PageFormDataPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

routeConfig.$inject = ['$stateProvider', 'gettext'];


var pagesPageModule = _angular2.default.module('cms.pages.pages', [_angularjs2.default, _angularGettext2.default, _PagesListPage2.default, _PagesFormPage2.default, _PageFormDataListPage2.default, _PageFormDataPage2.default]).config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */
    $stateProvider.state('pages', {
        url: '/pages?title&slug&status&order_by&order_direction&page',
        component: 'pagesListPage',
        title: gettext('Landing pages'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        reloadOnSearch: false,
        sidebarMeta: {
            icon: 'ion-ios-paper',
            order: 0,
            allow: ['ROLE_ADMIN']
        }
    }).state('pagesAdd', {
        url: '/pages/add',
        component: 'pagesFormPage',
        title: gettext('Add Page'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        params: {
            returnState: null
        },
        breadcrumbsMeta: {
            parentState: 'pages'
        }
    }).state('pagesEdit', {
        url: '/pages/edit/:id',
        component: 'pagesFormPage',
        params: {
            returnState: null,
            title: null
        },
        title: gettext('Edit Page'),
        breadcrumbsMeta: {
            parentState: 'pages'
        }
    }).state('pageFormDataList', {
        url: '/pages/form/:id?order_by&order_direction&page',
        component: 'pageFormDataListPage',
        params: {
            returnState: null
        },
        title: gettext('Form Data List Page'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        breadcrumbsMeta: {
            parentState: 'pages'
        }
    }).state('pageFormDataDetails', {
        url: '/pages/form/data/:id',
        component: 'pageFormDataPage',
        params: {
            returnState: {
                name: 'pageFormDataList',
                params: {
                    id: ':pageId'
                }
            }
        },
        title: gettext('Form Data Page'),
        data: {
            requiresAuth: ['ROLE_ADMIN']
        },
        breadcrumbsMeta: {
            parentState: 'pageFormDataList'
        }
    });
}

exports.default = pagesPageModule.name;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _PagesGrid = __webpack_require__(996);

var _PagesGrid2 = _interopRequireDefault(_PagesGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.pages.list', [_PagesGrid2.default]).component('pagesListPage', {
    template: __webpack_require__(998),
    bindings: {
        $transition$: '<'
    },
    controller: ['gettextCatalog', 'toastr', 'CONFIG', '$state', 'ExportService', '$uibModal', 'addPageDialog', function controller(gettextCatalog, toastr, CONFIG, $state, ExportService, $uibModal, addPageDialog) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.initialParams = _this.$transition$.params();
        };

        this.onParamsChange = function (params) {
            delete params.page;
            $state.go('.', params, {
                location: 'replace'
            });
        };

        this.addPage = function () {
            addPageDialog.open().then(function (response) {
                $state.go('pagesEdit', {
                    id: response.id,
                    title: response.title,
                    returnState: {
                        name: 'pages',
                        params: _angular2.default.copy($state.params)
                    }

                });
            }).catch(function () {});
        };

        this.onPageChange = function (page) {
            if (page === 0) {
                return;
            }
            $state.go('.', { page: page !== 1 ? page : undefined }, {
                location: 'replace'
            });
        };

        this.exportUrl = function () {
            return ExportService.getUrl('pages');
        };
    }]
}).name;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _GridDirective = __webpack_require__(107);

var _GridDirective2 = _interopRequireDefault(_GridDirective);

var _GridParamsConverter = __webpack_require__(116);

var _GridParamsConverter2 = _interopRequireDefault(_GridParamsConverter);

var _PageResource = __webpack_require__(130);

var _PageResource2 = _interopRequireDefault(_PageResource);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productsGridModule = _angular2.default.module('cms.pages.grid', [_GridDirective2.default, _PageResource2.default, _angularGettext2.default, _ConfigModule2.default, _GridParamsConverter2.default]).component('pagesGrid', {
    template: __webpack_require__(997),
    bindings: {
        initialParams: '<?',
        onParamsChange: '&?',
        onPageChange: '&?'
    },
    controller: ['PageResource', 'gettextCatalog', 'toastr', 'CONFIG', 'GridParamsConverter', '$state', function controller(PageResource, gettextCatalog, toastr, CONFIG, GridParamsConverter, $state) {
        var _this = this;

        /** @ngInject */

        var getColumnDefs = function getColumnDefs() {
            return [{
                headerName: gettextCatalog.getString("Title"),
                field: "title",
                filter: "text",
                filterParams: { filterOptions: ['contains'] }
            }, {
                headerName: gettextCatalog.getString("Slug"),
                field: "slug",
                filter: "text",
                filterParams: { filterOptions: ['contains'] }
            }, {
                headerName: gettextCatalog.getString("Status"),
                field: "status",
                filter: "text",
                filterParams: { filterOptions: ['startsWith'] },
                cellRenderer: function cellRenderer(params) {
                    var cls = params.value === 'public' ? 'success' : 'danger';
                    var label = _angular2.default.element('<span class="text-' + cls + '"><i class="fa fa-circle"></i>&nbsp; ' + gettextCatalog.getString(params.value.charAt(0).toUpperCase() + params.value.slice(1)) + '</span>');
                    return label[0];
                }

            }, {
                headerName: gettextCatalog.getString("Actions"),
                suppressFilter: true,
                cellRenderer: function cellRenderer(params) {
                    var buttons = _angular2.default.element('<div></div>');
                    var buttonEdit = _angular2.default.element('<button class="btn btn-xs btn-primary">\n                                    <em class="ion-edit"></em>\n                                    ' + gettextCatalog.getString('Edit') + '\n                                </button>');

                    buttonEdit.on('click', function () {
                        $state.go('pagesEdit', {
                            id: params.data.id,
                            title: params.data.title,
                            returnState: {
                                name: 'pages',
                                params: _angular2.default.copy($state.params)
                            }
                        });
                    });
                    buttons.append(buttonEdit[0]);

                    var buttonShowFormData = _angular2.default.element('<button class="btn btn-xs btn-primary">\n                                    <em class="ion-android-clipboard"></em>\n                                    ' + gettextCatalog.getString('Show form data') + '\n                                </button>');

                    buttonShowFormData.on('click', function () {
                        $state.go('pageFormDataList', {
                            id: params.data.id,
                            returnState: {
                                name: 'pages',
                                params: _angular2.default.copy($state.params)
                            }
                        });
                    });
                    buttons.append(buttonShowFormData[0]);

                    return buttons[0];
                }
            }];
        };

        this.options = {
            _columnDefsCallback: getColumnDefs,
            _gridStateId: 'page-grid-state'
        };

        this.initialFilterModel = {};
        var dataInitialized = false;

        var defaultParams = {
            title: undefined,
            slug: undefined,
            status: undefined,
            order_by: undefined,
            order_direction: undefined
        };

        this.$onInit = function () {
            if (!_this.initialParams) {
                _this.initialParams = _angular2.default.copy(defaultParams);
            }

            if (_this.initialParams.order_by) {
                _this.initialSortModel = [{ colId: _this.initialParams.order_by, sort: _this.initialParams.order_direction || 'asc' }];
            }

            if (_this.initialParams.page) {
                _this.initialPage = _this.initialParams.page;
            }

            ['title', 'slug', 'status'].forEach(function (field) {
                if (_this.initialParams[field]) _this.initialFilterModel[field] = { type: 'contains', filter: _this.initialParams[field] };
            });

            _this.datasource = {
                getRows: function getRows(params) {
                    var queryParams = GridParamsConverter.getCmsApiParams(params);
                    var stateParams = Object.assign({}, defaultParams, queryParams);

                    if (_this.onParamsChange) _this.onParamsChange({ params: _angular2.default.copy(stateParams) });

                    delete stateParams.page;
                    $state.go('.', stateParams, {
                        location: 'replace'
                    });

                    var responseData = [];
                    PageResource.findAll(queryParams, function (response) {
                        responseData = response.data;
                        var lastRow = response.total_count;
                        params.successCallback(responseData, lastRow);

                        if (!dataInitialized && _this.initialPage && _this.initialPage !== _this.options.api.paginationGetCurrentPage() + 1) {
                            dataInitialized = true;
                            _this.options.api.paginationGoToPage(parseInt(_this.initialPage) - 1);
                        }
                    }, function (errResponse) {});
                }
            };
        };

        this._onPageChange = function (page) {
            if (!dataInitialized) return;
            if (_this.onPageChange) _this.onPageChange({ $page: page });
        };
    }]
});

exports.default = productsGridModule.name;

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <cms-grid grid-options=\"$ctrl.options\"\n              datasource=\"$ctrl.datasource\"\n              initial-sort-model=\"$ctrl.initialSortModel\"\n              initial-filter-model=\"$ctrl.initialFilterModel\"\n              on-page-change=\"$ctrl._onPageChange($page)\"></cms-grid>\n</div>";

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "<div ba-panel ba-panel-title=\"{{'Landing pages' | translate }}\" ba-panel-class=\"\">\n    <div class=\"text-right\">\n        <a class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.addPage()\" translate >Add Page</a>\n    </div>\n    <br>\n    <pages-grid initial-params=\"$ctrl.initialParams\" on-params-change=\"$ctrl.onParamsChange(params)\" on-page-change=\"$ctrl.onPageChange($page)\"></pages-grid>\n</div>";

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _PageResource = __webpack_require__(130);

var _PageResource2 = _interopRequireDefault(_PageResource);

var _Preview = __webpack_require__(1000);

var _Preview2 = _interopRequireDefault(_Preview);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

var _Context = __webpack_require__(231);

var _Context2 = _interopRequireDefault(_Context);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _historyStorage = __webpack_require__(436);

var _historyStorage2 = _interopRequireDefault(_historyStorage);

var _undoRedo = __webpack_require__(1004);

var _undoRedo2 = _interopRequireDefault(_undoRedo);

var _SaveGuard = __webpack_require__(232);

var _SaveGuard2 = _interopRequireDefault(_SaveGuard);

var _ImageSpinner = __webpack_require__(1006);

var _ImageSpinner2 = _interopRequireDefault(_ImageSpinner);

var _Tutorial = __webpack_require__(1009);

var _Tutorial2 = _interopRequireDefault(_Tutorial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var pagesFormPage = _angular2.default.module('cms.pages.add', [_ConfigModule2.default, _PageResource2.default, _angularGettext2.default, _angularToastr2.default, _Preview2.default, _deleteElement2.default, _SaveGuard2.default, _historyStorage2.default, _undoRedo2.default, _ImageSpinner2.default, _Tutorial2.default]).component('pagesFormPage', {
    template: __webpack_require__(1013),
    controller: ['$scope', 'PageResource', '$state', '$stateParams', '$http', '$q', 'toastr', 'gettextCatalog', 'ACLService', 'baSidebarService', 'deleteElementDialog', 'SaveWarning', 'SaveGuard', 'CONFIG', 'historyStorage', '$element', 'tutorial', 'exportAsTemplateDialog', function controller($scope, PageResource, $state, $stateParams, $http, $q, toastr, gettextCatalog, ACLService, baSidebarService, deleteElementDialog, SaveWarning, SaveGuard, CONFIG, historyStorage, $element, tutorial, exportAsTemplateDialog) {
        var _this = this;

        /** @ngInject */
        this.accordionsStatuses = {
            main: {
                isOpen: true
            },
            first: {
                isOpen: true,
                requiredKeys: ['title', 'slug', 'status'],
                hasErrors: false
            },
            second: {
                isOpen: false
            },
            third: {
                isOpen: false
            },
            fourth: {
                isOpen: false
            },
            fifth: {
                isOpen: false
            }
        };

        this.disablePageInfoAccordion = true;

        this.isElementSelected = function () {
            if (!_this.creatorContext.hasCurrentElement()) {
                _this.accordionsStatuses.main.isOpen = true;
                _this.disablePageInfoAccordion = true;
                return true;
            } else {
                _this.accordionsStatuses.main.isOpen = false;
                _this.disablePageInfoAccordion = false;
                return false;
            }
        };

        this.$onInit = function () {
            _this.creatorContext = new _Context2.default();
            _this.creatorContext.setDragularScope($scope);
            historyStorage.register($element, function () {
                return _this.page;
            }, $scope);
        };

        $scope.$on('history-storage-change', function (event, snapshot) {
            _this.creatorContext.clearCurrentElement();
            _this.page = snapshot.snapshot;
        });
        this.pageUrl = '';
        this.getPageUrl = function () {
            var showToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;


            var getTokenString = function getTokenString() {
                if (showToken && !_this.letOpenPageWithoutToken) {
                    return '?token=' + btoa(_this.page.slug + _this.page.title + 'security-token');
                }
                return '';
            };

            return typeof _this.page.slug !== 'undefined' ? CONFIG.PUBLIC_SITE_URL.replace('__SITE_SLUG__', _this.page.slug) + getTokenString() : _this.pageUrl + getTokenString();
        };

        this.lineHeightUnits = [];

        PageResource.find({ id: $stateParams.id }, function (response) {
            _this.page = response;
            _this.pageUrl = CONFIG.PUBLIC_SITE_URL.replace('__SITE_SLUG__', _this.page.slug);
            SaveWarning.watch(response, _this.page, $scope, $element);
            historyStorage.add(_this.page);
            _this.letOpenPageWithoutToken = _this.page.status === "public";
            $stateParams.pageTitle = _this.page.title;

            tutorial.openIfFirstUsage();
        });

        this.matchRoles = ACLService.matchRoles;
        if (this.matchRoles('ROLE_USER')) {
            $stateParams.returnState = {};
            $stateParams.returnState.name = 'dashboard';
        }

        this.errors = {};
        this.pending = false;

        this.statuses = [{
            value: 'public',
            label: gettextCatalog.getString('Public')
        }, {
            value: 'draft',
            label: gettextCatalog.getString('Draft')
        }];

        /**
         * Broadcast slug recalculation request
         */
        this.updateSlug = function () {
            if (!this.page.id || !this.page.slug) {
                $scope.$broadcast('slug.recalc');
            }
        };

        /**
         * Actions to validate slug
         * Returns promise;
         * @param data
         */
        this.validateSlug = function (data) {
            var _this2 = this;

            this.errors.slug = [];
            if (!data) {
                return $q.when([]);
            }

            var pageResourcePromise = PageResource.findAll({ slug_strict: data }).$promise;

            pageResourcePromise.then(function (response) {

                _angular2.default.forEach(response.data, function (value) {
                    if (value.id !== this.page.id) {
                        this.errors.slug = [gettextCatalog.getString('This value is already used')];
                    } else {
                        this.errors.slug = null;
                    }
                }, _this2);
            });

            return pageResourcePromise;
        };

        this.onErrorMessage = function () {
            return toastr.error(gettextCatalog.getString('Please correct form errors and try again.', { title: this.page.title }), gettextCatalog.getString('Validation Errors'));
        };

        this.checkForErrors = function () {
            _angular2.default.forEach(Object.keys(_this.accordionsStatuses), function (accordionGroup) {
                if (!_this.accordionsStatuses[accordionGroup].requiredKeys) {
                    return;
                }
                var reqKeys = _this.accordionsStatuses[accordionGroup].requiredKeys;
                var foundErrors = Object.keys(_this.errors).filter(function (errorKey) {
                    return reqKeys.indexOf(errorKey) !== -1 && _this.errors[errorKey].length;
                }).length > 0;

                if (foundErrors) {
                    _this.accordionsStatuses[accordionGroup].hasErrors = true;
                    _this.accordionsStatuses[accordionGroup].isOpen = true;
                    _this.accordionsStatuses['main'].isOpen = true;
                } else {
                    _this.accordionsStatuses[accordionGroup].hasErrors = false;
                }
            });
        };

        /**
         * Submit pages
         */
        this.update = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var clearHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _this.pending = true;
                            _context.next = 3;
                            return SaveGuard.check();

                        case 3:

                            if (clearHistory) {
                                historyStorage.clear();
                            }

                            return _context.abrupt('return', PageResource.update(_this.page, function (response) {
                                _this.errors = {};
                                SaveWarning.watch(response, _this.page, $scope, $element);
                                toastr.success(gettextCatalog.getString('Page {{title}} saved!', { title: _this.page.title }), gettextCatalog.getString('Success'));
                                if (redirect) {
                                    goToReturnState();
                                }
                                _this.pending = false;
                                _this.letOpenPageWithoutToken = _this.page.status === "public";
                                _this.checkForErrors();
                            }, function (response) {
                                if (response.status === 400) {
                                    _this.errors = response.data;
                                    _this.onErrorMessage();
                                    _this.checkForErrors();
                                }
                                _this.pending = false;
                            }).$promise);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        this.confirmDelete = function () {
            var removeMessage = gettextCatalog.getString("Are you sure that you want to delete this page?");
            deleteElementDialog.open(removeMessage).then(function () {
                _this.delete();
            }).catch(function () {});
        };

        this.delete = function () {
            _this.pending = true;
            PageResource.delete({ id: _this.page.id }, function (response) {
                toastr.success(gettextCatalog.getString('Page {{title}} deleted!', { title: _this.page.title }), gettextCatalog.getString('Success'));
                goToReturnState();
                _this.pending = false;
            });
        };

        this.cancel = function () {
            return goToReturnState();
        };

        function goToReturnState() {
            SaveWarning.stopWatch();
            if ($stateParams.returnState) {
                $state.go($stateParams.returnState.name, $stateParams.returnState.params);
            } else {
                $state.go('pages', {});
            }
        }

        function collapseSidebar() {
            var startStatus = baSidebarService.isMenuCollapsed();
            baSidebarService.setMenuCollapsed(true);
            baSidebarService.lockAutoCollapse(true);
            $scope.$on('$destroy', function () {
                baSidebarService.lockAutoCollapse(false);
                baSidebarService.setMenuCollapsed(startStatus);
            });
        };

        collapseSidebar();

        $scope.$on('save.object', function () {
            _this.update(false, false);
        });

        this.showTutorial = function () {
            tutorial.clearFirstUsage();
            tutorial.openIfFirstUsage();
        };

        this.exportAsTemplate = function () {
            exportAsTemplateDialog.open(_this.page);
        };
    }]
});

exports.default = pagesFormPage.name;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(1001);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CmsPagesPreview = _angular2.default.module('cms.pages.preview', []).component('cmsPagesPreview', {
  bindings: {
    page: '=',
    prePreview: '<',
    pending: '<'
  },
  template: __webpack_require__(1002),
  controller: ['$uibModal', 'ExportPageTemplateService', function controller($uibModal, ExportPageTemplateService) {
    var _this = this;

    this.preview = function () {

      _this.prePreview(false, false).then(function (response) {

        _this.page = response;

        $uibModal.open({
          template: __webpack_require__(1003),
          size: 'lg',
          controllerAs: '$ctrl',
          controller: ['url', '$sce', function controller(url, $sce) {
            var _this2 = this;

            this.url = $sce.trustAsResourceUrl(url);
            this.loading = true;
            this.shownSize = 'desktop';

            this.onLoaded = function (event) {
              _this2.loading = false;
            };

            this.setMobile = function () {
              _this2.shownSize = 'mobile';
            };

            this.setTablet = function () {
              _this2.shownSize = 'tablet';
            };

            this.setDesktop = function () {
              _this2.shownSize = 'desktop';
            };
          }],
          windowClass: "pagePreview",
          resolve: {
            url: function url() {
              return _this.getTemplateUrl(response.slug);
            }
          }
        }).result.then(function () {}, function (res) {});
      }).catch(function (e) {
        console.log(e);
      });
    };

    this.getTemplateUrl = function (slug) {
      return ExportPageTemplateService.getUrl(slug);
    };
  }]
});

exports.default = CmsPagesPreview.name;

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = "<button ng-click=\"$ctrl.preview()\" ng-disabled=\"$ctrl.pending\"\n        class=\"btn btn-default\"\n        uib-tooltip=\"{{'Save and Preview' | translate}}\"\n        tooltip-placement=\"bottom\"\n>\n    <em class=\"fa fa-eye\"></em>\n</button>";

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-default\">\n        <span translate>Preview (all links, buttons and forms are disabled in preview mode, if you wan't to test them open page in new window)</span>\n    </div>\n    <div class=\"modal-body text-center\">\n        <div class=\"row\">\n            <button class=\"btn btn-{{$ctrl.shownSize == 'desktop' ? 'default ' : 'success'}} btn-with-icon\" ng-click=\"$ctrl.setDesktop()\">\n                <em class=\"ion-monitor\"></em>Desktop\n            </button>\n            <button class=\"btn btn-{{$ctrl.shownSize == 'tablet' ? 'default ' : 'success'}} btn-with-icon\" ng-click=\"$ctrl.setTablet()\">\n                <em class=\"ion-ipad\" ></em>Tablet\n            </button>\n            <button class=\"btn btn-{{$ctrl.shownSize == 'mobile' ? 'default ' : 'success'}} btn-with-icon\" ng-click=\"$ctrl.setMobile()\">\n                <em class=\"ion-iphone\" ></em>Mobile\n            </button>\n        </div>\n        <br>\n        <div class=\"cms-spinner sample-show-hide animated\" ng-show=\"$ctrl.loading\"\n             style=\"position: absolute; top: 10% ;left: 50%;\">\n            <em class=\"fa fa-circle-o-notch fa-spin\"></em>\n        </div>\n\n        <iframe class=\"iframe-preview\" ng-class=\"{'iframe-loaded': !$ctrl.loading, 'iframe-mobile': $ctrl.shownSize == 'mobile', 'iframe-tablet': $ctrl.shownSize == 'tablet'}\" ng-src=\"{{ $ctrl.url }}\"\n                cms-on-load=\"$ctrl.onLoaded(event)\" title=\"preview\">\n        </iframe>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\" translate>Close</button>\n    </div>\n</div>";

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _historyStorage = __webpack_require__(436);

var _historyStorage2 = _interopRequireDefault(_historyStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cmsCreatorUndoRedo = {
    bindings: {
        onChange: '&',
        fieldValue: '='
    },
    template: __webpack_require__(1005),
    controller: ['historyStorage', function controller(historyStorage) {

        this.undo = function () {
            historyStorage.back();
        };

        this.redo = function () {
            historyStorage.next();
        };

        this.undoDisabled = function () {
            return historyStorage.getCounter() <= 0;
        };

        this.redoDisabled = function () {
            return historyStorage.getCounter() + 1 >= historyStorage.getStackLength();
        };
    }]

};

exports.default = _angular2.default.module('cms.creator.undo-redo', [_historyStorage2.default]).component('cmsCreatorUndoRedo', cmsCreatorUndoRedo).name;

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default material-icons undo-redo\"\n        ng-click=\"$ctrl.undo()\"\n        ng-disabled=\"$ctrl.undoDisabled()\"\n        tooltip-placement=\"bottom\"\n        uib-tooltip=\"{{ 'Undo' | translate }}\">undo</button>\n<button class=\"btn btn-default material-icons undo-redo\"\n        ng-click=\"$ctrl.redo()\"\n        ng-disabled=\"$ctrl.redoDisabled()\"\n        tooltip-placement=\"bottom\"\n        uib-tooltip=\"{{ 'Redo' | translate }}\">redo</button>";

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MediaUsage = __webpack_require__(201);

var _MediaUsage2 = _interopRequireDefault(_MediaUsage);

__webpack_require__(1007);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageSpinner = {
    bindings: {
        ngModel: '<'
    },
    template: __webpack_require__(1008),
    controller: ['$scope', '$timeout', function controller($scope, $timeout) {
        var _this = this;

        var SHOW_SPINNER_DELAY = 500;

        this.pending = false;

        this.$onChanges = function () {

            if (!_this.ngModel || !_this.ngModel.length) {
                return;
            }

            var delay = $timeout(function () {
                _this.pending = true;
            }, SHOW_SPINNER_DELAY);

            var url = new _MediaUsage2.default(_this.ngModel[0].media, 1920, 0).getImgUrl();

            var img = new Image();

            img.onload = function () {
                _this.pending = false;
                $timeout.cancel(delay);

                if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                    $scope.$apply();
                }
            };

            img.src = url;

            if (img.complete) img.onload();
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.imageSpinner', []).component('cmsCreatorImageSpinner', imageSpinner).name;

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cms-creator-image-spinner__content animated\" ng-if=\"$ctrl.pending\">\n    <em class=\"fa fa-3x fa-circle-o-notch fa-spin\" ></em>\n</div>\n";

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _shepherd = __webpack_require__(1010);

var _shepherd2 = _interopRequireDefault(_shepherd);

var _angularLocalStorage = __webpack_require__(94);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

__webpack_require__(1012);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.page.tutorial', [_angularGettext2.default, _angularLocalStorage2.default]).factory('tutorial', ['$timeout', 'localStorageService', 'gettextCatalog', 'ClickOutside', function ($timeout, localStorageService, gettextCatalog, ClickOutside) {

    var tutorialStorageKey = 'tutorial';

    var open = function open() {

        var attachToElement = findSectionAttachTo();

        var tour = new _shepherd2.default.Tour({
            defaults: {
                classes: 'shepherd-theme-square-dark',
                showCancelLink: false,
                when: {
                    show: function show() {
                        window.scrollTo(0, 0);
                    }
                }
            }
        });

        var buttons = [{
            text: gettextCatalog.getString('Exit'),
            action: tour.cancel,
            classes: 'shepherd-button-secondary'
        }, {
            text: gettextCatalog.getString('Back'),
            action: tour.back,
            classes: 'shepherd-button-secondary'
        }, {
            text: gettextCatalog.getString('Next'),
            action: tour.next
        }];
        tour.addStep('welcome', {
            title: gettextCatalog.getString('Welcome'),
            text: gettextCatalog.getString('Welcome to the <img style="max-width: 75px; display: inline-block;" src="/fonts/contente.svg" alt="logo"> trial. You can explore all builder functionalities without any limits. Just pick the first element and drag and drop it on the page to see how easy it is! Don\'t forget about registration to share your page with the wider audience.'),
            classes: 'shepherd shepherd-welcome',
            buttons: [buttons[0], buttons[2]],
            when: {
                show: function show() {
                    $timeout(function () {
                        $('.shepherd.shepherd-welcome.shepherd-has-title.shepherd-element').css('transform', 'translate(-230px,-90px)');
                    });
                }
            }
        });

        tour.addStep('sectionLibrary', {
            title: gettextCatalog.getString('Toolbox modules'),
            text: gettextCatalog.getString('Click on the selected module with the left mouse button and drag and drop elements to the place where you want them in the workspace. Gray lines suggest where the item will be added.<img src="/images/drag_and_drop.gif" alt="drag and drop showcase" class="img-responsive"/>'),
            attachTo: '.section-library-tutorial top',
            buttons: buttons,
            when: {
                'before-show': function beforeShow() {
                    $(window).scrollTop(0);
                }
            }
        });

        var columnsResizeStep = {
            title: gettextCatalog.getString('Resizing of columns'),
            text: gettextCatalog.getString('Drag (left or right) column divider to change columns size.<img src="/images/columns-resize.gif" alt="columns resize" class="img-responsive"/>'),
            when: {
                'before-show': function beforeShow() {
                    if (attachToElement) {
                        attachToElement.click();
                    }
                    $(window).scrollTop(0);
                },
                show: function show() {
                    $timeout(function () {
                        $(window).scrollTop($(window).scrollTop() + 5);
                        $(window).scrollTop($(window).scrollTop() - 5);
                    });
                }
            },
            buttons: buttons
        };

        if (attachToElement) {
            columnsResizeStep.attachTo = '.creator-workspace__section-selected top';
        }

        tour.addStep('columnsResize', columnsResizeStep);

        tour.addStep('editPageSettings', {
            title: gettextCatalog.getString('Editing page settings'),
            text: gettextCatalog.getString('You can manage information about your website here.'),
            attachTo: '.accordion-page-info left',
            when: {
                'before-show': function beforeShow() {
                    $(window).scrollTop(0);
                },
                show: function show() {
                    $timeout(function () {
                        ClickOutside.clear();
                    });
                }
            },
            buttons: buttons

        });

        var editPageModuleStep = {
            title: gettextCatalog.getString('Module editions'),
            text: gettextCatalog.getString('You can edit and customize each element of the page here.'),
            attachTo: '.module-settings left',
            when: {
                'before-show': function beforeShow() {
                    if (attachToElement) {
                        attachToElement.click();
                    }
                    $(window).scrollTop(0);
                },
                show: function show() {
                    $timeout(function () {
                        $(window).scrollTop($(window).scrollTop() + 15);
                        $(window).scrollTop($(window).scrollTop() - 15);
                    }, 300);
                }
            },
            buttons: buttons

        };

        if (attachToElement) {
            editPageModuleStep.attachTo = '.module-settings left';
        }

        tour.addStep('editPageModule', editPageModuleStep);

        tour.addStep('mediaLibraryButton', {
            title: gettextCatalog.getString('Media library'),
            text: gettextCatalog.getString('Use media button to add beautiful images directly to your page. Choose from thousand Unsplash library photos or upload one of your own.<img src="/images/media-library.jpg" alt="stock photos" class="img-responsive"/>'),
            buttons: buttons,
            when: {
                'before-show': function beforeShow() {
                    $(window).scrollTop(0);
                },
                show: function show() {
                    $timeout(function () {
                        $('div[data-id="mediaLibraryButton"]').css('transform', 'translate(-230px,-315px)');
                    });
                }
            }
        });

        tour.addStep('menu', {
            title: gettextCatalog.getString('Adding menu'),
            text: gettextCatalog.getString('Drag and drop this component if you want to add the menu to your page.'),
            attachTo: '.creator-sections-element__section-pageMenu bottom',
            buttons: buttons,
            when: {
                'before-show': function beforeShow() {
                    $(window).scrollTop(0);
                }
            }
        });

        var linkButtonStep = {
            title: gettextCatalog.getString('Adding menu item'),
            text: gettextCatalog.getString('Use this button to add a new element to your menu. Don\'t forget to add a section title.<img src="/images/section-title.jpg" alt="section title" class="img-responsive"/>'),
            when: {
                'before-show': function beforeShow() {
                    if (attachToElement) {
                        attachToElement.click();
                    }
                    $(window).scrollTop(0);
                    $timeout(function () {
                        if (attachToElement) $(attachToElement).addClass('_shep-en-div');
                        $(window).scrollTop($(window).scrollTop() + 5);
                        $(window).scrollTop($(window).scrollTop() - 5);
                    });
                },
                hide: function hide() {
                    $timeout(function () {
                        $(attachToElement).removeClass('_shep-en-div');
                    });
                }
            },
            buttons: buttons
        };

        if (attachToElement) {
            linkButtonStep.attachTo = '.creator-workspace__section-selected .btn-info top';
        }

        tour.addStep('linkButton', linkButtonStep);

        tour.addStep('remember', {
            title: gettextCatalog.getString('Do not forget about me'),
            text: gettextCatalog.getString('You can return to this tutorial anytime by clicking on the help icon in the upper right corner.'),
            attachTo: '.side-form top',
            buttons: [buttons[1], buttons[0]],
            when: {
                'before-show': function beforeShow() {
                    $(window).scrollTop(0);
                }
            }

        });
        $timeout(function () {
            tour.start();
        });
    };

    var findSectionAttachTo = function findSectionAttachTo() {
        var selectedElement = null;
        var pageSections = $('.section-pageSection');

        pageSections.each(function (index, element) {
            selectedElement = element;
            if (index === 2) {
                selectedElement = element;
                return false;
            }
        });

        return selectedElement;
    };

    var openIfFirstUsage = function openIfFirstUsage() {
        var tutorial = localStorageService.get(tutorialStorageKey);
        if (tutorial) {
            return;
        }
        open();
        localStorageService.set(tutorialStorageKey, 1);
    };

    var clearFirstUsage = function clearFirstUsage() {
        localStorageService.remove(tutorialStorageKey);
    };

    return {
        open: open,
        openIfFirstUsage: openIfFirstUsage,
        clearFirstUsage: clearFirstUsage
    };
}]).name;

/***/ }),
/* 1010 */,
/* 1011 */,
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = "<style ng-if=\"$ctrl.page\">\n\n    /*\n     *  Common page styles - equivalent of backend page styles\n     *  Editing this part of css requires implementation in generator app\n     */\n\n    .main-creator-workspace {\n        background: url({{$ctrl.page.globalBackgroundImage[0].media | imageUrl : 1920 : ''}}) no-repeat top center / cover;\n        background-color: {{$ctrl.page.globalBackgroundColor || '#ededed' }};\n    }\n\n    .creator-workspace__section {\n        font-size: 14px;\n        font-family: \"{{ $ctrl.page.globalTextConfig.text.fontFamily }}\", Sans-Serif;\n        line-height: {{ $ctrl.page.globalLineHeight.value }};\n        color: {{ $ctrl.page.globalColor }};\n    }\n\n    .creator-workspace__section a {\n        color: {{$ctrl.page.globalTextConfig.href.color }};\n        text-decoration: none;\n    }\n\n    .creator-workspace__section a:hover {\n        color: {{$ctrl.page.globalTextConfig.linkHover.color }};\n        text-decoration: none;\n    }\n\n    .creator-workspace__section h1 {\n        font-size: 3em;\n        font-family: '{{ $ctrl.page.globalTextConfig.h1.fontFamily }}' !important;\n    }\n\n    .creator-workspace__section h2 {\n        font-size: 2em;\n        font-family: '{{ $ctrl.page.globalTextConfig.h2.fontFamily }}' !important;\n    }\n\n    .creator-workspace__section h3 {\n        font-size: 1.5em;\n        font-family: '{{ $ctrl.page.globalTextConfig.h3.fontFamily }}' !important;\n    }\n\n    .creator-workspace__section p,\n    .creator-workspace__section .menu\n    {\n        font-family: '{{ $ctrl.page.globalTextConfig.text.fontFamily }}' !important;\n    }\n\n    .creator-workspace__section h1,\n    .creator-workspace__section h2,\n    .creator-workspace__section h3,\n    .creator-workspace__section p,\n    .creator-workspace__section .menu\n    {\n        margin: 0;\n        box-sizing: border-box;\n        word-wrap: break-word;\n        white-space: normal;\n        font-weight: 400;\n        line-height: {{ $ctrl.page.globalLineHeight.value }};\n    }\n\n    .creator-workspace__section input {\n        font-family: 'Ubuntu', sans-serif !important;\n    }\n\n</style>\n<div ng-if=\"!$ctrl.page\" class=\"spinner-loading animated\">\n    <span class=\"fa fa-circle-o-notch fa-spin loading-spinner\"></span>\n</div>\n<div class=\"landing-widgets\" ng-if=\"$ctrl.page\">\n    <div class=\"landing-main\">\n        <div hl-sticky=\"\" offset-top=\"66\" collection=\"sections\" class=\"section-library-tutorial\">\n            <div class=\"landing-top panel\">\n                <creator-sections-library group=\"page\" context=\"$ctrl.creatorContext\"></creator-sections-library>\n            </div>\n\n        </div>\n        <div class=\"landing-workspace panel\">\n            <creator-workspace sections=\"$ctrl.page.content\"\n                               context=\"$ctrl.creatorContext\"\n                               type=\"workspace\"\n                               sections-nested=\"true\"\n                               class=\"main-creator-workspace\"\n                               content=\"$ctrl.page.content\"\n            ></creator-workspace>\n            <style>\n                {{ $ctrl.page.customStyles}}\n            </style>\n        </div>\n    </div>\n\n    <div class=\"landing-right\">\n\n        <div hl-sticky=\"\" offset-top=\"90\" id=\"stickyScrolledContainer\" collection=\"settings\">\n            <div ba-panel class=\"side-form\">\n                <div class=\"side-form__buttons\">\n                    <cms-pages-preview pending=\"$ctrl.pending\" page=\"$ctrl.page\"\n                                       pre-preview=\"$ctrl.update\"></cms-pages-preview>\n\n                    <div ng-if=\"$ctrl.page.id\"  class=\"btn-group\" uib-dropdown dropdown-append-to=\"'#stickyScrolledContainer'\"\n                         uib-tooltip=\"{{'Save' | translate }}\" tooltip-placement=\"bottom\"\n                    >\n                        <button ng-disabled=\"$ctrl.pending\" type=\"button\" ng-click=\"$ctrl.update(false)\" ng-disabled=\"$ctrl.pending\"\n\n                                class=\"btn btn-success\">\n                            <em class=\"fa fa-save\"></em>\n                        </button>\n                        <button ng-disabled=\"$ctrl.pending\" type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle>\n                            <span class=\"caret\"></span>\n                            <span class=\"sr-only\" translate>Toggle Dropdown</span>\n                        </button>\n                        <ul uib-dropdown-menu>\n                            <li>\n                                <a href=\"#\" ng-click=\"$ctrl.update()\" ng-disabled=\"$ctrl.pending\" ng-if=\"$ctrl.page.id\" translate=>Save and leave</a>\n                            </li>\n                            <li><a href=\"{{ $ctrl.getPageUrl() }}\" target=\"_blank\" translate>Open page</a></li>\n                            <li ng-if=\"$ctrl.matchRoles(['ROLE_ADMIN'])\"><a ng-click=\"$ctrl.exportAsTemplate()\" translate>Export as a template</a></li>\n                        </ul>\n                    </div>\n                    <button ng-click=\"$ctrl.confirmDelete()\" ng-disabled=\"!$ctrl.page.id || $ctrl.pending\" uib-tooltip=\"{{ 'Delete' | translate }}\" tooltip-placement=\"bottom\"\n                            class=\"btn btn-danger\">\n                        <em class=\"ion-trash-a\"></em>\n                    </button>\n\n                    <cms-creator-undo-redo class=\"pull-right\" field-value=\"$ctrl.page\" ></cms-creator-undo-redo>\n\n                    <button ng-click=\"$ctrl.showTutorial()\" uib-tooltip=\"{{ 'Help' | translate }}\" tooltip-placement=\"bottom\"\n                            class=\"btn btn-default btn-help btn-tutorial\">\n                        <em class=\"ion-help\"></em>\n                    </button>\n\n                </div>\n            </div>\n            <uib-accordion scroll-lock=\"\">\n                <div uib-accordion-group is-open=\"$ctrl.accordionsStatuses.main.isOpen\"\n                     is-disabled=\"$ctrl.disablePageInfoAccordion\"\n                     class=\"accordion-page-info\">\n                    <uib-accordion-heading>\n                        {{ 'Page info' | translate}}\n                        <em class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': $ctrl.accordionsStatuses.main.isOpen, 'glyphicon-chevron-right': !$ctrl.accordionsStatuses.main.isOpen}\"></em>\n                    </uib-accordion-heading>\n                <creator-toolbar model=\"$ctrl.page\" >\n                    <form class=\"form-horizontal\" autocomplete=\"off\" novalidate>\n\n                        <uib-accordion>\n                            <div uib-accordion-group is-open=\"$ctrl.accordionsStatuses.first.isOpen\">\n                                <uib-accordion-heading>\n                                    <div>{{ 'Main' | translate }}\n                                    <span class=\"glyphicon glyphicon-exclamation-sign validation-icon-error\" aria-hidden=\"true\" ng-show=\"$ctrl.accordionsStatuses.first.hasErrors\"></span>\n                                    <em class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': $ctrl.accordionsStatuses.first.isOpen, 'glyphicon-chevron-right': !$ctrl.accordionsStatuses.first.isOpen}\"></em></div>\n                                </uib-accordion-heading>\n                                <cms-input-text model=\"$ctrl.page.title\"\n                                                maxlength=\"200\"\n                                                label=\"{{ 'Title' | translate }}\"\n                                                errors=\"$ctrl.errors.title\"\n                                                on-blur=\"$ctrl.updateSlug(data)\">\n                                </cms-input-text>\n                                <cms-input-slug model=\"$ctrl.page.slug\"\n                                                maxlength=\"200\"\n                                                label=\"{{'Site address' | translate }}\"\n                                                errors=\"$ctrl.errors.slug\"\n                                                slug-validation=\"$ctrl.validateSlug(data)\"\n                                                slug-source=\"$ctrl.page.title\">\n                                </cms-input-slug>\n\n                                <div class=\"help-block domain-name\">\n                                    {{ 'Your free domain name will be:' | translate }}\n                                    <div class=\"domain-name-url\">{{ $ctrl.getPageUrl(false) }}</div>\n                                </div>\n\n\n\n                                <cms-input-object-select model=\"$ctrl.page.status\"\n                                                  errors=\"$ctrl.errors.status\"\n                                                  label=\"{{ 'Status' | translate }}\"\n                                                  options=\"$ctrl.statuses\">\n                                </cms-input-object-select>\n\n                            </div>\n                            <div uib-accordion-group is-open=\"$ctrl.accordionsStatuses.second.isOpen\">\n                                <uib-accordion-heading>\n                                    <div>{{ 'View' | translate }}\n                                    <span class=\"glyphicon glyphicon-exclamation-sign validation-icon-error\" aria-hidden=\"true\" ng-show=\"$ctrl.accordionsStatuses.second.hasErrors\"></span>\n                                    <em class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': $ctrl.accordionsStatuses.second.isOpen, 'glyphicon-chevron-right': !$ctrl.accordionsStatuses.second.isOpen}\"></em></div>\n                                </uib-accordion-heading>\n                                <cms-input-color model=\"$ctrl.page.globalBackgroundColor\"\n                                                 errors=\"$ctrl.errors.globalBackgroundColor\"\n                                                 label=\"{{ 'Background color' | translate }}\">\n                                </cms-input-color>\n                                <cms-input-media model=\"$ctrl.page.globalBackgroundImage\"\n                                                 errors=\"$ctrl.errors.globalBackgroundImage\"\n                                                 label=\"{{ 'Background image' | translate }}\">\n                                </cms-input-media>\n                                <cms-input-media model=\"$ctrl.page.globalTabletBackgroundImage\"\n                                                 errors=\"$ctrl.errors.globalTabletBackgroundImage\"\n                                                 label=\"{{ 'Tablet background image' | translate }}\">\n                                </cms-input-media>\n                                <cms-input-media model=\"$ctrl.page.globalMobileBackgroundImage\"\n                                                 errors=\"$ctrl.errors.globalMobileBackgroundImage\"\n                                                 label=\"{{ 'Mobile background image' | translate }}\">\n                                </cms-input-media>\n                                <cms-input-color model=\"$ctrl.page.globalColor\"\n                                                 errors=\"$ctrl.errors.globalColor\"\n                                                 label=\"{{ 'Text color' | translate }}\">\n                                </cms-input-color>\n                                <cms-input-color model=\"$ctrl.page.globalLinkColor\"\n                                                 errors=\"$ctrl.errors.globalLinkColor\"\n                                                 label=\"{{ 'Link color' | translate }}\">\n                                </cms-input-color>\n                                <cms-input-textarea model=\"$ctrl.page.customStyles\"\n                                                    errors=\"$ctrl.errors.customStyles\"\n                                                    label=\"{{ 'Custom styles' | translate }}\">\n                                </cms-input-textarea>\n                            </div>\n                            <div uib-accordion-group is-open=\"$ctrl.accordionsStatuses.third.isOpen\">\n                                <uib-accordion-heading><div>\n                                    {{ 'SEO' | translate }}\n                                    <span class=\"glyphicon glyphicon-exclamation-sign validation-icon-error\" aria-hidden=\"true\" ng-show=\"$ctrl.accordionsStatuses.third.hasErrors\"></span>\n                                    <em class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': $ctrl.accordionsStatuses.third.isOpen, 'glyphicon-chevron-right': !$ctrl.accordionsStatuses.third.isOpen}\"></em></div>\n                                </uib-accordion-heading>\n\n                                <cms-input-text model=\"$ctrl.page.seoKeywords\"\n                                                errors=\"$ctrl.errors.seoKeywords\"\n                                                label=\"{{ 'Keywords' | translate }}\">\n                                </cms-input-text>\n                                <cms-input-text model=\"$ctrl.page.seoDescription\"\n                                                errors=\"$ctrl.errors.seoDescription\"\n                                                label=\"{{ 'Description' | translate }}\">\n                                </cms-input-text>\n                                <cms-input-text model=\"$ctrl.page.seoOgTitle\"\n                                                errors=\"$ctrl.errors.seoOgTitle\"\n                                                label=\"{{ 'og:title' | translate }}\"\n                                helper=\"{{ 'The title of your object as it should appear within the graph, e.g., `The Rock`.' | translate }}\"></cms-input-text>\n                                <cms-input-text model=\"$ctrl.page.seoOgType\"\n                                                errors=\"$ctrl.errors.seoOgType\"\n                                                label=\"{{ 'og:type' | translate }}\"\n                                                helper=\"{{ 'The type of your object, e.g., `video.movie`. Depending on the type you specify, other properties may also be required.' |translate }}\">\n                                </cms-input-text>\n                                <cms-input-text model=\"$ctrl.page.seoOgImage\"\n                                                errors=\"$ctrl.errors.seoOgImage\"\n                                                label=\"{{ 'og:image' | translate }}\"\n                                helper=\"{{ 'An image URL which should represent your object within the graph.' | translate }}\"></cms-input-text>\n                                <cms-input-text model=\"$ctrl.page.seoOgUrl\"\n                                                errors=\"$ctrl.errors.seoOgUrl\"\n                                                label=\"{{ 'og:url' | translate }}\"\n                                                helper=\"{{ 'The canonical URL of your object that will be used as its permanent ID in the graph, e.g., `http://www.imdb.com/title/tt0117500/`.' |translate }}\">\n                                </cms-input-text>\n                            </div>\n\n                            <div uib-accordion-group is-open=\"$ctrl.accordionsStatuses.fourth.isOpen\">\n                                <uib-accordion-heading>\n                                    <div>{{ 'Analytics' | translate }}\n                                    <span class=\"glyphicon glyphicon-exclamation-sign validation-icon-error\" aria-hidden=\"true\" ng-show=\"$ctrl.accordionsStatuses.fourth.hasErrors\"></span>\n                                    <em class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': $ctrl.accordionsStatuses.fourth.isOpen, 'glyphicon-chevron-right': !$ctrl.accordionsStatuses.fourth.isOpen}\"></em></div>\n                                </uib-accordion-heading>\n\n                                    <cms-input-text model=\"$ctrl.page.googleAnalytics\"\n                                                    label=\"{{ 'Google Analytics token' | translate }}\"\n                                                    placeholder=\"GA-XXXXXXXX\"\n                                                    errors=\"$ctrl.errors.title\">\n                                    </cms-input-text>\n\n                                    <cms-input-text model=\"$ctrl.page.googleTagManager\"\n                                                    label=\"{{ 'Google Tag Manager key' | translate }}\"\n                                                    placeholder=\"GTM-XXXXXXXX\"\n                                                    errors=\"$ctrl.errors.googleTagManager\">\n                                    </cms-input-text>\n\n                                    <cms-input-text model=\"$ctrl.page.googleTagManagerAMP\"\n                                                    label=\"{{ 'Google Tag Manager key for AMP' | translate }}\"\n                                                    placeholder=\"GTM-XXXXXXXX\"\n                                                    errors=\"$ctrl.errors.googleTagManagerAMP\">\n                                    </cms-input-text>\n                                </div>\n\n                            <div uib-accordion-group is-open=\"$ctrl.accordionsStatuses.fifth.isOpen\">\n                                <uib-accordion-heading>\n                                    <div>\n                                        {{ 'Text' | translate }}\n                                    <span class=\"glyphicon glyphicon-exclamation-sign validation-icon-error\" aria-hidden=\"true\" ng-show=\"$ctrl.accordionsStatuses.fifth.hasErrors\"></span>\n                                    <em class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': $ctrl.accordionsStatuses.fifth.isOpen, 'glyphicon-chevron-right': !$ctrl.accordionsStatuses.fifth.isOpen}\"></em></div>\n                                </uib-accordion-heading>\n                                <p><strong>{{ 'Heading 1' | translate }}</strong></p>\n                                <cms-input-font-select model=\"$ctrl.page.globalTextConfig.h1.fontFamily\"\n                                                       errors=\"$ctrl.errors.globalTextConfig.h1.fontFamily\"\n                                                       label=\"{{ 'Font' | translate }}\">\n                                </cms-input-font-select>\n                                <p><strong>{{ 'Heading 2' | translate }}</strong></p>\n                                <cms-input-font-select model=\"$ctrl.page.globalTextConfig.h2.fontFamily\"\n                                                       errors=\"$ctrl.errors.globalTextConfig.h2.fontFamily\"\n                                                       label=\"{{ 'Font' | translate }}\">\n                                </cms-input-font-select>\n                                <p><strong>{{ 'Heading 3' | translate }}</strong></p>\n                                <cms-input-font-select model=\"$ctrl.page.globalTextConfig.h3.fontFamily\"\n                                                       errors=\"$ctrl.errors.globalTextConfig.h3.fontFamily\"\n                                                       label=\"{{ 'Font' | translate }}\">\n                                </cms-input-font-select>\n                                <p><strong>{{ 'Text' | translate }}</strong></p>\n                                <cms-input-font-select model=\"$ctrl.page.globalTextConfig.text.fontFamily\"\n                                                       errors=\"$ctrl.errors.globalTextConfig.text.fontFamily\"\n                                                       label=\"{{ 'Font' | translate }}\">\n                                </cms-input-font-select>\n                                <cms-input-number model=\"$ctrl.page.globalLineHeight\"\n                                                  label=\"{{'Line height' | translate}}\"\n                                                  units=\"$ctrl.lineHeightUnits\"\n                                                  step=\"0.01\"\n                                                  label-class=\"creator-toolbar__line-height-label\"\n                                                  input-size=12\n                                                  errors=\"$ctrl.errors.globalLineHeight\">\n                                </cms-input-number>\n                                <p><strong>{{ 'Link' | translate }}</strong></p>\n                                <cms-input-color model=\"$ctrl.page.globalTextConfig.href.color\"\n                                                 errors=\"$ctrl.errors.globalTextConfig.href.color\"\n                                                 label=\"{{ 'Color' | translate }}\">\n                                </cms-input-color>\n                                <p><strong>{{ 'Hover effect' | translate }}</strong></p>\n                                <cms-input-color model=\"$ctrl.page.globalTextConfig.linkHover.color\"\n                                                 errors=\"$ctrl.errors.globalTextConfig.linkHover.color\"\n                                                 label=\"{{ 'Color' | translate }}\">\n                                </cms-input-color>\n                            </div>\n                        </uib-accordion>\n                    </form>\n                </creator-toolbar>\n                </div>\n            </uib-accordion>\n            <div ba-panel ba-panel-title=\"{{'Module settings' | translate}}\" ba-panel-class=\"with-scroll disable-click-outside module-settings\" scroll-lock=\"\">\n                <p ng-show=\"$ctrl.isElementSelected()\">{{ \"Select a module to see it's options\" | translate}}</p>\n                <creator-toolbar model=\"$ctrl.page\" context=\"$ctrl.creatorContext\" ng-show=\"!$ctrl.isElementSelected()\"></creator-toolbar>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _PageFormDataGrid = __webpack_require__(1015);

var _PageFormDataGrid2 = _interopRequireDefault(_PageFormDataGrid);

var _PageResource = __webpack_require__(130);

var _PageResource2 = _interopRequireDefault(_PageResource);

var _FindFormService = __webpack_require__(437);

var _FindFormService2 = _interopRequireDefault(_FindFormService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.page.form.data.list', [_PageFormDataGrid2.default, _PageResource2.default, _FindFormService2.default]).component('pageFormDataListPage', {
    template: __webpack_require__(1017),
    bindings: {
        $transition$: '<'
    },
    controller: ['gettextCatalog', 'toastr', 'CONFIG', '$state', 'PageResource', 'FindFormService', function controller(gettextCatalog, toastr, CONFIG, $state, PageResource, FindFormService) {
        var _this = this;

        /** @ngInject */

        this.page = {};
        this.total_count = 0;
        this.$onInit = function () {
            _this.initialParams = _this.$transition$.params();
            PageResource.find({ id: $state.params.id }, function (response) {
                _this.page = response;
                _this.form = FindFormService.findForm(_this.page.content);
                _this.columns = _this.form.config ? _this.form.config.content : [];
            });
        };

        this.onParamsChange = function (params) {
            delete params.page;
            $state.go('.', params, {
                location: 'replace'
            });
        };

        this.onPageChange = function (page) {
            if (page === 0) {
                return;
            }
            $state.go('.', { page: page !== 1 ? page : undefined }, {
                location: 'replace'
            });
        };
    }]
}).name;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _GridDirective = __webpack_require__(107);

var _GridDirective2 = _interopRequireDefault(_GridDirective);

var _GridParamsConverter = __webpack_require__(116);

var _GridParamsConverter2 = _interopRequireDefault(_GridParamsConverter);

var _PageResource = __webpack_require__(130);

var _PageResource2 = _interopRequireDefault(_PageResource);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageFormDataGridModule = _angular2.default.module('cms.page.form.data.grid', [_GridDirective2.default, _PageResource2.default, _angularGettext2.default, _ConfigModule2.default, _GridParamsConverter2.default]).component('pageFormDataGrid', {
    template: __webpack_require__(1016),
    bindings: {
        initialParams: '<?',
        onParamsChange: '&?',
        onPageChange: '&?',
        columns: '='
    },
    controller: ['PageResource', 'gettextCatalog', 'toastr', 'CONFIG', 'GridParamsConverter', '$state', function controller(PageResource, gettextCatalog, toastr, CONFIG, GridParamsConverter, $state) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.initialFilterModel = {};
            var dataInitialized = false;

            var defaultParams = {
                order_by: undefined,
                order_direction: undefined
            };

            if (!_this.initialParams) {
                _this.initialParams = _angular2.default.copy(defaultParams);
            }

            if (_this.initialParams.order_by) {
                _this.initialSortModel = [{ colId: _this.initialParams.order_by, sort: _this.initialParams.order_direction || 'asc' }];
            }

            if (_this.initialParams.page) {
                _this.initialPage = _this.initialParams.page;
            }

            _this.form = undefined;

            var getColumnDefs = function getColumnDefs() {

                var columns = [{
                    headerName: gettextCatalog.getString('Date'),
                    field: "createdAt",
                    filter: 'date',
                    filterParams: { filterOptions: ['inRange'] }
                }];
                if (_this.columns) {
                    _this.columns.forEach(function (input) {
                        var key = input.config.key;
                        if (['formText', 'formTextarea', 'formEmail', 'formNumber'].indexOf(input.type) > -1) {
                            columns.push({
                                headerName: input.config.label || input.config.placeholder,
                                field: 'data.' + key
                            });
                        }
                        if (['formDate', 'formDateTime'].indexOf(input.type) > -1) {
                            columns.push({
                                headerName: input.config.label || input.config.placeholder,
                                field: 'data.' + key,
                                filter: 'date',
                                filterParams: { filterOptions: ['inRange'] },
                                cellRenderer: function cellRenderer(params) {
                                    if (params.data.data[key]) {
                                        return input.type === 'formDate' ? params.data.data[key].date.substr(0, 10) : params.data.data[key].date.substr(0, 16);
                                    }
                                    return '';
                                }
                            });
                        }
                    });
                }
                columns.push({
                    headerName: gettextCatalog.getString("Actions"),
                    suppressFilter: true,
                    cellRenderer: function cellRenderer(params) {
                        var buttons = _angular2.default.element('<div></div>');
                        var button = _angular2.default.element('<button class="btn btn-xs btn-primary">\n                                        <em class="ion-eye"></em>\n                                        ' + gettextCatalog.getString('Show details') + '\n                                    </button>');

                        button.on('click', function () {
                            $state.go('pageFormDataDetails', {
                                id: params.data.id,
                                returnState: {
                                    name: 'pageFormData',
                                    params: _angular2.default.copy($state.params)
                                }
                            });
                        });
                        buttons.append(button[0]);
                        return buttons[0];
                    }
                });
                return columns;
            };

            _this.options = {
                _columnDefsCallback: getColumnDefs,
                enableColResize: false
            };

            var responseData = [];
            _this.datasource = {
                getRows: function getRows(params) {
                    var queryParams = GridParamsConverter.getCmsApiParams(params);
                    queryParams['pageId'] = $state.params.id;
                    var stateParams = Object.assign({}, defaultParams, queryParams);

                    if (_this.onParamsChange) _this.onParamsChange({ params: _angular2.default.copy(stateParams) });

                    delete stateParams.page;
                    $state.go('.', stateParams, {
                        location: 'replace'
                    });

                    PageResource.findFormData(queryParams, function (response) {
                        responseData = response.data;
                        responseData.map(function (data) {
                            data.createdAt = new Date(data.createdAt).toLocaleString();
                        });
                        var lastRow = response.total_count;
                        params.successCallback(responseData, lastRow);

                        if (!dataInitialized && _this.initialPage && _this.initialPage !== _this.options.api.paginationGetCurrentPage() + 1) {
                            dataInitialized = true;
                            _this.options.api.paginationGoToPage(parseInt(_this.initialPage) - 1);
                        }
                        _this.totalCount = response.total_count;
                    }, function (errResponse) {});
                }
            };

            _this._onPageChange = function (page) {
                if (!dataInitialized) return;
                if (_this.onPageChange) _this.onPageChange({ $page: page });
            };
        };
    }]
});

exports.default = pageFormDataGridModule.name;

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <p>{{'Number of inputs' | translate}}: {{$ctrl.totalCount}}</p>\n    <cms-grid grid-options=\"$ctrl.options\"\n              datasource=\"$ctrl.datasource\"\n              initial-sort-model=\"$ctrl.initialSortModel\"\n              initial-filter-model=\"$ctrl.initialFilterModel\"\n              on-page-change=\"$ctrl._onPageChange($page)\"></cms-grid>\n</div>";

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = "<div ba-panel ba-panel-title=\"{{'Form data for' | translate }} <strong>{{$ctrl.page.title}}</strong>\" ba-panel-class=\"\">\n    <div ng-if=\"$ctrl.columns\">\n        <page-form-data-grid initial-params=\"$ctrl.initialParams\" on-params-change=\"$ctrl.onParamsChange(params)\" on-page-change=\"$ctrl.onPageChange($page)\" columns=\"$ctrl.columns\" total-count=\"$ctrl.total_count\"></page-form-data-grid>\n    </div>\n</div>";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _PageResource = __webpack_require__(130);

var _PageResource2 = _interopRequireDefault(_PageResource);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

var _FindFormService = __webpack_require__(437);

var _FindFormService2 = _interopRequireDefault(_FindFormService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageFormDataPage = _angular2.default.module('cms.page.form.data', [_PageResource2.default, _angularGettext2.default, _angularToastr2.default, _deleteElement2.default, _FindFormService2.default]).component('pageFormDataPage', {
    template: __webpack_require__(1019),
    controller: ['PageResource', '$state', '$stateParams', 'toastr', 'gettextCatalog', 'ACLService', 'deleteElementDialog', 'FindFormService', function controller(PageResource, $state, $stateParams, toastr, gettextCatalog, ACLService, deleteElementDialog, FindFormService) {
        var _this = this;

        if ($stateParams.id) {
            PageResource.findFormDataDetails({ id: $stateParams.id }, function (response) {
                _this.formData = response;
                _this.form = FindFormService.findForm(_this.formData.page.content);
                _this.formData.createdAt = new Date(_this.formData.createdAt).toLocaleString();
            });
        }

        this.matchRoles = ACLService.matchRoles;

        this.errors = {};
        this.pending = false;

        this.confirmDelete = function () {
            var removeMessage = gettextCatalog.getString("Are you sure that you want to delete this form data?");
            deleteElementDialog.open(removeMessage).then(function () {
                _this.delete();
            }).catch(function () {});
        };

        this.delete = function () {
            _this.pending = true;
            PageResource.deleteFormData({ id: _this.formData.id }, function () {
                toastr.success(gettextCatalog.getString('Form data deleted!'), gettextCatalog.getString('Success'));
                _this.goToList();
                _this.pending = false;
            });
        };

        this.cancel = function () {
            return _this.goToList();
        };

        this.goToList = function () {
            $state.go('pageFormDataList', { id: _this.formData.page.id });
        };

        this.isSimpleField = function (type) {
            return ['formText', 'formTextarea', 'formEmail', 'formNumber'].indexOf(type) > -1;
        };
    }]
});

exports.default = pageFormDataPage.name;

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = "<div class=\"landing-widgets\">\n\n    <div class=\"landing-main\">\n            <div ba-panel ba-panel-title=\"{{'Form data for' | translate }}: <strong>{{$ctrl.formData.page.title}}</strong>\"\n                 ba-panel-class=\"\">\n                <p><strong translate>Created at:</strong> {{$ctrl.formData.createdAt}}</p>\n                <hr>\n                <h3 translate>Submitted data:</h3>\n                <br/>\n                <div ng-repeat=\"data in $ctrl.form.config.content\">\n                    <p ng-if=\"$ctrl.isSimpleField(data.type)\">\n                        <strong>{{data.config.label || data.config.placeholder}}:</strong>\n                        {{ $ctrl.formData.data[data.config.key] }}\n                    </p>\n                    <p ng-if=\"data.type == 'formCheckbox'\">\n                        <strong>{{data.config.label || data.config.placeholder || \"Checked checkboxes\" |\n                            translate}}:</strong>\n                        <span ng-repeat=\"index in $ctrl.formData.data[data.config.key]\">{{data.config.options[index]}}<br/></span>\n                    </p>\n                    <p ng-if=\"data.type == 'formRadio'\">\n                        <strong>{{data.config.label || data.config.placeholder || \"Radio checked\" |\n                            translate}}:</strong>\n                        {{data.config.options[$ctrl.formData.data[data.config.key]]}}\n                    </p>\n                    <p ng-if=\"data.type == 'formSelect'\">\n                        <strong>{{data.config.label || data.config.placeholder || \"Selected option\" |\n                            translate}}:</strong>\n                        {{data.config.options[$ctrl.formData.data[data.config.key]]}}\n                    </p>\n                    <p ng-if=\"data.type == 'formDate'\">\n                        <strong>{{data.config.label || data.config.placeholder}}:</strong>\n                        {{ $ctrl.formData.data[data.config.key].date.substr(0, 10) }}\n                    </p>\n                    <p ng-if=\"data.type == 'formDateTime'\">\n                        <strong>{{data.config.label || data.config.placeholder}}:</strong>\n                        {{ $ctrl.formData.data[data.config.key].date.substr(0, 16) }}\n                    </p>\n                </div>\n            </div>\n    </div>\n\n    <div class=\"landing-right\">\n\n        <div hl-sticky=\"\" offset-top=\"90\" id=\"stickyScrolledContainer\" collection=\"settings\">\n            <div ba-panel class=\"side-form\">\n                <div class=\"side-form__buttons\">\n                    <button ng-click=\"$ctrl.confirmDelete()\" uib-tooltip=\"{{ 'Delete' | translate }}\"\n                            tooltip-placement=\"bottom\"\n                            class=\"btn btn-danger\">\n                        <em class=\"ion-trash-a\"></em>\n                    </button>\n                    <button ng-click=\"$ctrl.cancel()\" uib-tooltip=\"{{'Cancel' | translate}}\" tooltip-placement=\"bottom\"\n                            class=\"btn btn-default\">\n                        <em class=\"ion-android-arrow-back\"></em>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiBootstrap = __webpack_require__(233);

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

var _angularHttpAuth = __webpack_require__(281);

var _angularHttpAuth2 = _interopRequireDefault(_angularHttpAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service - auth dialog manager
 * @param $uibModal
 * @returns {{}}
 */
var AuthDialogService = function AuthDialogService($uibModal) {

    var service = {};

    service.open = function () {

        $uibModal.open({
            animation: true,
            template: __webpack_require__(1022),
            size: 'md',
            backdrop: 'static',
            controllerAs: 'vm',
            controller: ['$uibModalInstance', 'authService', 'CMSAuthService', function controller($uibModalInstance, authService, CMSAuthService) {

                var vm = {};

                vm.login = function () {
                    vm.loginError = false;
                    vm.loginPending = true;
                    CMSAuthService.reLogin(vm.password).then(function (data) {
                        if (data.success) {
                            // Angular-http-auth: rerun requests
                            authService.loginConfirmed('success', function (config) {
                                config.headers["Authorization"] = "JWT " + CMSAuthService.getToken();
                                return config;
                            });
                            $uibModalInstance.close();
                        } else {
                            vm.loginError = true;
                            vm.loginPending = false;
                        }
                    });
                };

                vm.logout = function () {
                    CMSAuthService.logout(function () {
                        window.location.href = "/login.html";
                    });
                };

                return vm;
            }]
        });
    };

    return service;
};

AuthDialogService.$inject = ['$uibModal'];
/**
 * Module responsible for re-login dialog
 * @namespace cms.auth.dialog
 */
exports.default = _angular2.default.module('cms.auth.dialog', [_angularUiBootstrap2.default, _CMSAuthService2.default, _angularHttpAuth2.default]).factory('AuthDialogService', AuthDialogService).name;

/***/ }),
/* 1021 */,
/* 1022 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" translate>Session expired</h4>\n    </div>\n    <div class=\"modal-body\">\n\n        <p translate>It seems that your session has been expired. To continue, please log in using your password.</p>\n\n        <div ng-show=\"vm.loginError\" class=\"alert bg-danger text-center\" translate>Invalid password</div>\n\n        <div class=\"form-group\">\n            <input type=\"password\" class=\"form-control\" ng-model=\"vm.password\" placeholder=\"{{'Password'|translate}}\">\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.logout()\" translate>Sign out</button>\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.login()\" ng-disabled=\"!vm.password\">\n            <span ng-show=\"!vm.loginPending\" translate>Sign in</span>\n            <span ng-show=\"vm.loginPending\"><em class=\"fa fa-circle-o-notch fa-spin\"></em></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _LoaderManager = __webpack_require__(282);

var _LoaderManager2 = _interopRequireDefault(_LoaderManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.loader.directive', [_LoaderManager2.default]).component('loader', {
    template: __webpack_require__(1024),
    controller: ['LoaderManager', function controller(LoaderManager) {
        this.active = function () {
            return LoaderManager.getActive('global');
        };
    }]
}).name;

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cms-spinner sample-show-hide animated\" ng-show=\"$ctrl.active()\" >\n    <em class=\"fa fa-circle-o-notch fa-spin\"></em>\n</div>";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.title.page', [_angularGettext2.default]).directive('cmsPageTitle', ['$transitions', 'gettextCatalog', function ($transitions, gettextCatalog) {
    /** @ngInclude() */
    return {
        link: function link(scope, element) {

            var TITLE = element.text;

            $transitions.onSuccess({}, function (transition) {
                var title = transition.to() ? transition.to().title : TITLE;
                element.text(gettextCatalog.getString(title));
            });
        }
    };
}]).name;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(72);

var _angularjs2 = _interopRequireDefault(_angularjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.page.class', [_angularjs2.default]).directive('cmsPageClass', ['$state', function ($state) {
    /** @ngInclude() */
    return {
        link: function link(scope) {

            scope.$stateClass = function () {
                return 'cms-state-' + ($state.current.name || 'undefined');
            };
        }
    };
}]).name;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cmsOnLoad', []).directive('cmsOnLoad', function () {
  /** @ngInclude() */
  return {
    restrict: "A",
    scope: {
      callback: "&cmsOnLoad"
    },
    link: function link(scope, element) {
      element.on("load", function (event) {
        scope.callback({ event: event });
        scope.$apply();
      });
    }
  };
}).name;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.export.service', [_ConfigModule2.default, _CMSAuthService2.default]).factory('ExportService', ['CONFIG', 'CMSAuthService', function (CONFIG, CMSAuthService) {

    this.getUrl = function (resourceName) {

        var url = CONFIG.API_URL + '/' + resourceName + '/export';
        url += '?_format=json&start=0&limit=0&format=csv&Authorization=';
        url += CMSAuthService.getToken();
        return url;
    };

    return this;
}]).name;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.mail.export.template', [_ConfigModule2.default, _CMSAuthService2.default]).factory('ExportMailTemplateService', ['CONFIG', 'CMSAuthService', function (CONFIG, CMSAuthService) {

  this.getUrl = function (id) {

    var url = CONFIG.API_URL + '/mails/' + id + '/html';
    url += '?_format=json&start=0&limit=0&format=csv&Authorization=';
    url += CMSAuthService.getToken();
    return url;
  };

  return this;
}]).name;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _CMSAuthService = __webpack_require__(36);

var _CMSAuthService2 = _interopRequireDefault(_CMSAuthService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.page.export.template', [_ConfigModule2.default, _CMSAuthService2.default]).factory('ExportPageTemplateService', ['CONFIG', 'CMSAuthService', function (CONFIG, CMSAuthService) {

  this.getUrl = function (slug) {

    var url = CONFIG.API_PUBLIC + '/page/preview/' + slug + '.html';
    url += '?_format=json&start=0&limit=0&format=csv&Authorization=';
    url += CMSAuthService.getToken();
    return url;
  };

  return this;
}]).name;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ACLService = __webpack_require__(117);

var _ACLService2 = _interopRequireDefault(_ACLService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.text
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.title      Input title and/or placeholder
 * @property {function} bindings.onBlur     Function called on input blur event
 * @property {function} bindings.onChange   Function called on input change event
 */
var cmsInputText = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        placeholder: '@',
        maxlength: '@'
    },
    template: __webpack_require__(1032)
};

/**
 * Text control
 * @namespace cms.input.text
 */
exports.default = _angular2.default.module('cms.input.text', [_ACLService2.default]).component('cmsInputText', cmsInputText).name;

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n        <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__text-label\"\n               uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n            <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n        </label>\n        <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} creator-toolbar__text-input\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ $ctrl.placeholder }}\"\n                   maxlength=\"{{ $ctrl.maxlength || 255}}\"\n                   ng-model=\"$ctrl.model\"\n                   ng-disabled=\"$ctrl.aclDisable\"\n                   ng-blur=\"$ctrl.onBlur({data: $ctrl.model})\"\n                   ng-change=\"$ctrl.onChange({data: $ctrl.model})\">\n            <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n                {{ error }}\n            </span>\n        </div>\n</div>";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.slug
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.label      Input label string
 * @property {string}   bindings.helper     Form helper object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.disabled   ACL config - disable input
 * @property {function} bindings.aclShow    ACL config - show input
 */
var cmsInputVideo = {
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        model: '=',
        disabled: '<',
        aclShow: '<?'
    },
    template: __webpack_require__(1034),
    controller: ['gettext', '$scope', function controller(gettext, $scope) {
        var _this = this;

        /** @ngInclude */

        this.$onInit = function () {
            _this.validate();
        };

        $scope.$on('creator-workspace-selection-changed', function () {
            _this.validate();
        });

        this.onBlur = function () {
            this.validate();
            this.parseLink();
        };

        this.onChange = function () {

            _this.validate();
            _this.parseLink();
        };

        this.parseLink = function () {
            if (_this.isValidYoutubeLink()) {
                _this.model.video.videoId = _this.parseYoutubeId(_this.model.video.url);
                _this.model.video.videoType = 'youtube';
                _this.model.video.data = 'https://www.youtube.com/embed/' + _this.model.video.videoId;
            } else if (_this.isValidVimeoLink()) {
                _this.model.video.videoId = _this.parseVimeoId(_this.model.video.url);
                _this.model.video.videoType = 'vimeo';
                _this.model.video.data = 'https://player.vimeo.com/video/' + _this.model.video.videoId;
            }
        };

        this.parseYoutubeId = function (youtubeLink) {
            if (youtubeLink.indexOf('v=') !== -1) {
                var _linkChunks = youtubeLink.split('v=');
                return _linkChunks[1];
            }

            var linkChunks = youtubeLink.split('/');
            return linkChunks[linkChunks.length - 1];
        };

        this.parseVimeoId = function (vimeoLink) {

            var linkChunks = vimeoLink.split('/');

            return linkChunks[linkChunks.length - 1];
        };

        this.validate = function () {
            _this.errors = [];
            if (_this.isValidVimeoLink() || _this.isValidYoutubeLink()) {
                _this.errors = [];
            } else {
                _this.errors = [gettext('Incorrect url address youtube/vimeo!')];
            }
        };

        this.isValidYoutubeLink = function () {
            var youtubeRegexp = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

            return youtubeRegexp.test(_this.model.video.url);
        };

        this.isValidVimeoLink = function () {
            var vimeoRegexp = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/;

            return vimeoRegexp.test(_this.model.video.url);
        };
    }]
};

/**
 * Video control
 * @namespace cms.input.video
 */
exports.default = _angular2.default.module('cms.input.video', []).component('cmsInputVideo', cmsInputVideo).name;

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors.length}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-2 control-label creator-toolbar__slug-control-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-10 creator-toolbar__slug-control-input\">\n        <div class=\"input-group\">\n\n            <input type=\"text\" class=\"form-control with-default-addon\"\n                   ng-disabled=\"$ctrl.aclDisable\"\n                   ng-blur=\"$ctrl.onBlur()\"\n                   ng-change=\"$ctrl.onChange()\"\n                   placeholder=\"{{ $ctrl.label }}\"\n                   ng-model=\"$ctrl.model.video.url\">\n        </div>\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error | translate }}\n        </span>\n    </div>\n</div>";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.select
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {array}       bindings.options    Select options
 * @property {boolean}     bindings.multiple   Multi or single select
 *
 * @todo More flexible data operations in ui-select-choices
 */
var cmsFontSelect = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        options: '<',
        multiple: '<',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@'
    },
    template: __webpack_require__(1036),
    controller: function controller() {
        var _this = this;

        this.$onInit = function () {
            _this.options = ["Abril FatFace", "Archivo", "Arvo", "Cardo", "Cormorant", "Fira Sans", "Fjalla One", "Frank Ruhl Libre", "Karla", "Lato", "Lora", "Merriweather", "Montserrat", "Noto Sans", "Nunito", "Old Standard TT", "Open Sans", "Oswald", "Oxygen", "PT Sans", "PT Serif", "Playfair Display", "Poppins", "Rakkas", "Roboto", "Rubik", "Source Sans", "Source Sans Pro", "Spectral", "Ubuntu", "Work Sans", "Yatra One"];
        };
    }
};

/**
 * Select control using ui-select
 * @namespace cms.input.select
 * @see https://angular-ui.github.io/ui-select
 */
exports.default = _angular2.default.module('cms.input.font.select', []).component('cmsInputFontSelect', cmsFontSelect).name;

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label  class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__font-select-label\"\n            uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} btn-group creator-toolbar__font-select-input\" >\n        <ui-select ng-model=\"$ctrl.model\"\n                   ng-disabled=\"$ctrl.aclDisable\"\n                   theme=\"bootstrap\">\n            <ui-select-match placeholder=\"{{ $ctrl.title }}\">\n                {{$select.selected}}\n            </ui-select-match>\n            <ui-select-choices repeat=\"item as item in $ctrl.options | filter: $select.search\">\n                <span style=\"font-family: {{ item }};\">{{item}}</span>\n            </ui-select-choices>\n        </ui-select>\n\n        <span class=\"help-block error-block basic-block\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n    </div>\n</div>\n";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.textarea
 * @property {object}   bindings.errors         Form errors object
 * @property {string}   bindings.title          Input title and/or placeholder
 * @property {string}   bindings.model          Input value reference
 * @property {function} bindings.slugValidation Function that returns promise if slug is valid
 * @property {string}   bindings.slugSource     Input value reference
 */
var cmsInputTextarea = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        rows: '@'
    },
    template: __webpack_require__(1038)
};

/**
 * Textarea control
 * @namespace cms.input.textarea
 */
exports.default = _angular2.default.module('cms.input.textarea', []).component('cmsInputTextarea', cmsInputTextarea).name;

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__textarea-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} creator-toolbar__textarea-input\">\n        <textarea\n                class=\"form-control\"\n                style=\"resize: vertical;\"\n                placeholder=\"{{ $ctrl.placeholder }}\"\n                ng-model=\"$ctrl.model\"\n                ng-blur=\"$ctrl.onBlur({data: $ctrl.model})\"\n                ng-change=\"$ctrl.onChange({data: $ctrl.model})\"\n                ng-disabled=\"$ctrl.aclDisable\"\n                rows=\"{{$ctrl.rows || 10}}\">\n        </textarea>\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n    </div>\n</div>";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularSlugify = __webpack_require__(438);

var _angularSlugify2 = _interopRequireDefault(_angularSlugify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.slug
 * @property {object}   bindings.errors         Form errors object
 * @property {string}   bindings.title          Input title and/or placeholder
 * @property {string}   bindings.model          Input value reference
 * @property {function} bindings.slugValidation Function that returns promise if slug is valid
 * @property {string}   bindings.slugSource     Input value reference
 */
var cmsInputSlug = {
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        model: '=',
        slugValidation: '&',
        slugSource: '<',
        disabled: '<',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        maxlength: '@'
    },
    template: __webpack_require__(1040),
    controller: ['$scope', 'Slug', function controller($scope, Slug) {
        var _this = this;

        /** @ngInclude */
        this.$onInit = function () {

            _this.refreshPending = false;

            /**
             * Refresh request from outside control
             */
            $scope.$on('slug.recalc', function () {
                _this.refreshSlug();
            });

            /**
             * Refresh action accessible from 'refresh' arrows
             */
            _this.refreshSlug = function () {
                if (this.aclDisable) {
                    return;
                }
                this.model = this.slugSource;
                this.onBlur();
            };

            /**
             * Remember previous input value
             * to prevent re-validating same values
             */
            _this.copyTmpModel = function () {
                this.previousModel = _angular2.default.copy(this.model);
            };

            _this.modelChanged = function () {
                return this.previousModel !== this.model;
            };

            _this.onBlur = function () {
                var _this2 = this;

                if (this.modelChanged()) {
                    this.model = Slug.slugify(this.model);
                    if (this.slugValidation) {
                        this.refreshPending = true;
                        this.slugValidation({ data: this.model }).then(function () {
                            _this2.refreshPending = false;
                        });
                    }
                }
                this.copyTmpModel();
            };
        };
    }]
};

/**
 * Slug control
 * @namespace cms.input.slug
 */
exports.default = _angular2.default.module('cms.input.slug', ['slugifier']).component('cmsInputSlug', cmsInputSlug).name;

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors.length}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__slug-control-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} creator-toolbar__slug-control-input\">\n        <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control with-default-addon\"\n                   maxlength=\"{{$ctrl.maxlength || 255 }}\"\n                   ng-disabled=\"$ctrl.aclDisable\"\n                   ng-blur=\"$ctrl.onBlur()\"\n                   placeholder=\"{{ $ctrl.title }}\"\n                   ng-model=\"$ctrl.model\">\n            <span class=\"input-group-btn\">\n                <button type=\"button\"\n                        class=\"btn btn-default\"\n                        ng-click=\"$ctrl.refreshSlug()\"\n                        ng-disabled=\"$ctrl.aclDisable\"\n                        title=\"{{ 'Rebuild and validate slug' | translate }}\">\n                    <em ng-class=\"{'fa-spin': $ctrl.refreshPending }\"\n                       class=\"fa fa-refresh\">\n                    </em>\n                </button>\n            </span>\n        </div>\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n    </div>\n</div>";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.money
 * @property {object}   bindings.errors         Form errors object
 * @property {string}   bindings.model          Input value reference
 * @property {string}   bindings.title          Input title and/or placeholder
 * @property {string}   bindings.currency       Currency label (if empty, label not added)
 * @property {function} bindings.slugValidation Function that returns promise if slug is valid
 * @property {string}   bindings.slugSource     Input value reference
 */
var cmsInputMoney = {
  bindings: {
    errors: '=',
    model: '=',
    label: '@',
    helper: '@',
    currency: '@',
    onBlur: '&',
    onChange: '&',
    aclShow: '<?',
    aclDisable: '<?'
  },
  template: __webpack_require__(1042)
};

/**
 * Money control
 * @namespace cms.input.money
 */
exports.default = _angular2.default.module('cms.input.money', []).component('cmsInputMoney', cmsInputMoney).name;

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-2 control-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-10\">\n\n        <div ng-class=\"{'input-group with-default-addon': $ctrl.currency}\">\n            <input type=\"number\" step=\"0.01\" min=\"0\"\n                   class=\"form-control\"\n                   placeholder=\"{{ $ctrl.title }}\"\n                   ng-model=\"$ctrl.model\"\n                   ng-blur=\"$ctrl.onBlur({data: $ctrl.model})\"\n                   ng-change=\"$ctrl.onChange({data: $ctrl.model})\"\n                   ng-disabled=\"$ctrl.aclDisable\">\n            <span ng-show=\"$ctrl.currency\" class=\"input-group-addon addon-right input-group-addon-default\">\n                <small>{{$ctrl.currency}}</small>\n            </span>\n        </div>\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n\n    </div>\n</div>";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(1044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.number
 * @property {object}   bindings.errors         Form errors object
 * @property {string}   bindings.model          Input value reference
 * @property {string}   bindings.title          Input title and/or placeholder
 * @property {string}   bindings.unit           Unit label (if empty, label not added)
 */
var cmsInputNumber = {
    bindings: {
        errors: '=',
        model: '=',
        label: '@',
        units: '=',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        step: '@',
        labelClass: '@'
    },
    template: __webpack_require__(1045)
};

/**
 * Number control
 * @namespace cms.input.number
 */
exports.default = _angular2.default.module('cms.input.number', []).component('cmsInputNumber', cmsInputNumber).name;

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__number-label {{ $ctrl.labelClass }}\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} creator-toolbar__number-input\">\n\n        <div ng-class=\"{'input-group with-default-addon': $ctrl.units, 'number-addon-with-select' : $ctrl.units.length > 1}\">\n            <input type=\"number\" step=\"{{ $ctrl.step || 1}}\" min=\"0\"\n                   class=\"form-control \"\n                   placeholder=\"{{ $ctrl.title }}\"\n                   ng-model=\"$ctrl.model.value\"\n                   ng-blur=\"$ctrl.onBlur({data: $ctrl.model})\"\n                   ng-change=\"$ctrl.onChange({data: $ctrl.model})\"\n                   ng-disabled=\"$ctrl.aclDisable\">\n            <span ng-if=\"$ctrl.units.length == 1 && $ctrl.model.unit\" class=\"input-group-addon addon-right input-group-addon-default\">\n                <small>{{$ctrl.model.unit}}</small>\n            </span>\n            <div ng-if=\"$ctrl.units.length > 1\" class=\"input-group-addon addon-right input-group-addon--caret\">\n                <select ng-model=\"$ctrl.model.unit\" class=\"form-control input-sm form-control--no-button\">\n                    <option ng-repeat=\"unit in $ctrl.units\" value=\"{{ unit }}\">{{ unit }}</option>\n                </select>\n            </div>\n        </div>\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n\n    </div>\n</div>";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.checkbox
 * @property {string}  scope.title Input title and/or placeholder
 * @property {boolean} scope.model Input value reference
 */
var cmsInputCheckbox = {
    bindings: {
        model: '=',
        label: '@',
        helper: '@',
        aclShow: '<?',
        aclDisable: '<?',
        disabled: '<',
        changed: '&',
        labelSize: '@',
        inputSize: '@',
        position: '@',
        validator: '<'
    },
    template: __webpack_require__(1047),
    controller: ['$scope', function controller($scope) {
        var _this = this;

        this.$onInit = function () {
            $scope.validatorErrors = _this.validator;
        };

        this.$onChanges = function () {
            $scope.validatorErrors = _this.validator;
        };
    }]
};

/**
 * Checkbox control
 * @namespace cms.input.checkbox
 */
exports.default = _angular2.default.module('cms.input.checkbox', []).component('cmsInputCheckbox', cmsInputCheckbox).name;

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\" ng-class=\"{'has-error':$ctrl.errors || validatorErrors }\" ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n\n    <div class=\"checkbox toolbar-checkbox\">\n        <div class=\"col-sm-{{ $ctrl.inputSize || 2 }}\">\n            <input type=\"checkbox\" ng-model=\"$ctrl.model\"\n                   ng-disabled=\"$ctrl.disabled || $ctrl.aclDisable\"\n                   ng-click=\"$ctrl.changed()\"\n                   class=\"toolbar-checkbox__right\">\n            <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n                {{ error }}\n            </span>\n        </div>\n        <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__checkbox-label\"\n               uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\"\n                ng-if=\"$ctrl.position == 'right' || !$ctrl.position\">{{ $ctrl.label }}\n            <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n            <span class=\"help-block error-block basic-block\" ng-if=\"$ctrl.validator\">\n                {{ validatorErrors|translate }}\n            </span>\n        </label>\n        <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label\"\n               uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\"\n               ng-if=\"$ctrl.position == 'left'\">{{ $ctrl.label }}\n            <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n        </label>\n\n    </div>\n</div>";

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.select
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {array}       bindings.options    Select options
 * @property {boolean}     bindings.multiple   Multi or single select
 *
 * @todo More flexible data operations in ui-select-choices
 */
var cmsInputSelect = {
  bindings: {
    errors: '<',
    model: '=',
    label: '@',
    helper: '@',
    options: '<',
    multiple: '<',
    aclShow: '<?',
    aclDisable: '<?',
    labelSize: '@',
    inputSize: '@'
  },
  template: __webpack_require__(1049)
};

/**
 * Select control using ui-select
 * @namespace cms.input.select
 * @see https://angular-ui.github.io/ui-select
 */
exports.default = _angular2.default.module('cms.input.select', []).component('cmsInputSelect', cmsInputSelect).name;

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label  class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__select-label\"\n            uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} btn-group creator-toolbar__select-input\" >\n        <ui-select ng-if=\"!$ctrl.multiple\"\n                   ng-model=\"$ctrl.model\"\n                   search-enabled=\"true\"\n                   ng-disabled=\"$ctrl.aclDisable\"\n                   class=\"\">\n            <ui-select-match placeholder=\"{{ $ctrl.title }}\">\n                {{ $select.selected }}\n            </ui-select-match>\n            <ui-select-choices repeat=\"item in $ctrl.options | filter: $select.search\">\n                {{ item }}\n            </ui-select-choices>\n        </ui-select>\n\n        <ui-select ng-if=\"$ctrl.multiple\"\n                   ng-model=\"$ctrl.model\"\n                   search-enabled=\"true\"\n                   ng-disabled=\"$ctrl.aclDisable\"\n                   multiple\n                   class=\"\">\n            <ui-select-match placeholder=\"{{ $ctrl.title }}\">\n                {{$item.name}}\n            </ui-select-match>\n            <ui-select-choices repeat=\"item as item in $ctrl.options | filter: $select.search\">\n                {{item.name}}\n            </ui-select-choices>\n        </ui-select>\n\n\n        <span class=\"help-block error-block basic-block\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n\n    </div>\n\n</div>\n";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.object.select
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.label      Input label and placeholder
 * @property {string}      bindings.helper     Helper message for input
 * @property {array}       bindings.options    Objects array  [{value:'val', label: 'Val}]
 * @property {string}      bindings.labelSize  Label column size (1-12)
 * @property {string}      bindings.inputSize  Input column size (1-12)
 * @property {string}      bindings.aclShow    ACL config - show input
 * @property {string}      bindings.aclDisable ACL config - disable input
 *
 * @todo More flexible data operations in ui-select-choices
 */
var cmsInputObjectSelect = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        options: '<',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        validator: '<'

    },
    template: __webpack_require__(1051),
    controller: ['$scope', function controller($scope) {
        var _this = this;

        this.$onInit = function () {
            $scope.validatorErrors = _this.validator;
            if (_angular2.default.isFunction(_this.options)) {
                _this.options = _this.options();
            }
        };

        this.$onChanges = function () {
            $scope.validatorErrors = _this.validator;
        };
    }]
};

/**
 * Select control using ui-select
 * @namespace cms.input.select
 * @see https://angular-ui.github.io/ui-select
 */
exports.default = _angular2.default.module('cms.input.object.select', []).component('cmsInputObjectSelect', cmsInputObjectSelect).name;

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors || validatorErrors }\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__select-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} btn-group creator-toolbar__select-input\">\n        <ui-select\n                ng-model=\"$ctrl.model\"\n                search-enabled=\"true\"\n                ng-disabled=\"$ctrl.aclDisable\">\n            <ui-select-match placeholder=\"{{ $ctrl.label }}\">\n                {{ $select.selected.label | translate }}\n            </ui-select-match>\n            <ui-select-choices repeat=\"item.value as item in ($ctrl.options | filter: $select.search)\" null-option=\"anyValue\">\n                {{ item.label | translate }}\n            </ui-select-choices>\n        </ui-select>\n        <span class=\"help-block error-block basic-block\" ng-if=\"$ctrl.validator\">\n            {{ validatorErrors | translate }}\n        </span>\n\n        <span class=\"help-block error-block basic-block\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n\n\n    </div>\n\n</div>\n";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.align
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {string}      bindings.labelSize  Label column size (1-12)
 * @property {string}      bindings.inputSize  Input column size (1-12)
 * @property {string}      bindings.aclShow    ACL config - show input
 * @property {string}      bindings.aclDisable ACL config - disable input
 *
 */
var cmsInputAlign = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: __webpack_require__(1053)
};

exports.default = _angular2.default.module('cms.input.align', []).component('cmsInputAlign', cmsInputAlign).name;

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} creator-toolbar__align-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} btn-group\">\n\n        <div class=\"btn-group\">\n            <button type=\"button\"\n                    ng-click=\"$ctrl.model = 'left'\"\n                    class=\"btn btn-icon btn-{{$ctrl.model === 'left' ? 'info' : 'default'}}\">\n                <em class=\"fa fa-align-left\"></em>\n            </button>\n            <button type=\"button\"\n                    ng-click=\"$ctrl.model = 'center'\"\n                    class=\"btn btn-icon btn-{{$ctrl.model === 'center' ? 'info' : 'default'}}\">\n                <em class=\"fa fa-align-center\"></em>\n            </button>\n            <button type=\"button\"\n                    ng-click=\"$ctrl.model = 'right'\"\n                    class=\"btn btn-icon btn-{{$ctrl.model === 'right' ? 'info' : 'default'}}\">\n                <em class=\"fa fa-align-right\"></em>\n            </button>\n        </div>\n\n        <span class=\"help-block error-block basic-block\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n\n    </div>\n\n</div>\n";

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.selection-buttons
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {object|text} bindings.options    Options to select
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {string}      bindings.labelSize  Label column size (1-12)
 * @property {string}      bindings.inputSize  Input column size (1-12)
 * @property {string}      bindings.aclShow    ACL config - show input
 * @property {string}      bindings.aclDisable ACL config - disable input
 *
 */
var cmsInputSelectionButtons = {
    bindings: {
        errors: '<',
        model: '=',
        options: '<',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: __webpack_require__(1055)
};

exports.default = _angular2.default.module('cms.input.selection-buttons', []).component('cmsInputSelectionButtons', cmsInputSelectionButtons).name;

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__selection-buttons-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} btn-group\">\n\n        <div class=\"btn-group\">\n            <button class=\"btn btn-icon btn-{{$ctrl.model ===  option.value ? 'info' : 'default'}}\"\n                    ng-repeat=\"option in $ctrl.options\"\n                    ng-click=\"$ctrl.model = option.value\"\n            >\n               <span ng-bind-html=\"option.template | trust \" ng-if=\"option.template !== undefined\"></span>\n               <span ng-if=\"option.template === undefined\">{{ option.value}}</span>\n            </button>\n        </div>\n        <span class=\"help-block error-block basic-block\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n\n    </div>\n\n</div>\n";

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _jstimezonedetect = __webpack_require__(1057);

var _jstimezonedetect2 = _interopRequireDefault(_jstimezonedetect);

var _angularUiBootstrap = __webpack_require__(233);

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

var _angularUiMask = __webpack_require__(1060);

var _angularUiMask2 = _interopRequireDefault(_angularUiMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cmsInputDate = function cmsInputDate($filter) {
    return {
        template: __webpack_require__(1062),

        /**
         * @memberOf cms.input.date
         * @property {object}   scope.errors         Form errors object
         * @property {string}   scope.title          Input title and/or placeholder
         * @property {string}   scope.model          Input value reference
         * @property {function} scope.slugValidation Function that returns promise if slug is valid
         * @property {string}   scope.slugSource     Input value reference
         */
        scope: {
            errors: '=',
            model: '=',
            helper: '@',
            timePickerEnabled: '<',
            label: '@',
            aclShow: '<?',
            aclDisable: '<?'
        },

        link: function link(scope) {

            /**
             * Pobiera ciąg hhmm z daty
             * @param date
             * @returns {*}
             */
            var getTimeString = function getTimeString(date) {
                if (!date) {
                    return null;
                }
                return $filter('date')(date, "HHmm");
            };

            scope.$watch('model', function () {
                if (scope.model) {
                    scope.time = getTimeString(new Date(scope.model));
                    scope.date = new Date(scope.model);
                }
            });

            scope.dateChanged = function () {

                if (!scope.date) {
                    scope.time = null;
                    scope.model = null;
                    return;
                }

                if (!scope.time) {
                    scope.time = getTimeString(scope.date);
                }

                if (scope.date) {
                    scope.date.setHours(scope.time.substr(0, 2));
                    scope.date.setMinutes(scope.time.substr(2, 2));
                    scope.model = scope.date.toISOString();
                }
            };

            scope.timeChanged = function () {

                if (!scope.time) {
                    scope.date = null;
                    scope.model = null;
                    return;
                }

                if (!scope.date) {
                    scope.date = new Date();
                }

                scope.date.setHours(scope.time.substr(0, 2));
                scope.date.setMinutes(scope.time.substr(2, 2));
                scope.model = scope.date.toISOString();
            };

            /**
             * Make 23 from 24-29:xx hour
             */
            scope.validateTime = function () {
                if (scope.time) {
                    if (scope.time.substr(0, 2) >= 23) {
                        scope.time = scope.time.replace(/^.{2}/g, '23');
                    }
                }
            };

            scope.userTz = _jstimezonedetect2.default.determine().name();
        }
    };
};

cmsInputDate.$inject = ['$filter'];
/**
 * Datepicker control
 * @namespace cms.input.date
 */
exports.default = _angular2.default.module('cms.input.date', [_angularUiMask2.default, _angularUiBootstrap2.default]).config(['uiMask.ConfigProvider', function (uiMaskConfigProvider) {
    uiMaskConfigProvider.maskDefinitions({
        '9': /\d/,
        '5': /[012345]/,
        '2': /[012]/
    });
    uiMaskConfigProvider.allowInvalidValue(true);
}]).directive('cmsInputDate', cmsInputDate).name;

/***/ }),
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':errors}\"\n     ng-show=\"aclShow === true || aclShow === undefined\">\n\n    <label class=\"col-sm-2 control-label\" uib-tooltip=\"{{$ctrl.helper}}\" tooltip-placement=\"right\">{{ $ctrl.label }}\n        {{ label }}\n        <em class=\"fa fa-info-circle\"\n           uib-tooltip=\"{{'Timezone:'|translate}} {{userTz}}\"\n           tooltip-append-to-body=\"true\">\n        </em>\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n\n    <div class=\"col-sm-10\">\n        <div class=\"row\">\n            <div class=\"col-lg-4 col-sm-6\">\n\n                <div class=\"input-group datepicker\">\n                    <input type=\"text\"\n                           class=\"form-control\"\n                           placeholder=\"{{'DD/MM/YYYY'}}\"\n                           ng-model=\"date\"\n                           ng-change=\"dateChanged()\"\n                           ng-required\n                           ng-disabled=\"aclDisable\"\n                           uib-datepicker-popup=\"dd/MM/yyyy\"\n\n                           is-open=\"opened\"/>\n                    <span class=\"input-group-btn\">\n                    <button type=\"button\"\n                            class=\"btn btn-default\"\n                            ng-disabled=\"aclDisable\"\n                            ng-click=\"opened = !opened\">\n                        <em class=\"fa fa-calendar\"></em>\n                    </button>\n                </span>\n                </div>\n            </div>\n            <div class=\"col-lg-3 col-sm-4\">\n                <input\n                        type=\"text\"\n                        class=\"form-control\"\n                        placeholder=\"HH:MM\"\n                        ng-show=\"timePickerEnabled\"\n                        ng-model=\"time\"\n                        ng-blur=\"timeChanged()\"\n                        ng-change=\"validateTime()\"\n                        ng-maxlength=\"5\"\n                        ng-required\n                        ng-disabled=\"aclDisable\"\n                        ui-mask=\"29:59\"/>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-sm-12\">\n                <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in errors\">\n                    {{ error }}\n                </span>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _modal = __webpack_require__(125);

var _modal2 = _interopRequireDefault(_modal);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _MediaResource = __webpack_require__(95);

var _MediaResource2 = _interopRequireDefault(_MediaResource);

var _MediaPickerModal = __webpack_require__(147);

var _MediaPickerModal2 = _interopRequireDefault(_MediaPickerModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.media
 * @property {object}   bindings.errors       Form errors object
 * @property {string}   bindings.label        Input label and/or placeholder
 * @property {string}   bindings.helper       Helper message for input
 * @property {string}   bindings.buttonTitle  Button label, default "Choose file"
 * @property {array}    bindings.model        Model array reference
 * @property {object}   bindings.extraFields  Function that returns promise if slug is valid
 * @property {boolean}  bindings.multiple     Allow to select multiple media
 * @property {string}   bindings.aclShow      ACL config - show input
 * @property {string}   bindings.aclDisable   ACL config - disable input
 * @property {string}   bindings.labelSize    Label column size (1-12)
 * @property {string}   bindings.inputSize    Input column size (1-12)
 */
var cmsInputMedia = {
    template: __webpack_require__(1064),
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        buttonTitle: '@',
        model: '=',
        extraFields: '<',
        multiple: '<',
        aclShow: '<?',
        aclDisable: '<?'
    },

    controller: ['$scope', '$uibModal', 'MediaPickerModal', 'CONFIG', function controller($scope, $uibModal, MediaPickerModal, CONFIG) {
        var _this = this;

        this.$onInit = function () {
            _this.selectedMedia = [];
            if (!_this.model) {
                _this.model = [];
            }
        };

        this.getMediaUrl = function (key) {
            return CONFIG.API_PUBLIC + '/image/250x180/' + key;
        };

        /**
         * Used from in the modal to remember current selection
         *
         * @private
         * @param {MediaResource} media
         * @param {boolean} selected
         */
        this.onMediaSelected = function (media, selected) {

            if (_this.multiple) {
                if (selected) {
                    _this.selectedMedia.push(media);
                } else {
                    _this.selectedMedia = _this.selectedMedia.filter(function (mediaUsage) {
                        return mediaUsage.id !== media.id;
                    });
                }
            } else {
                _this.selectedMedia = selected ? [media] : [];
            }
        };

        this.onMediaRemove = function (mediaElement) {
            _this.model = _this.model.filter(function (usedMedia) {
                return usedMedia.media.id !== mediaElement.media.id;
            });
            $scope.$emit('content-changed');
        };

        this.openMediaPickerModal = function () {
            var scroll = $(document).scrollTop();
            MediaPickerModal.open(_this.multiple).result.then(function (selectedMedia) {
                selectedMedia.forEach(function (el) {
                    var exists = _this.model.filter(function (existing) {
                        return existing.media.id === el.id;
                    }).length >= 1;

                    if (!exists) {
                        if (_this.multiple) {
                            _this.model.push({
                                media: _angular2.default.copy(el)
                            });
                        } else {
                            _this.model = [{ media: _angular2.default.copy(el) }];
                        }
                    }
                }, _this);

                $scope.$emit('content-changed');
                $(document).scrollTop(scroll);
            }).catch(function () {
                $(document).scrollTop(scroll);
            });
        };
    }]
};

/**
 * Media control
 * @namespace cms.input.media
 */
exports.default = _angular2.default.module('cms.input.media', [_modal2.default, _angularGettext2.default, _ConfigModule2.default, _MediaPickerModal2.default, _MediaResource2.default]).component('cmsInputMedia', cmsInputMedia).name;

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n\n    <div class=\"media-control__label col-xs-12\">\n        <label class=\"control-label creator-toolbar__select-label\"\n               uib-tooltip=\"{{$ctrl.helper | translate}}\"\n               tooltip-placement=\"bottom\">\n            {{ $ctrl.label }}\n            <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n        </label>\n        <button type=\"button\" class=\"btn btn-success\"\n                data-toggle=\"modal\"\n                ng-disabled=\"$ctrl.aclDisable\"\n                ng-click=\"$ctrl.openMediaPickerModal()\">\n            {{ ('Pick the media' | translate:'Media picker CTA') }}\n        </button>\n    </div>\n\n    <div class=\"media-control__tiles col-xs-12\">\n        <div class=\"media-control__tile animated\" ng-repeat=\"mediaUsage in $ctrl.model\">\n            <div class=\"media-control__tile-presentation panel\">\n                <div class=\"media-control__tile-preview\"\n                     style=\"background-image: url('{{ $ctrl.getMediaUrl(mediaUsage.media.key) }}')\">\n                    <em ng-if=\"mediaUsage.media.type !== 'image'\" class=\"media-control__tile-icon ion-document-text\"></em>\n                    <a href=\"\" class=\"media-control__tile-action btn-remove disable-click-outside\" type=\"button\"\n                           ng-if=\"!$ctrl.aclDisable\"\n                           ng-click=\"$ctrl.onMediaRemove(mediaUsage)\">\n                            <em class=\"ion-trash-a\"></em>\n                    </a>\n                </div>\n            </div>\n\n            <div class=\"media-control__tile-data\">\n                <p class=\"media-control__tile-data-name\">{{mediaUsage.media.clientOriginalName}}</p>\n                <p class=\"media-control__tile-data-desc\">{{'Size' | translate:'File size label'}}: {{mediaUsage.media.size | fileSize}}</p>\n                <input type=\"text\"\n                       class=\"form-control input-sm\"\n                       ng-if=\"$ctrl.extraFields.alt\"\n                       ng-disabled=\"$ctrl.aclDisable\"\n                       placeholder=\"{{ 'Media alt' | translate: 'Media tile input' }}\" ng-model=\"mediaUsage.alt\">\n            </div>\n        </div>\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n    </div>\n\n</div>";

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ACLService = __webpack_require__(117);

var _ACLService2 = _interopRequireDefault(_ACLService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.color
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.title      Input title and/or placeholder
 * @property {function} bindings.onBlur     Function called on input blur event
 * @property {function} bindings.onChange   Function called on input change event
 */
var cmsInputColor = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@'
    },
    template: __webpack_require__(1066),

    controller: function controller() {
        var _this = this;

        this.colors = ['#ef5350', '#ec407a', '#ab47bc', '#7e57c2', '#5c6bc0', '#42a5f5', '#29b6f6', '#26c6da', '#26a69a', '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#d32f2f', '#d81b60', '#8e24aa', '#5e35b1', '#3949ab', '#1e88e5', '#039be5', '#00acc1', '#00897b', '#64ffda', '#66bb6a', '#d4e157', '#f3d390', '#ffca28', '#ffa726', '#ff7043', '#c2185b', '#7b1fa2', '#1de9b6', '#4caf50', '#cddc39', '#f2ce82', '#ffc107', '#ff9800', '#ff5722', '#ad1457', '#603775', '#13c2a5', '#43a047', '#c0ca33', '#efc468', '#fdb722', '#fb8c00', '#f4511e', '#880e4f', '#4e2b61', '#512da8', '#303f9f', '#1976d2', '#ffffff', '#e0e0e0', '#78909c', '#455a64', '#192a3a', '#8d6e63', '#4527a0', '#283593', '#1565c0', '#f5f5f5', '#bdbdbd', '#607d8b', '#37474f', '#101e2a', '#795548', '#311b92', '#1a237e', '#0d47a1', '#eeeeee', '#757575', '#546e7a', '#212121', '#000000', 'transparent'];

        this.isShowPalette = false;

        this.togglePalette = function () {
            if (_this.isShowPalette === false) {
                _this.isShowPalette = true;
            } else {
                _this.isShowPalette = false;
            }
        };
    }
};

/**
 * Color control
 * @namespace cms.input.color
 */
exports.default = _angular2.default.module('cms.input.color', [_ACLService2.default]).component('cmsInputColor', cmsInputColor).name;

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n        <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__select-label\"\n               uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n            <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n        </label>\n        <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} creator-toolbar__color-input\">\n\n            <div class=\"input-group with-default-addon\">\n                <input type=\"text\"\n                   class=\"form-control\"\n                   placeholder=\"{{ $ctrl.title }}\"\n                   ng-model=\"$ctrl.model\"\n                   ng-disabled=\"$ctrl.aclDisable\">\n                <span class=\"input-group-addon addon-right input-group-addon-default addon-cursor\" ng-click=\"$ctrl.togglePalette()\">\n\n                    <div class=\"color-control-palette\">\n                        <div\n                            class=\"color-control-item color-control-item-active\"\n                            ng-disabled=\"$ctrl.aclDisable\"\n                            style=\"background-color: {{$ctrl.model}}\"\n                        >\n                        </div>\n                    </div>\n                </span>\n            </div>\n            <div ng-class=\"{'animate': $ctrl.isShowPalette}\" class=\"animate-init\">\n                <div class=\"palette color-control-palette\">\n                    <div class=\"color-control-item\"\n                        ng-class=\"{\n                            'color-control-item-selected': color === $ctrl.model ,\n                            'color-control-item-transparent': color === 'transparent'\n                         }\"\n                        ng-click=\"$ctrl.model = color; $ctrl.isShowPalette = false\"\n                        style=\"background-color: {{color}};\"\n                        ng-repeat=\"color in $ctrl.colors\">\n                    </div>\n                </div>\n            </div>\n\n            <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n                {{ error }}\n            </span>\n        </div>\n</div>\n";

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _EditorTextarea = __webpack_require__(439);

var _EditorTextarea2 = _interopRequireDefault(_EditorTextarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.htmlEditor
 * @property {object}   bindings.errors   Form errors object
 * @property {array}    bindings.model    Text model reference
 * @property {string}   bindings.title    Input label and/or placeholder
 */
var cmsInputHtmlEditor = {
    bindings: {
        errors: '=',
        model: '=',
        label: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: __webpack_require__(1070),
    controller: function controller() {
        var _this = this;

        this.contentLoaded = function () {
            return typeof _this.model !== 'undefined';
        };
    }
};

/**
 * Html editor control. Includes editor implementation abstraction layer.
 * @namespace cms.input.htmlEditor
 */
exports.default = _angular2.default.module('cms.input.htmlEditor', [_EditorTextarea2.default]).component('cmsInputHtmlEditor', cmsInputHtmlEditor).name;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _CKEditorOptions = __webpack_require__(440);

var _CKEditorOptions2 = _interopRequireDefault(_CKEditorOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Standard textarea CKEditor bridge
 */
exports.default = _angular2.default.module('cms.ckeditor.textarea.directive', [_CKEditorOptions2.default]).directive('ckeditorTextarea', ["CKEditorConfig", "$rootScope", function (CKEditorConfig, $rootScope) {

    var PREFIX = '__ckd_textarea_';
    var counter = 0;

    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            contentLoaded: '<'
        },
        link: function link(scope, element, attrs, ngModel) {

            var editor;
            var options = _angular2.default.copy(CKEditorConfig.getOptions()) || {};
            var apply = function apply() {
                if ($rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest') {
                    $rootScope.$apply();
                }
            };

            _angular2.default.merge(options, { sharedSpaces: false });

            element[0].setAttribute('contenteditable', true);

            if (!attrs.id) {
                attrs.$set('id', PREFIX + ++counter);
            }

            editor = CKEDITOR.replace(element[0], options);

            editor.on('instanceReady', function () {
                editor.setData(ngModel.$viewValue || '');
                apply();
            });

            editor.on('change', function (e) {
                if (e.editor.checkDirty()) {
                    ngModel.$setViewValue(e.editor.getData());
                    e.editor.resetDirty();
                }
                apply();
            });

            scope.$watch('contentLoaded()', function (nV, oV) {
                if (nV !== oV) {
                    editor.setData(ngModel.$viewValue || '');
                    apply();
                }
            }, true);

            ngModel.$render = render;

            scope.$on('$destroy', function () {
                editor.focusManager.blur(true);
                editor.destroy();
            });

            scope.$on('language-changed', function (event, language) {
                editor.destroy();
                options.language = language.newLanguage;
                editor = CKEDITOR.replace(element[0], options);
            });

            function render() {
                element[0].innerHTML = ngModel.$viewValue || '';
            }
        }
    };
}]).name;

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = "<textarea ckeditor-textarea\n    content-loaded=\"$ctrl.contentLoaded\"\n    ng-disabled=\"$ctrl.disabled\"\n    ng-model=\"$ctrl.model\">\n</textarea>";

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-2 control-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em></label>\n    <div class=\"col-sm-10\">\n        <editor-textarea\n                content-loaded=\"$ctrl.contentLoaded\"\n                disabled=\"$ctrl.aclDisable\"\n                model=\"$ctrl.model\">\n        </editor-textarea>\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n    </div>\n</div>";

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ACLService = __webpack_require__(117);

var _ACLService2 = _interopRequireDefault(_ACLService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.text
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.title      Input title and/or placeholder
 * @property {function} bindings.onBlur     Function called on input blur event
 * @property {function} bindings.onChange   Function called on input change event
 */
var cmsInputOptions = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        placeholder: '@'
    },
    template: __webpack_require__(1072),
    controller: function controller() {
        var _this = this;

        this.removeOption = function (object) {
            _this.model.splice(object.key, 1);
        };

        this.addOption = function (object) {
            if (_this.model) {
                _this.model.splice(object.key + 1, 0, '');
            } else {
                _this.model = [''];
            }
        };
    }
};

/**
 * Options control
 * @namespace cms.input.options
 */
exports.default = _angular2.default.module('cms.input.options', [_ACLService2.default]).component('cmsInputOptions', cmsInputOptions).name;

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label form-toolbar__options-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">\n        {{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }}\">\n        <div ng-repeat=\"model in $ctrl.model track by $index\" class=\"input-group options-control__option\">\n            <input type=\"text\" class=\"form-control with-danger-addon\" placeholder=\"{{ $ctrl.placeholder }}\"\n                   ng-model=\"$ctrl.model[$index]\"\n                   ng-disabled=\"$ctrl.aclDisable\">\n            <span class=\"input-group-btn\">\n                <button class=\"btn btn-danger disable-click-outside\"\n                        ng-disabled=\"$ctrl.aclDisable\"\n                        ng-click=\"$ctrl.removeOption({key: $index})\">\n                    <em class=\"fa fa-trash\"></em>\n                </button>\n            </span>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-sm-12\">\n                <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n                    {{ error }}\n                </span>\n                <button class=\"btn btn-success btn-sm options-control__add-option\"\n                        ng-disabled=\"$ctrl.aclDisable\"\n                        ng-click=\"$ctrl.addOption({key: $ctrl.model.length})\">\n                    <em class=\"fa fa-plus\"></em>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _modal = __webpack_require__(125);

var _modal2 = _interopRequireDefault(_modal);

var _Context = __webpack_require__(231);

var _Context2 = _interopRequireDefault(_Context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER_HEIGHT = 100;
var SCROLL_ZONE_HEIGHT = 60;

/**
 * @memberOf cms.input.edit.form
 * @property {object}   bindings.errors       Form errors object
 * @property {string}   bindings.label        Input label and/or placeholder
 * @property {string}   bindings.buttonTitle  Button label, default "Choose file"
 * @property {array}    bindings.model        Model array reference
 */
var cmsInputEditForm = {
    template: __webpack_require__(1074),
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        buttonTitle: '@',
        model: '=',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@'
    },

    controller: ['$scope', '$uibModal', function controller($scope, $uibModal) {

        this.openEditFormModal = function (_model) {
            var scroll = $(document).scrollTop();
            $uibModal.open({
                scope: $scope,
                animation: true,
                template: __webpack_require__(1075),
                size: 'lg',
                resolve: { model: function model() {
                        return _model;
                    } },
                controller: ['$scope', 'model', function controller($scope, model) {

                    $scope.context = new _Context2.default();
                    $scope.context.setDragularScope($scope);
                    $scope.context.setClickOutsideEnabled(false);

                    $scope.dragularScope = $scope.context.getDragularScope();
                    $scope.context.clearCurrentElement();
                    $scope.model = model;
                    $scope.parentModel = { parentModel: model };

                    $scope.onFocus = function (input) {
                        $scope.context.setCurrentElement(input);
                    };

                    $scope.dragularScope.$on('sections-library.drop-model', function () {
                        _angular2.default.forEach($scope.model.content, function (val, key) {

                            if (!val.$$hashKey) {
                                if (!$scope.model.content[key].config) {
                                    $scope.model.content[key].config = {};
                                }
                                $scope.model.content[key].config.key = $scope.model.content[key].type + Math.floor(Math.random() * (Math.pow(2, 30) - 1) + 1);
                                $scope.onFocus($scope.model.content[key]);
                            }
                        });
                    });

                    $scope.isSelected = function (input) {
                        return $scope.context.getCurrentElement() === input;
                    };

                    $scope.findPosition = function (input) {
                        var position = -1;
                        $scope.model.content.forEach(function (el, key) {

                            if (el.$$hashKey === input.$$hashKey) {
                                position = key;
                            }
                        });
                        return position;
                    };

                    $scope.dragularScope.$on('sections-library.drag', function (el, target, source) {
                        document.documentElement.addEventListener('mousemove', scrollFn);
                    });

                    $scope.dragularScope.$on('sections-library.dragend', function (el, target, source) {
                        document.documentElement.removeEventListener('mousemove', scrollFn);
                        clearInterval(timer);
                    });

                    var timer = null;

                    var scrollFn = function scrollFn(e) {
                        var height = $('.form-setting__inputs-container').outerHeight(true);
                        if (timer) {
                            clearInterval(timer);
                        }

                        var fn = function fn() {
                            if (e.clientY > height - SCROLL_ZONE_HEIGHT) {
                                $('.form-setting__inputs-container')[0].scrollTop += 10;
                            } else if (e.clientY < HEADER_HEIGHT + SCROLL_ZONE_HEIGHT) {
                                $('.form-setting__inputs-container')[0].scrollTop -= 10;
                            }
                        };

                        fn();
                        timer = setInterval(fn, 20);
                    };
                }]
            }).result.then(function () {
                $(document).scrollTop(scroll);
            }).catch(function () {
                $(document).scrollTop(scroll);
            });
        };
    }]
};

/**
 * Edit form control
 * @namespace cms.input.edit.form
 */
exports.default = _angular2.default.module('cms.input.edit.form', [_modal2.default]).component('cmsInputEditForm', cmsInputEditForm).name;

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__edit-form-label\"\n           uib-tooltip=\"{{$ctrl.helper}}\" tooltip-placement=\"right\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }}\">\n\n        <button type=\"button\" class=\"btn btn-success\"\n                data-toggle=\"modal\"\n                ng-disabled=\"$ctrl.aclDisable\"\n                ng-click=\"$ctrl.openEditFormModal($ctrl.model)\">\n            {{ 'Edit form inputs' | translate }}\n        </button>\n\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in errors\">\n            {{ error }}\n        </span>\n    </div>\n</div>\n";

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = "<style>\n    creator-workspace input,\n    creator-workspace select,\n    creator-workspace button[type=\"submit\"],\n    creator-workspace textarea,\n    creator-workspace label {\n        /*pointer-events: none;*/\n    }\n    creator-workspace .disabled-input  {\n        position: relative;\n    }\n    creator-workspace .disabled-input:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n    }\n</style>\n<div class=\"modal-content creator-modal-form-settings\">\n    <div class=\"modal-header bg-info\">\n        <em class=\"fa fa-info\"></em><span style=\"margin-left: 10px;\" translate>Settings</span>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <creator-sections-library group=\"form\" context=\"context\"></creator-sections-library>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-lg-7 form-setting__inputs-container\">\n                <creator-workspace sections=\"model.content\" options=\"parentModel\" context=\"context\"></creator-workspace>\n            </div>\n            <div class=\"col-lg-5\">\n                <creator-toolbar model=\"content[0]\" context=\"context\"></creator-toolbar>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-info\" ng-click=\"$close()\" translate>OK</button>\n    </div>\n</div>";

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @memberOf cms.input.columns
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {object|text} bindings.options    Options to select
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {string}      bindings.labelSize  Label column size (1-12)
 * @property {string}      bindings.inputSize  Input column size (1-12)
 * @property {string}      bindings.aclShow    ACL config - show input
 * @property {string}      bindings.aclDisable ACL config - disable input
 *
 */
var cmsInputColumns = {
    bindings: {
        errors: '<',
        model: '=',
        options: '<',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: __webpack_require__(1077),
    controller: ['deleteElementDialog', 'gettext', '$scope', function controller(deleteElementDialog, gettext, $scope) {
        var _this = this;

        this.$onInit = function () {
            /* TODO: Sprawdzić, czy $onInit jest wciąż potrzebne, gdy przypisanie klucza mamy w WorkspaceElement */
            if (!_this.model.hasOwnProperty('columnsWidth')) {
                _this.model.columnsWidth = [];
                _angular2.default.forEach(_this.model.children, function (value, key) {
                    _this.model.columnsWidth[key] = 12 / _this.model.children.length;
                });
            }
        };

        var rebuildColumns = function rebuildColumns(newColumnsCount) {

            if (_this.model.children.length === newColumnsCount) {
                return;
            }

            if (_this.model.children.length < newColumnsCount) {
                while (_this.model.children.length < newColumnsCount) {
                    _this.model.children.push([]);
                    _this.model.columnsWidth = addElementToWidths(_this.model.columnsWidth);
                }
            } else {
                while (_this.model.children.length > newColumnsCount) {
                    _this.model.children.pop();
                    _this.model.columnsWidth = removeElementFromWidths(_this.model.columnsWidth);
                }
            }
        };

        /**
         * Return columns widths when new element added
         * @param columnsWidths {array}
         * @returns {array}
         */
        var addElementToWidths = function addElementToWidths(columnsWidths) {

            if (!getColumnChildrenCount()) {
                return getEqualColumnsWidth();
            }

            var gainedSpace = 0;
            var newColumnsWidths = [].concat(_toConsumableArray(columnsWidths)).reverse().map(function (oldWidth) {
                if (oldWidth > 1 && !gainedSpace) {
                    gainedSpace = gainedSpace + 1;
                    return --oldWidth;
                }
                return oldWidth;
            });

            newColumnsWidths.reverse();
            newColumnsWidths.push(gainedSpace);

            return newColumnsWidths;
        };

        /**
         * Return column widths when element removed
         * @param columnsWidths
         */
        var removeElementFromWidths = function removeElementFromWidths(columnsWidths) {

            if (!getColumnChildrenCount()) {
                return getEqualColumnsWidth();
            }

            var newColumnsWidths = [].concat(_toConsumableArray(columnsWidths));
            var removedWidth = newColumnsWidths.pop();
            newColumnsWidths[newColumnsWidths.length - 1] += removedWidth;
            return newColumnsWidths;
        };

        /**
         * Return count of children elements in columns
         * @returns {integer}
         */
        var getColumnChildrenCount = function getColumnChildrenCount() {
            return _this.model.children.reduce(function (acc, column) {
                return acc + column.length;
            }, 0);
        };

        /**
         * Get optimal columns width
         * @returns {number[]}
         */
        var getEqualColumnsWidth = function getEqualColumnsWidth() {
            return Array(_this.model.children.length).fill(null).map(function () {
                return 12 / _this.model.children.length;
            });
        };

        this.selectOption = function (newCount) {
            var oldCount = _this.model.children.length;
            if (newCount < oldCount && removedColumnsNotEmpty(newCount, oldCount)) {
                var deleteMessage = gettext("Do you really want to change number of columns? Content of last columns will be removed. (This action is irreversible!)");
                return deleteElementDialog.open(deleteMessage).then(function () {
                    rebuildColumns(newCount);
                }).catch(function () {});
            } else {
                rebuildColumns(newCount);
            }

            $scope.$emit('content-changed');
        };

        var removedColumnsNotEmpty = function removedColumnsNotEmpty(newCount, oldCount) {
            for (var i = oldCount; i > newCount; i--) {
                if (_this.model.children[i - 1].length) {
                    return true;
                }
            }
            return false;
        };
    }]

};

exports.default = _angular2.default.module('cms.input.columns', [_deleteElement2.default, _angularGettext2.default]).component('cmsInputColumns', cmsInputColumns).name;

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__text-label\">{{ $ctrl.label }}</label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} btn-group creator-toolbar__columns-count-input\">\n\n        <div class=\"btn-group\">\n            <button class=\"btn btn-icon btn-{{$ctrl.model.children.length ===  option ? 'info' : 'default'}}\"\n                    ng-repeat=\"option in $ctrl.options\"\n                    ng-click=\"$ctrl.selectOption(option)\"\n            >\n               {{ option }}\n            </button>\n        </div>\n\n        <span class=\"help-block error-block basic-block\" ng-repeat=\"error in $ctrl.errors\">\n            {{ error }}\n        </span>\n\n    </div>\n</div>\n\n\n";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _ACLService = __webpack_require__(117);

var _ACLService2 = _interopRequireDefault(_ACLService);

__webpack_require__(1079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.menu
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.label      Input title and/or placeholder
 * @property {string}   bindings.helper     Helper message for input
 * @property {string}   bindings.labelSize  Label column size (1-12)
 * @property {string}   bindings.inputSize  Input column size (1-12)
 * @property {string}   bindings.aclShow    ACL config - show input
 * @property {string}   bindings.aclDisable ACL config - disable input
 */
var cmsInputMenu = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: __webpack_require__(1080),
    controller: ['$scope', 'gettextCatalog', function controller($scope, gettextCatalog) {
        this.onChange = function () {
            $scope.$emit('content-changed');
        };

        this.scrollToSection = function (sectionUid) {

            var navigationHeight = 147;

            var scrollPos = $('.' + sectionUid).offset().top - navigationHeight;
            $('html').animate({
                scrollTop: scrollPos
            }, 500);
        };

        this.toggleVisible = function (anchor) {
            anchor.visible = !anchor.visible;
        };

        this.sectionPlaceholder = function (index) {
            return gettextCatalog.getString('Section {{index}} title', { 'index': index });
        };
    }]
};

/**
 * Text control
 * @namespace cms.input.text
 */
exports.default = _angular2.default.module('cms.input.menu', [_ACLService2.default, _angularGettext2.default]).component('cmsInputMenu', cmsInputMenu).name;

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n        <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__text-label\"\n               uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n            <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n        </label>\n\n        <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} creator-toolbar__text-input\"\n             ng-repeat=\"section in $ctrl.model\" ng-if=\"section.type === 'pageSection'\">\n            <div class=\"input-group\">\n                <span class=\"input-group-addon hand\" ng-click=\"$ctrl.toggleVisible(section.config.anchor)\">\n                    <em class=\"ion\"\n                        ng-class=\"{'ion-eye':section.config.anchor.visible, 'ion-eye-disabled': !section.config.anchor.visible}\"\n                    ></em>\n                </span>\n                <input type=\"text\" class=\"form-control\"\n                       ng-model=\"section.config.anchor.title\"\n                       ng-disabled=\"$ctrl.aclDisable\"\n                       placeholder=\"{{$ctrl.sectionPlaceholder($index+1)}}\"\n                       ng-blur=\"$ctrl.onBlur({data: $ctrl.model})\"\n                       ng-change=\"$ctrl.onChange({data: $ctrl.model})\"\n                >\n                <span class=\"input-group-addon hand\" ng-click=\"$ctrl.scrollToSection(section.config.uid)\">\n                    <i class=\"fa fa-arrow-circle-right\" aria-hidden=\"true\"></i>\n                </span>\n            </div>\n        </div>\n</div>";

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _modal = __webpack_require__(125);

var _modal2 = _interopRequireDefault(_modal);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _MediaResource = __webpack_require__(95);

var _MediaResource2 = _interopRequireDefault(_MediaResource);

var _MediaPickerModal = __webpack_require__(147);

var _MediaPickerModal2 = _interopRequireDefault(_MediaPickerModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.media
 * @property {object}   bindings.errors       Form errors object
 * @property {string}   bindings.label        Input label and/or placeholder
 * @property {string}   bindings.helper       Helper message for input
 * @property {string}   bindings.buttonTitle  Button label, default "Choose file"
 * @property {array}    bindings.mediaModel        Model array reference
 * @property {object}   bindings.extraFields  Function that returns promise if slug is valid
 * @property {boolean}  bindings.multiple     Allow to select multiple media
 * @property {string}   bindings.aclShow      ACL config - show input
 * @property {string}   bindings.aclDisable   ACL config - disable input
 * @property {string}   bindings.labelSize    Label column size (1-12)
 * @property {string}   bindings.inputSize    Input column size (1-12)
 */
var cmsButtonLink = {
    template: __webpack_require__(1082),
    bindings: {
        errors: '<',
        label: '@',
        helper: '@',
        placeholder: '@',
        buttonTitle: '@',
        model: '=',
        extraFields: '<',
        multiple: '<',
        aclShow: '<?',
        aclDisable: '<?'
    },

    controller: ['$scope', '$uibModal', 'MediaPickerModal', function controller($scope, $uibModal, MediaPickerModal) {
        var _this = this;

        this.$onInit = function () {
            _this.selectedMedia = [];
            if (!_this.mediaModel) {
                _this.mediaModel = [];
            }
        };

        /**
         * Used from in the modal to remember current selection
         *
         * @private
         * @param {MediaResource} media
         * @param {boolean} selected
         */
        this.onMediaSelected = function (media, selected) {

            if (_this.multiple) {
                if (selected) {
                    _this.selectedMedia.push(media);
                } else {
                    _this.selectedMedia = _this.selectedMedia.filter(function (mediaUsage) {
                        return mediaUsage.id !== media.id;
                    });
                }
            } else {
                _this.selectedMedia = selected ? [media] : [];
            }
        };

        this.openMediaPickerModal = function () {

            MediaPickerModal.open(_this.multiple).result.then(function (selectedMedia) {
                selectedMedia.forEach(function (el) {
                    var exists = _this.mediaModel.filter(function (existing) {
                        return existing.media.id === el.id;
                    }).length >= 1;

                    if (!exists) {
                        if (_this.multiple) {
                            _this.mediaModel.push({
                                media: _angular2.default.copy(el)
                            });
                        } else {
                            _this.mediaModel = [{ media: _angular2.default.copy(el) }];
                        }
                    }
                    _this.model = '/image/0x0/' + _this.mediaModel[0].media.key;
                }, _this);

                $scope.$emit('content-changed');
            });
        };
    }]
};

/**
 * Media control
 * @namespace cms.input.media
 */
exports.default = _angular2.default.module('cms.input.button.link', [_modal2.default, _angularGettext2.default, _MediaPickerModal2.default, _MediaResource2.default]).component('cmsInputButtonLink', cmsButtonLink).name;

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__text-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 7 }}\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"{{ $ctrl.placeholder }}\"\n               ng-model=\"$ctrl.model\"\n               ng-disabled=\"$ctrl.aclDisable\"\n               ng-blur=\"$ctrl.onBlur({data: $ctrl.model})\"\n               ng-change=\"$ctrl.onChange({data: $ctrl.model})\">\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n                {{ error }}\n            </span>\n    </div>\n\n    <div class=\"media-control__label col-xs-5\">\n        <button type=\"button\" class=\"btn btn-success\"\n                data-toggle=\"modal\"\n                ng-disabled=\"$ctrl.aclDisable\"\n                ng-click=\"$ctrl.openMediaPickerModal()\" translate>\n            Pick the file\n        </button>\n    </div>\n</div>";

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ACLService = __webpack_require__(117);

var _ACLService2 = _interopRequireDefault(_ACLService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @memberOf cms.input.text
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.title      Input title and/or placeholder
 * @property {function} bindings.onBlur     Function called on input blur event
 * @property {function} bindings.onChange   Function called on input change event
 */
var cmsInputMapAddress = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        placeholder: '@'
    },
    template: __webpack_require__(1084),
    controller: ['$scope', function controller($scope) {
        var _this = this;

        this.findAddress = function () {

            var geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address: _this.model.textAddress }, function (results, status) {
                //this console log is necessary for testing why maps are not working
                console.log(status, google.maps.GeocoderStatus.OK);
                if (status === google.maps.GeocoderStatus.OK) {
                    var result = results.pop();

                    _this.model.coordinates.lat = result.geometry.location.lat();
                    _this.model.coordinates.lng = result.geometry.location.lng();
                    //this console log is necessary for testing why maps are not working
                    console.log(_this.model.coordinates.lat, _this.model.coordinates.lng, result.geometry.location.lat(), result.geometry.location.lng());
                    $scope.$emit('map-changed');
                }
            });
        };

        this.zoomInc = function () {
            if (_this.model.zoom > 21) {
                return;
            }

            _this.model.zoom++;
            $scope.$emit('map-changed');
        };

        this.zoomDec = function () {
            if (_this.model.zoom < 1) {
                return;
            }

            _this.model.zoom--;
            $scope.$emit('map-changed');
        };
    }]
};

/**
 * Text control
 * @namespace cms.input.text
 */
exports.default = _angular2.default.module('cms.input.map-address', [_ACLService2.default]).component('cmsInputMapAddress', cmsInputMapAddress).name;

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} control-label creator-toolbar__text-label\"\n           uib-tooltip=\"{{$ctrl.helper | translate}}\" tooltip-placement=\"bottom\">{{ $ctrl.label }}\n        <em class=\"fa fa-question-circle\" ng-if=\"$ctrl.helper\"></em>\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} creator-toolbar__text-input\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"{{ $ctrl.placeholder }}\"\n               ng-model=\"$ctrl.model.textAddress\"\n               ng-disabled=\"$ctrl.aclDisable\"\n               ng-model-options='{ debounce: 500 }'\n               ng-change=\"$ctrl.findAddress()\">\n        <span class=\"help-block error-block basic-block\" role=\"alert\" ng-repeat=\"error in $ctrl.errors\">\n               {{ error }}\n        </span>\n    </div>\n</div>\n\n<div class=\"form-group\"\n     ng-class=\"{'has-error':$ctrl.errors}\"\n     ng-show=\"$ctrl.aclShow === true || $ctrl.aclShow === undefined\">\n    <label class=\"col-sm-{{ $ctrl.labelSize || 2 }} creator-toolbar__align-label\" translate>\n        Zoom\n    </label>\n    <div class=\"col-sm-{{ $ctrl.inputSize || 10 }} btn-group\">\n\n        <div class=\"btn-group\">\n            <button type=\"button\"\n                    ng-disabled=\"$ctrl.model.zoom >= 21\"\n                    ng-click=\"$ctrl.zoomInc()\"\n                    class=\"btn btn-icon btn-default\">\n                <em class=\"fa fa-plus\"></em>\n            </button>\n            <button type=\"button\"\n                    ng-disabled=\"$ctrl.model.zoom <= 1\"\n                    ng-click=\"$ctrl.zoomDec()\"\n                    class=\"btn btn-icon btn-default\">\n                <em class=\"fa fa-minus\"></em>\n            </button>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.has.tile', [_ConfigModule2.default]).component('hasMediaTile', {
    template: __webpack_require__(1086),
    bindings: {
        model: '<',
        onRemoved: '&'
    },
    controller: ['CONFIG', function controller(CONFIG) {
        var _this = this;

        /** @ngInject */

        this.$onInit = function () {
            _this.previewImage = CONFIG.API_PUBLIC + '/image/250x250/' + _this.model.media.key;
        };
        this.onRemove = function () {
            if (_this.onRemoved) {
                _this.onRemoved();
            }
        };
    }]
}).name;

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports = "<img ng-if=\"$ctrl.model.media.type === 'image'\" ng-src=\"{{ $ctrl.previewImage }}\" alt=\"image\"/>\n<div>\n    <a class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.onRemove()\">\n        <em class=\"ion-trash-a\"></em>\n    </a>\n</div>";

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

var _MediaResource = __webpack_require__(95);

var _MediaResource2 = _interopRequireDefault(_MediaResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.media.select', [_ConfigModule2.default, _MediaResource2.default]).component('selectMedia', {
    template: __webpack_require__(1088),
    bindings: {
        model: '<',
        onRemoved: '&'
    },
    controller: ['CONFIG', 'MediaResource', function controller(CONFIG, MediaResource) {
        var _this = this;

        /** @ngInject */

        this.medias = {};

        this.$onInit = function () {
            MediaResource.get(function (response) {
                _this.medias = response;
            }, function (errResponse) {});
        };
    }]
}).name;

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = "<a class=\"btn btn-primary\">Select photo form media library</a>\n\n<div class=\"modal-content\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\">\n            <em class=\"ion-ios-close-empty sn-link-close\"></em>\n        </button>\n        <h4 class=\"modal-title\" id=\"myModalLabel\">Modal title</h4>\n    </div>\n    <div class=\"modal-body\">\n        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet\n        dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper\n        suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button>\n    </div>\n</div>\n";

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordChangeService = function PasswordChangeService($uibModal, UserResource, gettext, toastr, CMSAuthService) {

    var service = {};

    service.open = function () {

        $uibModal.open({
            animation: true,
            template: __webpack_require__(1090),
            size: 'md',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            controller: ['$uibModalInstance', 'toastr', '$state', 'gettextCatalog', function controller($uibModalInstance, toastr, $state, gettextCatalog) {
                var vm = {};
                vm.password = '';
                vm.passwordRepeat = '';
                vm.error = '';
                vm.changePending = false;

                vm.change = function () {

                    vm.errors = {};

                    if (!vm.password) {
                        vm.errors = { plainPassword: [gettextCatalog.getString('This field cannot be empty.')] };
                        return;
                    }

                    if (vm.password && vm.password !== vm.passwordRepeat) {
                        vm.errors = { repeatPassword: [gettextCatalog.getString('The passwords are not identical.')] };
                        return;
                    }

                    vm.changePending = true;
                    var userId = CMSAuthService.getUser().id;
                    var request = { id: userId, plainPassword: vm.password };

                    UserResource.update(request, function (response) {
                        CMSAuthService.reLogin(vm.password).then(function () {
                            $uibModalInstance.close();

                            toastr.success(gettextCatalog.getString('Password has been changed'), gettextCatalog.getString('Success'));
                            $state.go('dashboard');
                        });
                    }, function (error) {
                        vm.changePending = false;
                        vm.errors = error.data;
                    });
                };

                return vm;
            }]
        });
    };

    return service;
};

PasswordChangeService.$inject = ['$uibModal', 'UserResource', 'gettext', 'toastr', 'CMSAuthService'];
/**
 * Service providing change password modal.
 * @namespace cms.password.change
 */
exports.default = _angular2.default.module('cms.password.change', []).factory('PasswordChangeService', PasswordChangeService).name;

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content cms-modal\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" translate>Change password</h4>\n    </div>\n    <div class=\"modal-body\">\n        <form class=\"form-horizontal\">\n            <cms-input-password label=\"{{ 'Password' | translate }}\"\n                                model=\"vm.password\"\n                                label-size=\"3\"\n                                input-size=\"9\"\n                                errors=\"vm.errors.plainPassword\">\n            </cms-input-password>\n            <cms-input-password label=\"{{ 'Repeat password' | translate }}\"\n                                model=\"vm.passwordRepeat\"\n                                label-size=\"3\"\n                                input-size=\"9\"\n                                errors=\"vm.errors.repeatPassword\">\n            </cms-input-password>\n        </form>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.changePending\" ng-click=\"vm.change()\">\n            <span translate>Change</span>\n            <span ng-show=\"vm.changePending\"><em class=\"fa fa-circle-o-notch fa-spin\"></em></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('unique.id.generator', []).factory('UniqueIdGenerator', function () {

    var service = {};

    service.generate = function () {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "section";


        var uniqueId = parseInt(Math.random() * 1000000).toString();

        return [prefix, '-', uniqueId].join('');
    };

    return service;
}).name;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.save.warning.dialog', []).factory('saveWarningDialog', ['$uibModal', function ($uibModal) {

    var service = {};

    service.open = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            template: __webpack_require__(1093),
            size: 'md',
            keyboard: false,
            backdrop: 'static'
        });

        return modalInstance.result;
    };

    return service;
}]).name;

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-danger\">\n        <em class=\"fa fa-warning\"></em><span style=\"margin-left: 10px;\" translate>Leave the page?</span>\n    </div>\n    <div class=\"modal-body text-center\" translate>\n        You have not finished entering data into the form. Do you want to leave anyway?\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$close()\" translate>Stay on the site</button>\n        <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\" translate>Leave the page</button>\n    </div>\n</div>";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.save.warning.interval.dialog', []).factory('saveWarningIntervalDialog', ['$uibModal', function ($uibModal) {

    var service = {};
    var open = false;

    service.isOpen = function () {
        return open;
    };

    service.open = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            template: __webpack_require__(1095),
            size: 'md',
            keyboard: false,
            backdrop: 'static'
        });

        open = true;

        modalInstance.result.finally(function () {
            open = false;
        });

        return modalInstance.result;
    };

    return service;
}]).name;

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-danger\">\n        <em class=\"fa fa-warning\"></em><span style=\"margin-left: 10px;\" translate>You haven't saved your progress in 5 minutes!</span>\n    </div>\n    <div class=\"modal-body text-center\" translate>\n        You may lose your work if you are not saving it regularly.\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-success\" ng-click=\"$close()\" translate>Save</button>\n        <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\" translate>Cancel</button>\n    </div>\n</div>";

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _angularSlugify = __webpack_require__(438);

var _angularSlugify2 = _interopRequireDefault(_angularSlugify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.add.page.dialog.service', [_angularToastr2.default, _angularGettext2.default, "slugifier"]).factory('addPageDialog', ['$uibModal', '$q', 'CMSAuthService', 'Slug', 'gettextCatalog', function ($uibModal, $q, CMSAuthService, Slug, gettextCatalog) {

    var service = {};

    service.open = function () {
        var user = CMSAuthService.getUser();
        var title = gettextCatalog.getString('New page') + ' ' + user.email.split('@')[0].replace('.', ' ');
        var modalInstance = $uibModal.open({
            animation: true,
            template: __webpack_require__(1097),
            size: 'md',
            controllerAs: '$ctrl',
            controller: ['$scope', 'PageResource', 'toastr', 'gettextCatalog', 'TemplateResource', 'CONFIG', function controller($scope, PageResource, toastr, gettextCatalog, TemplateResource, CONFIG) {
                var _this = this;

                this.errors = {};
                this.pending = false;
                this.templates = [];
                TemplateResource.findAll(function (response) {
                    response.data.forEach(function (data) {
                        _this.templates.push({ 'value': data, 'label': data.title });
                    });
                });
                this.page = {
                    title: title,
                    status: 'public',
                    slug: Slug.slugify(title),
                    template: null
                };

                this.create = function () {
                    _this.pending = true;
                    if (!_this.page.template) {
                        _this.page.globalBackgroundColor = '#ededed';
                        _this.page.globalColor = '#000000';
                        _this.page.globalLinkColor = '#209e91';
                        _this.page.globalTextConfig = {
                            "h1": {
                                "fontFamily": "Ubuntu"
                            },
                            "h2": {
                                "fontFamily": "Ubuntu"
                            },
                            "h3": {
                                "fontFamily": "Ubuntu"
                            },
                            "href": {
                                "color": "#209e91"
                            },
                            "text": {
                                "fontFamily": "Ubuntu"
                            },
                            "linkHover": {
                                "color": "#209e91"
                            }
                        };
                    }
                    return PageResource.save(_this.page, function (response) {
                        _this.errors = {};
                        toastr.success(gettextCatalog.getString('Page {{title}} added!', { title: _this.page.title }), gettextCatalog.getString('Success'));
                        _this.pending = false;
                        $scope.$close(response);
                    }, function (response) {
                        if (response.status === 400) {
                            _this.errors = response.data;
                        }
                        _this.pending = false;
                    }).$promise;
                };

                /**
                 * Broadcast slug recalculation request
                 */
                this.updateSlug = function () {
                    //@TODO: Zaproponować i przedyskutować sposób wyniesienia do osobnego serwisu
                    if (!this.page.id || !this.page.slug) {
                        $scope.$broadcast('slug.recalc');
                    }
                };

                /**
                 * Actions to validate slug
                 * Returns promise;
                 * @param data
                 */
                this.validateSlug = function (data) {
                    var _this2 = this;

                    //@TODO: Zaproponować i przedyskutować sposób wyniesienia do osobnego serwisu
                    this.errors.slug = [];
                    if (!data) {
                        return $q.when([]);
                    }

                    var pageResourcePromise = PageResource.findAll({ slug_strict: data }).$promise;

                    pageResourcePromise.then(function (response) {

                        _angular2.default.forEach(response.data, function (value) {
                            if (value.id !== this.page.id) {
                                this.errors.slug = [gettextCatalog.getString('This value is already used')];
                            } else {
                                this.errors.slug = null;
                            }
                        }, _this2);
                    });

                    return pageResourcePromise;
                };

                this.getSiteUrl = function (slug) {
                    return CONFIG.PUBLIC_SITE_URL.replace('__SITE_SLUG__', slug);
                };
            }]

        });

        return modalInstance.result;
    };

    return service;
}]).name;

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content add-page-dialog\">\n    <div class=\"modal-header bg-success\">\n        <em class=\"fa fa-info\"></em><span style=\"margin-left: 10px;\" translate>Create new page</span>\n    </div>\n    <div class=\"modal-body\">\n        <form novalidate autocomplete=\"off\" class=\"form-horizontal\">\n            <cms-input-text model=\"$ctrl.page.title\"\n                            label=\"{{ 'Title' | translate }}\"\n                            placeholder=\"{{ 'Insert title of your page' | translate }}\"\n                            errors=\"$ctrl.errors.title\"\n                            label-size=\"3\"\n                            input-size=\"9\"\n                            maxlength=\"200\"\n                            on-blur=\"$ctrl.updateSlug()\">\n            </cms-input-text>\n            <div class=\"clearfix\"></div>\n            <cms-input-slug model=\"$ctrl.page.slug\"\n                            label=\"{{'Site address' | translate }}\"\n                            errors=\"$ctrl.errors.slug\"\n                            slug-validation=\"$ctrl.validateSlug(data)\"\n                            label-size=\"3\"\n                            input-size=\"9\"\n                            maxlength=\"200\"\n                            slug-source=\"$ctrl.page.title\">\n            </cms-input-slug>\n\n            <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\">{{ $ctrl.label }}</label>\n                <div class=\"col-sm-9 creator-toolbar__slug-control-input\">\n                    <div class=\"site-url-info\">\n                        {{ 'Your free domain name will be:' | translate }}\n                        <div class=\"site-url-given\">{{ $ctrl.getSiteUrl($ctrl.page.slug) }}</div>\n                    </div>\n                </div>\n            </div>\n\n            <cms-input-object-select model=\"$ctrl.page.template\"\n                                     label=\"{{ 'Template' | translate }}\"\n                                     options=\"$ctrl.templates\"\n                                     label-size=\"3\"\n                                     input-size=\"9\">\n            </cms-input-object-select>\n            <div class=\"row\">\n                <div class=\"col-sm-8 col-sm-offset-2\">\n                    <p>&nbsp;&nbsp;{{ 'You can check out templates' | translate }} <a href=\"https://contente.app/template-showcase/\" target=\"_blank\">{{'here' | translate }}</a></p>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" translate>Cancel</button>\n        <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.create()\" ng-disabled=\"$ctrl.pending\">\n            <span ng-show=\"!$ctrl.pending\" translate>Create</span>\n            <span ng-show=\"$ctrl.pending\" class=\"fa fa-circle-o-notch fa-spin\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularToastr = __webpack_require__(35);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

var _TemplateResource = __webpack_require__(1099);

var _TemplateResource2 = _interopRequireDefault(_TemplateResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.export.as.template.dialog.service', [_angularToastr2.default, _angularGettext2.default, _TemplateResource2.default]).factory('exportAsTemplateDialog', ['$uibModal', '$q', function ($uibModal, $q) {

    var service = {};

    service.open = function (page) {
        var modalInstance = $uibModal.open({
            animation: true,
            template: __webpack_require__(1100),
            size: 'md',
            controllerAs: '$ctrl',
            controller: ['$scope', 'TemplateResource', 'toastr', 'gettextCatalog', function controller($scope, TemplateResource, toastr, gettextCatalog) {
                var _this = this;

                this.errors = {};
                this.pending = false;
                this.template = {
                    title: page.title,
                    slug: page.slug,
                    content: page.content,
                    globalBackgroundColor: page.globalBackgroundColor,
                    globalBackgroundImage: page.globalBackgroundImage,
                    globalColor: page.globalColor,
                    globalLinkColor: page.globalLinkColor,
                    globalTextConfig: page.globalTextConfig,
                    globalTabletBackgroundImage: page.globalTabletBackgroundImage,
                    globalMobileBackgroundImage: page.globalMobileBackgroundImage,
                    customStyles: page.customStyles,
                    globalLineHeight: page.globalLineHeight,
                    page: page,
                    accessibleByEveryone: true
                };

                this.export = function () {
                    _this.pending = true;
                    return TemplateResource.save(_this.template, function (response) {
                        _this.errors = {};
                        toastr.success(gettextCatalog.getString('Template {{title}} added!', { title: _this.template.title }), gettextCatalog.getString('Success'));
                        _this.pending = false;
                        $scope.$close(response);
                    }, function (response) {
                        if (response.status === 400) {
                            _this.errors = response.data;
                        }
                        _this.pending = false;
                    }).$promise;
                };
            }]

        });

        return modalInstance.result;
    };

    return service;
}]).name;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _angularResource = __webpack_require__(65);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _ConfigModule = __webpack_require__(10);

var _ConfigModule2 = _interopRequireDefault(_ConfigModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templateResource = _angular2.default.module('cms.template.resource', [_angularResource2.default, _ConfigModule2.default]).factory('TemplateResource', ['$resource', 'CONFIG', function ($resource, CONFIG) {
    /** @ngInclude */

    return $resource(CONFIG.API_URL + '/templates/:id', { id: '@id' }, {
        'findAll': { method: 'GET' },
        'find': { method: 'GET' },
        'save': { method: 'POST' },
        'update': { method: 'PUT', params: { id: '@id' } },
        'delete': { method: 'DELETE', params: { id: '@id' } }
    }, {
        stripTrailingSlashes: true
    });
}]);

exports.default = templateResource.name;

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-success\">\n        <em class=\"fa fa-info\"></em><span style=\"margin-left: 10px;\" translate>Export template</span>\n    </div>\n    <div class=\"modal-body\">\n        <form novalidate autocomplete=\"off\" class=\"form-horizontal\">\n            <cms-input-text model=\"$ctrl.template.title\"\n                            label=\"{{ 'Title' | translate }}\"\n                            placeholder=\"{{ 'Insert title of your template' | translate }}\"\n                            errors=\"$ctrl.errors.title\">\n            </cms-input-text>\n            <cms-input-text model=\"$ctrl.template.slug\"\n                            label=\"{{ 'Slug' | translate }}\"\n                            acl-disable=\"true\"\n                            errors=\"$ctrl.errors.slug\">\n            </cms-input-text>\n            <div class=\"clearfix\"></div>\n            <cms-input-media model=\"$ctrl.template.thumbnail\"\n                             label=\"{{ 'Thumbnail' | translate }}\"\n                             errors=\"$ctrl.errors.thumbnail\"></cms-input-media>\n\n            <cms-input-checkbox model=\"$ctrl.template.accessibleByEveryone\"\n                            label=\"{{ 'This template can be accessible by everyone' | translate }}\"\n                            label-size=\"10\"\n                            input-size=\"2\"\n                            errors=\"$ctrl.errors.accessibleByEveryone\"></cms-input-checkbox>\n        </form>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" translate>Cancel</button>\n        <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.export()\" ng-disabled=\"$ctrl.pending\">\n            <span ng-show=\"!$ctrl.pending\" translate>Export</span>\n            <span ng-show=\"$ctrl.pending\" class=\"fa fa-circle-o-notch fa-spin\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ClickOutsideService = __webpack_require__(1102);

var _ClickOutsideService2 = _interopRequireDefault(_ClickOutsideService);

var _deleteElement = __webpack_require__(74);

var _deleteElement2 = _interopRequireDefault(_deleteElement);

var _WorkspaceElement = __webpack_require__(238);

var _WorkspaceElement2 = _interopRequireDefault(_WorkspaceElement);

var _angularGettext = __webpack_require__(9);

var _angularGettext2 = _interopRequireDefault(_angularGettext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorWorkspace = {
    bindings: {
        sections: '<',
        context: '<',
        type: '@', // {workspace|bag}
        options: '<', // {parentModel: }
        sectionsNested: '<',
        content: '='
    },
    template: __webpack_require__(1106),
    controller: ['$element', function controller($element) {
        var _this = this;

        /** @ngInject() */

        this.$onInit = function () {
            _this.type = _this.type ? _this.type : 'workspace';
            _this.dragularScope = _this.context.getDragularScope();
        };

        this.$postLink = function () {

            /**
             * Dragular bugfix https://github.com/bevacqua/dragula/issues/527
             * When click on section blur (unfocus) all contenteditable elements
             */
            var blurEditableOnClick = function blurEditableOnClick() {
                var editableSelector = '[contenteditable]';
                $element.on('mousedown', function (el) {
                    var clickedInsideEditable = el.target.closest(editableSelector, $element);
                    if (!clickedInsideEditable) {
                        $element.find(editableSelector).each(function (key, el) {
                            el.blur();
                        });
                    }
                });
            };

            if (_this.type === 'workspace') {
                blurEditableOnClick();
            }
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.workspace', [_ClickOutsideService2.default, _deleteElement2.default, _angularGettext2.default, _WorkspaceElement2.default]).component('creatorWorkspace', creatorWorkspace).name;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.clickOutside', []).service('ClickOutside', ['$document', function ($document) {
  var _this = this;

  var KEY_ATTR = 'click-outside-element-uid';

  this.setCurrent = function (keyValue, callbackFn, ignore) {
    _this.currentKey = keyValue;
    _this.callback = callbackFn;
    _this.ignoreClass = ignore;
  };

  this.clear = function () {
    if (_this.currentKey && _this.callback) {
      _this.callback();
    }
    _this.setCurrent(null);
  };

  var isIgnoredElement = function isIgnoredElement(element) {
    if (!element.className) {
      return false;
    }

    if (_this.ignoreClass && element.className.toString().indexOf(_this.ignoreClass) !== -1) {
      return true;
    }

    return element.id === 'ckeditorToolbarContainer' || element.className.toString().indexOf('ui-select-choices') !== -1 || element.className.toString().indexOf('modal') !== -1 || element.className.toString().indexOf('modal-backdrop') !== -1 || element.className.toString().indexOf('shepherd') !== -1;
  };

  var handler = function handler(e) {

    if (!_this.currentKey) {
      return;
    }

    for (var element = e.target; element; element = element.parentNode) {
      if (element.attributes) {
        if (element.getAttribute(KEY_ATTR) === _this.currentKey || isIgnoredElement(element)) {
          return;
        }
      }
    }

    _this.currentKey = null;
    return _this.callback();
  };

  $document.on('click', handler);

  return {
    setCurrent: this.setCurrent,
    clear: this.clear
  };
}]).name;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnchorModal = function AnchorModal($uibModal) {

    var service = {};

    service.open = function (section) {

        $uibModal.open({
            animation: true,
            template: __webpack_require__(1104),
            size: 'md',
            controllerAs: 'vm',
            controller: ['$uibModalInstance', function controller($uibModalInstance) {
                var vm = {};
                vm.section = section;

                vm.change = function () {
                    if (vm.section.config.anchor.title) {
                        vm.section.config.anchor.visible = true;
                    }

                    $uibModalInstance.close();
                };

                return vm;
            }]
        });
    };

    return service;
};

AnchorModal.$inject = ['$uibModal'];
/**
 * Service providing change password modal.
 * @namespace cms.password.change
 */
exports.default = _angular2.default.module('cms.creator.anchor.modal', []).factory('AnchorModal', AnchorModal).name;

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content cms-modal\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" translate>Section title</h4>\n    </div>\n    <div class=\"modal-body\">\n        <form class=\"form-horizontal\">\n            <cms-input-text label=\"{{ 'Title' | translate }}\"\n                                model=\"vm.section.config.anchor.title\"\n                                label-size=\"3\"\n                                input-size=\"9\">\n            </cms-input-text>\n        </form>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.changePending\" ng-click=\"vm.change()\">\n            <span translate>OK</span>\n        </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\">\n            <span translate>Cancel</span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = "<div class=\"\n        creator-workspace__section\n        section-{{ $ctrl.section.type }}\n        {{ $ctrl.isSelected($ctrl.section) ? 'creator-workspace__section-selected' : ''}}\n        {{ $ctrl.section.type != 'pageSection' ? 'highlight-section' : ''}}\n        {{$ctrl.section.config.parallax ? 'parallax' : ''}}\n        {{$ctrl.section.config.uid}}\n        \"\n     click-outside-element-uid=\"$ctrl.section-element\"\n     ng-class=\"{'creator-workspace__section-selected': $ctrl.isSelected($ctrl.section)}\"\n     ng-click=\"$ctrl.onFocus($ctrl.section, $event)\"\n     ng-style=\"{color: $ctrl.section.config.color.value}\"\n>\n\n    <div ng-if=\"$ctrl.section.type == 'pageSection'\" class=\"section-anchor\">\n        <span translate>SECTION</span>: <span ng-if=\"!$ctrl.section.config.anchor.title\" translate=\"\">Untitled</span>\n        <span ng-if=\"$ctrl.section.config.anchor.title\">{{$ctrl.section.config.anchor.title}}</span>\n        <span>({{$ctrl.section.config.uid}})</span>\n    </div>\n\n    <div class=\"creator-workspace__section-config\">\n        <button type=\"button\"\n                class=\"btn btn-warning\"\n                ng-if=\"$ctrl.section.type === 'pageSection'\"\n                ng-click=\"$ctrl.moveUp($ctrl.section)\">\n            <em class=\"fa fa-arrow-up\"></em>\n        </button>\n        <button type=\"button\"\n                class=\"btn btn-warning\"\n                ng-if=\"$ctrl.section.type === 'pageSection'\"\n                ng-click=\"$ctrl.moveDown($ctrl.section)\">\n            <em class=\"fa fa-arrow-down\"></em>\n        </button>\n        <button type=\"button\"\n                class=\"btn btn-info\"\n                ng-if=\"$ctrl.section.type === 'pageSection'\"\n                ng-click=\"$ctrl.showAnchorModal($ctrl.section)\">\n            <em class=\"fa fa-link\"></em>\n        </button>\n\n\n        <button type=\"button\"\n                class=\"btn btn-info\"\n                ng-if=\"!$ctrl.isCopyDisabled()\"\n                ng-click=\"$ctrl.copySection($event, $ctrl.section)\">\n            <em class=\"fa fa-copy\"></em>\n        </button>\n\n        <button type=\"button\"\n                class=\"btn btn-danger disable-click-outside\"\n                ng-if=\"!$ctrl.isRemoveDisabled()\"\n                ng-click=\"$ctrl.removeSection($ctrl.section, $event)\">\n            <em class=\"fa fa-trash\"></em>\n        </button>\n    </div>\n\n\n    <div class=\"creator-workspace__section-container\" ng-if=\"$ctrl.section.group === 'mail'\">\n        <cms-creator-mail-section-text ng-if=\"$ctrl.section.type === 'text'\" element-model=\"$ctrl.section.config\"></cms-creator-mail-section-text>\n        <cms-creator-mail-section-image ng-if=\"$ctrl.section.type === 'image'\" element-model=\"$ctrl.section.config\"></cms-creator-mail-section-image>\n        <cms-creator-mail-section-divider ng-if=\"$ctrl.section.type === 'divider'\" element-model=\"$ctrl.section.config\"></cms-creator-mail-section-divider>\n        <cms-creator-mail-section-social ng-if=\"$ctrl.section.type === 'social'\" element-model=\"$ctrl.section.config\"></cms-creator-mail-section-social>\n        <cms-creator-mail-section-button ng-if=\"$ctrl.section.type === 'button'\" element-model=\"$ctrl.section.config\"></cms-creator-mail-section-button>\n        <cms-creator-mail-section-image-text ng-if=\"$ctrl.section.type === 'imageText'\" element-model=\"$ctrl.section.config\"></cms-creator-mail-section-image-text>\n    </div>\n\n\n    <div class=\"creator-workspace__section-container\" ng-if=\"$ctrl.section.group === 'page'\">\n        <cms-creator-page-section-text ng-if=\"$ctrl.section.type === 'pageText'\" element-model=\"$ctrl.section.config\"></cms-creator-page-section-text>\n        <cms-creator-page-section-image ng-if=\"$ctrl.section.type === 'pageImage'\" element-model=\"$ctrl.section.config\"></cms-creator-page-section-image>\n        <cms-creator-page-section-divider ng-if=\"$ctrl.section.type === 'pageDivider'\" element-model=\"$ctrl.section.config\"></cms-creator-page-section-divider>\n        <cms-creator-page-section-social ng-if=\"$ctrl.section.type === 'pageSocial'\" element-model=\"$ctrl.section.config\"></cms-creator-page-section-social>\n        <cms-creator-page-section-button ng-if=\"$ctrl.section.type === 'pageButton'\" element-model=\"$ctrl.section.config\"></cms-creator-page-section-button>\n        <cms-creator-page-section-form ng-if=\"$ctrl.section.type === 'pageForm'\" element-model=\"$ctrl.section.config\"></cms-creator-page-section-form>\n        <cms-creator-page-menu ng-if=\"$ctrl.section.type === 'pageMenu'\"\n                               content=\"$ctrl.content\"\n                               element-model=\"$ctrl.section.config\">\n        </cms-creator-page-menu>\n        <cms-creator-page-section\n                ng-if=\"$ctrl.section.type === 'pageSection'\"\n                element-model=\"$ctrl.section.config\"\n                context=\"$ctrl.context\"\n                content=\"$ctrl.content\"\n        ></cms-creator-page-section>\n\n        <cms-creator-page-section-html\n                ng-if=\"$ctrl.section.type === 'pageHtml'\"\n                element-model=\"$ctrl.section.config\"\n                context=\"$ctrl.context\"\n                content=\"$ctrl.content\"\n        ></cms-creator-page-section-html>\n        <cms-creator-page-section-video\n                ng-if=\"$ctrl.section.type === 'pageVideo'\"\n                element-model=\"$ctrl.section.config\"\n                context=\"$ctrl.context\"\n                content=\"$ctrl.content\"\n        ></cms-creator-page-section-video>\n\n        <cms-creator-page-section-map\n                ng-if=\"$ctrl.section.type === 'pageMap'\"\n                element-model=\"$ctrl.section.config\"\n                context=\"$ctrl.context\"\n                content=\"$ctrl.section.config\"\n        ></cms-creator-page-section-map>\n\n        <cms-creator-page-section-facebook-feed\n            ng-if=\"$ctrl.section.type === 'pageFacebookFeed'\"\n            element-model=\"$ctrl.section.config\"\n            context=\"$ctrl.context\"\n            content=\"$ctrl.section.config\"\n        ></cms-creator-page-section-facebook-feed>\n\n        <cms-creator-page-section-twitter-feed\n            ng-if=\"$ctrl.section.type === 'pageTwitterFeed'\"\n            element-model=\"$ctrl.section.config\"\n            context=\"$ctrl.context\"\n            content=\"$ctrl.section.config\"\n        ></cms-creator-page-section-twitter-feed>\n    </div>\n\n    <!-- Form editor inputs -->\n    <div class=\"creator-workspace__section-container\" ng-if=\"$ctrl.section.group === 'form' || !section.group\">\n\n        <cms-creator-form-input-text\n                ng-if=\"$ctrl.section.type == 'formText'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-text>\n        <cms-creator-form-input-email\n                ng-if=\"$ctrl.section.type == 'formEmail'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-email>\n        <cms-creator-form-input-date\n                ng-if=\"$ctrl.section.type == 'formDate'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-date>\n        <cms-creator-form-input-date-time\n                ng-if=\"$ctrl.section.type == 'formDateTime'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-date-time>\n        <cms-creator-form-input-number\n                ng-if=\"$ctrl.section.type == 'formNumber'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-number>\n        <cms-creator-form-input-select\n                ng-if=\"$ctrl.section.type == 'formSelect'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-select>\n        <cms-creator-form-input-textarea\n                ng-if=\"$ctrl.section.type == 'formTextarea'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-textarea>\n        <cms-creator-form-input-plain-text\n                ng-if=\"$ctrl.section.type == 'formPlainText'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-plain-text>\n        <cms-creator-form-input-radio\n                ng-if=\"$ctrl.section.type == 'formRadio'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-radio>\n        <cms-creator-form-input-checkbox\n                ng-if=\"$ctrl.section.type == 'formCheckbox'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-checkbox>\n        <cms-creator-form-input-submit\n                ng-if=\"$ctrl.section.type == 'formSubmit'\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-submit>\n        <cms-creator-form-input-captcha\n                ng-if=\"$ctrl.section.type == 'formCaptcha' && $ctrl.options.parentModel.recaptcha\"\n                element-model=\"$ctrl.section.config\"\n                parent-model=\"$ctrl.options.parentModel\"></cms-creator-form-input-captcha>\n        <div class=\"clearfix\"></div>\n    </div>\n</div>";

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = "<div class=\"creator-workspace__workspace-container creator-workspace__type-{{$ctrl.type}}\"\n     ng-class=\"{'creator-workspace__empty': !$ctrl.sections.length }\"\n     dragula=\"'sections-library'\"\n     dragula-scope=\"$ctrl.dragularScope\"\n     dragula-model=\"$ctrl.sections\"\n>\n\n    <div class=\"workpace-info\" ng-if=\"!$ctrl.sections.length && $ctrl.type == 'workspace'\">\n        <h1 class=\"workpace-info-text text-center\" translate>Drop elements here</h1>\n        <img src=\"/images/drag_and_drop.gif\" alt=\"drag and drop showcase\"\n             class=\"workspace-info-image img-responsive center-block\" />\n    </div>\n    <div ng-repeat=\"section in $ctrl.sections\"\n         class=\"creator-workspace__section-{{section.type}}\">\n        <workspace-element\n                section=\"section\"\n                context=\"$ctrl.context\"\n                sections=\"$ctrl.sections\"\n                on-focus=\"$ctrl.onFocus\"\n                workspace-type=\"$ctrl.type\"\n                sections-nested=\"$ctrl.sectionsNested\"\n                content=\"$ctrl.content\"\n                options=\"$ctrl.options\"\n        ></workspace-element>\n    </div>\n\n</div>";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorToolbar = {
    bindings: {
        model: '=',
        context: '<',
        options: '<' // {withScroll: boolean}
    },
    transclude: true,
    template: __webpack_require__(1108),
    controller: ['ToolbarService', 'SectionsLibraryService', function controller(ToolbarService, SectionsLibraryService) {
        var _this = this;

        this.getSectionConfigSchema = function (type) {
            return ToolbarService.getSectionSchema(type);
        };

        this.getSectionDefinition = function (type) {
            return SectionsLibraryService.getSectionDefinition(type);
        };

        this.closeToolbar = function () {
            _this.context.clearCurrentElement();
        };

        this.isCurrentElement = function () {
            if (!_this.context) {
                return false;
            }
            return _this.context.hasCurrentElement();
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.toolbar', [_ToolbarService2.default, _SectionsLibraryService2.default]).component('creatorToolbar', creatorToolbar).name;

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports = "<div class=\"creator-toolbar with-scroll\">\n\n    <div ng-if=\"$ctrl.isCurrentElement()\">\n\n\n        <em class=\"fa fa-times pull-right\" ng-click=\"$ctrl.closeToolbar()\"></em>\n        <h4>{{$ctrl.getSectionDefinition($ctrl.context.getCurrentElement().type).label | translate }}</h4>\n\n        <form class=\"form-horizontal\" autocomplete=\"off\" novalidate>\n\n            <uib-accordion close-others=\"true\">\n                <div uib-accordion-group is-open=\"element.isOpen\" ng-repeat=\"element in $ctrl.getSectionDefinition($ctrl.context.getCurrentElement().type).groups\">\n                    <uib-accordion-heading>\n                        <div>\n                            {{ element.label | translate }}\n                            <em class=\"pull-right glyphicon\"\n                               ng-class=\"{'glyphicon-chevron-down': element.isOpen,\n                               'glyphicon-chevron-right': !element.isOpen}\"></em>\n                        </div>\n                    </uib-accordion-heading>\n                    <div>\n                        <div ng-repeat=\"(key, config) in $ctrl.getSectionConfigSchema($ctrl.context.getCurrentElement().type) track by key\" ng-if=\"config.group === element.type\">\n\n                            <cms-input-number\n                                    ng-if=\"config.type === 'number'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    units=\"config.units\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-number>\n\n                            <cms-input-text\n                                    ng-if=\"config.type === 'text'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    placeholder=\"{{ (config.placeholder || config.label) | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-text>\n\n                            <cms-input-select\n                                    ng-if=\"config.type === 'select'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    options=\"config.options\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-select>\n\n                            <cms-input-object-select\n                                    ng-if=\"config.type === 'object-select'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    options=\"config.options\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    validator=\"config.validator($ctrl.context.getCurrentElement().config)\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-object-select>\n\n                            <cms-input-align\n                                    ng-if=\"config.type === 'align'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-align>\n                            <cms-input-media\n                                    ng-if=\"config.type === 'media'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    options=\"config.options\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-media>\n\n                            <cms-input-color\n                                    ng-if=\"config.type === 'color'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-color>\n\n                            <cms-input-selection-buttons\n                                    ng-if=\"config.type === 'selectionButtons'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    options=\"config.options\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\"\n                            >\n                            </cms-input-selection-buttons>\n\n                            <cms-input-checkbox\n                                    ng-if=\"config.type === 'checkbox'\"\n                                    label=\"{{config.label | translate}}\"\n                                    helper=\"{{config.helper}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"10\"\n                                    input-size=\"2\"\n                                    validator=\"config.validator($ctrl.context.getCurrentElement().config)\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-checkbox>\n\n                            <cms-input-textarea\n                                    ng-if=\"config.type === 'textarea'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{ (config.placeholder || config.label) | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-textarea>\n\n                            <cms-input-options\n                                    ng-if=\"config.type === 'options'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{config.placeholder | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-options>\n\n                            <cms-input-edit-form\n                                    ng-if=\"config.type === 'edit-form'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{config.placeholder | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    input-size=\"8\"\n                                    model=\"$ctrl.context.getCurrentElement().config\">\n                            </cms-input-edit-form>\n\n                            <cms-input-columns\n                                    ng-if=\"config.type === 'columns'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{config.placeholder | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    helper=\"{{config.helper}}\"\n                                    input-size=\"8\"\n                                    options=\"config.options\"\n                                    model=\"$ctrl.context.getCurrentElement().config\">\n                            </cms-input-columns>\n\n                            <cms-input-menu\n                                    ng-if=\"config.type === 'menu'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{config.placeholder | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    label-size=\"4\"\n                                    helper=\"{{config.helper}}\"\n                                    input-size=\"8\"\n                                    options=\"$ctrl.options\"\n                                    model=\"$ctrl.model.content\">\n                            </cms-input-menu>\n\n                            <cms-input-button-link\n                                    ng-if=\"config.type === 'button-link'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{config.placeholder | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    helper=\"{{config.helper}}\"\n                                    options=\"$ctrl.options\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-button-link>\n\n                            <cms-input-video\n                                    ng-if=\"config.type === 'video'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{config.placeholder | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    helper=\"{{config.helper}}\"\n                                    model=\"$ctrl.context.getCurrentElement().config\">\n                            </cms-input-video>\n\n                            <cms-input-map-address\n                                    ng-if=\"config.type === 'map-address'\"\n                                    label=\"{{config.label | translate}}\"\n                                    placeholder=\"{{config.placeholder | translate}}\"\n                                    acl-disable=\"config.aclDisable\"\n                                    helper=\"{{config.helper}}\"\n                                    options=\"$ctrl.options\"\n                                    model=\"$ctrl.context.getCurrentElement().config[key]\">\n                            </cms-input-map-address>\n                        </div>\n                    </div>\n                </div>\n            </uib-accordion>\n        </form>\n\n    </div>\n\n    <div ng-if=\"!$ctrl.isCurrentElement()\">\n        <ng-transclude></ng-transclude>\n    </div>\n\n</div>";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _DnDGuard = __webpack_require__(1110);

var _DnDGuard2 = _interopRequireDefault(_DnDGuard);

var _ContentGuardService = __webpack_require__(169);

var _ContentGuardService2 = _interopRequireDefault(_ContentGuardService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER_HEIGHT = 36;
var SCROLL_ZONE_HEIGHT = 35;

var creatorSectionsLibrary = {
  bindings: {
    group: '@',
    context: '<'
  },
  template: __webpack_require__(1112),
  controller: ['$scope', '$rootScope', 'dragulaService', 'SectionsLibraryService', 'ContentGuardService', function controller($scope, $rootScope, dragulaService, SectionsLibraryService, ContentGuardService) {
    var _this = this;

    /** @ngInject() */

    this.$onInit = function () {
      _this.sections = SectionsLibraryService.getSections(_this.group);
      _this.dragularScope = _this.context.getDragularScope();
      _this.dndGuard = new _DnDGuard2.default();

      if (!dragulaService.find(_this.dragularScope, _this.dndGuard.sectionsLibraryClass)) {
        dragulaService.options(_this.dragularScope, _this.dndGuard.sectionsLibraryClass, {
          revertOnSpill: true,
          direction: 'vertical',
          moves: function moves(el, source, handle) {

            var sectionType = _this.dndGuard.getSectionType(el);
            if (_this.isSectionDisabled(sectionType, true)) {
              return false;
            }

            return _this.dndGuard.isMovable(el, handle);
          },
          accepts: function accepts(el, target) {
            return _this.dndGuard.isAcceptable(el, target);
          },
          copy: function copy(el) {
            return _this.dndGuard.isSectionElement(el);
          }
        });

        _this.dragularScope.$on('sections-library.drop', function (el, target, source) {
          if (_this.dndGuard.hasSectionElementClass(target)) {
            $(target).css('display', 'none');
          }
        });

        _this.dragularScope.$on('sections-library.drag', function (el, target, source) {
          document.documentElement.addEventListener('mousemove', scrollFn);
        });

        _this.dragularScope.$on('sections-library.dragend', function (el, target, source) {
          document.documentElement.removeEventListener('mousemove', scrollFn);
          clearInterval(timer);
        });
      }
    };

    this.isSectionDisabled = function (sectionType, showAlert) {
      return ContentGuardService.checkIsLocked(sectionType, showAlert);
    };

    var height = window.innerHeight;
    var timer = null;

    var scrollFn = function scrollFn(e) {
      if (timer) {
        clearInterval(timer);
      }

      var fn = function fn() {
        if (e.clientY > height - SCROLL_ZONE_HEIGHT) {
          document.documentElement.scrollTop += 10;
        } else if (e.clientY < HEADER_HEIGHT + SCROLL_ZONE_HEIGHT) {
          document.documentElement.scrollTop -= 10;
        }
      };

      fn();
      timer = setInterval(fn, 20);
    };
  }]
};

exports.default = _angular2.default.module('cms.creator.sections-library', [_SectionsLibraryService2.default, _ContentGuardService2.default]).component('creatorSectionsLibrary', creatorSectionsLibrary).name;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DnDGuard = function () {
    function DnDGuard() {
        _classCallCheck(this, DnDGuard);

        this.sectionsLibraryClass = 'sections-library';
        this.sectionElementPageClass = 'creator-sections-element__section-pageSection';
        this.sectionPageClass = 'creator-workspace__section-pageSection';
        this.typeBagClass = 'creator-workspace__type-bag';
        this.typeWorkSpaceClass = 'creator-workspace__type-workspace';
        this.guTransitClass = 'gu-transit';
        this.creatorSectionElementClass = 'creator-sections-element';
        this.contenteditableSelector = '[contenteditable="true"]';
        this.sectionTypeAttr = 'section-type';
        this.columnResizeHandlerClass = 'column-resizer__handler';
    }

    _createClass(DnDGuard, [{
        key: 'isColumnResizeHandler',
        value: function isColumnResizeHandler(handler) {
            return handler.classList.contains(this.columnResizeHandlerClass);
        }
    }, {
        key: 'isMovable',
        value: function isMovable(el, handler) {

            var isContentEditable = this.isContenteditable(el);
            var isColumnResizeHandler = this.isColumnResizeHandler(handler);

            return !isContentEditable && !isColumnResizeHandler;
        }
    }, {
        key: 'isAcceptable',
        value: function isAcceptable(el, target) {
            var toWorkspace = this.isTypeWorkspace(target);
            var toBag = this.isTypeBag(target);
            var isBag = this.isSectionPageInSectionLibrary(el) || // TODO: change type based (page.section) to isBag class
            this.isPageSection(el);

            var isDraggingNow = this.isTransit(target);
            return (toWorkspace || toBag && !isBag) && !isDraggingNow;
        }
    }, {
        key: 'getSectionType',
        value: function getSectionType(el) {
            return $(el).attr(this.sectionTypeAttr);
        }
    }, {
        key: 'isContenteditable',
        value: function isContenteditable(el) {
            return $(el).has(this.contenteditableSelector).length !== 0;
        }
    }, {
        key: 'isTypeBag',
        value: function isTypeBag(el) {
            return el.classList.contains(this.typeBagClass);
        }
    }, {
        key: 'isTypeWorkspace',
        value: function isTypeWorkspace(el) {
            return el.classList.contains(this.typeWorkSpaceClass);
        }
    }, {
        key: 'isSectionPageInSectionLibrary',
        value: function isSectionPageInSectionLibrary(el) {
            return el.classList.contains(this.sectionElementPageClass);
        }
    }, {
        key: 'isPageSection',
        value: function isPageSection(el) {
            return el.classList.contains(this.sectionPageClass);
        }
    }, {
        key: 'isTransit',
        value: function isTransit(el) {
            return el.classList.contains(this.guTransitClass);
        }
    }, {
        key: 'hasSectionElementClass',
        value: function hasSectionElementClass(el) {
            return $(el).hasClass(this.creatorSectionElementClass);
        }
    }, {
        key: 'isSectionElement',
        value: function isSectionElement(el) {
            return el.classList.contains(this.creatorSectionElementClass);
        }
    }]);

    return DnDGuard;
}();

exports.default = DnDGuard;

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-danger\">\n        <em class=\"fa fa-warning\"></em><span style=\"margin-left: 10px;\" translate>Warning</span>\n    </div>\n    <div class=\"modal-body text-center\"><p translate>You can't add more than one section of this type.</p></div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" translate>OK</button>\n    </div>\n</div>";

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = "<div id=\"source-modules\"\n     class=\"creator-sections-list\"\n     dragula=\"'sections-library'\"\n     dragula-scope=\"$ctrl.dragularScope\"\n     dragula-model=\"$ctrl.sections\"\n>\n    <div class=\"creator-sections-element creator-sections-element__section-{{section.type}}\"\n         ng-class=\"{'creator-sections-element__disabled': $ctrl.isSectionDisabled(section.type)}\"\n         section-type=\"{{section.type}}\"\n         ng-repeat=\"section in $ctrl.sections\">\n        <div class=\"library-element library-element-{{section.type}}\" uib-tooltip=\"{{ section.label | translate }}\" tooltip-placement=\"bottom\">\n            <em class=\"material-icons\">{{ section.icon }}</em>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _text = __webpack_require__(1114);

var _text2 = _interopRequireDefault(_text);

__webpack_require__(1115);

var _MjmlTemplateExtractor = __webpack_require__(118);

var _MjmlTemplateExtractor2 = _interopRequireDefault(_MjmlTemplateExtractor);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _TextContent = __webpack_require__(239);

var _TextContent2 = _interopRequireDefault(_TextContent);

var _Backgrounds = __webpack_require__(119);

var _Backgrounds2 = _interopRequireDefault(_Backgrounds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorMailSectionText = {
    bindings: {
        elementModel: '='
    },
    template: (0, _MjmlTemplateExtractor2.default)(_text2.default),
    controller: ["ToolbarService", function controller(ToolbarService) {
        var _this = this;

        this.editorOptions = {
            toolbar: [{ name: 'styles', items: ['Format', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat'] }, '/', { name: 'links', items: ['Link', 'Unlink'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', '-', 'CmsCustomPlaceholder'] }]
        };

        var defaultConfig = ToolbarService.getSectionDefaultSchema('text');

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.mail.section-text', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["SectionsLibraryService", "ToolbarService", "gettext", function (SectionsLibraryService, ToolbarService, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'text_fields',
        type: 'text',
        label: gettext('Text'),
        group: 'mail',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            }
        }
    });

    ToolbarService.registerSectionSchema('text', _extends({}, new _TextContent2.default(), new _TextColor2.default(), new _Backgrounds2.default(), new _Paddings2.default({ value: 15, unit: 'px' }, { value: 30, unit: 'px' }, ['px'])));
}]).component('cmsCreatorMailSectionText', creatorMailSectionText).name;

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports = "\n    <!doctype html>\n    <html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n      <head>\n        <title>\n          \n        </title>\n        <!--[if !mso]><!-- -->\n        <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n        <!--<![endif]-->\n        <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <style type=\"text/css\">\n          #outlook a { padding:0; }\n          .ReadMsgBody { width:100%; }\n          .ExternalClass { width:100%; }\n          .ExternalClass * { line-height:100%; }\n          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n          p { display:block;margin:13px 0; }\n        </style>\n        <!--[if !mso]><!-->\n        <style type=\"text/css\">\n          @media only screen and (max-width:480px) {\n            @-ms-viewport { width:320px; }\n            @viewport { width:320px; }\n          }\n        </style>\n        <!--<![endif]-->\n        <!--[if mso]>\n        <xml>\n        <o:OfficeDocumentSettings>\n          <o:AllowPNG/>\n          <o:PixelsPerInch>96</o:PixelsPerInch>\n        </o:OfficeDocumentSettings>\n        </xml>\n        <![endif]-->\n        <!--[if lte mso 11]>\n        <style type=\"text/css\">\n          .outlook-group-fix { width:100% !important; }\n        </style>\n        <![endif]-->\n        \n      <!--[if !mso]><!-->\n        <link href=\"https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700\" rel=\"stylesheet\" type=\"text/css\">\n        <style type=\"text/css\">\n          @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);\n        </style>\n      <!--<![endif]-->\n\n    \n        \n    <style type=\"text/css\">\n      @media only screen and (min-width:480px) {\n        .mj-column-per-100 { width:100% !important; max-width: 100%; }\n      }\n    </style>\n    \n  \n        <style type=\"text/css\">\n        \n        \n        </style>\n        \n      </head>\n      <body>\n        \n        \n      <div\n        \n      >\n        \n      \n      <!--[if mso | IE]>\n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:600px;\" width=\"600\"\n      >\n        <tr>\n          <td style=\"line-height:0px;font-size:0px;mso-line-height-rule:exactly;\">\n      \n        <v:rect  style=\"width:600px;\" xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"true\" stroke=\"false\">\n        <v:fill  origin=\"0.5, 0\" position=\"0.5, 0\" src=\"{{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}\" color=\"{{$ctrl.elementModel.backgroundColor}}\" type=\"tile\" />\n        <v:textbox style=\"mso-fit-shape-to-text:true\" inset=\"0,0,0,0\">\n      <![endif]-->\n          \n      <div  style=\"background:{{$ctrl.elementModel.backgroundColor}} url({{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}) top center / cover no-repeat;Margin:0px auto;max-width:600px;\">\n        <div  style=\"line-height:0;font-size:0;\">\n        <table\n           align=\"center\" background=\"{{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:{{$ctrl.elementModel.backgroundColor}} url({{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}) top center / cover no-repeat;width:100%;\"\n        >\n          <tbody>\n            <tr>\n              <td\n                 style=\"direction:ltr;font-size:0px;padding:20px 0;padding-bottom:{{$ctrl.elementModel.paddingBottom | numberWithUnit}};padding-left:{{$ctrl.elementModel.paddingLeft | numberWithUnit}};padding-right:{{$ctrl.elementModel.paddingRight | numberWithUnit}};padding-top:{{$ctrl.elementModel.paddingTop | numberWithUnit}};text-align:center;vertical-align:top;\"\n              >\n                <!--[if mso | IE]>\n                  <table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n                \n        <tr>\n      \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-100 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n            <tr>\n              <td\n                 align=\"left\" style=\"font-size:0px;padding:0 0 0 0;word-break:break-word;\"\n              >\n                \n      <div\n         style=\"font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:1;text-align:left;color:{{$ctrl.elementModel.color}};\"\n      >\n        \n                        <editor-inline\n                            options=\"$ctrl.editorOptions\"\n                            model=\"$ctrl.elementModel.text\">\n                        </editor-inline>\n                    \n                    \n                        <cms-creator-image-spinner ng-model=\"$ctrl.elementModel.backgroundImage\"></cms-creator-image-spinner>\n                    \n      </div>\n    \n              </td>\n            </tr>\n          \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n        </tr>\n      \n                  </table>\n                <![endif]-->\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        </div>\n      </div>\n    \n        <!--[if mso | IE]>\n        </v:textbox>\n      </v:rect>\n    \n          </td>\n        </tr>\n      </table>\n      <![endif]-->\n    \n    \n      </div>\n    \n      </body>\n    </html>\n  "

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingTop = function (_ConfigParameter) {
    _inherits(PaddingTop, _ConfigParameter);

    function PaddingTop() {
        _classCallCheck(this, PaddingTop);

        return _possibleConstructorReturn(this, (PaddingTop.__proto__ || Object.getPrototypeOf(PaddingTop)).call(this, 'paddingTop', 'number', (0, _ConfigParameter2.gettext)('Padding top'), 'position', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingTop;
}(_ConfigParameter3.default);

exports.default = PaddingTop;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingBottom = function (_ConfigParameter) {
    _inherits(PaddingBottom, _ConfigParameter);

    function PaddingBottom() {
        _classCallCheck(this, PaddingBottom);

        return _possibleConstructorReturn(this, (PaddingBottom.__proto__ || Object.getPrototypeOf(PaddingBottom)).call(this, 'paddingBottom', 'number', (0, _ConfigParameter2.gettext)('Padding bottom'), 'position', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingBottom;
}(_ConfigParameter3.default);

exports.default = PaddingBottom;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingLeft = function (_ConfigParameter) {
    _inherits(PaddingLeft, _ConfigParameter);

    function PaddingLeft() {
        _classCallCheck(this, PaddingLeft);

        return _possibleConstructorReturn(this, (PaddingLeft.__proto__ || Object.getPrototypeOf(PaddingLeft)).call(this, 'paddingLeft', 'number', (0, _ConfigParameter2.gettext)('Padding left'), 'position', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingLeft;
}(_ConfigParameter3.default);

exports.default = PaddingLeft;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingRight = function (_ConfigParameter) {
    _inherits(PaddingRight, _ConfigParameter);

    function PaddingRight() {
        _classCallCheck(this, PaddingRight);

        return _possibleConstructorReturn(this, (PaddingRight.__proto__ || Object.getPrototypeOf(PaddingRight)).call(this, 'paddingRight', 'number', (0, _ConfigParameter2.gettext)('Padding right'), 'position', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingRight;
}(_ConfigParameter3.default);

exports.default = PaddingRight;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundImage = function (_ConfigParameter) {
    _inherits(BackgroundImage, _ConfigParameter);

    function BackgroundImage() {
        _classCallCheck(this, BackgroundImage);

        return _possibleConstructorReturn(this, (BackgroundImage.__proto__ || Object.getPrototypeOf(BackgroundImage)).call(this, 'backgroundImage', 'media', (0, _ConfigParameter2.gettext)('Background image'), 'mainConfig', []));
    }

    return BackgroundImage;
}(_ConfigParameter3.default);

exports.default = BackgroundImage;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _divider = __webpack_require__(1122);

var _divider2 = _interopRequireDefault(_divider);

__webpack_require__(1123);

var _MjmlTemplateExtractor = __webpack_require__(118);

var _MjmlTemplateExtractor2 = _interopRequireDefault(_MjmlTemplateExtractor);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _LineStyle = __webpack_require__(441);

var _LineStyle2 = _interopRequireDefault(_LineStyle);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _LineSize = __webpack_require__(442);

var _LineSize2 = _interopRequireDefault(_LineSize);

var _Color = __webpack_require__(170);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorMailSectionDivider = {
    bindings: {
        elementModel: '='
    },
    template: (0, _MjmlTemplateExtractor2.default)(_divider2.default),
    controller: ['ToolbarService', function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema('divider');

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.mail.section-divider', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', function (SectionsLibraryService, ToolbarService, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'remove',
        type: 'divider',
        label: gettext('Division'),
        group: 'mail',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            }
        }
    });

    var color = new _Color2.default();
    color.setDefaultValue('#000000');
    ToolbarService.registerSectionSchema('divider', _extends({}, new _LineSize2.default(), new _LineStyle2.default(), color, new _BackgroundColor2.default(), new _Paddings2.default({ value: 20, unit: 'px' }, { value: 30, unit: 'px' }, ['px'])));
}]).component('cmsCreatorMailSectionDivider', creatorMailSectionDivider).name;

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports = "\n    <!doctype html>\n    <html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n      <head>\n        <title>\n          \n        </title>\n        <!--[if !mso]><!-- -->\n        <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n        <!--<![endif]-->\n        <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <style type=\"text/css\">\n          #outlook a { padding:0; }\n          .ReadMsgBody { width:100%; }\n          .ExternalClass { width:100%; }\n          .ExternalClass * { line-height:100%; }\n          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n          p { display:block;margin:13px 0; }\n        </style>\n        <!--[if !mso]><!-->\n        <style type=\"text/css\">\n          @media only screen and (max-width:480px) {\n            @-ms-viewport { width:320px; }\n            @viewport { width:320px; }\n          }\n        </style>\n        <!--<![endif]-->\n        <!--[if mso]>\n        <xml>\n        <o:OfficeDocumentSettings>\n          <o:AllowPNG/>\n          <o:PixelsPerInch>96</o:PixelsPerInch>\n        </o:OfficeDocumentSettings>\n        </xml>\n        <![endif]-->\n        <!--[if lte mso 11]>\n        <style type=\"text/css\">\n          .outlook-group-fix { width:100% !important; }\n        </style>\n        <![endif]-->\n        \n        \n    <style type=\"text/css\">\n      @media only screen and (min-width:480px) {\n        .mj-column-per-100 { width:100% !important; max-width: 100%; }\n      }\n    </style>\n    \n  \n        <style type=\"text/css\">\n        \n        \n        </style>\n        \n      </head>\n      <body>\n        \n        \n      <div\n        \n      >\n        \n      \n      <!--[if mso | IE]>\n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"creator-section-divider-outlook\" style=\"width:600px;\" width=\"600\"\n      >\n        <tr>\n          <td style=\"line-height:0px;font-size:0px;mso-line-height-rule:exactly;\">\n      <![endif]-->\n    \n      \n      <div  class=\"creator-section-divider\" style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};Margin:0px auto;max-width:600px;\">\n        \n        <table\n           align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};width:100%;\"\n        >\n          <tbody>\n            <tr>\n              <td\n                 style=\"direction:ltr;font-size:0px;padding:20px 0;padding-bottom:{{$ctrl.elementModel.paddingBottom | numberWithUnit}};padding-left:{{$ctrl.elementModel.paddingLeft | numberWithUnit}};padding-right:{{$ctrl.elementModel.paddingRight | numberWithUnit}};padding-top:{{$ctrl.elementModel.paddingTop | numberWithUnit}};text-align:center;vertical-align:top;\"\n              >\n                <!--[if mso | IE]>\n                  <table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n                \n        <tr>\n      \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-100 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n            <tr>\n              <td\n                 style=\"font-size:0px;padding:0 0 0 0;word-break:break-word;\"\n              >\n                \n      <p\n         style=\"border-top:{{$ctrl.elementModel.style }} {{$ctrl.elementModel.size | numberWithUnit }} {{$ctrl.elementModel.color }};font-size:1;margin:0px auto;width:100%;\"\n      >\n      </p>\n      \n      <!--[if mso | IE]>\n        <table\n           align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"border-top:{{$ctrl.elementModel.style }} {{$ctrl.elementModel.size | numberWithUnit }} {{$ctrl.elementModel.color }};font-size:1;margin:0px auto;width:NaNpx;\" role=\"presentation\" width=\"NaNpx\"\n        >\n          <tr>\n            <td style=\"height:0;line-height:0;\">\n              &nbsp;\n            </td>\n          </tr>\n        </table>\n      <![endif]-->\n    \n    \n              </td>\n            </tr>\n          \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n        </tr>\n      \n                  </table>\n                <![endif]-->\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        \n      </div>\n    \n      \n      <!--[if mso | IE]>\n          </td>\n        </tr>\n      </table>\n      <![endif]-->\n    \n    \n      </div>\n    \n      </body>\n    </html>\n  "

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _MjmlTemplateExtractor = __webpack_require__(118);

var _MjmlTemplateExtractor2 = _interopRequireDefault(_MjmlTemplateExtractor);

var _image = __webpack_require__(1125);

var _image2 = _interopRequireDefault(_image);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _Image = __webpack_require__(240);

var _Image2 = _interopRequireDefault(_Image);

var _Link = __webpack_require__(241);

var _Link2 = _interopRequireDefault(_Link);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorMailSectionImage = {
    bindings: {
        elementModel: '='
    },
    template: (0, _MjmlTemplateExtractor2.default)(_image2.default),
    controller: ['ToolbarService', function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema('image');

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        $('td > a').on('click', function (e) {
            e.preventDefault();
        });
    }]

};

exports.default = _angular2.default.module('cms.creator.mail.section-image', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', function (SectionsLibraryService, ToolbarService, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'image',
        type: 'image',
        label: gettext('Image'),
        group: 'mail',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            }
        }
    });

    ToolbarService.registerSectionSchema('image', _extends({}, new _Image2.default(), new _Link2.default(), new _BackgroundColor2.default(), new _Paddings2.default({ value: 0, unit: 'px' }, { value: 0, unit: 'px' }, ['px'])));
}]).component('cmsCreatorMailSectionImage', creatorMailSectionImage).name;

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports = "\n    <!doctype html>\n    <html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n      <head>\n        <title>\n          \n        </title>\n        <!--[if !mso]><!-- -->\n        <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n        <!--<![endif]-->\n        <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <style type=\"text/css\">\n          #outlook a { padding:0; }\n          .ReadMsgBody { width:100%; }\n          .ExternalClass { width:100%; }\n          .ExternalClass * { line-height:100%; }\n          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n          p { display:block;margin:13px 0; }\n        </style>\n        <!--[if !mso]><!-->\n        <style type=\"text/css\">\n          @media only screen and (max-width:480px) {\n            @-ms-viewport { width:320px; }\n            @viewport { width:320px; }\n          }\n        </style>\n        <!--<![endif]-->\n        <!--[if mso]>\n        <xml>\n        <o:OfficeDocumentSettings>\n          <o:AllowPNG/>\n          <o:PixelsPerInch>96</o:PixelsPerInch>\n        </o:OfficeDocumentSettings>\n        </xml>\n        <![endif]-->\n        <!--[if lte mso 11]>\n        <style type=\"text/css\">\n          .outlook-group-fix { width:100% !important; }\n        </style>\n        <![endif]-->\n        \n        \n    <style type=\"text/css\">\n      @media only screen and (min-width:480px) {\n        .mj-column-per-100 { width:100% !important; max-width: 100%; }\n      }\n    </style>\n    \n  \n        <style type=\"text/css\">\n        \n        \n        </style>\n        \n      </head>\n      <body>\n        \n        \n      <div\n        \n      >\n        \n      \n      <!--[if mso | IE]>\n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:600px;\" width=\"600\"\n      >\n        <tr>\n          <td style=\"line-height:0px;font-size:0px;mso-line-height-rule:exactly;\">\n      <![endif]-->\n    \n      \n      <div  style=\"background:{{ $ctrl.elementModel.backgroundColor }};background-color:{{ $ctrl.elementModel.backgroundColor }};Margin:0px auto;max-width:600px;\">\n        \n        <table\n           align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:{{ $ctrl.elementModel.backgroundColor }};background-color:{{ $ctrl.elementModel.backgroundColor }};width:100%;\"\n        >\n          <tbody>\n            <tr>\n              <td\n                 style=\"direction:ltr;font-size:0px;padding:20px 0;padding-bottom:{{ $ctrl.elementModel.paddingBottom | numberWithUnit }};padding-left:{{ $ctrl.elementModel.paddingLeft | numberWithUnit }};padding-right:{{ $ctrl.elementModel.paddingRight | numberWithUnit }};padding-top:{{ $ctrl.elementModel.paddingTop | numberWithUnit }};text-align:center;vertical-align:top;\"\n              >\n                <!--[if mso | IE]>\n                  <table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n                \n        <tr>\n      \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-100 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n                        <div ng-if=\"$ctrl.elementModel.image.length\">\n                    \n            <tr>\n              <td\n                 align=\"center\" style=\"font-size:0px;padding:0 0 0 0;word-break:break-word;\"\n              >\n                \n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"border-collapse:collapse;border-spacing:0px;\"\n      >\n        <tbody>\n          <tr>\n            <td  style=\"width:NaNNaN;\">\n              \n        <a\n           href=\"{{ $ctrl.elementModel.link }}\" target=\"_blank\"\n        >\n          \n      <img\n         height=\"auto\" src=\"{{$ctrl.elementModel.image[0].media | imageUrl }}\" style=\"border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;\"\n      />\n    \n        </a>\n      \n            </td>\n          </tr>\n        </tbody>\n      </table>\n    \n              </td>\n            </tr>\n          \n                        </div>\n                    \n                        <media-placeholder ng-if=\"!$ctrl.elementModel.image.length\" model=\"$ctrl.elementModel.image\"></media-placeholder>\n                    \n                <cms-creator-image-spinner ng-model=\"$ctrl.elementModel.image\"></cms-creator-image-spinner>\n                \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n        </tr>\n      \n                  </table>\n                <![endif]-->\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        \n      </div>\n    \n      \n      <!--[if mso | IE]>\n          </td>\n        </tr>\n      </table>\n      <![endif]-->\n    \n    \n      </div>\n    \n      </body>\n    </html>\n  "

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _social = __webpack_require__(1127);

var _social2 = _interopRequireDefault(_social);

__webpack_require__(1128);

var _MjmlTemplateExtractor = __webpack_require__(118);

var _MjmlTemplateExtractor2 = _interopRequireDefault(_MjmlTemplateExtractor);

var _FacebookUrl = __webpack_require__(443);

var _FacebookUrl2 = _interopRequireDefault(_FacebookUrl);

var _GooglePlusUrl = __webpack_require__(444);

var _GooglePlusUrl2 = _interopRequireDefault(_GooglePlusUrl);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _LinkedInUrl = __webpack_require__(445);

var _LinkedInUrl2 = _interopRequireDefault(_LinkedInUrl);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _InstagramUrl = __webpack_require__(446);

var _InstagramUrl2 = _interopRequireDefault(_InstagramUrl);

var _TwitterUrl = __webpack_require__(447);

var _TwitterUrl2 = _interopRequireDefault(_TwitterUrl);

var _PinterestUrl = __webpack_require__(448);

var _PinterestUrl2 = _interopRequireDefault(_PinterestUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorMailSectionSocial = {
    bindings: {
        elementModel: '='
    },
    template: (0, _MjmlTemplateExtractor2.default)(_social2.default),
    controller: ['ToolbarService', 'gettextCatalog', '$element', function controller(ToolbarService, gettextCatalog, $element) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema('social');

        $element.find('a').on('click', function (e) {
            e.preventDefault();
        });

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
            _this.placeholderText = gettextCatalog.getString('Click to set module options', null, "Creator section module placeholder");
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.mail.section-social', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', function (SectionsLibraryService, ToolbarService, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'group',
        type: 'social',
        label: gettext('Social'),
        group: 'mail',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            }
        }
    });
    //facebook google instagram pinterest linkedin twitter
    ToolbarService.registerSectionSchema('social', _extends({}, new _FacebookUrl2.default(), new _GooglePlusUrl2.default(), new _LinkedInUrl2.default(), new _InstagramUrl2.default(), new _TwitterUrl2.default(), new _PinterestUrl2.default(), new _Align2.default(), new _BackgroundColor2.default(), new _Paddings2.default({ value: 15, unit: 'px' }, { value: 30, unit: 'px' }, ['px'])));
}]).component('cmsCreatorMailSectionSocial', creatorMailSectionSocial).name;

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports = "\n    <!doctype html>\n    <html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n      <head>\n        <title>\n          \n        </title>\n        <!--[if !mso]><!-- -->\n        <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n        <!--<![endif]-->\n        <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <style type=\"text/css\">\n          #outlook a { padding:0; }\n          .ReadMsgBody { width:100%; }\n          .ExternalClass { width:100%; }\n          .ExternalClass * { line-height:100%; }\n          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n          p { display:block;margin:13px 0; }\n        </style>\n        <!--[if !mso]><!-->\n        <style type=\"text/css\">\n          @media only screen and (max-width:480px) {\n            @-ms-viewport { width:320px; }\n            @viewport { width:320px; }\n          }\n        </style>\n        <!--<![endif]-->\n        <!--[if mso]>\n        <xml>\n        <o:OfficeDocumentSettings>\n          <o:AllowPNG/>\n          <o:PixelsPerInch>96</o:PixelsPerInch>\n        </o:OfficeDocumentSettings>\n        </xml>\n        <![endif]-->\n        <!--[if lte mso 11]>\n        <style type=\"text/css\">\n          .outlook-group-fix { width:100% !important; }\n        </style>\n        <![endif]-->\n        \n        \n    <style type=\"text/css\">\n      @media only screen and (min-width:480px) {\n        .mj-column-per-100 { width:100% !important; max-width: 100%; }\n      }\n    </style>\n    \n  \n        <style type=\"text/css\">\n        \n        \n        </style>\n        \n      </head>\n      <body>\n        \n        \n      <div\n        \n      >\n        \n      \n      <!--[if mso | IE]>\n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:600px;\" width=\"600\"\n      >\n        <tr>\n          <td style=\"line-height:0px;font-size:0px;mso-line-height-rule:exactly;\">\n      <![endif]-->\n    \n      \n      <div  style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};Margin:0px auto;max-width:600px;\">\n        \n        <table\n           align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};width:100%;\"\n        >\n          <tbody>\n            <tr>\n              <td\n                 style=\"direction:ltr;font-size:0px;padding:20px 0;padding-bottom:{{$ctrl.elementModel.paddingBottom | numberWithUnit}};padding-left:{{$ctrl.elementModel.paddingLeft | numberWithUnit}};padding-right:{{$ctrl.elementModel.paddingRight | numberWithUnit}};padding-top:{{$ctrl.elementModel.paddingTop | numberWithUnit}};text-align:center;vertical-align:top;\"\n              >\n                <!--[if mso | IE]>\n                  <table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n                \n        <tr>\n      \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-100 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" width=\"100%\"\n      >\n        <tbody>\n          <tr>\n            <td  style=\"vertical-align:top;padding:0 0 0 0;\">\n              \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" width=\"100%\"\n      >\n        \n            <tr>\n              <td\n                 align=\"{{$ctrl.elementModel.align}}\" style=\"font-size:0px;padding:0 0 0 0;word-break:break-word;\"\n              >\n                \n      \n     <!--[if mso | IE]>\n      <table\n         align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\"\n      >\n        <tr>\n      \n              <td>\n            <![endif]-->\n              <table\n                 align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"float:none;display:inline-table;\"\n              >\n                \n                        <div\n                            class=\"creator-workspace__placeholder-text\"\n                            ng-show=\"\n                                !$ctrl.elementModel.facebookUrl &&\n                                !$ctrl.elementModel.googlePlusUrl &&\n                                !$ctrl.elementModel.linkedInUrl &&\n                                !$ctrl.elementModel.instagramUrl &&\n                                !$ctrl.elementModel.twitterUrl &&\n                                !$ctrl.elementModel.pinterestUrl\">\n                                {{ $ctrl.placeholderText }}\n                        </div>\n                    \n              </table>\n            <!--[if mso | IE]>\n              </td>\n            \n              <td>\n            <![endif]-->\n              <table\n                 align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"float:none;display:inline-table;\"\n              >\n                \n      <tr\n         class=\"{{$ctrl.elementModel.facebookUrl?'':'ng-hide'}}\"\n      >\n        <td  style=\"padding:4px;\">\n          <table\n             border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:#3b5998;border-radius:3px;width:26px;\"\n          >\n            <tr>\n              <td  style=\"font-size:0;height:26px;vertical-align:middle;width:26px;\">\n                <a  href=\"https://www.facebook.com/sharer/sharer.php?u={{$ctrl.elementModel.facebookUrl}}\" target=\"_blank\">\n                    <img\n                       height=\"26\" src=\"https://www.mailjet.com/images/theme/v1/icons/ico-social/facebook.png\" style=\"border-radius:3px;\" width=\"26\"\n                    />\n                  </a>\n                </td>\n              </tr>\n          </table>\n        </td>\n          \n      </tr>\n    \n              </table>\n            <!--[if mso | IE]>\n              </td>\n            \n              <td>\n            <![endif]-->\n              <table\n                 align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"float:none;display:inline-table;\"\n              >\n                \n      <tr\n         class=\"{{$ctrl.elementModel.googlePlusUrl?'':'ng-hide'}}\"\n      >\n        <td  style=\"padding:4px;\">\n          <table\n             border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:#dc4e41;border-radius:3px;width:26px;\"\n          >\n            <tr>\n              <td  style=\"font-size:0;height:26px;vertical-align:middle;width:26px;\">\n                <a  href=\"https://plus.google.com/share?url={{$ctrl.elementModel.googlePlusUrl}}\" target=\"_blank\">\n                    <img\n                       height=\"26\" src=\"https://www.mailjet.com/images/theme/v1/icons/ico-social/google-plus.png\" style=\"border-radius:3px;\" width=\"26\"\n                    />\n                  </a>\n                </td>\n              </tr>\n          </table>\n        </td>\n          \n      </tr>\n    \n              </table>\n            <!--[if mso | IE]>\n              </td>\n            \n              <td>\n            <![endif]-->\n              <table\n                 align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"float:none;display:inline-table;\"\n              >\n                \n      <tr\n         class=\"{{$ctrl.elementModel.linkedInUrl?'':'ng-hide'}}\"\n      >\n        <td  style=\"padding:4px;\">\n          <table\n             border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:#0077b5;border-radius:3px;width:26px;\"\n          >\n            <tr>\n              <td  style=\"font-size:0;height:26px;vertical-align:middle;width:26px;\">\n                <a  href=\"https://www.linkedin.com/shareArticle?mini=true&url={{$ctrl.elementModel.linkedInUrl}}&title=&summary=&source=\" target=\"_blank\">\n                    <img\n                       height=\"26\" src=\"https://www.mailjet.com/images/theme/v1/icons/ico-social/linkedin.png\" style=\"border-radius:3px;\" width=\"26\"\n                    />\n                  </a>\n                </td>\n              </tr>\n          </table>\n        </td>\n          \n      </tr>\n    \n              </table>\n            <!--[if mso | IE]>\n              </td>\n            \n              <td>\n            <![endif]-->\n              <table\n                 align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"float:none;display:inline-table;\"\n              >\n                \n      <tr\n         class=\"{{$ctrl.elementModel.instagramUrl?'':'ng-hide'}}\"\n      >\n        <td  style=\"padding:4px;\">\n          <table\n             border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:#3f729b;border-radius:3px;width:26px;\"\n          >\n            <tr>\n              <td  style=\"font-size:0;height:26px;vertical-align:middle;width:26px;\">\n                <a  href=\"{{$ctrl.elementModel.instagramUrl}}\" target=\"_blank\">\n                    <img\n                       height=\"26\" src=\"https://www.mailjet.com/images/theme/v1/icons/ico-social/instagram.png\" style=\"border-radius:3px;\" width=\"26\"\n                    />\n                  </a>\n                </td>\n              </tr>\n          </table>\n        </td>\n          \n      </tr>\n    \n              </table>\n            <!--[if mso | IE]>\n              </td>\n            \n              <td>\n            <![endif]-->\n              <table\n                 align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"float:none;display:inline-table;\"\n              >\n                \n      <tr\n         class=\"{{$ctrl.elementModel.twitterUrl?'':'ng-hide'}}\"\n      >\n        <td  style=\"padding:4px;\">\n          <table\n             border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:#55acee;border-radius:3px;width:26px;\"\n          >\n            <tr>\n              <td  style=\"font-size:0;height:26px;vertical-align:middle;width:26px;\">\n                <a  href=\"https://twitter.com/home?status={{$ctrl.elementModel.twitterUrl}}\" target=\"_blank\">\n                    <img\n                       height=\"26\" src=\"https://www.mailjet.com/images/theme/v1/icons/ico-social/twitter.png\" style=\"border-radius:3px;\" width=\"26\"\n                    />\n                  </a>\n                </td>\n              </tr>\n          </table>\n        </td>\n          \n      </tr>\n    \n              </table>\n            <!--[if mso | IE]>\n              </td>\n            \n              <td>\n            <![endif]-->\n              <table\n                 align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"float:none;display:inline-table;\"\n              >\n                \n      <tr\n         class=\"{{$ctrl.elementModel.pinterestUrl?'':'ng-hide'}}\"\n      >\n        <td  style=\"padding:4px;\">\n          <table\n             border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:#bd081c;border-radius:3px;width:26px;\"\n          >\n            <tr>\n              <td  style=\"font-size:0;height:26px;vertical-align:middle;width:26px;\">\n                <a  href=\"https://pinterest.com/pin/create/button/?url={{$ctrl.elementModel.pinterestUrl}}&media=&description=\" target=\"_blank\">\n                    <img\n                       height=\"26\" src=\"https://www.mailjet.com/images/theme/v1/icons/ico-social/pinterest.png\" style=\"border-radius:3px;\" width=\"26\"\n                    />\n                  </a>\n                </td>\n              </tr>\n          </table>\n        </td>\n          \n      </tr>\n    \n              </table>\n            <!--[if mso | IE]>\n              </td>\n            \n          </tr>\n        </table>\n      <![endif]-->\n    \n    \n              </td>\n            </tr>\n          \n      </table>\n    \n            </td>\n          </tr>\n        </tbody>\n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n        </tr>\n      \n                  </table>\n                <![endif]-->\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        \n      </div>\n    \n      \n      <!--[if mso | IE]>\n          </td>\n        </tr>\n      </table>\n      <![endif]-->\n    \n    \n      </div>\n    \n      </body>\n    </html>\n  "

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _button = __webpack_require__(1130);

var _button2 = _interopRequireDefault(_button);

var _MjmlTemplateExtractor = __webpack_require__(118);

var _MjmlTemplateExtractor2 = _interopRequireDefault(_MjmlTemplateExtractor);

var _BorderRadius = __webpack_require__(449);

var _BorderRadius2 = _interopRequireDefault(_BorderRadius);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _Backgrounds = __webpack_require__(119);

var _Backgrounds2 = _interopRequireDefault(_Backgrounds);

var _BackgroundButtonColor = __webpack_require__(450);

var _BackgroundButtonColor2 = _interopRequireDefault(_BackgroundButtonColor);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _Color = __webpack_require__(170);

var _Color2 = _interopRequireDefault(_Color);

var _Link = __webpack_require__(241);

var _Link2 = _interopRequireDefault(_Link);

var _ButtonText = __webpack_require__(451);

var _ButtonText2 = _interopRequireDefault(_ButtonText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorMailSectionButton = {
    bindings: {
        elementModel: '='
    },
    template: (0, _MjmlTemplateExtractor2.default)(_button2.default),
    controller: ['ToolbarService', '$element', 'gettextCatalog', function controller(ToolbarService, $element, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema('button');

        // Update language-dependent value
        defaultConfig.text = gettextCatalog.getString(defaultConfig.text);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        $element.find('a').on('click', function (e) {
            e.preventDefault();
        });
    }]
};

exports.default = _angular2.default.module('cms.creator.mail.section-button', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', function (SectionsLibraryService, ToolbarService, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'add_box',
        type: 'button',
        label: gettext('Button'),
        group: 'mail',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            }
        }
    });

    var textColor = new _Color2.default();
    textColor.setDefaultValue('#ffffff');

    var borderRadius = new _BorderRadius2.default();
    borderRadius.setGroup('mainConfig');

    ToolbarService.registerSectionSchema('button', _extends({}, new _ButtonText2.default(), new _Link2.default(), textColor, new _Align2.default(), new _BackgroundButtonColor2.default(), borderRadius, new _Backgrounds2.default(), new _Paddings2.default({ value: 15, unit: 'px' }, { value: 30, unit: 'px' }, ['px'])));
}]).component('cmsCreatorMailSectionButton', creatorMailSectionButton).name;

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports = "\n    <!doctype html>\n    <html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n      <head>\n        <title>\n          \n        </title>\n        <!--[if !mso]><!-- -->\n        <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n        <!--<![endif]-->\n        <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <style type=\"text/css\">\n          #outlook a { padding:0; }\n          .ReadMsgBody { width:100%; }\n          .ExternalClass { width:100%; }\n          .ExternalClass * { line-height:100%; }\n          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n          p { display:block;margin:13px 0; }\n        </style>\n        <!--[if !mso]><!-->\n        <style type=\"text/css\">\n          @media only screen and (max-width:480px) {\n            @-ms-viewport { width:320px; }\n            @viewport { width:320px; }\n          }\n        </style>\n        <!--<![endif]-->\n        <!--[if mso]>\n        <xml>\n        <o:OfficeDocumentSettings>\n          <o:AllowPNG/>\n          <o:PixelsPerInch>96</o:PixelsPerInch>\n        </o:OfficeDocumentSettings>\n        </xml>\n        <![endif]-->\n        <!--[if lte mso 11]>\n        <style type=\"text/css\">\n          .outlook-group-fix { width:100% !important; }\n        </style>\n        <![endif]-->\n        \n      <!--[if !mso]><!-->\n        <link href=\"https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700\" rel=\"stylesheet\" type=\"text/css\">\n        <style type=\"text/css\">\n          @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);\n        </style>\n      <!--<![endif]-->\n\n    \n        \n    <style type=\"text/css\">\n      @media only screen and (min-width:480px) {\n        .mj-column-per-100 { width:100% !important; max-width: 100%; }\n      }\n    </style>\n    \n  \n        <style type=\"text/css\">\n        \n        \n        </style>\n        \n      </head>\n      <body>\n        \n        \n      <div\n        \n      >\n        \n      \n      <!--[if mso | IE]>\n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"creator-section-button-outlook\" style=\"width:600px;\" width=\"600\"\n      >\n        <tr>\n          <td style=\"line-height:0px;font-size:0px;mso-line-height-rule:exactly;\">\n      \n        <v:rect  style=\"width:600px;\" xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"true\" stroke=\"false\">\n        <v:fill  origin=\"0.5, 0\" position=\"0.5, 0\" src=\"{{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}\" color=\"{{$ctrl.elementModel.backgroundColor}}\" type=\"tile\" />\n        <v:textbox style=\"mso-fit-shape-to-text:true\" inset=\"0,0,0,0\">\n      <![endif]-->\n          \n      <div  class=\"creator-section-button\" style=\"background:{{$ctrl.elementModel.backgroundColor}} url({{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}) top center / auto repeat;Margin:0px auto;max-width:600px;\">\n        <div  style=\"line-height:0;font-size:0;\">\n        <table\n           align=\"center\" background=\"{{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:{{$ctrl.elementModel.backgroundColor}} url({{$ctrl.elementModel.backgroundImage[0].media | imageUrl : 600 : ''}}) top center / auto repeat;width:100%;\"\n        >\n          <tbody>\n            <tr>\n              <td\n                 style=\"direction:ltr;font-size:0px;padding:20px 0;padding-bottom:{{$ctrl.elementModel.paddingBottom | numberWithUnit}};padding-left:{{$ctrl.elementModel.paddingLeft | numberWithUnit}};padding-right:{{$ctrl.elementModel.paddingRight | numberWithUnit}};padding-top:{{$ctrl.elementModel.paddingTop | numberWithUnit}};text-align:center;vertical-align:top;\"\n              >\n                <!--[if mso | IE]>\n                  <table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n                \n        <tr>\n      \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-100 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n            <tr>\n              <td\n                 align=\"{{$ctrl.elementModel.align}}\" vertical-align=\"middle\" style=\"font-size:0px;padding:0 0 0 0;word-break:break-word;\"\n              >\n                \n      <table\n         align=\"{{$ctrl.elementModel.align}}\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"border-collapse:separate;line-height:100%;\"\n      >\n        <tr>\n          <td\n             align=\"center\" bgcolor=\"{{$ctrl.elementModel.backgroundButtonColor}}\" role=\"presentation\" style=\"border:none;border-radius:{{$ctrl.elementModel.borderRadius | numberWithUnit}};cursor:auto;padding:10px 25px;\" valign=\"middle\"\n          >\n            <a\n               href=\"{{$ctrl.elementModel.href}}\" style=\"background:{{$ctrl.elementModel.backgroundButtonColor}};color:{{$ctrl.elementModel.color}};font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;font-weight:normal;line-height:120%;Margin:0;text-decoration:none;text-transform:none;\" target=\"_blank\"\n            >\n              {{ $ctrl.elementModel.text }}\n            </a>\n          </td>\n        </tr>\n      </table>\n    \n              </td>\n            </tr>\n          \n                 <cms-creator-image-spinner ng-model=\"$ctrl.elementModel.backgroundImage\"></cms-creator-image-spinner>\n             \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n        </tr>\n      \n                  </table>\n                <![endif]-->\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        </div>\n      </div>\n    \n        <!--[if mso | IE]>\n        </v:textbox>\n      </v:rect>\n    \n          </td>\n        </tr>\n      </table>\n      <![endif]-->\n    \n    \n      </div>\n    \n      </body>\n    </html>\n  "

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _imageText = __webpack_require__(1132);

var _imageText2 = _interopRequireDefault(_imageText);

var _MjmlTemplateExtractor = __webpack_require__(118);

var _MjmlTemplateExtractor2 = _interopRequireDefault(_MjmlTemplateExtractor);

__webpack_require__(1133);

var _Image = __webpack_require__(240);

var _Image2 = _interopRequireDefault(_Image);

var _TextContent = __webpack_require__(239);

var _TextContent2 = _interopRequireDefault(_TextContent);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorMailSectionImageText = {
    bindings: {
        elementModel: '='
    },
    template: (0, _MjmlTemplateExtractor2.default)(_imageText2.default),
    controller: ['ToolbarService', function controller(ToolbarService) {
        var _this = this;

        //let imageFirst = false;

        this.editorOptions = {
            toolbar: [{ name: 'styles', items: ['Format', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat'] }, '/', { name: 'links', items: ['Link', 'Unlink'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', '-', 'CreatePlaceholder'] }]
        };

        var defaultConfig = ToolbarService.getSectionDefaultSchema('imageText');

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.mail.section-image-text', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', function (SectionsLibraryService, ToolbarService, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'art_track',
        type: 'imageText',
        label: gettext('Text with image'),
        group: 'mail',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            }
        }
    });

    ToolbarService.registerSectionSchema('imageText', _extends({}, new _Image2.default(), new _ConfigParameter2.default('imagePosition', 'selectionButtons', gettext('Image position'), 'position', 'right', null, [{ value: 'left', template: '<i class="fa fa-align-left">' }, { value: 'right', template: '<i class="fa fa-align-right"></i>' }]), new _TextContent2.default(), new _TextColor2.default(), new _BackgroundColor2.default(), new _Paddings2.default({ value: 15, unit: 'px' }, { value: 30, unit: 'px' }, ['px']), new _ConfigParameter2.default('imgPadding', 'number', gettext('Padding (image)'), 'position', { value: 10, unit: 'px' }, ['px']), new _ConfigParameter2.default('textPadding', 'number', gettext('Padding (text)'), 'position', { value: 10, unit: 'px' }, ['px'])));
}]).component('cmsCreatorMailSectionImageText', creatorMailSectionImageText).name;

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports = "\n    <!doctype html>\n    <html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\">\n      <head>\n        <title>\n          \n        </title>\n        <!--[if !mso]><!-- -->\n        <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n        <!--<![endif]-->\n        <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <style type=\"text/css\">\n          #outlook a { padding:0; }\n          .ReadMsgBody { width:100%; }\n          .ExternalClass { width:100%; }\n          .ExternalClass * { line-height:100%; }\n          body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }\n          table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }\n          img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }\n          p { display:block;margin:13px 0; }\n        </style>\n        <!--[if !mso]><!-->\n        <style type=\"text/css\">\n          @media only screen and (max-width:480px) {\n            @-ms-viewport { width:320px; }\n            @viewport { width:320px; }\n          }\n        </style>\n        <!--<![endif]-->\n        <!--[if mso]>\n        <xml>\n        <o:OfficeDocumentSettings>\n          <o:AllowPNG/>\n          <o:PixelsPerInch>96</o:PixelsPerInch>\n        </o:OfficeDocumentSettings>\n        </xml>\n        <![endif]-->\n        <!--[if lte mso 11]>\n        <style type=\"text/css\">\n          .outlook-group-fix { width:100% !important; }\n        </style>\n        <![endif]-->\n        \n      <!--[if !mso]><!-->\n        <link href=\"https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700\" rel=\"stylesheet\" type=\"text/css\">\n        <style type=\"text/css\">\n          @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);\n        </style>\n      <!--<![endif]-->\n\n    \n        \n    <style type=\"text/css\">\n      @media only screen and (min-width:480px) {\n        .mj-column-per-50 { width:50% !important; max-width: 50%; }\n      }\n    </style>\n    \n  \n        <style type=\"text/css\">\n        \n        \n        </style>\n        \n      </head>\n      <body>\n        \n        \n      <div\n        \n      >\n        \n            <div ng-if=\"$ctrl.elementModel.imagePosition === 'left'\">\n        \n      \n      <!--[if mso | IE]>\n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"creator-image-text-only-outlook\" style=\"width:600px;\" width=\"600\"\n      >\n        <tr>\n          <td style=\"line-height:0px;font-size:0px;mso-line-height-rule:exactly;\">\n      <![endif]-->\n    \n      \n      <div  class=\"creator-image-text-only\" style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};Margin:0px auto;max-width:600px;\">\n        \n        <table\n           align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};width:100%;\"\n        >\n          <tbody>\n            <tr>\n              <td\n                 style=\"direction:ltr;font-size:0px;padding:20px 0;padding-bottom:{{$ctrl.elementModel.paddingBottom | numberWithUnit}};padding-left:{{$ctrl.elementModel.paddingLeft | numberWithUnit}};padding-right:{{$ctrl.elementModel.paddingRight | numberWithUnit}};padding-top:{{$ctrl.elementModel.paddingTop | numberWithUnit}};text-align:center;vertical-align:top;\"\n              >\n                <!--[if mso | IE]>\n                  <table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n                \n        <tr>\n      \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-50 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n        <div ng-if=\"$ctrl.elementModel.image.length\">\n    \n            <tr>\n              <td\n                 align=\"center\" style=\"font-size:0px;padding:{{$ctrl.elementModel.imgPadding | numberWithUnit}};word-break:break-word;\"\n              >\n                \n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"border-collapse:collapse;border-spacing:0px;\"\n      >\n        <tbody>\n          <tr>\n            <td  style=\"width:NaNNaN;\">\n              \n      <img\n         height=\"auto\" src=\"{{ $ctrl.elementModel.image[0].media | imageUrl }}\" style=\"border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;\"\n      />\n    \n            </td>\n          </tr>\n        </tbody>\n      </table>\n    \n              </td>\n            </tr>\n          \n        </div>\n    \n        <media-placeholder ng-if=\"!$ctrl.elementModel.image.length\" model=\"$ctrl.elementModel.image\"></media-placeholder>\n    \n        <cms-creator-image-spinner ng-model=\"$ctrl.elementModel.image\"></cms-creator-image-spinner>\n    \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-50 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n            <tr>\n              <td\n                 align=\"left\" style=\"font-size:0px;padding:{{$ctrl.elementModel.textPadding | numberWithUnit}};word-break:break-word;\"\n              >\n                \n      <div\n         style=\"font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:1;text-align:left;color:{{$ctrl.elementModel.color}};\"\n      >\n        \n            <editor-inline options=\"$ctrl.editorOptions\" model=\"$ctrl.elementModel.text\"></editor-inline>\n        \n      </div>\n    \n              </td>\n            </tr>\n          \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n        </tr>\n      \n                  </table>\n                <![endif]-->\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        \n      </div>\n    \n      \n      <!--[if mso | IE]>\n          </td>\n        </tr>\n      </table>\n      <![endif]-->\n    \n    \n            </div>\n        \n            <div ng-if=\"$ctrl.elementModel.imagePosition === 'right'\">\n        \n      \n      <!--[if mso | IE]>\n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"creator-image-text-only-outlook\" style=\"width:600px;\" width=\"600\"\n      >\n        <tr>\n          <td style=\"line-height:0px;font-size:0px;mso-line-height-rule:exactly;\">\n      <![endif]-->\n    \n      \n      <div  class=\"creator-image-text-only\" style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};Margin:0px auto;max-width:600px;\">\n        \n        <table\n           align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"background:{{$ctrl.elementModel.backgroundColor}};background-color:{{$ctrl.elementModel.backgroundColor}};width:100%;\"\n        >\n          <tbody>\n            <tr>\n              <td\n                 style=\"direction:ltr;font-size:0px;padding:20px 0;padding-bottom:{{$ctrl.elementModel.paddingBottom | numberWithUnit}};padding-left:{{$ctrl.elementModel.paddingLeft | numberWithUnit}};padding-right:{{$ctrl.elementModel.paddingRight | numberWithUnit}};padding-top:{{$ctrl.elementModel.paddingTop | numberWithUnit}};text-align:center;vertical-align:top;\"\n              >\n                <!--[if mso | IE]>\n                  <table role=\"presentation\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\">\n                \n        <tr>\n      \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-50 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n            <tr>\n              <td\n                 align=\"left\" style=\"font-size:0px;padding:{{$ctrl.elementModel.textPadding | numberWithUnit}};word-break:break-word;\"\n              >\n                \n      <div\n         style=\"font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:1;text-align:left;color:{{$ctrl.elementModel.color}};\"\n      >\n        \n            <editor-inline options=\"$ctrl.editorOptions\" model=\"$ctrl.elementModel.text\"></editor-inline>\n        \n      </div>\n    \n              </td>\n            </tr>\n          \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n            <td\n               style=\"vertical-align:top;width:NaNpx;\"\n            >\n          <![endif]-->\n            \n      <div\n         class=\"mj-column-per-50 outlook-group-fix\" style=\"font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;\"\n      >\n        \n      <table\n         border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"vertical-align:top;\" width=\"100%\"\n      >\n        \n        <div ng-if=\"$ctrl.elementModel.image.length\">\n    \n            <tr>\n              <td\n                 align=\"center\" style=\"font-size:0px;padding:{{$ctrl.elementModel.imgPadding | numberWithUnit}};word-break:break-word;\"\n              >\n                \n      <table\n         align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" role=\"presentation\" style=\"border-collapse:collapse;border-spacing:0px;\"\n      >\n        <tbody>\n          <tr>\n            <td  style=\"width:NaNNaN;\">\n              \n      <img\n         height=\"auto\" src=\"{{ $ctrl.elementModel.image[0].media | imageUrl }}\" style=\"border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;\"\n      />\n    \n            </td>\n          </tr>\n        </tbody>\n      </table>\n    \n              </td>\n            </tr>\n          \n        </div>\n    \n        <media-placeholder ng-if=\"!$ctrl.elementModel.image.length\" model=\"$ctrl.elementModel.image\"></media-placeholder>\n    \n        <cms-creator-image-spinner ng-model=\"$ctrl.elementModel.image\"></cms-creator-image-spinner>\n    \n      </table>\n    \n      </div>\n    \n          <!--[if mso | IE]>\n            </td>\n          \n        </tr>\n      \n                  </table>\n                <![endif]-->\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        \n      </div>\n    \n      \n      <!--[if mso | IE]>\n          </td>\n        </tr>\n      </table>\n      <![endif]-->\n    \n    \n            </div>\n        \n      </div>\n    \n      </body>\n    </html>\n  "

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _CKEditorInline = __webpack_require__(1135);

var _CKEditorInline2 = _interopRequireDefault(_CKEditorInline);

__webpack_require__(1136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Inline editor component
 */
var editorInline = {
    bindings: {
        model: '=',
        options: '<'
    },
    template: __webpack_require__(1137)
};

exports.default = _angular2.default.module('cms.editor.inline', [_CKEditorInline2.default]).component('editorInline', editorInline).name;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _CKEditorOptions = __webpack_require__(440);

var _CKEditorOptions2 = _interopRequireDefault(_CKEditorOptions);

var _SaveGuard = __webpack_require__(232);

var _SaveGuard2 = _interopRequireDefault(_SaveGuard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Inline CKEditor bridge
 */
exports.default = _angular2.default.module('cms.ckeditor.inline.directive', [_CKEditorOptions2.default, _SaveGuard2.default]).directive('ckeditorInline', ["CKEditorConfig", "SaveGuard", function (CKEditorConfig, SaveGuard) {

    var PREFIX = '__ckd_inline_';
    var TOOLBAR_WRAPPER = 'ckeditorToolbarContainer';
    var TOOLBAR_HEIGHT = 76;

    var counter = 0;

    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            onFocus: '&',
            onBlur: '&',
            options: '<',
            contentLoaded: '<'
        },
        link: function link(scope, element, attrs, ngModel) {

            var editor = void 0;
            var options = _angular2.default.copy(CKEditorConfig.getOptions());
            var $toolbarContainer = $('#' + TOOLBAR_WRAPPER);

            options.sharedSpaces = {
                top: TOOLBAR_WRAPPER
            };

            if (scope.options && scope.options.toolbar) {
                options.toolbar = [];
            }

            _angular2.default.merge(options, scope.options || {});

            var attachEditor = function attachEditor() {

                element[0].setAttribute('contenteditable', true);

                if (!attrs.id) {
                    attrs.$set('id', PREFIX + ++counter);
                }

                editor = CKEDITOR.inline(element[0], options);
                removeClickListener();

                editor.on('instanceReady', function () {
                    this.focus();
                });

                editor.on('focus', function (e) {

                    var elementOffset = $(element).offset();
                    $toolbarContainer.addClass('md-whiteframe-2dp');
                    $toolbarContainer.css({
                        'display': 'block',
                        'top': elementOffset.top - TOOLBAR_HEIGHT,
                        'left': elementOffset.left - 1
                    });

                    SaveGuard.lock();
                    scope.$apply(function () {
                        return scope.onFocus();
                    });
                });

                editor.on('blur', function (e) {

                    if (e.editor.checkDirty()) {
                        ngModel.$setViewValue(e.editor.getData());
                        e.editor.resetDirty();
                    }

                    scope.$emit('content-changed');

                    scope.$apply(function () {
                        scope.onBlur();
                        editor.destroy();
                        element[0].setAttribute('contenteditable', false);
                        addClickListener();
                        SaveGuard.unlock();
                    });
                });
            };

            var removeClickListener = function removeClickListener() {
                element.off('click', attachEditor);
                ngModel.$render = renderWithEditor;
            };

            var addClickListener = function addClickListener() {
                element.on('click', attachEditor);
                ngModel.$render = render;
            };

            var renderWithEditor = function renderWithEditor() {
                editor.setData(ngModel.$viewValue || '');
            };

            var render = function render() {
                element[0].innerHTML = ngModel.$viewValue || '';
            };

            addClickListener();
        }
    };
}]).name;

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports = "<div ckeditor-inline\n     class=\"editor-inline__container\"\n     options=\"$ctrl.options\"\n     ng-model=\"$ctrl.model\">\n</div>\n\n<style>\n    .editor-inline__container:empty::after {\n        content: '{{ \"Insert text here...\"|translate }}';\n    }\n</style>";

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

__webpack_require__(1139);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _Backgrounds = __webpack_require__(119);

var _Backgrounds2 = _interopRequireDefault(_Backgrounds);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _TextContent = __webpack_require__(239);

var _TextContent2 = _interopRequireDefault(_TextContent);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageText';

var creatorPageSectionText = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1140),
    controller: ["ToolbarService", function controller(ToolbarService) {
        var _this = this;

        this.editorOptions = {
            toolbar: [{ name: 'styles', items: ['Format', 'FontSize'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat'] }, '/', { name: 'links', items: ['Link', 'Unlink'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight'] }],
            removePlugins: 'sourcearea,save,elementspath',
            format_tags: 'p;h1;h2;h3',
            floatSpacePinnedOffsetY: -200
        };

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-text', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["SectionsLibraryService", "ToolbarService", "gettext", "UniqueIdGenerator", function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'text_fields',
        type: MODULE_NAME,
        label: gettext('Text'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _TextContent2.default(), new _TextColor2.default(), new _Backgrounds2.default(), new _Paddings2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionText', creatorPageSectionText).name;

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} .editor-inline__container {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n\n        background-image: url('{{($ctrl.elementModel.backgroundImage[0].media | imageUrl : 1920 : '')}}');\n        background-size: cover;\n        background-repeat: no-repeat;\n\n        background-color: {{ $ctrl.elementModel.backgroundColor }};\n        color: {{ $ctrl.elementModel.color }};\n    }\n</style>\n<div id=\"{{ $ctrl.elementModel.sectionId }}\" class=\"{{$ctrl.elementModel.customClassName}}\">\n    <editor-inline\n        options=\"$ctrl.editorOptions\"\n        model=\"$ctrl.elementModel.text\">\n    </editor-inline>\n</div>\n\n<cms-creator-image-spinner ng-model=\"$ctrl.elementModel.backgroundImage\"></cms-creator-image-spinner>";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

__webpack_require__(1142);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _HtmlContent = __webpack_require__(1143);

var _HtmlContent2 = _interopRequireDefault(_HtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageHtml';

var creatorPageSectionHtml = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1144),
    controller: ["ToolbarService", function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-html', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["SectionsLibraryService", "ToolbarService", "gettext", "UniqueIdGenerator", function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'code',
        type: MODULE_NAME,
        label: gettext('Html'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            }
        }
    });

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _HtmlContent2.default()));
}]).component('cmsCreatorPageSectionHtml', creatorPageSectionHtml).name;

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextContent = function (_ConfigParameter) {
    _inherits(TextContent, _ConfigParameter);

    function TextContent() {
        _classCallCheck(this, TextContent);

        return _possibleConstructorReturn(this, (TextContent.__proto__ || Object.getPrototypeOf(TextContent)).call(this, 'html', 'textarea', (0, _ConfigParameter2.gettext)('Html code'), 'mainConfig', ''));
    }

    return TextContent;
}(_ConfigParameter3.default);

exports.default = TextContent;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports = "<div id=\"{{ $ctrl.elementModel.sectionId }}\">\n    <div class=\"image-placeholder\">\n        <em class=\"fa fa-code\"></em>\n    </div>\n</div>\n";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

__webpack_require__(1146);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _Color = __webpack_require__(170);

var _Color2 = _interopRequireDefault(_Color);

var _LineStyle = __webpack_require__(441);

var _LineStyle2 = _interopRequireDefault(_LineStyle);

var _LineSize = __webpack_require__(442);

var _LineSize2 = _interopRequireDefault(_LineSize);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageDivider';

var creatorPageSectionDivider = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1147),
    controller: ['ToolbarService', function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-divider', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', 'UniqueIdGenerator', function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'remove',
        type: MODULE_NAME,
        label: gettext('Division'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var color = new _Color2.default();
    color.setDefaultValue('#000000');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _LineSize2.default(), new _LineStyle2.default(), color, new _BackgroundColor2.default(), new _Paddings2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionDivider', creatorPageSectionDivider).name;

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n        background-color: {{ $ctrl.elementModel.backgroundColor}};\n    }\n    .{{ ::$ctrl.elementModel.uid }} .divider {\n        width: 100%;\n        height: 0;\n        padding: 0 0 0 0;\n        border-top-width: {{ $ctrl.elementModel.size | numberWithUnit }};\n        border-top-style: {{ $ctrl.elementModel.style }};\n        border-top-color: {{ $ctrl.elementModel.color }};\n    }\n</style>\n<div class=\"creator-section-divider\">\n    <div id=\"{{ $ctrl.elementModel.sectionId }}\" class=\"divider {{$ctrl.elementModel.customClassName}}\"></div>\n</div>\n";

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _MediaPlaceholder = __webpack_require__(242);

var _MediaPlaceholder2 = _interopRequireDefault(_MediaPlaceholder);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _Link = __webpack_require__(241);

var _Link2 = _interopRequireDefault(_Link);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _Image = __webpack_require__(240);

var _Image2 = _interopRequireDefault(_Image);

var _SizeWidth = __webpack_require__(452);

var _SizeWidth2 = _interopRequireDefault(_SizeWidth);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageImage';

var creatorPageSectionImage = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1152),
    controller: ['ToolbarService', function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        $('td > a').on('click', function (e) {
            e.preventDefault();
        });
    }]

};

exports.default = _angular2.default.module('cms.creator.page.section-image', [_SectionsLibraryService2.default, _ToolbarService2.default, _MediaPlaceholder2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', 'UniqueIdGenerator', function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'image',
        type: MODULE_NAME,
        label: gettext('Image'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });
    var align = new _Align2.default();
    align.setLabel(gettext('Image position'));
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _Image2.default(), align, new _Link2.default(), new _BackgroundColor2.default(), new _Paddings2.default(), new _SizeWidth2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionImage', creatorPageSectionImage).name;

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MediaPickerModal = __webpack_require__(147);

var _MediaPickerModal2 = _interopRequireDefault(_MediaPickerModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.media.picker.modal.service', [_MediaPickerModal2.default]).factory('MediaPickerModalService', ['MediaPickerModal', function (MediaPickerModal) {

    var open = function open(model) {
        var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return MediaPickerModal.open(multiple).result.then(function (selectedMedia) {
            selectedMedia.forEach(function (el) {
                var exists = model.filter(function (existing) {
                    return existing.media.id === el.id;
                }).length >= 1;

                if (!exists) {
                    if (multiple) {
                        model.push({
                            media: _angular2.default.copy(el)
                        });
                    } else {
                        model = [{ media: _angular2.default.copy(el) }];
                    }
                }
            });
            return new Promise(function (resolve) {
                return resolve(model);
            });
        });
    };

    return {
        open: open
    };
}]).name;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports = "<div class=\"image-placeholder\" ng-click=\"$ctrl.openMediaPicker()\">\n    <em class=\"fa fa-photo\" ></em>\n</div>";

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{$ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{$ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{$ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{$ctrl.elementModel.paddingRight | numberWithUnit }};\n        background-color: {{$ctrl.elementModel.backgroundColor}};\n        text-align: {{$ctrl.elementModel.align}};\n    }\n    .{{ ::$ctrl.elementModel.uid }} img {\n        width: {{ $ctrl.elementModel.width | numberWithUnit }};\n    }\n</style>\n<div>\n    <img ng-show=\"$ctrl.elementModel.image.length\"\n            id=\"{{ $ctrl.elementModel.sectionId }}\"\n            ng-style=\"{'max-width': '100%'}\"\n            src=\"{{$ctrl.elementModel.image[0].media | imageUrl : 1920 }}\"\n            href=\"{{ $ctrl.elementModel.href }}\"\n            alt=\"media\"\n            class=\"{{$ctrl.elementModel.customClassName}}\"\n    />\n    <media-placeholder ng-show=\"!$ctrl.elementModel.image.length\" model=\"$ctrl.elementModel.image\"></media-placeholder>\n</div>\n\n<cms-creator-image-spinner ng-model=\"$ctrl.elementModel.image\"></cms-creator-image-spinner>\n";

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

__webpack_require__(1154);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _LinkedInUrl = __webpack_require__(445);

var _LinkedInUrl2 = _interopRequireDefault(_LinkedInUrl);

var _GooglePlusUrl = __webpack_require__(444);

var _GooglePlusUrl2 = _interopRequireDefault(_GooglePlusUrl);

var _FacebookUrl = __webpack_require__(443);

var _FacebookUrl2 = _interopRequireDefault(_FacebookUrl);

var _InstagramUrl = __webpack_require__(446);

var _InstagramUrl2 = _interopRequireDefault(_InstagramUrl);

var _TwitterUrl = __webpack_require__(447);

var _TwitterUrl2 = _interopRequireDefault(_TwitterUrl);

var _PinterestUrl = __webpack_require__(448);

var _PinterestUrl2 = _interopRequireDefault(_PinterestUrl);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageSocial';

var creatorPageSectionSocial = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1155),
    controller: ['ToolbarService', 'gettextCatalog', '$element', function controller(ToolbarService, gettextCatalog, $element) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        $element.find('a').on('click', function (e) {
            e.preventDefault();
        });

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
            _this.placeholderText = gettextCatalog.getString('Click to set module options', null, "Creator section module placeholder");
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-social', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', 'UniqueIdGenerator', function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'group',
        type: MODULE_NAME,
        label: gettext('Social'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });
    //facebook google instagram pinterest linkedin twitter
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _FacebookUrl2.default(), new _GooglePlusUrl2.default(), new _LinkedInUrl2.default(), new _InstagramUrl2.default(), new _TwitterUrl2.default(), new _PinterestUrl2.default(), new _Align2.default(), new _BackgroundColor2.default(), new _Paddings2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionSocial', creatorPageSectionSocial).name;

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n        background-color: {{ $ctrl.elementModel.backgroundColor}};\n    }\n    .{{ ::$ctrl.elementModel.uid }} .social-container {\n        text-align: {{ $ctrl.elementModel.align }};\n        padding: 0 0 0 0;\n        line-height: 0.1em;\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} .social-container a {\n        display: inline-block;\n    }\n</style>\n\n<div>\n        <div id=\"{{ $ctrl.elementModel.sectionId }}\" class=\"social-container {{$ctrl.elementModel.customClassName}}\">\n\n            <div\n                    class=\"creator-workspace__placeholder-text\"\n                    ng-show=\"\n                                !$ctrl.elementModel.facebookUrl &&\n                                !$ctrl.elementModel.googlePlusUrl &&\n                                !$ctrl.elementModel.linkedInUrl &&\n                                !$ctrl.elementModel.instagramUrl &&\n                                !$ctrl.elementModel.twitterUrl &&\n                                !$ctrl.elementModel.pinterestUrl\">\n                {{ $ctrl.placeholderText }}\n            </div>\n\n\n            <a href=\"{{$ctrl.elementModel.facebookUrl}}\"\n               class=\"{{$ctrl.elementModel.facebookUrl?'facebook':'ng-hide'}}\"\n               id=\"{{ $ctrl.elementModel.sectionId }}-fb\"\n            ></a>\n\n            <a href=\"{{$ctrl.elementModel.googlePlusUrl}}\"\n               class=\"{{$ctrl.elementModel.googlePlusUrl?'google':'ng-hide'}}\"\n               id=\"{{ $ctrl.elementModel.sectionId }}-gplus\"\n            ></a>\n\n            <a href=\"{{$ctrl.elementModel.linkedInUrl}}\"\n               class=\"{{$ctrl.elementModel.linkedInUrl?'linkedin':'ng-hide'}}\"\n               id=\"{{ $ctrl.elementModel.sectionId }}-li\"\n            ></a>\n\n            <a href=\"{{$ctrl.elementModel.instagramUrl}}\"\n               class=\"{{$ctrl.elementModel.instagramUrl?'instagram':'ng-hide'}}\"\n               id=\"{{ $ctrl.elementModel.sectionId }}-in\"\n            ></a>\n\n            <a href=\"{{$ctrl.elementModel.twitterUrl}}\"\n               class=\"{{$ctrl.elementModel.twitterUrl?'twitter':'ng-hide'}}\"\n               id=\"{{ $ctrl.elementModel.sectionId }}-tw\"\n            ></a>\n\n            <a href=\"{{$ctrl.elementModel.pinterestUrl}}\"\n               class=\"{{$ctrl.elementModel.pinterestUrl?'pinterest':'ng-hide'}}\"\n               id=\"{{ $ctrl.elementModel.sectionId }}-pin\"\n            ></a>\n\n        </div>\n</div>";

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _Backgrounds = __webpack_require__(119);

var _Backgrounds2 = _interopRequireDefault(_Backgrounds);

var _Margins = __webpack_require__(453);

var _Margins2 = _interopRequireDefault(_Margins);

var _BackgroundButtonColor = __webpack_require__(450);

var _BackgroundButtonColor2 = _interopRequireDefault(_BackgroundButtonColor);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _Color = __webpack_require__(170);

var _Color2 = _interopRequireDefault(_Color);

var _ButtonText = __webpack_require__(451);

var _ButtonText2 = _interopRequireDefault(_ButtonText);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _Borders = __webpack_require__(243);

var _Borders2 = _interopRequireDefault(_Borders);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _Analytics = __webpack_require__(1164);

var _Analytics2 = _interopRequireDefault(_Analytics);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageButton';

var creatorPageSectionButton = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1165),
    controller: ['ToolbarService', '$element', 'gettextCatalog', function controller(ToolbarService, $element, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        // Update language-dependent value
        defaultConfig.text = gettextCatalog.getString(defaultConfig.text);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        $element.find('a').on('click', function (e) {
            e.preventDefault();
        });
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-button', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', 'UniqueIdGenerator', function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'add_box',
        type: MODULE_NAME,
        label: gettext('Button'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            borders: {
                label: gettext('Button borders'),
                isOpen: false,
                type: 'borders'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            analytics: {
                label: gettext('Analytics'),
                isOpen: false,
                type: 'analytics'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _Color2.default();
    textColor.setDefaultValue('#ffffff');

    var fontWeight = new _FontWeight2.default();
    fontWeight.setDefaultValue('normal');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _ButtonText2.default(), new _ConfigParameter2.default('href', 'button-link', gettext('Link or attached file'), 'mainConfig', "", null, null, null, gettext('Insert URL or pick the file.')), textColor, new _FontSize2.default(), fontWeight, new _Align2.default(), new _BackgroundButtonColor2.default(), new _Borders2.default(), new _Backgrounds2.default(), new _Paddings2.default(), new _Margins2.default(), new _Analytics2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionButton', creatorPageSectionButton).name;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarginTop = function (_ConfigParameter) {
    _inherits(MarginTop, _ConfigParameter);

    function MarginTop() {
        _classCallCheck(this, MarginTop);

        return _possibleConstructorReturn(this, (MarginTop.__proto__ || Object.getPrototypeOf(MarginTop)).call(this, 'marginTop', 'number', (0, _ConfigParameter2.gettext)('Margin top'), 'position', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return MarginTop;
}(_ConfigParameter3.default);

exports.default = MarginTop;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarginBottom = function (_ConfigParameter) {
    _inherits(MarginBottom, _ConfigParameter);

    function MarginBottom() {
        _classCallCheck(this, MarginBottom);

        return _possibleConstructorReturn(this, (MarginBottom.__proto__ || Object.getPrototypeOf(MarginBottom)).call(this, 'marginBottom', 'number', (0, _ConfigParameter2.gettext)('Margin bottom'), 'position', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return MarginBottom;
}(_ConfigParameter3.default);

exports.default = MarginBottom;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarginLeft = function (_ConfigParameter) {
    _inherits(MarginLeft, _ConfigParameter);

    function MarginLeft() {
        _classCallCheck(this, MarginLeft);

        return _possibleConstructorReturn(this, (MarginLeft.__proto__ || Object.getPrototypeOf(MarginLeft)).call(this, 'marginLeft', 'number', (0, _ConfigParameter2.gettext)('Margin left'), 'position', { value: 30, unit: 'px' }, ['px', '%']));
    }

    return MarginLeft;
}(_ConfigParameter3.default);

exports.default = MarginLeft;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarginRight = function (_ConfigParameter) {
    _inherits(MarginRight, _ConfigParameter);

    function MarginRight() {
        _classCallCheck(this, MarginRight);

        return _possibleConstructorReturn(this, (MarginRight.__proto__ || Object.getPrototypeOf(MarginRight)).call(this, 'marginRight', 'number', (0, _ConfigParameter2.gettext)('Margin right'), 'position', { value: 30, unit: 'px' }, ['px', '%']));
    }

    return MarginRight;
}(_ConfigParameter3.default);

exports.default = MarginRight;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BorderColor = function (_ConfigParameter) {
    _inherits(BorderColor, _ConfigParameter);

    function BorderColor() {
        _classCallCheck(this, BorderColor);

        return _possibleConstructorReturn(this, (BorderColor.__proto__ || Object.getPrototypeOf(BorderColor)).call(this, 'borderColor', 'color', (0, _ConfigParameter2.gettext)('Border color'), 'borders', '#cbcbcb'));
    }

    return BorderColor;
}(_ConfigParameter3.default);

exports.default = BorderColor;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BorderWidth = function (_ConfigParameter) {
    _inherits(BorderWidth, _ConfigParameter);

    function BorderWidth() {
        _classCallCheck(this, BorderWidth);

        return _possibleConstructorReturn(this, (BorderWidth.__proto__ || Object.getPrototypeOf(BorderWidth)).call(this, 'borderWidth', 'number', (0, _ConfigParameter2.gettext)('Border width'), 'borders', { value: 1, unit: 'px' }, ['px']));
    }

    return BorderWidth;
}(_ConfigParameter3.default);

exports.default = BorderWidth;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BorderStyle = function (_ConfigParameter) {
    _inherits(BorderStyle, _ConfigParameter);

    function BorderStyle() {
        _classCallCheck(this, BorderStyle);

        return _possibleConstructorReturn(this, (BorderStyle.__proto__ || Object.getPrototypeOf(BorderStyle)).call(this, 'borderStyle', 'selectionButtons', (0, _ConfigParameter2.gettext)('Border style'), 'borders', 'solid', null, [{ value: 'solid', template: '<hr style="border-top: 2px solid; margin-top: 15px; width: 16px">' }, { value: 'dashed', template: '<hr style="border-top: 2px dashed; margin-top: 15px; width: 16px">' }, { value: 'dotted', template: '<hr style="border-top: 2px dotted; margin-top: 15px; width: 16px">' }]));
    }

    return BorderStyle;
}(_ConfigParameter3.default);

exports.default = BorderStyle;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Analytics = function (_ConfigParameter) {
    _inherits(Analytics, _ConfigParameter);

    function Analytics() {
        _classCallCheck(this, Analytics);

        return _possibleConstructorReturn(this, (Analytics.__proto__ || Object.getPrototypeOf(Analytics)).call(this, 'analytics', 'checkbox', (0, _ConfigParameter2.gettext)('Enable event tracking'), 'analytics', true, null, null, null, null, (0, _ConfigParameter2.gettext)('Event tracking uses Google Analytics. Check global page settings to enable your GA key.')));
    }

    return Analytics;
}(_ConfigParameter3.default);

exports.default = Analytics;

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        background-color: {{$ctrl.elementModel.backgroundColor}};\n        background-image: url('{{($ctrl.elementModel.backgroundImage[0].media | imageUrl : 1920 : '')}}');\n        background-size: cover;\n        text-align: {{$ctrl.elementModel.align}};\n    }\n    .{{ ::$ctrl.elementModel.uid }} a.btn {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n        margin-top: {{ $ctrl.elementModel.marginTop | numberWithUnit }};\n        margin-bottom: {{ $ctrl.elementModel.marginBottom | numberWithUnit }};\n        margin-left: {{ $ctrl.elementModel.marginLeft | numberWithUnit }};\n        margin-right: {{ $ctrl.elementModel.marginRight | numberWithUnit }};\n        color: {{ $ctrl.elementModel.color }};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        background-color: {{ $ctrl.elementModel.backgroundButtonColor }};\n        border-radius: {{ $ctrl.elementModel.borderRadius | numberWithUnit}};\n        border-width: {{ $ctrl.elementModel.borderWidth | numberWithUnit}};\n        border-color: {{ $ctrl.elementModel.borderColor}};\n        border-style: {{ $ctrl.elementModel.borderStyle}};\n    }\n</style>\n<div class=\"creator-section-button\">\n    <div>\n        <a\n                class=\"btn {{$ctrl.elementModel.customClassName}}\"\n                href=\"{{$ctrl.elementModel.href}}\"\n                id=\"{{$ctrl.elementModel.sectionId}}\">\n            {{ $ctrl.elementModel.text }}\n        </a>\n    </div>\n</div>\n\n<cms-creator-image-spinner ng-model=\"$ctrl.elementModel.backgroundImage\"></cms-creator-image-spinner>\n";

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _Borders = __webpack_require__(243);

var _Borders2 = _interopRequireDefault(_Borders);

var _LabelWidth = __webpack_require__(1167);

var _LabelWidth2 = _interopRequireDefault(_LabelWidth);

var _LabelsPosition = __webpack_require__(1168);

var _LabelsPosition2 = _interopRequireDefault(_LabelsPosition);

var _Recaptcha = __webpack_require__(1169);

var _Recaptcha2 = _interopRequireDefault(_Recaptcha);

var _EditForm = __webpack_require__(1170);

var _EditForm2 = _interopRequireDefault(_EditForm);

var _ThankYouText = __webpack_require__(1171);

var _ThankYouText2 = _interopRequireDefault(_ThankYouText);

var _ThankYouTargetUrl = __webpack_require__(1172);

var _ThankYouTargetUrl2 = _interopRequireDefault(_ThankYouTargetUrl);

var _ZapierWebhookUrl = __webpack_require__(1173);

var _ZapierWebhookUrl2 = _interopRequireDefault(_ZapierWebhookUrl);

var _SendFormDataByMail = __webpack_require__(1174);

var _SendFormDataByMail2 = _interopRequireDefault(_SendFormDataByMail);

var _SendMailToUser = __webpack_require__(1175);

var _SendMailToUser2 = _interopRequireDefault(_SendMailToUser);

var _FormContent = __webpack_require__(1176);

var _FormContent2 = _interopRequireDefault(_FormContent);

var _LabelsAlign = __webpack_require__(1177);

var _LabelsAlign2 = _interopRequireDefault(_LabelsAlign);

var _ContentGuardService = __webpack_require__(169);

var _ContentGuardService2 = _interopRequireDefault(_ContentGuardService);

var _MailsResource = __webpack_require__(230);

var _MailsResource2 = _interopRequireDefault(_MailsResource);

var _FormTemplate = __webpack_require__(1178);

var _FormTemplate2 = _interopRequireDefault(_FormTemplate);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageForm';

var creatorPageSectionForm = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1179),
    controller: ["ToolbarService", "ContentGuardService", "$scope", "gettextCatalog", function controller(ToolbarService, ContentGuardService, $scope, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);
        defaultConfig.thankYouText = gettextCatalog.getString('Your entry has been saved');

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
            ContentGuardService.registerLocked(MODULE_NAME);
        };

        $scope.$on('$destroy', function () {
            ContentGuardService.deregisterLocked(MODULE_NAME);
        });
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-form', [_SectionsLibraryService2.default, _ToolbarService2.default, _ContentGuardService2.default, _MailsResource2.default]).run(["SectionsLibraryService", "ToolbarService", "gettext", "UniqueIdGenerator", "MailsResource", "ACLService", function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator, MailsResource, ACLService) {

    SectionsLibraryService.registerSection({
        icon: 'assignment',
        type: MODULE_NAME,
        label: gettext('Form'),
        group: 'page',
        options: {
            disableCopy: true
        },
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            borders: {
                label: gettext('Input borders'),
                isOpen: false,
                type: 'borders'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });
    var formTemplate = new _FormTemplate2.default();
    var sendMailToUser = new _SendMailToUser2.default();

    formTemplate.setOptions(function () {
        var options = [{ value: null, label: gettext("Choose...") }];
        if (ACLService.matchRoles(['ROLE_ADMIN'])) {
            MailsResource.findAll(null, function (response) {
                if (!response.data.error) {
                    _angular2.default.forEach(response.data, function (mail) {
                        options.push({ value: mail.id, label: mail.title });
                    });
                }
            }, function (err) {});
        }
        return options;
    });

    sendMailToUser.setValidator(function (form) {
        var errorMessage = gettext('You have to choose e-mail template');
        if (!form.formTemplate && form.sendMailToUser) {
            return errorMessage;
        }
    });

    formTemplate.setValidator(function (form) {
        if (!form.formTemplate) {
            return;
        }

        var errorMessage = gettext('Your form must have 1 required e-mail field!');
        var formFieldCounter = 0;

        _angular2.default.forEach(form.content, function (field) {
            if (field.type === 'formEmail' && field.config.required) {
                formFieldCounter++;
            }
        });

        if (formFieldCounter !== 1) {
            return errorMessage;
        }

        return;
    });

    if (!ACLService.matchRoles(['ROLE_ADMIN'])) {
        formTemplate.setAclDisable(true);
        formTemplate.setHelper(gettext('Option is available only in full version of the product.'));
    }

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _FormContent2.default(), formTemplate, new _EditForm2.default(), new _TextColor2.default(), new _BackgroundColor2.default(), new _ThankYouText2.default(), new _ThankYouTargetUrl2.default(), new _ZapierWebhookUrl2.default(), new _SendFormDataByMail2.default(), sendMailToUser, new _Recaptcha2.default(), new _Borders2.default(), new _Paddings2.default(), new _LabelsPosition2.default(), new _LabelWidth2.default(), new _LabelsAlign2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionForm', creatorPageSectionForm).name;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelWidth = function (_ConfigParameter) {
    _inherits(LabelWidth, _ConfigParameter);

    function LabelWidth() {
        _classCallCheck(this, LabelWidth);

        return _possibleConstructorReturn(this, (LabelWidth.__proto__ || Object.getPrototypeOf(LabelWidth)).call(this, 'labelWidth', 'select', (0, _ConfigParameter2.gettext)('Labels width'), 'position', 2, null, [2, 3, 4, 5, 6, 7, 8]));
    }

    return LabelWidth;
}(_ConfigParameter3.default);

exports.default = LabelWidth;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelsPosition = function (_ConfigParameter) {
    _inherits(LabelsPosition, _ConfigParameter);

    function LabelsPosition() {
        _classCallCheck(this, LabelsPosition);

        return _possibleConstructorReturn(this, (LabelsPosition.__proto__ || Object.getPrototypeOf(LabelsPosition)).call(this, 'labelsPosition', 'selectionButtons', (0, _ConfigParameter2.gettext)('Labels position'), 'position', 'top', null, [{ value: 'top', template: '<em class="material-icons icon-size form-label-position">arrow_upward</em>' }, { value: 'left', template: '<em class="material-icons icon-size form-label-position">arrow_back</em>' }]));
    }

    return LabelsPosition;
}(_ConfigParameter3.default);

exports.default = LabelsPosition;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Recaptcha = function (_ConfigParameter) {
    _inherits(Recaptcha, _ConfigParameter);

    function Recaptcha() {
        _classCallCheck(this, Recaptcha);

        return _possibleConstructorReturn(this, (Recaptcha.__proto__ || Object.getPrototypeOf(Recaptcha)).call(this, 'recaptcha', 'checkbox', (0, _ConfigParameter2.gettext)('Show captcha'), 'mainConfig', null, null, null, null, null, (0, _ConfigParameter2.gettext)('Check it if you want your form secured by Google reCaptcha')));
    }

    return Recaptcha;
}(_ConfigParameter3.default);

exports.default = Recaptcha;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditForm = function (_ConfigParameter) {
    _inherits(EditForm, _ConfigParameter);

    function EditForm() {
        _classCallCheck(this, EditForm);

        return _possibleConstructorReturn(this, (EditForm.__proto__ || Object.getPrototypeOf(EditForm)).call(this, 'editInputs', 'edit-form', (0, _ConfigParameter2.gettext)('Edit form'), 'mainConfig'));
    }

    return EditForm;
}(_ConfigParameter3.default);

exports.default = EditForm;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThankYouText = function (_ConfigParameter) {
    _inherits(ThankYouText, _ConfigParameter);

    function ThankYouText() {
        _classCallCheck(this, ThankYouText);

        return _possibleConstructorReturn(this, (ThankYouText.__proto__ || Object.getPrototypeOf(ThankYouText)).call(this, 'thankYouText', 'text', (0, _ConfigParameter2.gettext)('Thank you text'), 'mainConfig', (0, _ConfigParameter2.gettext)('Your entry has been saved')));
    }

    return ThankYouText;
}(_ConfigParameter3.default);

exports.default = ThankYouText;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThankYouTargetUrl = function (_ConfigParameter) {
    _inherits(ThankYouTargetUrl, _ConfigParameter);

    function ThankYouTargetUrl() {
        _classCallCheck(this, ThankYouTargetUrl);

        return _possibleConstructorReturn(this, (ThankYouTargetUrl.__proto__ || Object.getPrototypeOf(ThankYouTargetUrl)).call(this, 'thankYouTargetUrl', 'text', (0, _ConfigParameter2.gettext)('Thank you custom URL'), 'mainConfig', '/'));
    }

    return ThankYouTargetUrl;
}(_ConfigParameter3.default);

exports.default = ThankYouTargetUrl;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZapierWebhookUrl = function (_ConfigParameter) {
    _inherits(ZapierWebhookUrl, _ConfigParameter);

    function ZapierWebhookUrl() {
        _classCallCheck(this, ZapierWebhookUrl);

        return _possibleConstructorReturn(this, (ZapierWebhookUrl.__proto__ || Object.getPrototypeOf(ZapierWebhookUrl)).call(this, 'zapierWebhookUrl', 'text', (0, _ConfigParameter2.gettext)('Webhook Url'), 'advanced', ''));
    }

    return ZapierWebhookUrl;
}(_ConfigParameter3.default);

exports.default = ZapierWebhookUrl;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SendFormDataByMail = function (_ConfigParameter) {
    _inherits(SendFormDataByMail, _ConfigParameter);

    function SendFormDataByMail() {
        _classCallCheck(this, SendFormDataByMail);

        return _possibleConstructorReturn(this, (SendFormDataByMail.__proto__ || Object.getPrototypeOf(SendFormDataByMail)).call(this, 'sendFormDataByMail', 'checkbox', (0, _ConfigParameter2.gettext)('Receive an e-mail with submitted form'), 'advanced', false));
    }

    return SendFormDataByMail;
}(_ConfigParameter3.default);

exports.default = SendFormDataByMail;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SendMailToUser = function (_ConfigParameter) {
    _inherits(SendMailToUser, _ConfigParameter);

    function SendMailToUser() {
        _classCallCheck(this, SendMailToUser);

        return _possibleConstructorReturn(this, (SendMailToUser.__proto__ || Object.getPrototypeOf(SendMailToUser)).call(this, 'sendMailToUser', 'checkbox', (0, _ConfigParameter2.gettext)('Send e-mail confirmation to submitter'), 'mainConfig', false));
    }

    return SendMailToUser;
}(_ConfigParameter3.default);

exports.default = SendMailToUser;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormContent = function (_ConfigParameter) {
    _inherits(FormContent, _ConfigParameter);

    function FormContent() {
        _classCallCheck(this, FormContent);

        return _possibleConstructorReturn(this, (FormContent.__proto__ || Object.getPrototypeOf(FormContent)).call(this, 'content', 'hidden', null, null, [{
            type: 'formEmail',
            group: 'form',
            config: {
                key: 'email',
                label: 'Email',
                placeholder: (0, _ConfigParameter2.gettext)('E-mail'),
                required: true,
                inline: false
            }
        }, {
            type: 'formCaptcha',
            group: 'form',
            config: {
                inline: false,
                key: 'captcha',
                label: '',
                placeholder: ''
            }
        }, {
            type: 'formSubmit',
            group: 'form',
            config: {
                key: 'submit',
                label: (0, _ConfigParameter2.gettext)('Submit'),
                inline: false,
                submitButtonBackgroundColor: '#2dacd1',
                submitButtonBorderColor: '#2dacd1',
                submitButtonTextColor: '#ffffff',
                placeholder: ''
            }
        }]));
    }

    return FormContent;
}(_ConfigParameter3.default);

exports.default = FormContent;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LabelsAlign = function (_ConfigParameter) {
    _inherits(LabelsAlign, _ConfigParameter);

    function LabelsAlign() {
        _classCallCheck(this, LabelsAlign);

        return _possibleConstructorReturn(this, (LabelsAlign.__proto__ || Object.getPrototypeOf(LabelsAlign)).call(this, 'labelsAlign', 'align', (0, _ConfigParameter2.gettext)('Labels align'), 'position', 'left'));
    }

    return LabelsAlign;
}(_ConfigParameter3.default);

exports.default = LabelsAlign;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormTemplate = function (_ConfigParameter) {
    _inherits(FormTemplate, _ConfigParameter);

    function FormTemplate() {
        _classCallCheck(this, FormTemplate);

        return _possibleConstructorReturn(this, (FormTemplate.__proto__ || Object.getPrototypeOf(FormTemplate)).call(this, 'formTemplate', 'object-select', (0, _ConfigParameter2.gettext)('Choose message template'), 'mainConfig', null, null, [{}]));
    }

    return FormTemplate;
}(_ConfigParameter3.default);

exports.default = FormTemplate;

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports = "<style>\n    cms-creator-form-editor input,\n    cms-creator-form-editor select,\n    cms-creator-form-editor button[type=\"submit\"],\n    cms-creator-form-editor textarea,\n    cms-creator-form-editor label {\n        cursor: pointer;\n    }\n    cms-creator-form-editor .disabled-input  {\n        position: relative;\n    }\n    cms-creator-form-editor .disabled-input:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n    }\n    cms-creator-form-editor .radio label, cms-creator-form-editor .radio-inline label,\n    cms-creator-form-editor .checkbox label, cms-creator-form-editor .checkbox-inline label {\n        line-height: 21px;\n    }\n    cms-creator-form-editor .radio, cms-creator-form-editor .radio-inline,\n    cms-creator-form-editor .checkbox , cms-creator-form-editor .checkbox-inline {\n        margin: 0;\n        padding-top: 7px;\n    }\n\n    cms-creator-form-editor .labels-left label {\n        padding-top: 7px;\n    }\n\n    .form-label-position {\n        line-height: 1.3;\n    }\n\n    cms-creator-form-editor .form-group label {\n        font-size: 14px;\n        {{ ($ctrl.elementModel.labelsPosition == 'top') ? 'width: 100%;' : '' }}\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{$ctrl.elementModel.paddingTop | numberWithUnit}};\n        padding-bottom: {{$ctrl.elementModel.paddingBottom | numberWithUnit}};\n        padding-left: {{$ctrl.elementModel.paddingLeft | numberWithUnit}};\n        padding-right: {{$ctrl.elementModel.paddingRight | numberWithUnit}};\n        background-color: {{$ctrl.elementModel.backgroundColor}};\n        color: {{$ctrl.elementModel.color}};\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} input,\n    .{{ ::$ctrl.elementModel.uid }} textarea,\n    .{{ ::$ctrl.elementModel.uid }} select {\n        color: {{ $ctrl.elementModel.color }};\n        border-style: {{ $ctrl.elementModel.borderStyle }};\n        border-color: {{ $ctrl.elementModel.borderColor }};\n        border-radius: {{ $ctrl.elementModel.borderRadius | numberWithUnit}};\n        border-width: {{ $ctrl.elementModel.borderWidth | numberWithUnit}};\n    }\n</style>\n<div>\n    <div class=\"row\">\n        <cms-creator-form-editor element-model=\"$ctrl.elementModel\"></cms-creator-form-editor>\n    </div>\n</div>";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _WorkspaceElement = __webpack_require__(238);

var _WorkspaceElement2 = _interopRequireDefault(_WorkspaceElement);

var _ColumnResizer = __webpack_require__(1181);

var _ColumnResizer2 = _interopRequireDefault(_ColumnResizer);

__webpack_require__(1184);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _Backgrounds = __webpack_require__(119);

var _Backgrounds2 = _interopRequireDefault(_Backgrounds);

var _ColumnsBackgroundColor = __webpack_require__(1185);

var _ColumnsBackgroundColor2 = _interopRequireDefault(_ColumnsBackgroundColor);

var _Children = __webpack_require__(1186);

var _Children2 = _interopRequireDefault(_Children);

var _ColumnsWidth = __webpack_require__(1187);

var _ColumnsWidth2 = _interopRequireDefault(_ColumnsWidth);

var _FullWidth = __webpack_require__(1188);

var _FullWidth2 = _interopRequireDefault(_FullWidth);

var _PinSection = __webpack_require__(1189);

var _PinSection2 = _interopRequireDefault(_PinSection);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _Animation = __webpack_require__(1190);

var _Animation2 = _interopRequireDefault(_Animation);

var _Anchor = __webpack_require__(1191);

var _Anchor2 = _interopRequireDefault(_Anchor);

var _Parallax = __webpack_require__(1192);

var _Parallax2 = _interopRequireDefault(_Parallax);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageSection';

var creatorPageSection = {
    bindings: {
        elementModel: '=',
        context: '<',
        content: '=',
        uid: '<'
    },
    template: __webpack_require__(1193),
    controller: ["ToolbarService", function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section', [_SectionsLibraryService2.default, _ToolbarService2.default, _WorkspaceElement2.default, _ColumnResizer2.default]).run(["SectionsLibraryService", "ToolbarService", "UniqueIdGenerator", "gettext", function (SectionsLibraryService, ToolbarService, UniqueIdGenerator, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'view_column',
        type: MODULE_NAME,
        label: gettext('Section'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _Children2.default(), new _ColumnsWidth2.default(), new _Backgrounds2.default(), new _ColumnsBackgroundColor2.default(), new _Paddings2.default(), new _FullWidth2.default(), new _PinSection2.default(), new _Animation2.default(), new _Parallax2.default(), new _Anchor2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSection', creatorPageSection).name;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(1182);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnResizer = {
    bindings: {
        columnsWidth: '=',
        columnIndex: '<'
    },
    template: __webpack_require__(1183),
    controller: ['$element', '$document', '$scope', function controller($element, $document, $scope) {
        var _this = this;

        var MIN_COL_WIDTH = 1;
        var MAX_COL_WIDTH = 12;
        var RESIZE_LEFT_STEP = -1;
        var RESIZE_RIGHT_STEP = 1;
        var RESIZE_PENDING_SELECTOR = 'column-resize__pending';
        var RESIZE_PENDING_HANDLER = 'column-resize__pending-handler';
        var ANIMATE_LEFT = 'animate-left';
        var ANIMATE_RIGHT = 'animate-right';

        var row = null;
        var rowWidth = null;
        var stepSize = null;
        var startPos = null;

        var colMinWidth = null;
        var colMaxWidth = null;

        var startWidth = null;

        this.$onInit = function () {
            $element.on('mousedown', startResizing);
        };

        /**
         * Compute start parameters of mouse move
         * Bind handlers
         * @param e
         */
        var startResizing = function startResizing(e) {
            row = $element.parent().parent()[0];
            rowWidth = row.offsetWidth;
            stepSize = rowWidth / 12;
            startPos = e.clientX;

            startWidth = currentColumnWidth();
            colMinWidth = calculateColumnMinWidth();
            colMaxWidth = calculateColumnMaxWidth();

            $(row).addClass(RESIZE_PENDING_SELECTOR);
            $element.addClass(RESIZE_PENDING_HANDLER);

            $document.on('mouseup', stopResizing);
            $document.on('mousemove', move);
        };

        /**
         * Clear handlers and classes at the end of action
         * @param e
         */
        var stopResizing = function stopResizing() {
            $(row).removeClass(RESIZE_PENDING_SELECTOR);
            $element.removeClass(RESIZE_PENDING_HANDLER);

            $(row).removeClass(ANIMATE_LEFT);
            $(row).removeClass(ANIMATE_RIGHT);

            $document.off('mouseup', stopResizing);
            $document.off('mousemove', move);

            // Pass info to undo redo service
            if (startWidth !== currentColumnWidth()) {
                startWidth = currentColumnWidth();
                $scope.$emit('content-changed');
            }
        };

        /**
         * Fire on move
         * Detect if move left or right
         * @param e
         */
        var move = function move(e) {

            var currentPos = e.clientX;

            if (startPos > currentPos) {
                $(row).removeClass(ANIMATE_RIGHT);
                $(row).addClass(ANIMATE_LEFT);
            } else if (startPos < currentPos) {

                $(row).removeClass(ANIMATE_LEFT);
                $(row).addClass(ANIMATE_RIGHT);
            }

            // If mouse moves 1/2 step distance
            if (startPos - currentPos > stepSize / 2) {
                resizeColumn(RESIZE_LEFT_STEP);
            } else if (currentPos - startPos > stepSize / 2) {
                resizeColumn(RESIZE_RIGHT_STEP);
            }

            e.preventDefault();
        };

        /**
         * Do actions to resize columns in view
         * @param changeValue
         */
        var resizeColumn = function resizeColumn(changeValue) {

            var newWidth = _this.columnsWidth[_this.columnIndex] + changeValue;

            if (!validateColumnWidth(newWidth)) {
                return;
            }

            recalculateStartDragPosition(changeValue);

            _this.columnsWidth[_this.columnIndex] = newWidth;
            _this.columnsWidth[_this.columnIndex + 1] = _this.columnsWidth[_this.columnIndex + 1] - changeValue;

            $scope.$apply();
        };

        /**
         * Check if column width is inside min/max.
         * Min max is calculated on mousedown
         * @param newWidth
         * @returns {boolean}
         */
        var validateColumnWidth = function validateColumnWidth(newWidth) {
            return newWidth >= colMinWidth && newWidth <= colMaxWidth;
        };

        /**
         * Recalculate cursor "start position"
         * Used to detect if we move right or left in future
         * @param changeValue Value of step for example -1 for step left, +1 step right
         */
        var recalculateStartDragPosition = function recalculateStartDragPosition(changeValue) {
            startPos += changeValue * stepSize;
        };

        /**
         * Calculate column width based on self width and right sibling width
         * @returns {number}
         */
        var calculateColumnMaxWidth = function calculateColumnMaxWidth() {
            if (_this.columnsWidth.length > 1) {
                return _this.columnsWidth[_this.columnIndex] + _this.columnsWidth[_this.columnIndex + 1] - 1;
            }
            return MAX_COL_WIDTH;
        };

        /**
         * Return minimum column width
         * @returns {number}
         */
        var calculateColumnMinWidth = function calculateColumnMinWidth() {
            return MIN_COL_WIDTH;
        };

        var currentColumnWidth = function currentColumnWidth() {
            return _this.columnsWidth[_this.columnIndex];
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.column-resizer', []).component('columnResizer', columnResizer).name;

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports = "<div class=\"column-resizer__handler\"></div>";

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColumnsBackgroundColor = function (_ConfigParameter) {
    _inherits(ColumnsBackgroundColor, _ConfigParameter);

    function ColumnsBackgroundColor() {
        _classCallCheck(this, ColumnsBackgroundColor);

        return _possibleConstructorReturn(this, (ColumnsBackgroundColor.__proto__ || Object.getPrototypeOf(ColumnsBackgroundColor)).call(this, 'columnsBackgroundColor', 'color', (0, _ConfigParameter2.gettext)('Columns background color'), 'mainConfig', 'transparent'));
    }

    return ColumnsBackgroundColor;
}(_ConfigParameter3.default);

exports.default = ColumnsBackgroundColor;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Children = function (_ConfigParameter) {
    _inherits(Children, _ConfigParameter);

    function Children() {
        _classCallCheck(this, Children);

        return _possibleConstructorReturn(this, (Children.__proto__ || Object.getPrototypeOf(Children)).call(this, 'children', 'columns', (0, _ConfigParameter2.gettext)('Columns count'), 'mainConfig', [[], []], null, [1, 2, 3, 4], null, null, (0, _ConfigParameter2.gettext)("Normally section is split into 12 columns. Adjust their widths according to your personal preferences. Remember that sum of widths bigger than max(12) will cause collumns to collapse.")));
    }

    return Children;
}(_ConfigParameter3.default);

exports.default = Children;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColumnsWidth = function (_ConfigParameter) {
    _inherits(ColumnsWidth, _ConfigParameter);

    function ColumnsWidth() {
        _classCallCheck(this, ColumnsWidth);

        return _possibleConstructorReturn(this, (ColumnsWidth.__proto__ || Object.getPrototypeOf(ColumnsWidth)).call(this, 'columnsWidth', 'columnsWidth', (0, _ConfigParameter2.gettext)('Columns width'), 'mainConfig', [6, 6], null, null));
    }

    return ColumnsWidth;
}(_ConfigParameter3.default);

exports.default = ColumnsWidth;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullWidth = function (_ConfigParameter) {
    _inherits(FullWidth, _ConfigParameter);

    function FullWidth() {
        _classCallCheck(this, FullWidth);

        return _possibleConstructorReturn(this, (FullWidth.__proto__ || Object.getPrototypeOf(FullWidth)).call(this, 'fullWidth', 'checkbox', (0, _ConfigParameter2.gettext)('Stretch section to full width'), 'position', false));
    }

    return FullWidth;
}(_ConfigParameter3.default);

exports.default = FullWidth;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PinSection = function (_ConfigParameter) {
    _inherits(PinSection, _ConfigParameter);

    function PinSection() {
        _classCallCheck(this, PinSection);

        var defaultOption = 0;
        var options = [{ value: "", label: (0, _ConfigParameter2.gettext)("Don't pin") }, { value: "top", label: (0, _ConfigParameter2.gettext)("Top") }, { value: "middle", label: (0, _ConfigParameter2.gettext)("Middle") }, { value: "bottom", label: (0, _ConfigParameter2.gettext)("Bottom") }];

        return _possibleConstructorReturn(this, (PinSection.__proto__ || Object.getPrototypeOf(PinSection)).call(this, 'pinSection', 'object-select', (0, _ConfigParameter2.gettext)('Pin Section'), 'position', options[defaultOption].value, null, options));
    }

    return PinSection;
}(_ConfigParameter3.default);

exports.default = PinSection;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Animation = function (_ConfigParameter) {
    _inherits(Animation, _ConfigParameter);

    function Animation() {
        _classCallCheck(this, Animation);

        var defaultValueIndex = 1;
        var options = [{ value: "", label: (0, _ConfigParameter2.gettext)("Animation disabled") }, { value: "fade-in", label: (0, _ConfigParameter2.gettext)("Fade in") }, { value: "fade-right", label: (0, _ConfigParameter2.gettext)("Fade right") }, { value: "fade-left", label: (0, _ConfigParameter2.gettext)("Fade left") }];

        return _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this, 'animation', 'object-select', (0, _ConfigParameter2.gettext)('Animation'), 'mainConfig', options[defaultValueIndex].value, null, options, null, null, (0, _ConfigParameter2.gettext)('Ignored if section is pinned.')));
    }

    return Animation;
}(_ConfigParameter3.default);

exports.default = Animation;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Anchor = function (_ConfigParameter) {
    _inherits(Anchor, _ConfigParameter);

    function Anchor() {
        _classCallCheck(this, Anchor);

        var anchorSchema = {
            title: '',
            sectionUid: '',
            visible: true
        };

        return _possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, 'anchor', 'text', (0, _ConfigParameter2.gettext)('Anchor'), 'hidden', anchorSchema, null, null, null, null, null));
    }

    return Anchor;
}(_ConfigParameter3.default);

exports.default = Anchor;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Parallax = function (_ConfigParameter) {
    _inherits(Parallax, _ConfigParameter);

    function Parallax() {
        _classCallCheck(this, Parallax);

        return _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, 'parallax', 'checkbox', (0, _ConfigParameter2.gettext)('Enable parallax effect'), 'mainConfig', false));
    }

    return Parallax;
}(_ConfigParameter3.default);

exports.default = Parallax;

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} section {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} {\n        background-image: url('{{($ctrl.elementModel.backgroundImage[0].media | imageUrl : 1920 : '') }}');\n        background-size: cover;\n        background-repeat: no-repeat;\n        background-color: {{ $ctrl.elementModel.backgroundColor }};\n        background-position: 50% 50%;\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} .section-columns {\n        display: flex;\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} .section-columns .section-column {\n        width: 100%;\n        background-color: {{ $ctrl.elementModel.columnsBackgroundColor }};\n    }\n\n</style>\n<div class=\"{{ $ctrl.elementModel.uid }} {{$ctrl.elementModel.customClassName}}\">\n    <div class=\"container{{ $ctrl.elementModel.fullWidth ? '-fluid' : '' }}\">\n        <section id=\"{{ $ctrl.elementModel.anchor.title }}\">\n            <div class=\"row section-row\">\n                <div class=\"col-sm-{{$ctrl.elementModel.columnsWidth[$index]}} section-{{columnIndex}} section-columns\"\n                     ng-repeat=\"(columnIndex,tmp) in [].constructor($ctrl.elementModel.children.length) track by $index\">\n                    <div class=\"section-column\">\n                        <creator-workspace\n                                sections=\"$ctrl.elementModel.children[columnIndex]\"\n                                context=\"$ctrl.context\" type=\"bag\"\n                                content=\"$ctrl.content\"\n                                ng-class=\"{'highlight-section': $ctrl.elementModel.children[columnIndex].length === 0}\">\n                        </creator-workspace>\n                    </div>\n                    <column-resizer\n                            columns-width=\"$ctrl.elementModel.columnsWidth\"\n                            column-index=\"$index\"\n                            ng-if=\"!$last\">\n                    </column-resizer>\n                </div>\n            </div>\n        </section>\n    </div>\n</div>\n\n<cms-creator-image-spinner ng-model=\"$ctrl.elementModel.backgroundImage\"></cms-creator-image-spinner>";

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _WorkspaceElement = __webpack_require__(238);

var _WorkspaceElement2 = _interopRequireDefault(_WorkspaceElement);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _PaddingsItems = __webpack_require__(1195);

var _PaddingsItems2 = _interopRequireDefault(_PaddingsItems);

var _ItemSpacing = __webpack_require__(1200);

var _ItemSpacing2 = _interopRequireDefault(_ItemSpacing);

var _ItemBorderRadius = __webpack_require__(1201);

var _ItemBorderRadius2 = _interopRequireDefault(_ItemBorderRadius);

var _Backgrounds = __webpack_require__(119);

var _Backgrounds2 = _interopRequireDefault(_Backgrounds);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _BackgroundItemColor = __webpack_require__(1202);

var _BackgroundItemColor2 = _interopRequireDefault(_BackgroundItemColor);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _MenuItemSelect = __webpack_require__(1203);

var _MenuItemSelect2 = _interopRequireDefault(_MenuItemSelect);

__webpack_require__(1204);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageMenu';

var creatorPageMenu = {
    bindings: {
        elementModel: '=',
        context: '<',
        content: '=',
        uid: '<'
    },
    template: __webpack_require__(1205),
    controller: ["ToolbarService", function controller(ToolbarService) {
        var _this = this;

        /** @ngInject */

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.menu', [_SectionsLibraryService2.default, _ToolbarService2.default, _WorkspaceElement2.default]).run(["SectionsLibraryService", "ToolbarService", "UniqueIdGenerator", "gettext", function (SectionsLibraryService, ToolbarService, UniqueIdGenerator, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'menu',
        type: MODULE_NAME,
        label: gettext('Menu'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            itemPosition: {
                label: gettext('Item position'),
                isOpen: false,
                type: 'itemPosition'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var align = new _Align2.default();
    align.setDefaultValue('right');

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('#192a3a');

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _MenuItemSelect2.default(), textColor, new _BackgroundItemColor2.default(), new _ItemBorderRadius2.default(), new _Backgrounds2.default(), align, new _Paddings2.default(), new _ItemSpacing2.default(), new _PaddingsItems2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageMenu', creatorPageMenu).name;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _PaddingItemTop = __webpack_require__(1196);

var _PaddingItemTop2 = _interopRequireDefault(_PaddingItemTop);

var _PaddingItemBottom = __webpack_require__(1197);

var _PaddingItemBottom2 = _interopRequireDefault(_PaddingItemBottom);

var _PaddingItemLeft = __webpack_require__(1198);

var _PaddingItemLeft2 = _interopRequireDefault(_PaddingItemLeft);

var _PaddingItemRight = __webpack_require__(1199);

var _PaddingItemRight2 = _interopRequireDefault(_PaddingItemRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaddingsItems = function PaddingsItems() {
    var paddingTopBottom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { value: 15, unit: 'px' };
    var paddingLeftRight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { value: 15, unit: 'px' };
    var defaultUnits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['px', '%'];

    _classCallCheck(this, PaddingsItems);

    var paddingItemTop = new _PaddingItemTop2.default();
    paddingItemTop.setDefaultValue(_extends({}, paddingTopBottom));
    paddingItemTop.setUnits(defaultUnits);
    paddingItemTop.setGroup('itemPosition');

    var paddingItemBottom = new _PaddingItemBottom2.default();
    paddingItemBottom.setDefaultValue(_extends({}, paddingTopBottom));
    paddingItemBottom.setUnits(defaultUnits);
    paddingItemBottom.setGroup('itemPosition');

    var paddingItemLeft = new _PaddingItemLeft2.default();
    paddingItemLeft.setDefaultValue(_extends({}, paddingLeftRight));
    paddingItemLeft.setUnits(defaultUnits);
    paddingItemLeft.setGroup('itemPosition');

    var paddingItemRight = new _PaddingItemRight2.default();
    paddingItemRight.setDefaultValue(_extends({}, paddingLeftRight));
    paddingItemRight.setUnits(defaultUnits);
    paddingItemRight.setGroup('itemPosition');

    return _extends({}, paddingItemTop, paddingItemBottom, paddingItemLeft, paddingItemRight);
};

exports.default = PaddingsItems;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingItemTop = function (_ConfigParameter) {
    _inherits(PaddingItemTop, _ConfigParameter);

    function PaddingItemTop() {
        _classCallCheck(this, PaddingItemTop);

        return _possibleConstructorReturn(this, (PaddingItemTop.__proto__ || Object.getPrototypeOf(PaddingItemTop)).call(this, 'paddingItemTop', 'number', (0, _ConfigParameter2.gettext)('Padding top'), 'itemPosition', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingItemTop;
}(_ConfigParameter3.default);

exports.default = PaddingItemTop;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingItemBottom = function (_ConfigParameter) {
    _inherits(PaddingItemBottom, _ConfigParameter);

    function PaddingItemBottom() {
        _classCallCheck(this, PaddingItemBottom);

        return _possibleConstructorReturn(this, (PaddingItemBottom.__proto__ || Object.getPrototypeOf(PaddingItemBottom)).call(this, 'paddingItemBottom', 'number', (0, _ConfigParameter2.gettext)('Padding bottom'), 'itemPosition', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingItemBottom;
}(_ConfigParameter3.default);

exports.default = PaddingItemBottom;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingItemLeft = function (_ConfigParameter) {
    _inherits(PaddingItemLeft, _ConfigParameter);

    function PaddingItemLeft() {
        _classCallCheck(this, PaddingItemLeft);

        return _possibleConstructorReturn(this, (PaddingItemLeft.__proto__ || Object.getPrototypeOf(PaddingItemLeft)).call(this, 'paddingItemLeft', 'number', (0, _ConfigParameter2.gettext)('Padding left'), 'itemPosition', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingItemLeft;
}(_ConfigParameter3.default);

exports.default = PaddingItemLeft;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaddingItemRight = function (_ConfigParameter) {
    _inherits(PaddingItemRight, _ConfigParameter);

    function PaddingItemRight() {
        _classCallCheck(this, PaddingItemRight);

        return _possibleConstructorReturn(this, (PaddingItemRight.__proto__ || Object.getPrototypeOf(PaddingItemRight)).call(this, 'paddingItemRight', 'number', (0, _ConfigParameter2.gettext)('Padding right'), 'itemPosition', { value: 15, unit: 'px' }, ['px', '%']));
    }

    return PaddingItemRight;
}(_ConfigParameter3.default);

exports.default = PaddingItemRight;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemSpacing = function (_ConfigParameter) {
    _inherits(ItemSpacing, _ConfigParameter);

    function ItemSpacing() {
        _classCallCheck(this, ItemSpacing);

        return _possibleConstructorReturn(this, (ItemSpacing.__proto__ || Object.getPrototypeOf(ItemSpacing)).call(this, 'itemSpacing', 'number', (0, _ConfigParameter2.gettext)('Space between items'), 'itemPosition', { value: 15, unit: 'px' }, ['px']));
    }

    return ItemSpacing;
}(_ConfigParameter3.default);

exports.default = ItemSpacing;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemBorderRadius = function (_ConfigParameter) {
    _inherits(ItemBorderRadius, _ConfigParameter);

    function ItemBorderRadius() {
        _classCallCheck(this, ItemBorderRadius);

        return _possibleConstructorReturn(this, (ItemBorderRadius.__proto__ || Object.getPrototypeOf(ItemBorderRadius)).call(this, 'itemBorderRadius', 'number', (0, _ConfigParameter2.gettext)('Item border radius'), 'mainConfig', { value: 0, unit: 'px' }, ['px']));
    }

    return ItemBorderRadius;
}(_ConfigParameter3.default);

exports.default = ItemBorderRadius;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundItemColor = function (_ConfigParameter) {
    _inherits(BackgroundItemColor, _ConfigParameter);

    function BackgroundItemColor() {
        _classCallCheck(this, BackgroundItemColor);

        return _possibleConstructorReturn(this, (BackgroundItemColor.__proto__ || Object.getPrototypeOf(BackgroundItemColor)).call(this, 'backgroundItemColor', 'color', (0, _ConfigParameter2.gettext)('Item background color'), 'mainConfig', 'transparent'));
    }

    return BackgroundItemColor;
}(_ConfigParameter3.default);

exports.default = BackgroundItemColor;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItemSelect = function (_ConfigParameter) {
    _inherits(MenuItemSelect, _ConfigParameter);

    function MenuItemSelect() {
        _classCallCheck(this, MenuItemSelect);

        return _possibleConstructorReturn(this, (MenuItemSelect.__proto__ || Object.getPrototypeOf(MenuItemSelect)).call(this, 'menu-item-select', 'menu', (0, _ConfigParameter2.gettext)('Select items'), 'mainConfig', '', null, null, null, null, null));
    }

    return MenuItemSelect;
}(_ConfigParameter3.default);

exports.default = MenuItemSelect;

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n        background-color: {{ $ctrl.elementModel.backgroundColor }};\n        text-align: {{ $ctrl.elementModel.align }};\n        line-height: 0;\n\n        background-image: url('{{($ctrl.elementModel.backgroundImage[0].media | imageUrl : 1920 : '') }}');\n        background-size: cover;\n        background-repeat: no-repeat;\n\n    }\n\n    /*menu-default*/\n\n    .{{ ::$ctrl.elementModel.uid }} ul.menu {\n        list-style: none;\n        margin: 0 auto;\n        padding: 0;\n        overflow: hidden;\n        display: block;\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} ul.menu > li {\n        float: left;\n        margin-right: {{ $ctrl.elementModel.itemSpacing | numberWithUnit }};\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} ul.menu > li:last-child {\n        margin-right: 0;\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} ul.menu > li a {\n        display: block;\n        text-decoration: none;\n        color: {{ $ctrl.elementModel.color }};\n        border-radius: {{ $ctrl.elementModel.itemBorderRadius | numberWithUnit }};\n        background-color: {{ $ctrl.elementModel.backgroundItemColor }};\n        padding-top: {{ $ctrl.elementModel.paddingItemTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingItemBottom | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingItemRight | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingItemLeft | numberWithUnit }};\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} ul.menu > li a:hover {\n        opacity: .8;\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} .collapse {\n        display: inline-block;\n    }\n\n</style>\n\n<div>\n    <div class=\"collapse\">\n        <ul class=\"menu {{$ctrl.elementModel.customClassName}}\">\n            <li ng-repeat=\"section in $ctrl.content\" ng-if=\"section.config.anchor.title && section.config.anchor.visible\">\n                <a>{{ section.config.anchor.title }}</a>\n            </li>\n        </ul>\n    </div>\n</div>\n\n\n\n\n";

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _MediaPlaceholder = __webpack_require__(242);

var _MediaPlaceholder2 = _interopRequireDefault(_MediaPlaceholder);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _MapAddress = __webpack_require__(1207);

var _MapAddress2 = _interopRequireDefault(_MapAddress);

var _MapApiKey = __webpack_require__(1208);

var _MapApiKey2 = _interopRequireDefault(_MapApiKey);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _Height = __webpack_require__(244);

var _Height2 = _interopRequireDefault(_Height);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageMap';

var creatorPageSectionMap = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1209),
    controller: ['ToolbarService', '$element', '$rootScope', function controller(ToolbarService, $element, $rootScope) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
            _this.markLocation();
        };

        $rootScope.$on('map-changed', function () {
            _this.markLocation();
        });

        this.markLocation = function () {
            //this console log is necessary for testing why maps are not working
            console.log(_this.elementModel.address);
            var map = new google.maps.Map($element.find('.map-container')[0], {
                zoom: _this.elementModel.address.zoom,
                center: _this.elementModel.address.coordinates,
                disableDefaultUI: true,
                draggable: false
            });
            var marker = new google.maps.Marker({ position: _this.elementModel.address.coordinates, map: map });
        };
    }]

};

exports.default = _angular2.default.module('cms.creator.page.section-map', [_SectionsLibraryService2.default, _ToolbarService2.default, _MediaPlaceholder2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', 'UniqueIdGenerator', function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'map',
        type: MODULE_NAME,
        label: gettext('Map'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _MapAddress2.default(), new _MapApiKey2.default(), new _Paddings2.default(), new _Height2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionMap', creatorPageSectionMap).name;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MapAddress = function (_ConfigParameter) {
    _inherits(MapAddress, _ConfigParameter);

    function MapAddress() {
        _classCallCheck(this, MapAddress);

        var defaultAddress = {
            textAddress: 'New York',
            coordinates: {
                lat: 40.7127753,
                lng: -74.0059728
            },
            zoom: 5
        };

        return _possibleConstructorReturn(this, (MapAddress.__proto__ || Object.getPrototypeOf(MapAddress)).call(this, 'address', 'map-address', (0, _ConfigParameter2.gettext)('Address'), 'mainConfig', defaultAddress));
    }

    return MapAddress;
}(_ConfigParameter3.default);

exports.default = MapAddress;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MapApiKey = function (_ConfigParameter) {
    _inherits(MapApiKey, _ConfigParameter);

    function MapApiKey() {
        _classCallCheck(this, MapApiKey);

        return _possibleConstructorReturn(this, (MapApiKey.__proto__ || Object.getPrototypeOf(MapApiKey)).call(this, 'apiKey', 'text', (0, _ConfigParameter2.gettext)('Map API key'), 'mainConfig', 'AIzaSyCx76iGb_5XO6gb9ZLGWeeO3Ok3EMUqbsc'));
    }

    return MapApiKey;
}(_ConfigParameter3.default);

exports.default = MapApiKey;

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{$ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{$ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{$ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{$ctrl.elementModel.paddingRight | numberWithUnit }};\n    }\n\n    #map-{{ $ctrl.elementModel.uid }}  {\n        height: {{$ctrl.elementModel.height | numberWithUnit }};\n    }\n</style>\n\n<div>\n    <div id=\"map-{{ $ctrl.elementModel.uid }}\" class=\"map-container {{$ctrl.elementModel.customClassName}}\"></div>\n</div>\n";

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _SizeWidth = __webpack_require__(452);

var _SizeWidth2 = _interopRequireDefault(_SizeWidth);

var _Video = __webpack_require__(1211);

var _Video2 = _interopRequireDefault(_Video);

__webpack_require__(1212);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageVideo';

var creatorPageSectionVideo = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1213),
    controller: ['ToolbarService', '$sce', function controller(ToolbarService, $sce) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.url = function () {
            return $sce.trustAsResourceUrl(_this.elementModel.video.data);
        };
    }]

};

exports.default = _angular2.default.module('cms.creator.page.section-video', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', 'UniqueIdGenerator', function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'video_library',
        type: MODULE_NAME,
        label: gettext('Video'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var sizeWidth = new _SizeWidth2.default();
    sizeWidth.setDefaultValue({ value: 100, unit: '%' });

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _Video2.default(), new _Align2.default(), new _Paddings2.default(), sizeWidth, new _CustomClassName2.default()));
}]).component('cmsCreatorPageSectionVideo', creatorPageSectionVideo).name;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Video = function (_ConfigParameter) {
    _inherits(Video, _ConfigParameter);

    function Video() {
        _classCallCheck(this, Video);

        var model = {
            videoId: '',
            data: '',
            videoType: '',
            url: ''
        };

        return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, 'video', 'video', (0, _ConfigParameter2.gettext)('Video URL'), 'mainConfig', model, null, null, null, null, (0, _ConfigParameter2.gettext)('Only videos from Youtube and Vimeo are supported.')));
    }

    return Video;
}(_ConfigParameter3.default);

exports.default = Video;

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n    }\n\n    .{{ ::$ctrl.elementModel.uid }} .wrapper-width {\n        position:relative;\n        width: {{ $ctrl.elementModel.width | numberWithUnit }};\n        max-width: 100%;\n    }\n\n</style>\n\n<div ng-if=\"$ctrl.elementModel.video.data\">\n    <div class=\"cover-video\"></div>\n    <div class=\"wrapper-width\"\n         ng-class=\"{'pull-left': $ctrl.elementModel.align == 'left',\n                    'pull-right': $ctrl.elementModel.align == 'right',\n                    'center-block': $ctrl.elementModel.align == 'center'}\">\n        <div class=\"video-wrapper {{$ctrl.elementModel.customClassName}}\">\n            <iframe\n                ng-src=\"{{ $ctrl.url() }}\"\n                allow=\"autoplay; encrypted-media\"\n                allowfullscreen\n                title=\"{{ 'Video player' | translate }}\"\n            >\n            </iframe>\n        </div>\n    </div>\n</div>\n<div style=\"width: 100%\" ng-if=\"!$ctrl.elementModel.video.data\">\n    <div class=\"video-placeholder\">\n        <div class=\"image-placeholder\">\n            <i class=\"material-icons video-icon\">video_library</i>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

__webpack_require__(1215);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

var _UrlPart = __webpack_require__(454);

var _UrlPart2 = _interopRequireDefault(_UrlPart);

var _Language = __webpack_require__(455);

var _Language2 = _interopRequireDefault(_Language);

var _Timeline = __webpack_require__(1216);

var _Timeline2 = _interopRequireDefault(_Timeline);

var _Events = __webpack_require__(1217);

var _Events2 = _interopRequireDefault(_Events);

var _Messages = __webpack_require__(1218);

var _Messages2 = _interopRequireDefault(_Messages);

var _ShowUsers = __webpack_require__(1219);

var _ShowUsers2 = _interopRequireDefault(_ShowUsers);

var _ContentGuardService = __webpack_require__(169);

var _ContentGuardService2 = _interopRequireDefault(_ContentGuardService);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

var _TwitterWidth = __webpack_require__(456);

var _TwitterWidth2 = _interopRequireDefault(_TwitterWidth);

var _Height = __webpack_require__(244);

var _Height2 = _interopRequireDefault(_Height);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageFacebookFeed';

var creatorPageSectionFacebookFeed = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1220),
    controller: ["ToolbarService", "ContentGuardService", "$scope", function controller(ToolbarService, ContentGuardService, $scope) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);
        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));

            ContentGuardService.registerLocked(MODULE_NAME);
            FB.init({
                status: true,
                xfbml: true,
                version: 'v3.2'
            });
            FB.XFBML.parse();
        };

        $scope.$on('$destroy', function () {
            ContentGuardService.deregisterLocked(MODULE_NAME);
        });

        var debounce = void 0;
        $scope.$watchCollection('$ctrl.elementModel', function (newParameters, oldParameters) {
            if (newParameters['customClassName'] === oldParameters['customClassName'] && newParameters['language'] === oldParameters['language'] && newParameters['align'] === oldParameters['align']) {
                reloadFacebook();
            }
        });

        $scope.$watchCollection('$ctrl.elementModel.width', function () {
            reloadFacebook();
        });
        $scope.$watchCollection('$ctrl.elementModel.height', function () {
            reloadFacebook();
        });

        var reloadFacebook = function reloadFacebook() {
            clearTimeout(debounce);
            debounce = setTimeout(function () {
                FB.XFBML.parse();
            }, 500);
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-facebook-feed', [_SectionsLibraryService2.default, _ToolbarService2.default, _ContentGuardService2.default]).run(["SectionsLibraryService", "ToolbarService", "gettext", "UniqueIdGenerator", function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'face',
        type: MODULE_NAME,
        label: gettext('Facebook Feed'),
        group: 'page',
        options: {
            disableCopy: true
        },
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _UrlPart2.default(), new _Language2.default(), new _TwitterWidth2.default(), new _Height2.default(), new _Paddings2.default(), new _Align2.default(), new _CustomClassName2.default(), new _Timeline2.default(), new _Events2.default(), new _Messages2.default(), new _ShowUsers2.default()));
}]).component('cmsCreatorPageSectionFacebookFeed', creatorPageSectionFacebookFeed).name;

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Timeline = function (_ConfigParameter) {
    _inherits(Timeline, _ConfigParameter);

    function Timeline() {
        _classCallCheck(this, Timeline);

        return _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, 'timeline', 'checkbox', (0, _ConfigParameter2.gettext)('Show timeline'), 'advanced', true));
    }

    return Timeline;
}(_ConfigParameter3.default);

exports.default = Timeline;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Events = function (_ConfigParameter) {
    _inherits(Events, _ConfigParameter);

    function Events() {
        _classCallCheck(this, Events);

        return _possibleConstructorReturn(this, (Events.__proto__ || Object.getPrototypeOf(Events)).call(this, 'events', 'checkbox', (0, _ConfigParameter2.gettext)('Show events'), 'advanced', false));
    }

    return Events;
}(_ConfigParameter3.default);

exports.default = Events;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Messages = function (_ConfigParameter) {
    _inherits(Messages, _ConfigParameter);

    function Messages() {
        _classCallCheck(this, Messages);

        return _possibleConstructorReturn(this, (Messages.__proto__ || Object.getPrototypeOf(Messages)).call(this, 'messages', 'checkbox', (0, _ConfigParameter2.gettext)('Show messages'), 'advanced', false));
    }

    return Messages;
}(_ConfigParameter3.default);

exports.default = Messages;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowUsers = function (_ConfigParameter) {
    _inherits(ShowUsers, _ConfigParameter);

    function ShowUsers() {
        _classCallCheck(this, ShowUsers);

        return _possibleConstructorReturn(this, (ShowUsers.__proto__ || Object.getPrototypeOf(ShowUsers)).call(this, 'showUsers', 'checkbox', (0, _ConfigParameter2.gettext)('Show users avatars in header'), 'advanced', true));
    }

    return ShowUsers;
}(_ConfigParameter3.default);

exports.default = ShowUsers;

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n        text-align: {{$ctrl.elementModel.align}};\n    }\n</style>\n\n<div class=\"{{ $ctrl.elementModel.customClassName }}\">\n    <div id=\"{{ $ctrl.elementModel.sectionId }}\">\n        <div class=\"fb-page\" data-href=\"https://www.facebook.com/{{ $ctrl.elementModel.urlPart }}\"\n             data-tabs=\"{{ $ctrl.elementModel.timeline  ? 'timeline' : '' }},{{ $ctrl.elementModel.events  ? 'events' : '' }},{{ $ctrl.elementModel.messages  ? 'messages' : '' }}\"\n             data-small-header=\"false\"\n             data-adapt-container-width=\"false\"\n             data-hide-cover=\"false\"\n             data-show-facepile=\"{{ $ctrl.elementModel.showUsers }}\"\n             data-width=\"{{ $ctrl.elementModel.width.value}}\"\n             data-height=\"{{ $ctrl.elementModel.height.value}}\">\n            <blockquote cite=\"https://www.facebook.com/{{ $ctrl.elementModel.urlPart }}\" class=\"fb-xfbml-parse-ignore\"><a\n                href=\"https://www.facebook.com/{{ $ctrl.elementModel.urlPart }}\">{{ $ctrl.elementModel.urlPart }}</a></blockquote>\n        </div>\n        <div id=\"fb-root\"></div>\n    </div>\n</div>";

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

__webpack_require__(1222);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

var _UrlPart = __webpack_require__(454);

var _UrlPart2 = _interopRequireDefault(_UrlPart);

var _ContentGuardService = __webpack_require__(169);

var _ContentGuardService2 = _interopRequireDefault(_ContentGuardService);

var _TwitterWidth = __webpack_require__(456);

var _TwitterWidth2 = _interopRequireDefault(_TwitterWidth);

var _Height = __webpack_require__(244);

var _Height2 = _interopRequireDefault(_Height);

var _Language = __webpack_require__(455);

var _Language2 = _interopRequireDefault(_Language);

var _Align = __webpack_require__(75);

var _Align2 = _interopRequireDefault(_Align);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'pageTwitterFeed';

var creatorPageSectionTwitterFeed = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: __webpack_require__(1223),
    controller: ["ToolbarService", "ContentGuardService", "$scope", "$element", function controller(ToolbarService, ContentGuardService, $scope, $element) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);
        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));

            ContentGuardService.registerLocked(MODULE_NAME);
        };

        $scope.$on('$destroy', function () {
            ContentGuardService.deregisterLocked(MODULE_NAME);
        });

        var debounce = void 0;
        $scope.$watchCollection('$ctrl.elementModel', function (newParameters, oldParameters) {
            if (newParameters['customClassName'] === oldParameters['customClassName'] && newParameters['language'] === oldParameters['language'] && newParameters['align'] === oldParameters['align']) {
                reloadTwitter();
            }
        });
        $scope.$watchCollection('$ctrl.elementModel.width', function () {
            reloadTwitter();
        });
        $scope.$watchCollection('$ctrl.elementModel.height', function () {
            reloadTwitter();
        });

        var reloadTwitter = function reloadTwitter() {
            clearTimeout(debounce);
            debounce = setTimeout(function () {
                var outerElement = document.getElementById(_this.elementModel.sectionId);
                outerElement.innerHTML = "<a class=\"twitter-timeline\" id=\"twitter-timeline\"\n                                               data-width=\"" + _this.elementModel.width.value + "\"\n                                               data-height=\"" + _this.elementModel.height.value + "\"\n                                               data-lang=\"en\"\n                                               href=\"https://twitter.com/" + _this.elementModel.urlPart + "?ref_src=twsrc%5Etfw\">\n                                                Tweets by " + _this.elementModel.urlPart + "\n                                            </a>";
                twttr.widgets.load($element[0].querySelector("#twitter-timeline"));
            }, 300);
        };
    }]
};

exports.default = _angular2.default.module('cms.creator.page.section-twitter-feed', [_SectionsLibraryService2.default, _ToolbarService2.default, _ContentGuardService2.default]).run(["SectionsLibraryService", "ToolbarService", "gettext", "UniqueIdGenerator", function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'view_stream',
        type: MODULE_NAME,
        label: gettext('Twitter Feed'),
        group: 'page',
        options: {
            disableCopy: true
        },
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var urlPart = new _UrlPart2.default();
    urlPart.setLabel(gettext('Twitter login'));
    urlPart.setDefaultValue('TwitterDev');

    var language = new _Language2.default();
    language.setOptions([{ value: 'en', label: 'English' }, { value: 'pl', label: 'Polski' }]);
    language.setDefaultValue('en');

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('sectionId', 'hidden', gettext('Section Id'), null, function (type) {
        return UniqueIdGenerator.generate(type);
    }), new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), urlPart, language, new _Paddings2.default(), new _Align2.default(), new _CustomClassName2.default(), new _TwitterWidth2.default(), new _Height2.default()));
}]).component('cmsCreatorPageSectionTwitterFeed', creatorPageSectionTwitterFeed).name;

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.elementModel.uid }} {\n        padding-top: {{ $ctrl.elementModel.paddingTop | numberWithUnit }};\n        padding-bottom: {{ $ctrl.elementModel.paddingBottom | numberWithUnit }};\n        padding-left: {{ $ctrl.elementModel.paddingLeft | numberWithUnit }};\n        padding-right: {{ $ctrl.elementModel.paddingRight | numberWithUnit }};\n        text-align: {{$ctrl.elementModel.align}};\n    }\n</style>\n\n<div class=\"{{ $ctrl.elementModel.customClassName }}\">\n    <div id=\"{{ $ctrl.elementModel.sectionId }}\">\n\n    </div>\n</div>";

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(1225);

var _textInput = __webpack_require__(1226);

var _textInput2 = _interopRequireDefault(_textInput);

var _emailInput = __webpack_require__(1228);

var _emailInput2 = _interopRequireDefault(_emailInput);

var _dateInput = __webpack_require__(1230);

var _dateInput2 = _interopRequireDefault(_dateInput);

var _dateTimeInput = __webpack_require__(1232);

var _dateTimeInput2 = _interopRequireDefault(_dateTimeInput);

var _numberInput = __webpack_require__(1234);

var _numberInput2 = _interopRequireDefault(_numberInput);

var _radioInput = __webpack_require__(1236);

var _radioInput2 = _interopRequireDefault(_radioInput);

var _selectInput = __webpack_require__(1238);

var _selectInput2 = _interopRequireDefault(_selectInput);

var _textareaInput = __webpack_require__(1240);

var _textareaInput2 = _interopRequireDefault(_textareaInput);

var _checkboxInput = __webpack_require__(1243);

var _checkboxInput2 = _interopRequireDefault(_checkboxInput);

var _plainTextInput = __webpack_require__(1245);

var _plainTextInput2 = _interopRequireDefault(_plainTextInput);

var _submitInput = __webpack_require__(1247);

var _submitInput2 = _interopRequireDefault(_submitInput);

var _captchaInput = __webpack_require__(1249);

var _captchaInput2 = _interopRequireDefault(_captchaInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creatorFormEditor = {
    bindings: {
        elementModel: '<'
    },
    template: __webpack_require__(1251)
};

exports.default = _angular2.default.module('cms.creator.form.editor', [_textInput2.default, _emailInput2.default, _dateInput2.default, _dateTimeInput2.default, _numberInput2.default, _radioInput2.default, _selectInput2.default, _textareaInput2.default, _checkboxInput2.default, _plainTextInput2.default, _submitInput2.default, _captchaInput2.default]).component('cmsCreatorFormEditor', creatorFormEditor).name;

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formText';

var creatorFormInputText = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "$uibModal", "$filter", "gettextCatalog", function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1227)
};

exports.default = _angular2.default.module('cms.creator.form.input.text', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'title',
        type: MODULE_NAME,
        label: gettext('Text'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Text'));
    var placeholder = new _Placeholder2.default();
    placeholder.setDefaultValue('Text');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputText', creatorFormInputText).name;

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} input {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{ $ctrl.elementModel.label}}</label>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\">\n        <input type=\"text\"\n               class=\"form-control form-{{ $ctrl.elementModel.key }}\"\n               name=\"form[{{ $ctrl.elementModel.key }}]\"\n               placeholder=\"{{ $ctrl.elementModel.placeholder || '' }}\"\n               required=\"{{ $ctrl.elementModel.required || false }}\"\n               ng-class=\"{'has-tooltip': $ctrl.input.helperText != ''}\"\n               tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n               autocomplete=\"off\"\n               readonly\n        />\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formEmail';

var creatorFormInputEmail = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "$uibModal", "$filter", "gettextCatalog", function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1229)
};

exports.default = _angular2.default.module('cms.creator.form.input.email', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'mail_outline',
        type: MODULE_NAME,
        label: gettext('Email'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Email'));
    var placeholder = new _Placeholder2.default();
    placeholder.setDefaultValue('Email');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputEmail', creatorFormInputEmail).name;

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} input {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required, 'inline-element': $ctrl.elementModel.inline}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{ $ctrl.elementModel.label}}</label>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\">\n        <input type=\"email\"\n               class=\"form-control form-{{ $ctrl.elementModel.key }}\"\n               name=\"form[{{ $ctrl.elementModel.key }}]\"\n               placeholder=\"{{ $ctrl.elementModel.placeholder || '' }}\"\n               required=\"{{ $ctrl.elementModel.required || false }}\"\n               tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n               autocomplete=\"off\"\n               readonly\n        />\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formDate';

var creatorFormInputDate = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ['ToolbarService', '$uibModal', '$filter', 'gettextCatalog', function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img alt="media" src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1231)
};

exports.default = _angular2.default.module('cms.creator.form.input.date', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['ToolbarService', 'gettext', 'SectionsLibraryService', function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'date_range',
        type: MODULE_NAME,
        label: gettext('Date'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Date'));
    var placeholder = new _Placeholder2.default();
    placeholder.setDefaultValue('Date');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputDate', creatorFormInputDate).name;

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} input {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required, 'inline-element': $ctrl.elementModel.inline}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{ $ctrl.elementModel.label}}</label>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\">\n        <input type=\"text\"\n               class=\"form-control form-{{ $ctrl.elementModel.key }}\"\n               name=\"form[{{ $ctrl.elementModel.key }}]\"\n               placeholder=\"{{ $ctrl.elementModel.placeholder || '' }}\"\n               required=\"{{ $ctrl.elementModel.required || false }}\"\n               tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n               autocomplete=\"off\"\n               readonly\n        />\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formDateTime';

var creatorFormInputDateTime = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "$uibModal", "$filter", "gettextCatalog", function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1233)
};

exports.default = _angular2.default.module('cms.creator.form.input.date.time', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'access_time',
        type: MODULE_NAME,
        label: gettext('Date and time'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Date and time'));
    var placeholder = new _Placeholder2.default();
    placeholder.setDefaultValue('Date and time');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputDateTime', creatorFormInputDateTime).name;

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} input {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required, 'inline-element': $ctrl.elementModel.inline}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{ $ctrl.elementModel.label}}</label>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\">\n        <input type=\"text\"\n               class=\"form-control form-{{ $ctrl.elementModel.key }}\"\n               name=\"form[{{ $ctrl.elementModel.key }}]\"\n               placeholder=\"{{ $ctrl.elementModel.placeholder || '' }}\"\n               required=\"{{ $ctrl.elementModel.required || false }}\"\n               tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n               autocomplete=\"off\"\n               readonly\n        />\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formNumber';

var creatorFormInputNumber = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "$uibModal", "$filter", "gettextCatalog", function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1235)
};

exports.default = _angular2.default.module('cms.creator.form.input.number', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'looks_one',
        type: MODULE_NAME,
        label: gettext('Number'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Number'));
    var placeholder = new _Placeholder2.default();
    placeholder.setDefaultValue('Number');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputNumber', creatorFormInputNumber).name;

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} input {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{ $ctrl.elementModel.label}}</label>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\">\n        <input type=\"number\"\n               class=\"form-control form-{{ $ctrl.elementModel.key }}\"\n               name=\"form[{{ $ctrl.elementModel.key }}]\"\n               placeholder=\"{{ $ctrl.elementModel.placeholder || '' }}\"\n               required=\"{{ $ctrl.elementModel.required || false }}\"\n               tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n               autocomplete=\"off\"\n               readonly\n        />\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _InlineInputs = __webpack_require__(457);

var _InlineInputs2 = _interopRequireDefault(_InlineInputs);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _Options = __webpack_require__(245);

var _Options2 = _interopRequireDefault(_Options);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formRadio';

var creatorFormInputRadio = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "$uibModal", "$filter", "gettextCatalog", function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        _angular2.default.forEach(defaultConfig.options, function (optionText, index) {
            defaultConfig.options[index] = gettextCatalog.getString(defaultConfig.options[index]);
        });

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1237)
};

exports.default = _angular2.default.module('cms.creator.form.input.radio', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'radio_button_checked',
        type: MODULE_NAME,
        label: gettext('Radio buttons'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });
    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Radio'));
    var placeholder = new _Placeholder2.default();
    placeholder.setInputType('hidden');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Options2.default(), new _InlineInputs2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputRadio', creatorFormInputRadio).name;

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} input {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{$ctrl.elementModel.label }}</label>\n    <div class=\"col-sm-{{$ctrl.parentModel.labelWidth}}\"\n         ng-if=\"($ctrl.parentModel.labelsPosition == 'left' && !$ctrl.elementModel.label)\"></div>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\"\n         tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\">\n            <span ng-repeat=\"option in $ctrl.elementModel.options track by $index\"\n                  ng-class=\"$ctrl.elementModel.inlineInputs ? 'radio-inline' : 'radio'\">\n                <label class=\"form-{{ $ctrl.elementModel.key }}\">\n                    <input type=\"radio\" name=\"form[{{ $ctrl.elementModel.key }}]\" value=\"{{ option }}\" readonly disabled/>\n                    <span>{{ option }}</span>\n                </label>\n            </span>\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _Options = __webpack_require__(245);

var _Options2 = _interopRequireDefault(_Options);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formSelect';

var creatorFormInputSelect = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "$uibModal", "$filter", "gettextCatalog", function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        _angular2.default.forEach(defaultConfig.options, function (optionText, index) {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            defaultConfig.options[index] = gettextCatalog.getString(defaultConfig.options[index]);
        });

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1239)
};

exports.default = _angular2.default.module('cms.creator.form.input.select', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'arrow_drop_down',
        type: MODULE_NAME,
        label: gettext('Select'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Select'));
    var placeholder = new _Placeholder2.default();
    placeholder.setDefaultValue('Select');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Options2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputSelect', creatorFormInputSelect).name;

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} select {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required, 'inline-element': $ctrl.elementModel.inline}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{$ctrl.elementModel.label }}</label>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\">\n        <select\n                class=\"form-control form-{{ $ctrl.elementModel.key }}\"\n                name=\"form[{{ $ctrl.elementModel.key }}]\"\n                required=\"{{ $ctrl.elementModel.required || false }}\"\n                tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n                readonly\n        >\n            <option value=\"\" disabled selected ng-if=\"$ctrl.elementModel.placeholder\">{{\n                $ctrl.elementModel.placeholder }}\n            </option>\n            <option ng-repeat=\"option in $ctrl.elementModel.options\" value=\"{{ ::option }}\">\n                {{ ::option }}\n            </option>\n        </select>\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _Rows = __webpack_require__(1241);

var _Rows2 = _interopRequireDefault(_Rows);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formTextarea';

var creatorFormInputTextarea = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "$uibModal", "$filter", "gettextCatalog", function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1242)
};

exports.default = _angular2.default.module('cms.creator.form.input.textarea', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'text_fields',
        type: MODULE_NAME,
        label: gettext('Textarea'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Textarea'));
    var placeholder = new _Placeholder2.default();
    placeholder.setDefaultValue('Textarea');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Rows2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputTextarea', creatorFormInputTextarea).name;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfigParameter2 = __webpack_require__(4);

var _ConfigParameter3 = _interopRequireDefault(_ConfigParameter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rows = function (_ConfigParameter) {
    _inherits(Rows, _ConfigParameter);

    function Rows() {
        _classCallCheck(this, Rows);

        return _possibleConstructorReturn(this, (Rows.__proto__ || Object.getPrototypeOf(Rows)).call(this, 'rows', 'number', (0, _ConfigParameter2.gettext)('Number of rows'), 'mainConfig', { value: 5, unit: '' }, ['']));
    }

    return Rows;
}(_ConfigParameter3.default);

exports.default = Rows;

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} textarea {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\"\n     tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n     ng-class=\"{'required': $ctrl.elementModel.required, 'inline-element': $ctrl.elementModel.inline}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{ $ctrl.elementModel.label}}</label>\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\">\n        <textarea class=\"form-control form-{{ $ctrl.elementModel.key }}\"\n                  name=\"{{ $ctrl.elementModel.key }}\"\n                  placeholder=\"{{ $ctrl.elementModel.placeholder || '' }}\"\n                  required=\"{{ $ctrl.elementModel.required || false }}\"\n                  rows=\"{{$ctrl.elementModel.rows | numberWithUnit : ''}}\"\n                  tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\"\n                  autocomplete=\"off\"\n                  readonly\n        ></textarea>\n        <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n            <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _Required = __webpack_require__(82);

var _Required2 = _interopRequireDefault(_Required);

var _Options = __webpack_require__(245);

var _Options2 = _interopRequireDefault(_Options);

var _InlineInputs = __webpack_require__(457);

var _InlineInputs2 = _interopRequireDefault(_InlineInputs);

var _HelperText = __webpack_require__(76);

var _HelperText2 = _interopRequireDefault(_HelperText);

var _HelperImage = __webpack_require__(77);

var _HelperImage2 = _interopRequireDefault(_HelperImage);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formCheckbox';

var creatorFormInputCheckbox = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ['ToolbarService', '$uibModal', '$filter', 'gettextCatalog', function controller(ToolbarService, $uibModal, $filter, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        defaultConfig.text = gettextCatalog.getString(defaultConfig.text);

        _angular2.default.forEach(defaultConfig.options, function (optionText, index) {
            defaultConfig.options[index] = gettextCatalog.getString(defaultConfig.options[index]);
        });

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };

        this.openModal = function (imageUrl) {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        };
    }],
    template: __webpack_require__(1244)
};

exports.default = _angular2.default.module('cms.creator.form.input.checkbox', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['ToolbarService', 'gettext', 'SectionsLibraryService', function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'check_box',
        type: MODULE_NAME,
        label: gettext('Checkboxes'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Checkbox'));
    var placeholder = new _Placeholder2.default();
    placeholder.setInputType('hidden');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Required2.default(), new _Options2.default(), new _InlineInputs2.default(), new _Width2.default(), new _HelperText2.default(), new _HelperImage2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputCheckbox', creatorFormInputCheckbox).name;

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-group label.form-{{ $ctrl.elementModel.key }} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n    .form-group label.form-{{ $ctrl.elementModel.key }} input {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\">\n    <label class=\"control-label form-{{ $ctrl.elementModel.key }}\"\n           ng-if=\"$ctrl.elementModel.label || $ctrl.parentModel.labelsPosition == 'left'\"\n           ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + $ctrl.parentModel.labelWidth : ''\">\n        {{$ctrl.elementModel.label }}</label>\n    <div ng-class=\"{'required': $ctrl.elementModel.required}\">\n        <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-' + (12 - $ctrl.parentModel.labelWidth) : ''\"\n             tooltip-placement=\"bottom\" uib-tooltip=\"{{$ctrl.elementModel.helperText}}\">\n            <span ng-repeat=\"option in $ctrl.elementModel.options track by $index\"\n                  ng-class=\"$ctrl.elementModel.inlineInputs ? 'checkbox-inline' : 'checkbox'\">\n                <label class=\"form-{{ $ctrl.elementModel.key }}\">\n                    <input id=\"{{option}}\" type=\"checkbox\" class=\"form-check-input\" name=\"form[{{ $ctrl.elementModel.key }}]\"\n                           value=\"{{ option }}\" readonly disabled/>\n                    <span>{{ option }}</span>\n                </label>\n            </span>\n            <div ng-if=\"$ctrl.elementModel.helperImage[0]\">\n                <span class=\"helper-button\" ng-click=\"$ctrl.openModal($ctrl.elementModel.helperImage)\">?</span>\n            </div>\n        </div>\n    </div>\n</div>\n<div ng-if=\"$ctrl.showClearfix\" class=\"\"></div>";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formPlainText';

var creatorFormInputPlainText = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", "gettextCatalog", function controller(ToolbarService, gettextCatalog) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }],
    template: __webpack_require__(1246)
};

exports.default = _angular2.default.module('cms.creator.form.input.plain.text', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", function (ToolbarService, gettext, SectionsLibraryService) {

    SectionsLibraryService.registerSection({
        icon: 'subject',
        type: MODULE_NAME,
        label: gettext('Plain text'),
        group: 'form',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });
    var placeholder = new _Placeholder2.default();
    placeholder.setInputType('hidden');
    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('');
    var label = new _Label2.default();
    label.setDefaultValue(gettext('Plain text'));
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, label, placeholder, new _Width2.default(), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputPlainText', creatorFormInputPlainText).name;

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .form-{{$ctrl.elementModel.key}} {\n        color: {{ $ctrl.elementModel.color || $ctrl.parentModel.color}};\n        font-size: {{ $ctrl.elementModel.fontSize | numberWithUnit }};\n        font-weight: {{ $ctrl.elementModel.fontWeight }};\n        text-align: {{ $ctrl.parentModel.labelsAlign }};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} form-{{$ctrl.elementModel.key}} {{$ctrl.elementModel.customClassName}}\">\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-12' : ''\">\n        {{$ctrl.elementModel.label}}\n    </div>\n</div>";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Label = __webpack_require__(58);

var _Label2 = _interopRequireDefault(_Label);

var _BackgroundColor = __webpack_require__(69);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

var _TextColor = __webpack_require__(33);

var _TextColor2 = _interopRequireDefault(_TextColor);

var _FontSize = __webpack_require__(47);

var _FontSize2 = _interopRequireDefault(_FontSize);

var _FontWeight = __webpack_require__(48);

var _FontWeight2 = _interopRequireDefault(_FontWeight);

var _Paddings = __webpack_require__(29);

var _Paddings2 = _interopRequireDefault(_Paddings);

var _Margins = __webpack_require__(453);

var _Margins2 = _interopRequireDefault(_Margins);

var _Borders = __webpack_require__(243);

var _Borders2 = _interopRequireDefault(_Borders);

var _ConfigParameter = __webpack_require__(4);

var _ConfigParameter2 = _interopRequireDefault(_ConfigParameter);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formSubmit';

var creatorFormInputSubmit = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ["ToolbarService", function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }],
    template: __webpack_require__(1248)
};

exports.default = _angular2.default.module('cms.creator.form.input.submit', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(["ToolbarService", "gettext", "SectionsLibraryService", "UniqueIdGenerator", function (ToolbarService, gettext, SectionsLibraryService, UniqueIdGenerator) {

    SectionsLibraryService.registerSection({
        icon: 'expand',
        type: MODULE_NAME,
        label: gettext('Submit'),
        group: 'form',
        hidden: true,
        options: {
            disableRemove: true,
            disableCopy: true
        },
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            borders: {
                label: gettext('Button borders'),
                isOpen: false,
                type: 'borders'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var placeholder = new _Placeholder2.default();
    placeholder.setInputType('hidden');

    var backgroundColor = new _BackgroundColor2.default();
    backgroundColor.setDefaultValue('#2dacd1');

    var textColor = new _TextColor2.default();
    textColor.setDefaultValue('#ffffff');

    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, new _ConfigParameter2.default('uid', 'hidden', '', null, function () {
        return UniqueIdGenerator.generate('element-uid');
    }), new _Label2.default(), placeholder, new _Width2.default(), backgroundColor, new _Borders2.default('#2dacd1'), textColor, new _FontSize2.default(), new _FontWeight2.default(), new _Margins2.default({ value: 0, unit: 'px' }, { value: 0, unit: 'px' }), new _Paddings2.default({ value: 6, unit: 'px' }, { value: 12, unit: 'px' }), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputSubmit', creatorFormInputSubmit).name;

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .{{ ::$ctrl.parentModel.uid }} button[type=\"submit\"] {\n        background-color: {{ $ctrl.elementModel.backgroundColor }};\n        border-color: {{ $ctrl.elementModel.borderColor }};\n        border-width: {{$ctrl.elementModel.borderWidth | numberWithUnit}};\n        border-style: {{$ctrl.elementModel.borderStyle}};\n        border-radius: {{$ctrl.elementModel.borderRadius | numberWithUnit}};\n        color: {{ $ctrl.elementModel.color }};\n        font-size: {{$ctrl.elementModel.fontSize | numberWithUnit}};\n        font-weight: {{$ctrl.elementModel.fontWeight}};\n        padding-top: {{$ctrl.elementModel.paddingTop | numberWithUnit}};\n        padding-bottom: {{$ctrl.elementModel.paddingBottom | numberWithUnit}};\n        padding-left: {{$ctrl.elementModel.paddingLeft | numberWithUnit}};\n        padding-right: {{$ctrl.elementModel.paddingRight | numberWithUnit}};\n        margin-top: {{$ctrl.elementModel.marginTop | numberWithUnit}};\n        margin-bottom: {{$ctrl.elementModel.marginBottom | numberWithUnit}};\n        margin-left: {{$ctrl.elementModel.marginLeft | numberWithUnit}};\n        margin-right: {{$ctrl.elementModel.marginRight | numberWithUnit}};\n    }\n</style>\n<div class=\"form-group disabled-input col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\">\n    <div ng-class=\"{'col-sm-10': $ctrl.parentModel.labelsPosition == 'left'}\">\n        <button type=\"submit\"\n               class=\"btn\"\n               name=\"form[submit]\"\n                readonly\n\n        >{{$ctrl.elementModel.label}}</button>\n    </div>\n</div>";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _SectionsLibraryService = __webpack_require__(12);

var _SectionsLibraryService2 = _interopRequireDefault(_SectionsLibraryService);

var _ToolbarService = __webpack_require__(16);

var _ToolbarService2 = _interopRequireDefault(_ToolbarService);

var _Width = __webpack_require__(49);

var _Width2 = _interopRequireDefault(_Width);

var _Placeholder = __webpack_require__(50);

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _CustomClassName = __webpack_require__(24);

var _CustomClassName2 = _interopRequireDefault(_CustomClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'formCaptcha';

var creatorFormInputCaptcha = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: ['ToolbarService', function controller(ToolbarService) {
        var _this = this;

        var defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = function () {
            _this.elementModel = _angular2.default.copy(_angular2.default.extend(defaultConfig, _this.elementModel));
        };
    }],
    template: __webpack_require__(1250)
};

exports.default = _angular2.default.module('cms.creator.form.input.captcha', [_SectionsLibraryService2.default, _ToolbarService2.default]).run(['SectionsLibraryService', 'ToolbarService', 'gettext', function (SectionsLibraryService, ToolbarService, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'expand',
        type: MODULE_NAME,
        label: gettext('Captcha'),
        group: 'form',
        hidden: true,
        options: {
            disableRemove: true,
            disableCopy: true
        },
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    var placeholder = new _Placeholder2.default();
    placeholder.setInputType('hidden');
    ToolbarService.registerSectionSchema(MODULE_NAME, _extends({}, placeholder, new _Width2.default(), new _CustomClassName2.default()));
}]).component('cmsCreatorFormInputCaptcha', creatorFormInputCaptcha).name;

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group col-sm-{{$ctrl.elementModel.width}} {{$ctrl.elementModel.customClassName}}\" ng-if=\"$ctrl.parentModel.recaptcha\">\n    <div ng-class=\"$ctrl.parentModel.labelsPosition == 'left' ? 'col-sm-12' : ''\">\n        <img alt=\"recaptcha\" src=\"/images/recaptcha.jpg\"/>\n    </div>\n</div>";

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

module.exports = "<form id=\"{{ $ctrl.elementModel.sectionId }}\" novalidate ng-class=\"{'labels-left' : $ctrl.elementModel.labelsPosition == 'left'}\" class=\"{{$ctrl.elementModel.customClassName}}\">\n    <div ng-repeat=\"input in $ctrl.elementModel.content\" ng-class=\"$ctrl.elementModel.labelsPosition == 'left' ? 'row' : '' \">\n        <cms-creator-form-input-text\n                ng-if=\"input.type == 'formText'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-text>\n        <cms-creator-form-input-email\n                ng-if=\"input.type == 'formEmail'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-email>\n        <cms-creator-form-input-date\n                ng-if=\"input.type == 'formDate'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-date>\n        <cms-creator-form-input-date-time\n                ng-if=\"input.type == 'formDateTime'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-date-time>\n        <cms-creator-form-input-number\n                ng-if=\"input.type == 'formNumber'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-number>\n        <cms-creator-form-input-select\n                ng-if=\"input.type == 'formSelect'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-select>\n        <cms-creator-form-input-textarea\n                ng-if=\"input.type == 'formTextarea'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-textarea>\n        <cms-creator-form-input-plain-text\n                ng-if=\"input.type == 'formPlainText'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-plain-text>\n        <cms-creator-form-input-radio\n                ng-if=\"input.type == 'formRadio'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-radio>\n        <cms-creator-form-input-checkbox\n                ng-if=\"input.type == 'formCheckbox'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-checkbox>\n        <cms-creator-form-input-submit\n                ng-if=\"input.type == 'formSubmit'\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-submit>\n        <cms-creator-form-input-captcha\n                ng-if=\"input.type == 'formCaptcha' && $ctrl.elementModel.recaptcha\"\n                parent-model=\"$ctrl.elementModel\"\n                element-model=\"input.config\"></cms-creator-form-input-captcha>\n    </div>\n    <div class=\"clearfix\"></div>\n</form>\n<div class=\"clearfix\"></div>";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.dashboard.logsFeed', []).component('logsFeed', {
    template: __webpack_require__(1253),
    controller: ['LogResource', '$scope', 'gettextCatalog', function controller(LogResource, $scope, gettextCatalog) {
        LogResource.get({ limit: 30 }, function (response) {
            $scope.logs = response.data;
        });

        $scope.getLogMessage = function (log) {
            var isNotUniqueEvent = log.event !== 'login' && log.event !== 'reset_password';
            var action = '';
            var subject = isNotUniqueEvent ? gettextCatalog.getString(log.context.split('\\').pop()) : '';
            var element = isNotUniqueEvent ? gettextCatalog.getString('element:') : '';
            switch (log.event) {
                case 'login':
                    action = gettextCatalog.getString('Logged in');
                    break;
                case 'update':
                    action = gettextCatalog.getString('Updated');
                    break;
                case 'create':
                    action = gettextCatalog.getString('Created');
                    break;
                case 'delete':
                    action = gettextCatalog.getString('Deleted');
                    break;
                case 'reset_password':
                    action = gettextCatalog.getString('Changed password');
                    break;
                default:
                    action = gettextCatalog.getString('Other action');
            }

            return action + " " + element + " " + subject;
        };
    }]
}).name;

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

module.exports = "<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\">\n    <div class=\"feed-message\" ng-repeat=\"log in logs\">\n        <div class=\"message-icon\">\n            <img class=\"photo-icon\" ng-src=\"{{ {email: log.ownerName, id:log.ownerId} | avatar:64}}\" alt=\"logo\">\n        </div>\n        <div class=\"text-block text-message\">\n            <div class=\"message-header\">\n                <span class=\"author\">{{log.ownerFirstName}} {{log.ownerLastName}}</span>\n            </div>\n            <div class=\"message-content line-clamp-2\">\n                {{ getLogMessage(log)}}\n            </div>\n            <div class=\"message-time\">\n                <div class=\"ago-time\">\n                    {{log.createdAt | date : 'dd/MM/y HH:mm:ss'}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.save.warning', []).factory('SaveWarning', ['saveWarningDialog', 'gettextCatalog', '$window', '$interval', 'saveWarningIntervalDialog', '$rootScope', function (saveWarningDialog, gettextCatalog, $window, $interval, saveWarningIntervalDialog, $rootScope) {
    var _this = this;

    /** @ngInject() */

    var TIME_TO_WARN = 300000;

    this.editedObject = {};
    this.currentObject = {};
    var warnInterval = void 0;

    var watch = function watch(editedObject, currentObject) {
        var contentScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var element = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        _this.editedObject = _angular2.default.copy(editedObject);
        _this.currentObject = currentObject;
        $window.onbeforeunload = onbeforeunload;
        if (contentScope && element) {
            element.on('mousedown', function () {
                if (!_angular2.default.equals(_this.editedObject, _this.currentObject)) {
                    addWarningInterval();
                }
            });

            contentScope.$on('sections-library.drop-model', function () {
                addWarningInterval();
            });
            contentScope.$on('content-changed', function () {
                addWarningInterval();
            });
        }
    };

    var stopWatch = function stopWatch() {
        _this.editedObject = {};
        _this.currentObject = {};
        cancelTimeWarning();
    };

    var addWarningInterval = function addWarningInterval() {
        if (!warnInterval) {
            warnInterval = $interval(warn, TIME_TO_WARN);
        }
    };

    var isEdited = function isEdited() {

        if (!_angular2.default.equals(_this.editedObject, _this.currentObject)) {

            return saveWarningDialog.open().then(function () {
                return false;
            }).catch(function () {
                cancelTimeWarning();
                $window.onbeforeunload = null;
            });
        }

        return true;
    };

    var onbeforeunload = function onbeforeunload() {

        if (!_angular2.default.equals(_this.editedObject, _this.currentObject)) {
            return true;
        }
    };

    var warn = function warn() {
        var scroll = $(document).scrollTop();
        if (!_angular2.default.equals(_this.editedObject, _this.currentObject)) {
            if (!saveWarningIntervalDialog.isOpen()) {
                saveWarningIntervalDialog.open().then(function () {
                    cancelTimeWarning();
                    $(document).scrollTop(scroll);
                    $rootScope.$broadcast('save.object');
                }).catch(function () {
                    cancelTimeWarning();
                    $(document).scrollTop(scroll);
                    return false;
                });
            }
        }
    };

    var cancelTimeWarning = function cancelTimeWarning() {
        $interval.cancel(warnInterval);
        warnInterval = null;
    };

    return {
        isEdited: isEdited,
        onbeforeunload: onbeforeunload,
        watch: watch,
        cancelTimeWarning: cancelTimeWarning,
        stopWatch: stopWatch
    };
}]).name;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _MediaUsage = __webpack_require__(201);

var _MediaUsage2 = _interopRequireDefault(_MediaUsage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.image.url.filter', []).filter('imageUrl', ImageUrlFilter).name;


function ImageUrlFilter() {

    var build = function build(image) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
        var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


        if (typeof image === 'undefined') {
            return defaultValue;
        }

        return new _MediaUsage2.default(image, width, 0).getImgUrl();
    };

    return build;
}

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.html.trusted.filter', []).filter('trust', ['$sce', function HtmlTrusted($sce) {

    return function (htmlCode) {
        return new $sce.trustAsHtml(htmlCode);
    };
}]).name;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.number.with.unit.filter', []).filter('numberWithUnit', function () {

    return function (numberWithUnitModel) {
        return numberWithUnitModel.value + numberWithUnitModel.unit;
    };
}).name;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.creator.scroll.lock', []).directive('scrollLock', function () {
    return {

        link: function link(scope, element) {
            var body = _angular2.default.element('body');
            var paddingRight = getScrollbarWidth(body);

            // Fixed elements
            var $_PAGETOP = $('.page-top');
            var $_BACKTOP = $('.back-top');
            var $_CHAT = $('.rocketchat-widget');
            var PAGETOP_PADDING_RIGHT = parseInt($_PAGETOP.css('padding-right'));
            var BACKTOP_PADDING_RIGHT = parseInt($_BACKTOP.css('right'));
            var CHAT_PADDING_RIGHT = parseInt($_CHAT.css('right'));

            element.on('mouseenter', function () {
                body.css('overflow', 'hidden');
                body.css('padding-right', paddingRight + 'px');
                $_PAGETOP.css('padding-right', paddingRight + PAGETOP_PADDING_RIGHT + 'px');
                $_BACKTOP.css('right', paddingRight + BACKTOP_PADDING_RIGHT + 'px');
                $_CHAT.css('right', paddingRight + CHAT_PADDING_RIGHT + 'px');
            });

            element.on('mouseleave', function () {
                body.css('overflow', 'auto');
                body.css('padding-right', '0');
                $_PAGETOP.css('padding-right', PAGETOP_PADDING_RIGHT + 'px');
                $_BACKTOP.css('right', BACKTOP_PADDING_RIGHT + 'px');
                $_CHAT.css('right', CHAT_PADDING_RIGHT + 'px');
            });

            /**
             * Calculating browser/system specific width of scrollbar
             * @param body
             * @returns {number}
             */
            function getScrollbarWidth(body) {
                var outer = document.createElement("div");
                outer.style.visibility = "hidden";
                outer.style.width = "100px";
                outer.style.msOverflowStyle = "scrollbar";

                var tmp = $(body)[0].style.fontSize;
                $(body)[0].style.fontSize = "14px";

                var style = '<style>*::-webkit-scrollbar{width:.5em;}</style>';
                $(body).append(style); //chrome blur-admin hack for ckeditor

                $(body).append(outer);

                var widthNoScroll = outer.offsetWidth;

                outer.style.overflow = "scroll";
                var inner = document.createElement("div");
                inner.style.width = "100%";
                outer.appendChild(inner);

                var widthWithScroll = inner.offsetWidth;

                outer.parentNode.removeChild(outer);
                $(body)[0].style.fontSize = tmp;

                return widthNoScroll - widthWithScroll;
            }
        }
    };
}).name;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _LanguageManager = __webpack_require__(146);

var _LanguageManager2 = _interopRequireDefault(_LanguageManager);

__webpack_require__(1260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('cms.chart.linearChart', [_LanguageManager2.default]).component('cmsLinearChart', {
    bindings: {
        callbackPromise: '<',
        chartId: '@',
        options: '='
    },
    template: __webpack_require__(1261),
    controller: ['baConfig', 'layoutPaths', 'baUtil', '$http', '$scope', 'languageManager', function controller(baConfig, layoutPaths, baUtil, $http, $scope, languageManager) {
        var _this = this;

        var layoutColors = baConfig.colors;
        var chart = void 0;

        this.$onInit = function () {
            _this.callbackPromise().then(function (response) {
                printChart(response.data);
            });
        };

        var printChart = function printChart(chartData) {

            var chartOptions = _angular2.default.merge({
                type: 'serial',
                theme: 'light',
                language: languageManager.getLanguage(),
                dataDateFormat: "DD/MM/YYYY",
                marginTop: 15,
                marginRight: 15,
                dataProvider: chartData,
                categoryField: 'date',
                categoryAxis: {
                    gridAlpha: 0,
                    parseDates: true,
                    minPeriod: 'DD',
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText
                },
                valueAxes: [{
                    minVerticalGap: 50,
                    gridAlpha: 0,
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText
                }],
                graphs: [{
                    id: 'g1',
                    bullet: 'none',
                    lineColor: layoutColors.danger,
                    lineThickness: 1,
                    type: 'smoothedLine',
                    valueField: 'deleted',
                    fillAlphas: .1,
                    fillColorsField: 'lineColor'
                }],
                creditsPosition: 'bottom-right',
                zoomControl: {
                    zoomControlEnabled: false

                }
            }, _this.options);

            chart = AmCharts.makeChart(_this.chartId, chartOptions);
        };

        $scope.$on('language-changed', function (event, data) {
            if (chart && data.newLanguage) {
                chart.language = data.newLanguage;
                chart.validateData();
            }
        });
    }]
}).name;

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

module.exports = "<div id=\"{{ $ctrl.chartId }}\"></div>";

/***/ })
],[458]);


// WEBPACK FOOTER //
// bundle.js